webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/ppa8DD/%3F1716663321421&title=Moon%20Rock%2C%20Otto%20Penzler%27s%20Locked%20Room%20Library&summary=A%20classic%20locked%20room%20mystery%20from%20the%20genre%26rsquo%3Bs%20Golden%20Age%20by%20the%20renowned%20Australian%20author%20of%20the%20Chief%20Inspector%20Luckraft%20series.%20%26%23160%3B%20On%20the%20day%20of%20his%20wife%26rsquo%3Bs%20funeral%2C%20Robert%20Turold%20reveals%20that%20he%20has%20completed%20his%20lif&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/ppa8DD/%3F1716663321421",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=A%20classic%20locked%20room%20mystery%20from%20the%20genre%26rsquo%3Bs%20Golden%20Age%20by%20the%20renowned%20Australian%20author%20of%20the%20Chief%20Inspector%20Luckraft%20series.%0Dhttps://textcafe.co/books/ppa8DD/%3F1716663321421&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/ppa8DD/%3F1716663321421&posttype=link&caption=A%20classic%20locked%20room%20mystery%20from%20the%20genre%26rsquo%3Bs%20Golden%20Age%20by%20the%20renowned%20Australian%20author%20of%20the%20Chief%20Inspector%20Luckraft%20series.%20%26%23160%3B%20On%20the%20day%20of%20his%20wife%26rsquo%3Bs%20funeral%2C%20Robert%20Turold%20reveals%20that%20he%20has%20completed%20his%20lif",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/ppa8DD/%3F1716663321421&description=A%20classic%20locked%20room%20mystery%20from%20the%20genre%26rsquo%3Bs%20Golden%20Age%20by%20the%20renowned%20Australian%20author%20of%20the%20Chief%20Inspector%20Luckraft%20series.%20%26%23160%3B%20On%20the%20day%20of%20his%20wife%26rsquo%3Bs%20funeral%2C%20Robert%20Turold%20reveals%20that%20he%20has%20completed%20his%20lif&media=https://textcafe.co/books/ppa8DD/tc-custom/9781504093149.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/s?k=9781504093149&i=stripbooks&linkCode=qs&tag=mobilebookcom-20',
        alt: 'None'
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=3-PwEAAAQBAJ&amp;rdid=book-3-PwEAAAQBAJ&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9781504093149').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/ppa8DD/tc-custom/9781504093149.jpg?1716663321421',
        alt: 'Moon Rock, Otto Penzler&#x27;s Locked Room Library'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "cover", "ebb", "tlu", "mm", "love_1", "01_Title", "MoonRock_4P", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/ppa8DD/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ebb__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ebb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ebb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_tlu__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_tlu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_tlu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_mm__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_mm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_mm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_love_1__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_love_1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_love_1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_01_Title__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_01_Title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_01_Title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_MoonRock_4P__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_MoonRock_4P___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_MoonRock_4P__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_love_2__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_love_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_love_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_copyright__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_copyright___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_copyright__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_auba__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_auba___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_auba__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_endmatter2__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_endmatter2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_endmatter2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_endmatter3__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_endmatter3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_endmatter3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ORIMad__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ORIMad___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_ORIMad__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_last__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_last__);
/*jshint esversion: 6 */




















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/cover",
    "name": "cover",
    "component": __WEBPACK_IMPORTED_MODULE_4__components_cover___default.a
  }, {
    "path": "/ebb",
    "name": "ebb",
    "component": __WEBPACK_IMPORTED_MODULE_5__components_ebb___default.a
  }, {
    "path": "/tlu",
    "name": "tlu",
    "component": __WEBPACK_IMPORTED_MODULE_6__components_tlu___default.a
  }, {
    "path": "/mm",
    "name": "mm",
    "component": __WEBPACK_IMPORTED_MODULE_7__components_mm___default.a
  }, {
    "path": "/love_1",
    "name": "love_1",
    "component": __WEBPACK_IMPORTED_MODULE_8__components_love_1___default.a
  }, {
    "path": "/01_Title",
    "name": "01_Title",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_01_Title___default.a
  }, {
    "path": "/MoonRock_4P",
    "name": "MoonRock_4P",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_MoonRock_4P___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_17__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Arthur J. Rees\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Arthur J. Rees was an Australian mystery writer. Born in Melbourne, he worked for the local newspaper the "), _c('I', [_vm._v("Age")]), _vm._v(" for a short time before later joining the "), _c('I', [_vm._v("New Zealand Herald")]), _vm._v(". He wrote more than twenty novels between the years 1913 and 1940.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ppa8DD/tc-custom/9781504093149.jpg?1716663321421",
      "alt": "This image is the cover for the book Moon Rock, Otto Penzler's Locked Room Library"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Moon Rock, Otto Penzler's Locked Room Library\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A classic locked room mystery from the genre’s Golden Age by the renowned Australian author of the Chief Inspector Luckraft series.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" On the day of his wife’s funeral, Robert Turold reveals that he has completed his lifelong quest to prove his family’s noble blood and restore its barony title. His brother and nephew will be his heirs, skipping over his daughter who he believes is illegitimate due to a deathbed confession from his wife. With the granting of a peerage within his reach, Robert has no qualms involving the neglected girl in public scandal—a turn of events that has left the surviving members of his family reeling."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" High on the Cornish cliffs, Robert’s isolated and imposing Flint House proves the perfect backdrop for a mysterious crime, when he’s found shot in a locked room. While first impressions point to suicide, Robert’s sister is convinced he was murdered. Arriving from Scotland Yard, Detective Barrant suspects Robert’s now-missing daughter, who has fled to London."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Mired in past secrets and sins, the case seems to go nowhere and everywhere at once. But the threads of obsession, greed, and revenge will lead to a devious killer, who is soon to be trapped in a web of their own design."), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    MysteriousPress.com/Open Road Integrated Media, Inc.\n   ")])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "epub:type": "cover"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "cover.jpg",
      "src": "image/cover.jpg"
    }
  })])])])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "ad"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "https://earlybirdbooks.com/?utm_source=EBBGOAAAAE&utm_campaign=9781504093149",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "signup.jpg"
    }
  })])])])])])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "ad"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "https://the-line-up.com/newsletters?utm_source=TLUGOAAAAJ&utm_campaign=9781504093149",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "tlu-signup.jpg"
    }
  })])])])])])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "ad"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "https://murder-mayhem.com/newsletters/?utm_source=MNMGOAAAAI&utm_campaign=9781504093149",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "mm-backad.jpg"
    }
  })])])])])])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-inside": "avoid",
      "text-align": "center",
      "margin": "0"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://earlybirdbooks.com/freebook/index.html?q=65026e4300d3b3f6d6b677aa&utm_campaign=front",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "love.jpg"
    }
  })])])])])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("The Moon Rock")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "titlea"
  }, [_vm._v("Otto Penzler’s Locked Room Library")]), _vm._v(" "), _c('p', {
    staticClass: "titlea"
  }, [_vm._v("Arthur J. Rees")])]), _c('p', {
    staticClass: "centerimg"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "image/logo3.jpg"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  })])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_c('span', {
    staticClass: "bold-italic _idGenCharOverride-1"
  }, [_vm._v("Puzzle: ")]), _vm._v("A man is shot to death in a room that is inaccessible on one side by a 200-foot-high cliff and a door that is locked from the inside on the other.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("When I opened my old copy of "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("The Moon Rock")]), _vm._v(", I was immediately comforted by the realization that I was about to become enveloped in the mood of a Victorian novel that combined elements of crime, horror, and melodrama, not unlike Wilkie Collins, Sheridan Le Fanu, and even Charles Dickens. I had to check the copyright page to be certain that, instead, I was reading a Golden Age mystery story published in 1922.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The very first scene begins as “a clergyman intoned the last sad hope of humanity,” as “mourners turned away, leaving Mrs. Turold to take her rest in a bleak Cornish churchyard.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It was immediately clear that this was a novel devoid of humor and, if I sought a cheerful and optimistic tale, I would need to pull a different book from my shelves. Could there be a greater indictment of a life lived poorly than these observations?")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“The fact would not have troubled her if she had known. In life she had been a nonentity; in death she was not less.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The poor lady had been married to Robert Turold, who had been obsessed for forty years with the restoration of a title, a baronetcy, to him and his family, leaving her and their daughter with neither affection nor more than a meager living.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("As in "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Bleak House")]), _vm._v(" and "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("The Woman in White")]), _vm._v(", and scores of lesser Victorian novels, the prospect of a sudden improvement in a station in life, and the commensurate wealth it is likely to bring, opens the possibility of intra-familiar quarrels, sometimes elevated to extreme circumstances.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Such is the case in the Turold family, which has its dark secrets that some want to be revealed while others strive to keep hidden. In an additional trope of nineteenth-century novels, the activities take place in an old house at the edge of a cliff, high above the ocean, making access to the house impossible from that side. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Inevitably, perhaps, Robert Turold keeps a sinister servant, Thalassa, who appears to be devoted to him but is less than fanatic about handling his responsibilities with enthusiasm, and whose wife is terrified of him, shrinking back whenever he comes near to her.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("When a loud "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("thump ")]), _vm._v("is heard on the second floor, it is Thalassa who rushes up the stairs to investigate but finds his master’s door locked from the inside. Repeated knocks, louder and louder, fail to elicit a response, so Turold’s sister sends for the family doctor, even though it is late at night. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("When Dr. Ravenshaw arrives, he takes a look at Thalassa and senses trouble. “What’s the matter with you, man?” he asks, a strange question, indeed, when he’s been asked to make all haste to call on the family. “Is there anything wrong?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That’s what I don’t know. But I’m affeered, yes, by God, I’m affeered.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The doctor, servant, and other family members climb the stairs and, when they arrive at the door, they notice a “thin, dark trickle making its way under the door.” Astutely, one of the frightened party states, “There’s been trouble in there.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa neatly sums up the problem. “How could anybody get in? The door is locked from the inside, and it’s two hundred feet from the windows to the bottom of the cliffs.” Nonetheless, sure enough, when they break down the door, Robert Turold’s body is spread on the floor, with a small dark object in his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The author, Arthur John Rees (1872–1942), was an Australian mystery writer who was quite prolific and who received considerable praise for his crime and detective novels, notably from Jacques Barzun and Wendell Hertig Taylor’s "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Catalogue of Crime")]), _vm._v(", which calls "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("The Shrieking Pit")]), _vm._v(" a “first-rate novel of the length and pace customary at the time of its writing, but distinguished from its fellows by an absolutely steady forward march through a variety of clues and contradictions,” and Dorothy L. Sayers, in the introduction to her monumental "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Great Short Stories of Detection, Mystery and Horror")]), _vm._v(" (1928).")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("In spite of his one-time popularity, long since dissipated, surprisingly little is known of his life beyond the books and stories he wrote. Although often reported to have been born in Melbourne, in fact Rees first saw the light of day on September 23, 1872, in St. Kilda, Australia, the reported twelfth child of Frederic Rees and Harriet (née Crutchfield). While this sounds firmly factual, numerous reference books list his birth date variously as 1870, 1872, 1874, 1875, 1877, and 1880.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He worked variously for the "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Melbourne Age")]), _vm._v(", the "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("New Zealand Herald")]), _vm._v(", and, after he emigrated to England (probably in the 1890s), the London "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Times")]), _vm._v(" (1914–22), and he was familiar to readers of the London "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Evening Standard")]), _vm._v(" as a regular contributor on Australian subjects. He died on November 22, 1942, in Worthing, Sussex, England.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("If you enjoyed "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("The Moon Rock")]), _vm._v(" and want to read more of Arthur J. Rees, here’s a list of his books. ")]), _vm._v(" "), _c('p', {
    staticClass: "list-level-1"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("The Merry Marauders")]), _vm._v(" (1913)")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented ParaOverride-2"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("The Hampstead Mystery")]), _vm._v(" (1916) [with John Reay Watson]")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented ParaOverride-2"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("The Mystery of the Downs")]), _vm._v(" (1918) [with John Reay Watson]")]), _vm._v(" "), _c('p', {
    staticClass: "list-level-1"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("The Shrieking Pit")]), _vm._v(" (1919)")]), _vm._v(" "), _c('p', {
    staticClass: "list-level-1"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("The Hand in the Dark")]), _vm._v(" (1920)")]), _vm._v(" "), _c('p', {
    staticClass: "list-level-1"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("The Moon Rock")]), _vm._v(" (1922)")]), _vm._v(" "), _c('p', {
    staticClass: "list-level-1"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("The Island of Destiny")]), _vm._v(" (1923)")]), _vm._v(" "), _c('p', {
    staticClass: "list-level-1"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("The Cup of Silence")]), _vm._v(" (1924)")]), _vm._v(" "), _c('p', {
    staticClass: "list-level-1"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("The Threshold of Fear")]), _vm._v(" (1925)")]), _vm._v(" "), _c('p', {
    staticClass: "list-level-1"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Simon of Hangletree")]), _vm._v(" (1926)")]), _vm._v(" "), _c('p', {
    staticClass: "list-level-1"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Greymarsh")]), _vm._v(" (1927)")]), _vm._v(" "), _c('p', {
    staticClass: "list-level-1"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Love Me Anise")]), _vm._v(" (1928)")]), _vm._v(" "), _c('p', {
    staticClass: "list-level-1"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Old Sussex and Her Diarists")]), _vm._v(" (1929)")]), _vm._v(" "), _c('p', {
    staticClass: "list-level-1"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("The Pavilion by the Lake")]), _vm._v(" (1930)")]), _vm._v(" "), _c('p', {
    staticClass: "list-level-1"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("The Brink")]), _vm._v(" (1931)")]), _vm._v(" "), _c('p', {
    staticClass: "list-level-1"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("The Tragedy of Twelvetrees")]), _vm._v(" (1931)")]), _vm._v(" "), _c('p', {
    staticClass: "list-level-1"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("The Investigations of Colwin Grey")]), _vm._v(" (1932)")]), _vm._v(" "), _c('p', {
    staticClass: "list-level-1"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("The River Mystery")]), _vm._v(" (1932)")]), _vm._v(" "), _c('p', {
    staticClass: "list-level-1"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Peak House")]), _vm._v(" (1933)")]), _vm._v(" "), _c('p', {
    staticClass: "list-level-1"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Aldringham’s Last Chance")]), _vm._v(" (1933)")]), _vm._v(" "), _c('p', {
    staticClass: "list-level-1"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("The Flying Argosy")]), _vm._v(" (1934)")]), _vm._v(" "), _c('p', {
    staticClass: "list-level-1"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("The Single Clue")]), _vm._v(" (1940)")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("He also wrote a very few short stories but they achieved minor success. “The Missing Passenger’s Trunk” and “The Finger of Death” were published in "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Volume IX of The World’s Best One Hundred Detective Stories")]), _vm._v(" (1929); “The Missing Passenger’s Trunk” was reprinted in the October 1987 issue of "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Alfred Hitchcock Mystery Magazine")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("A few of his books may be more highly recommended than others. I would suggest "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("The Hampstead Mystery")]), _vm._v(", a courtroom drama, and two Inspector Colwyn novels, "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("The Shrieking Pit ")]), _vm._v("and "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("The Hand in the Dark")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "extract-right-space-after"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("—Otto Penzler")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("Chapter I")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("The voice of the clergyman intoned the last sad hope of humanity, the final prayer was said, and the mourners turned away, leaving Mrs. Turold to take her rest in a bleak Cornish churchyard among strangers, far from the place of her birth and kindred.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The fact would not have troubled her if she had known. In life she had been a nonentity; in death she was not less. At least she could now mix with her betters without reproach, free (in the all-enveloping silence) from the fear of betraying her humble origin. Debrett’s Peerage was unimportant in the grave; breaches of social etiquette passed unnoticed there; the wagging of malicious tongues was stopped by dust.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Her husband lingered at the grave-side after the others had departed. As he stood staring into the open grave, regardless of a lurking grave-digger waiting to fill it, he looked like a man whose part in the drama of life was Care. There was no hint of happiness in his long narrow face, dull sunken eyes, and bloodless compressed lips. His expression was not that of one unable to tear himself away from the last glimpse of a loved wife fallen from his arms into the clutch of Death. It was the gaze of one immersed in anxious thought.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The mourners, who had just left the churchyard, awaited him by a rude stone cross near the entrance to the church. There were six—four men, a woman, and a girl. In the road close by stood the motor-car which had brought them to the churchyard in the wake of the hearse, glistening incongruously in the grey Cornish setting of moorland and sea.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The girl stood a little apart from the others. She was the daughter of the dead woman, but her head was turned away from the churchyard, and her sorrowful glance dwelt on the distant sea. The contour of her small face was perfect as a flower or gem, and colourless except for vivid scarlet lips and dark eyes gleaming beneath delicate dark brows. She was very young—not more than twenty—but in the soft lines of her beauty there was a suggestion of character beyond her years. Her face was dreamy and wayward, and almost gipsy in type. There was something rather disconcerting in the contrast between her air of inexperienced youth and the sombre intensity of her dark eyes, which seemed mature and disillusioned, like those of an older person. The slim lines of her figure had the lissome development of a girl who spent her days out of doors.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She stood there motionless, apparently lost in meditation, indifferent to the bitter wind which was driving across the moors with insistent force.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Put this on, Sisily.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Sisily turned with a start. Her aunt, a large stout woman muffled in heavy furs, was standing behind her, holding a wrap in her hand.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You’ll catch your death of cold, child, standing here in this thin dress,” the elder lady continued. “Why didn’t you wear your coat? You’d be warmer sitting in the car. It’s really very selfish of Robert, keeping us all waiting in this dreadful wind!” She shivered, and drew her furs closer. “Why doesn’t he come away? As if it could do any good!”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("As she spoke the tall form of Robert Turold was seen approaching through the rank grass and mouldering tombstones with a quick stride. He emerged from the churchyard gate with a stern and moody face.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Let us get home,” he said, and his words were more of a command than request.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He walked across the road to the car with his sister and daughter. The men by the cross followed. They were his brother, his brother’s son, his sister’s husband, and the local doctor, whose name was Ravenshaw. With a clang and a hoot the car started on the return journey. The winding cobbled street of the churchtown was soon left behind for a road which struck across the lonely moors to the sea. Through the moors and stony hills the car sped until it drew near a solitary house perched on the edge of the dark cliffs high above the tumbling waters of the yeasty sea which foamed at their base.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The car stopped by the gate where the moor road ended. The mourners alighted and entered the gate. Their approach was observed from within, for as they neared the house the front door was opened by an elderly man-servant with a brown and hawk-beaked face.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Walking rapidly ahead Robert Turold led the way into a front sitting-room lighted by a window overlooking the sea. There was an air of purpose in his movements, but an appearance of strain in his careworn face and twitching lips. He glanced at the others in a preoccupied way, but started perceptibly as his eye fell upon his daughter.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“There is no need for you to remain, Sisily,” he said in a harsh dry voice.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Sisily turned away without speaking. Her cousin Charles jumped up to open the door, and the two exchanged a glance as she went out. The young man then returned to his seat near the window. Robert Turold was speaking emphatically to Dr. Ravenshaw, answering some objection which the doctor had raised.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“. . . No, no, Ravenshaw—I want you to be present. You will oblige me by remaining. I will go upstairs and get the documents. I shall not keep you long. Thalassa, serve refreshments.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("He left the room quickly, as though to avoid further argument. The elderly serving-man busied himself by setting out decanters and glasses, then went out like one who considered his duty done, leaving the company to wait on themselves.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _vm._v("Chapter II")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("The group in the room sat in silence with an air of stiff expectation. The members of the family knew they were not assembled to pay respect to the memory of the woman who had just been buried. Her husband had regarded her as a drag upon him, and did not consider her removal an occasion for the display of hypocritical grief. Rather was it to be regarded as an act of timely intervention on the part of Death, who for once had not acted as marplot in human affairs.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("They were there to listen to the story of the triumph of the head of the family, Robert Turold. Most families have some common source of interest and pride. It may be a famous son, a renowned ancestor, a faded heirloom, even a musical daughter. The pride of the Turold family rested on the belief that they were of noble blood—the lineal inheritors of a great English title which had fallen into abeyance hundreds of years before.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Robert Turold had not been content to boast of his nobility and die a commoner like his father and grandfather before him. His intense pride demanded more than that. As a boy he had pored over the crabbed parchments in the family deed-box which indicated but did not record the family descent, and he had vowed to devote his life to prove the descent and restore the ancient title of Turrald of Missenden to the Turolds of which he was the head.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("There was not much to go upon when he commenced the labour of thirty years—merely a few old documents, a family tradition, and the similarity of name. And the Turolds were poor. Money, and a great deal of it, was needed for the search, in the first instance, of the unbroken line of descent, and for the maintenance of the title afterwards if the claim was completely established. But Robert Turold was not to be deterred by obstacles, however great. He was a man with a single idea, and such men are hard to baulk in the long run.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He left England in early manhood and remained away for some years. His family understood that he had gone to seek a fortune in the wilds of the earth. He reappeared—a saturnine silent man—as suddenly as he had gone away. In his wanderings he had gained a fortune but partly lost the use of one eye. The partial loss of an eye did not matter much in a country like England, where most people have two eyes and very little money, and therefore pay more respect to wealth than vision.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Robert Turold invested his money, and then set to work upon his great ambition with the fierce restlessness which characterized all his proceedings in life. He married shortly after his return. He soon came to the conclusion that his marriage was a great mistake—the greatest mistake of his life. His wife had borne him two girls. The first died in infancy, and some years later Sisily was born. His regrets increased with the birth of a second daughter. He wanted a son to succeed him in the title—when he gained it. Time passed, and he became enraged. His anger crushed the timid woman who shared his strange lot. His dominating temperament and moody pride were too much for her gentle soul. She became desperately afraid of him and his stern ways, of that monomania which kept them wandering through the country searching for links in a [pedigree] which had to be traced back for hundreds of years before Robert Turold could grasp his heart’s desire.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("When She died in the house on the cliffs where they had come six months before, Robert Turold had accomplished the task to which his life had been devoted. Some weeks before he had summoned his brother from London to disclose his future plans. The brothers had not met for many years, but Austin was quick to obey when he learnt that a fortune and a title were at stake. The sister and her husband, Mr. and Mrs. Pendleton, had reached Cornwall two days before the funeral. They were to take Sisily back to London with them. It was Robert Turold’s intention to part with his daughter and place her in his sister’s charge. For a reason he had not yet divulged, Sisily was to have no place in his brilliant future. He disliked his daughter. Her sex was a fatal bar to his regard. He had heaped so many reproaches on her mother for bringing another girl into the world that the poor woman had descended to the grave with a confused idea that she was to blame.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Sisily had a strange nature, reticent, yet tender. She had loved her mother passionately, and feared and hated her father because he had treated his wife so harshly. She had been the witness of it all—from her earliest childhood to the moment when the unhappy woman had died with her eyes fixed on her husband’s implacable face, but holding fast to her daughter’s hand, as though she wanted to carry the pressure of those loving fingers into the grave.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("A clock on the mantel-piece ticked loudly. But it was the only sound which disturbed the quietness of the room. The representatives of the family eyed one another with guarded indifference. Circumstances had kept them apart for many years, and they now met almost as strangers.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mrs. Pendleton sat on a sofa with her husband. She was a notable outline of a woman, large and massive, with a shrewd capable face and a middle-class mind. She lived, when at home, in the rarefied atmosphere of Golders Green, in a red house with a red-tiled roof, one of a streetful similarly afflicted, where she kept two maids and had a weekly reception day. She was childless, but she disdained to carry a pet dog as compensation for barrenness. Her husband was a meagre shrimp of a stockbroker under his wife’s control, who golfed on Sundays and played auction bridge at his club twice a week with cyclic regularity. He and his wife had little in common except the habit of living together, which had made them acquainted with each other’s ways.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mrs. Pendleton had not seen either of her brothers for a long time. Robert had been too engrossed in digging into the past for the skeletons of his ancestors to do more than write intermittent letters to the living members of his family, acquainting them with the progress of his search. Austin Turold, Robert’s younger brother, had spent a portion of his life in India and had but recently returned. He had gone there more than twenty years before to fill a Government post, taking with him his young wife, but leaving his son at school in England for some years. His wife had languished and died beneath an Indian sun, but her husband had become acclimatized, and remained until his time was up and he was free to return to England with a pension. His sister and he met on the previous day for the first time since he had left England for India, and Mrs. Pendleton had some difficulty in identifying the elderly and testy Anglo-Indian with the handsome young brother who had bade her farewell so many years before. And, she had even more difficulty in recognizing the fair-haired little boy of that time in the good-looking but rather moody-faced young man who at the present moment was seated near the window, staring out of it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The fifth member of the party was Dr. Ravenshaw, who practised in the churchtown where Mrs. Turold had been buried, and had attended her in her illness.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("But he had not been asked to share in the family council on that account. His presence was due to his intimacy with Robert Turold, which had commenced soon after the latter’s arrival in Cornwall. The claimant for a title had found in the churchtown doctor an antiquarian after his own heart, whose wide knowledge of Cornish antiquities had assisted in the discovery of the last piece of evidence necessary to establish his claim.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Dr. Ravenshaw sat a little apart from the other, a thickset grey figure of a man, with eyes reddened as though by excessive reading, and usually protected by glasses, which just then he had removed in order to polish them with his handkerchief. In age he was sixty or more. His thick grey beard was mingled with white, and the heavy moustache which drooped over his mouth was quite white. He presented a common-place figure in his rough worn tweeds and heavy boots, but he was a man of intelligence in spite of his unassuming exterior. He lived alone, cared for by a single servant, and he covered on foot a scattered practice among the fishing population of that part of the coast. His knowledge of Cornish antiquities and heraldic lore had won him the confidence of Robert Turold, and his kindness to Mrs. Turold in her illness had gained him the gratitude of her daughter Sisily.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It was Austin Turold who caused a diversion in this group of lay figures by walking to the table and helping himself to a whisky-and-soda. Austin bore very little resemblance to his grim and dominant elder brother. He had a slight frail figure, very carefully dressed, and one of those thin-lipped faces which seem, to wear a perpetual sneer of superiority over commoner humanity. The movements of his white hands, the inflection of his voice, the double eyeglass which dangled from his vest by a ribbon of black silk, revealed the type of human being which considers itself something rarer and finer than its fellows. The thin face, narrow white forehead, and high-bridged nose might have belonged to an Oxford don or fashionable preacher, but, apart from these features, Austin Turold had nothing in common with such earnest souls. By temperament he was a dilettante and cynic, who affected not to take life seriously. His axiom of faith was that a good liver was the one thing in life worth having, and a far more potent factor in human affairs than conscience. He had at one time regarded his brother Robert as a fool and visionary, but had seen fit to change that opinion latterly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He paused in the act of raising his glass to his lips, and looked over the silent company as though seeking a convivial companion. His son was still staring out of the window. The little stockbroker, seated on the sofa beside his large wife, made a deprecating movement of his eyebrows, as though entreating not to be asked. Austin’s cold glance roved to Dr. Ravenshaw.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Doctor,” he said, “let me give you a whisky-and-soda.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Doctor Ravenshaw shook his head. “I have a patient to visit before dark,” he said, “a lady. I do not care to carry the smell of spirits into a sick-room.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“But this is a special occasion, Ravenshaw,” persisted the other. “We do not restore a title every day.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Austin!” The voice of Mrs. Pendleton sounded from the sofa in shocked protest.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What’s the matter?” said Austin, pausing in the act of pouring some whisky into a glass.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It would be exceedingly improper to drink a toast at such a moment.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What’s the matter with the moment?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“The day, then. Just when we have buried poor Alice.” Mrs. Pendleton had not seen her brother’s wife for ten years before her death, but she had no difficulty in bringing tears to her eyes at the recollection of her. She dried her eyes with her handkerchief, and added in a different tone: “I fancy Robert is coming.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("A heavy step was heard descending the stairs. Austin drained his glass, and Dr. Ravenshaw adjusted his spectacles as Robert Turold entered the room.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-4"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v("Chapter III")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("With parchments and papers deep on the table before him, Robert Turold plunged into the history of his life’s task. The long hand of the mantelpiece clock slipped with a stealthy movement past the twelve as he commenced, as though determined not to be taken by surprise, but to keep abreast of him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("An hour passed, but Robert Turold kept steadily on. His hearers displayed symptoms of boredom like people detained in church beyond the usual time. Humanity is interested in achievement, but not in the manner of its accomplishment. And Robert’s brother and sister knew much of his story by heart. It had formed the sole theme of his letters to them for many years past. Mrs. Pendleton’s thoughts wandered to afternoon tea. Her husband nodded with closed eyes, and recovered himself with convulsive starts. Austin Turold fixed his glance on the ceiling, where a solitary fly was cleaning its wings with its legs. From the window Charles Turold presented an immobile profile. Only Dr. Ravenshaw seemed to listen with an interest which never flagged.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Yet it was a story well worth hearing, that record of indomitable pertinacity which had refused to be baulked by years or rebuffs. Men have acquired titles more easily. That was apparent as Robert Turold related the history of his long and patient investigation; of scents which had led nowhere; of threads which had broken in his hand; of fruitless burrowings into the graves of past generations. These disappointments had lengthened the search, but they had never baffled the searcher nor broken his faith.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The story began in the fourteenth century, when the second Edward had summoned his trusty retainer Robert Turrald from his quiet home in leafy Buckinghamshire to sit in Parliament as a baron, and by that act of kingly grace ennobled him and his heirs forever. Successive holders of the title were summoned to Parliament in their turn until the reign of the seventh Henry, when one succeeded whose wife brought him three daughters, but no sons. At his death the title went into abeyance among this plurality of girls. In peerage law they were his coheirs, and the inheritance could not descend because not one of them had an exclusive right to it. The daughters entered a convent and followed their parents to the grave within a few years, the Crown resumed the estate, and the title had remained in abeyance ever since.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("But the last Lord Turrald had a brother Simon, a roystering blade and lawless adventurer, who disappeared some years before his elder brother’s death. Little was known of him except that he was supposed to have closed a brawling career on the field of Bosworth, when Richard the Crookback was killed and the short-lived dynasty of York ended.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The Turolds’ family deed-box told a different story. There was a manuscript in monkish hand, setting forth, “in the name of God, Amen,” the secret history of Simon, as divulged by him on his deathbed for the information of his two sons. In this confession he claimed kinship with the last Lord Turrald of Great Missenden. But he had not dared to claim the title and rich estates on his brother’s death, because he was a proscribed man. He had been a Yorkist, and had fought for Richard. That might have been forgiven him if he had not unhorsed his future king at Bosworth and almost succeeded in slaughtering him with his own reckless hands. So he had fled, and had remained in obscurity and a safe hiding-place after his brother’s death, preferring his head without a title to a title without a head.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("On this document, unsigned and undated, with nothing to indicate the place of its origin, the Turold family based its claim of descent from the baronial Turralds of Great Missenden. But the Turold history was a chequered one. Their branch was nomadic, without territorial ties or wealth, without continuance of chronology. They could not trace their own genealogy back for two hundred years. There was a great gap of missing generations which had never been filled in. It was not even known how the document had come into their possession. Simon’s two sons and their descendants had vanished into unknown graves, leaving no trace. But the family clung fast to their belief that they were the lineal descendants of the Turralds of Buckinghamshire.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It had remained for Robert Turold to prove it. His father and grandfather had bragged of it, had fabricated family trees over their cups, and glowed with pride over their noble blood, but had let it go at that. Robert was a man of different mould. In his hands, the slender supposition had been turned into certainty. By immense labour and research he built a bridge from the first Turold of whom any record existed, backwards across the dark gap of the past. He traced the wanderings of his ancestors through different generations and different counties to Robert Turold, who established himself in Suffolk forty years after the last Lord Turrald was laid to rest in his family vault in the village church of Great Missenden.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The construction of this portion of his family tree occupied Robert Turold for ten years. There were scattered records to be collected, forgotten wills to be sought in county offices, parochial registers to be searched for births and deaths. A nomadic family has no traditions; Robert Turold had to trace his back to the darkness of the Middle Ages. It was a notable feat to trace the wanderings of an obscure family back so far as he did, but even then he seemed as far away from the attainment of his desire as ever. There remained a gap of forty years. To establish his claim to the title he had to prove that the Turolds sprang from the younger brother of the last Lord Turrald, who had allowed the title to lapse for fear of losing his head if he came forward to claim it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It did not seem a great gap to bridge after following a wandering scent through four centuries, but the paltry forty years almost beat Robert Turold, and cost him five years additional search. It was a lucky chance, no more, which finally led him to Cornwall, but it was the hand of Providence (he said so) which directed his footsteps to the churchtown in which Dr. Ravenshaw lived. It was there he discovered the connecting link in the signature of a single witness on a noble charter which granted to the monks of St. Nicholas “all wreck of sea which might happen in the Scilly Isles except whales.” To the eye of Robert Turold’s faith the illegible scrawl on this faded scroll formed the magic name of Simon Turrald.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("For once, faith was justified by its works. The signature was indeed Simon Turrald’s; not the younger brother of the last Lord Turrald, but Simon’s son.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Bit by bit, Robert Turold succeeded in fitting together the last pieces of the puzzle which had eluded him for so long. Simon Turrald, the brother, had fled to Cornwall, where he had married a Cornishwoman who had brought him two sons. The elder, Simon, had taken religious vows, and established a priory at St. Fair, a branch of the great priory of St. Germain. The holy fathers of the order had long since vanished from this earth to reap the reward of their goodness (it is to be hoped) in another world, but the remains of the priory still stood on a barren headland near Cape Cornwall. And there was a tomb in St. Fair church, behind the altar, marked by a blue slab, with an indent formerly filled by a recumbent figure. On the blue slab was a partly obliterated inscription in monkish Latin, which yielded its secret to him, and divulged that the remains beneath were those of Father Simon of St. Fair.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("With this important discovery to help him, Robert Turold had very little difficulty in completing the particulars of the family genealogy. Further search of the churchtown records brought to light that Simon’s other son, Robert, left Cornwall as a young man, and after some years of wandering had settled in Suffolk. Father Simon, of course, died without family, but Robert married, the family name came to be spelt “Turold,” and thus was founded that branch of the family of which the last Robert Turold was now the head. The family tree was complete.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Such was the substance of Robert Turold’s life quest, and the story had occupied two hours in telling.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I have petitioned the King’s most excellent majesty to terminate the abeyance in my favour and declare that I am entitled to the peerage,” he concluded. “I have no doubt that my claim will be admitted. I have set out the facts with great care, and in considerable detail. I have traced a clear line of descent back to Simon Turrald, younger brother of the last baron, and there are no coheirs in existence. Ours is the last surviving branch, or it would, perhaps, be better if I said that Austin and myself, and Austin’s son, are the only male members of the family. It is a difficult matter to give effectual proof of a long pedigree, but my lawyer has not the least doubt that the House of Lords will admit the validity of my claim, and will terminate the abeyance in my favour. The Attorney General has inspected my proofs, and I am to appear before the Committee for Privileges next week. In a few weeks at the outside, allowing for the worst of law’s delays, I shall be Lord Turrald.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Robert Turold’s whole bearing was transfigured as he made this announcement. His sound eye gleamed, his shrunken form seemed to expand and fill, and his harsh sallow features took on an expression which was almost ecstatic. It was his great moment, the moment for which he had lived for twenty years, and it compensated him for all his worry, delayed expectation, fruitless labour, and the bitter taste of the waters of despair.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I shall be Turrald of Great Missenden,” he said, and again the expression of his face showed what the words meant to him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Bob! So you’ve actually succeeded after all!” Mrs. Pendleton stepped quickly across to her brother as he sat regarding his audience from behind his pile of documents. It was like a sister, at that moment, to slip back to the juvenile name and kiss his elderly face with tears in her eyes. Robert Turold received the caress unmoved, and she went back to the sofa.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Lord Turrald! It sounds well,” murmured her husband, whose ideas were sufficiently democratic to give him a sneaking admiration for a title. He gazed at his brother-in-law with a new respect, discerning unsuspected indications of noble blood in his grim visage.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“How do you account for the two forms of spelling your family name?” observed Dr. Ravenshaw. “The House of Lords will require proof on that point, will they not?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I shall be able to satisfy them,” returned Robert Turold. “The first Robert Turold reverted to the Norman spelling when he settled in Suffolk. Turrald is the corrupted form, doubtless due to early Saxon difficulties with Norman names. The Saxons were never very glib at Norman-French, and there was no standardized spelling of family names at that period.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It would be interesting to know how the name of Simon came to be bestowed upon the Simon Turrald who fled to Cornwall after Bosworth. The name is Biblical—not Norman. The Normans were pagan, worshipping Woden and Thor, though supposed to be Christianized after Charles the Simple ceded Neustria to Rollo.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Simon was a good mediaeval name in France and was fairly common in England from the twelfth century until after the Reformation. It was Norman, as being that of an apostle, and was never popular among the Puritans.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It seems a pity that you cannot claim the Turrald estates,” put in Austin. “They must have been immensely wealthy.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It is quite out of the question,” replied Robert decisively. “They have been alienated for centuries. But it has been part of my life’s work to provide for the upkeep of the title when I gained it. I shall be able to ensure my heirs an income of nearly eight thousand pounds a year.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It was Mrs. Pendleton’s first intimation of the amount of the fortune her brother had gained abroad. “Eight thousand a year!” she exclaimed. “Oh, Robert, it is wealth.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“One could live very comfortably on eight thousand a year,” remarked her husband, “very comfortably indeed.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It’s not much to support a title, after the tax-gatherers have taken their pound of flesh in income tax and super-tax,” said Austin. “Robert, with his iron frame, will probably outlive a weakling like myself, but if he doesn’t I’m sure I shall find it difficult to keep up the title on the money.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“One word!” said Dr. Ravenshaw, with a quick glance at Robert Turold. “This is a barony by writ that you are claiming. Does not your daughter succeed you if you gain it, and not your brother?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No,” replied Robert Turold. “The next holder of the title, after me, will be my brother, and his son will succeed him.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Little Mr. Pendleton looked questioningly at his brother-in-law.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“A similar question was on my lips,” he said hesitatingly. “I know very little of such matters, but in view of our family’s probable entry into the ranks of the old nobility I have deemed it my duty to make myself acquainted, to some extent, with the history of the Turrald title and peerage law. It seems a very complicated business—peerage law, I mean—in the case of baronies by writ, but I certainly gathered the impression that a sole daughter can succeed, although several daughters are regarded as coheirs.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“My daughter cannot succeed to the Turrald title,” rejoined Robert Turold. The words seemed to be wrung out of him reluctantly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It is not for me to question your knowledge—your great knowledge—of English peerage law, Robert,” pursued Mr. Pendleton with a kind of timid persistence. “But I brought a book down with me in the train in which I remember reading that the right of a single daughter to succeed to a barony by writ had been well established by the Clifton case and several others. I am not precisely aware what the Clifton case is, but I’ve no doubt that you are well versed in the particulars of it. As you have no son your daughter has priority of claim over your brother and his son. From what you say I can see that I must be quite wrong, but I’d be glad if you would explain to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You have stated the law accurately enough,” said Robert Turold, “but my daughter does not succeed to the title.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Embarrassment, perceptible as a cloud, deepened on Robert Turold’s face. He regained his self-control with an effort.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“There was an informality in my marriage,” said he at last. “My daughter’s birth was irregular.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Do you mean that she is illegitimate?” asked Dr. Ravenshaw.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Robert Turold inclined his head. “Yes,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("At this admission his sister bounced from the sofa with a startled cry. “So that was why there was no name plate on the coffin,” she exclaimed. “Oh, Robert, what a terrible thing—what a disgrace!”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Spare me your protests until you have heard the explanation,” Robert coldly rejoined. “She”—he pointed a hand in the direction of the churchyard—“was married before she met me. She kept the fact from me. It was apparently a secret passage in her life. During our long association together she gave no hint of it. She confessed the truth on her deathbed. In justice to her memory let me say that she believed her husband dead.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Robert Turold told this with unmoved face in barest outline—etched in dry-point, as it were—leaving his hearers to fill in the picture of the unhappy woman who had gone through life tormented by the twin demons of conscience and fear, which had overtaken her and brought her down before she could reach the safe shelter of the grave.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mrs. Pendleton, whose robust mind had scant patience with the policy of cowardice which dictates death-bed confessions, regretted that Alice, having remained silent so long, had not kept silence altogether.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You do not intend to make this scandal public, Robert?” she said anxiously.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I am compelled to do so,” was the gloomy response.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Is it necessary?” she pleaded. “Cannot the story be kept quiet—if not for Alice’s sake, at least for Sisily’s? You must consider her above all things. She is your daughter, your only child.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I agree with Aunt,” said Charles Turold. He rose from the window-seat and approached the table. “Sisily must be your first consideration,” he said, looking at Robert Turold.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“This has nothing to do with you, Charles,” interposed Austin hastily.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I think it has,” said his son. “You told me nothing about this, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I was not aware of it myself,” replied his father.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Now that I know, I shall have nothing further to do with this,” continued the young man. “I’m not going to help you wrong Sisily.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I hardly expected such lofty moral sentiments from you,” said Austin, with a dark glance.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("His son flushed as though there was a hidden sting behind the jibe. He appeared to be about to say something more, but checked himself, and went back to his seat by the window.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Is there no way of keeping this matter quiet, Robert?” said his sister imploringly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I see none,” was the rejoinder. “It is a very painful disclosure, but I think it is inevitable. Do you not agree with me, Austin?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Do not ask my opinion,” his brother coldly replied. “It is for you to decide.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Robert Turold paused irresolutely. “What do you say, Ravenshaw?” he said, glancing round at the silent figure of the doctor. “I asked you to be present this afternoon to have the benefit of your advice. I owe much to you, so I beg you to speak freely.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Since you have asked my advice,” said Dr. Ravenshaw gravely, “I say that I entirely agree with Mrs. Pendleton. Your first duty is to Sisily. She should out-weigh all other considerations. If you make her illegitimacy public you may live to be sorry for having done so.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mrs. Pendleton cast a moist, grateful glance at the speaker, but Austin Turold turned on him a look of cold hostility.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Robert Turold sat brooding for a few moments in silence. He had asked advice, but his own mind was made up. The humane views of his sister and Dr. Ravenshaw were powerless to affect his decision. The monstrous growth of his single purpose had long since strangled such transient plants as human affection and feeling in his heart and mind.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“The facts must be made public,” he said inexorably. “The honour of a noble family is in my hands, and I must do my duty. It would be an insult to my Sovereign and my peers, and a grievous wrong to our family, if I concealed any portion of the truth. I shall make adequate provision for Sisily. You will not refuse to take charge of her, Constance, because of this disclosure?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You ought to know me better than that, Robert. She’ll need somebody to take care of her, poor child! But who is to tell her the truth? For I suppose she must be told?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I want you to tell her,” said Robert Turold. “Choose your time. There is no immediate hurry, but she must be in no false hopes about the future. She had better be told before the Investigations Committee meets.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Bother the Investigations Committee!” exclaimed Mrs. Pendleton. “Really, Robert—”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mrs. Pendleton broke off abruptly, in something like dismay. She had a fleeting impression of a pair of eyes encountering her own through a crack in the doorway, and as swiftly withdrawn. She walked quickly to the door and flung it open. There was nobody outside, and the passage was empty.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“We have been talking family secrets with the door open,” she said, returning to her seat. “I thought I saw one of the servants eavesdropping.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“My servants would not listen at doors,” said Robert Turold coldly. “You must have imagined it.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mrs. Pendleton made no rejoinder. She had a strong belief that someone had been watching and listening, but she could not be sure.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“We must really be going,” she announced, with a glance at the clock. “Joseph”—such was her husband’s name—“you had better go and see if the car is ready, and I will go for Sisily. Is she upstairs in her room, Robert?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I believe so,” said Robert Turold, bending abstractedly over his papers. “But you had better ask Thalassa. He’ll tell you. Thalassa will know.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mrs. Pendleton looked angrily at him, but was wise enough to forbear from further speech. She instinctively realized that her brother was beyond argument or reproof.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She went upstairs to look for her niece, but she was not in her room. She came downstairs again and proceeded to the kitchen. Through the half-open door she saw the elderly male servant, and she entered briskly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Can you tell me where Miss Sisily is, Thalassa?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Miss Sisily is out on the cliffs.” Thalassa, busy chopping suet with a knife, made answer without looking up. There was something absurdly incongruous between the mild domestic occupation and the grim warrior face bent over it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“When did she go out?” asked Mrs. Pendleton, struck by a sudden thought.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa threw a swift sidelong glance at her. “It might be an hour ago,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Do you know where I am likely to find her?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa pointed vaguely through an open window.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Somewhere along there,” he said. “Miss Sisily is fond of the cliffs. If you’re going to look for her you’d best not go round by the back of the house, or you’ll fall over, like as not. It’s a savage spot, only fit for savages—or madmen.” He turned his back and bent over his chopping board again.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mrs. Pendleton turned away in perplexity, and walked up the passage to the front door. There her eye fell on the figure of Charles Turold, lounging moodily over the gate, smoking a cigarette.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She walked down the flinty path and touched his arm. “Would you mind going and looking for Sisily?” she said. “She is out on the cliffs, Thalassa says.” She pointed a hand in the direction she supposed the girl to be.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("The young man’s moodiness vanished in eager alacrity. “Certainly,” he replied. “I’ll go with pleasure.” He tossed away his cigarette and disappeared around the side of the house.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-5"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _vm._v("Chapter IV")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("Sisily first opened her eyes on a grey day by a grim coast, and life had always been grim and grey to her. Her memory was a blurred record of wanderings from place to place in pursuit of something which was never to be found. Her earliest recollection was of a bleak eastern coast, where Robert Turold had spent long years in a losing game of patience with the sea. He had gone there in the belief that some of his ancestors were buried in a forgotten churchyard on the cliffs, and he spent his time attempting to decipher inscriptions which had been obliterated almost as effectually as the dead whose remains they extolled.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The old churchyard had been called “The Garden of Rest” by some sentimental versifier, but there was no rest for the dead who tried to sleep within its broken walls. The sea kept undermining the crumbling cliffs upon which it stood, carrying away earth, and tombstones, and bones. Nor was it a garden. Nothing grew in the dank air but crawling things which were horrible to the eye. There were great rank growths of toadstools, yellow, blue, livid white, or spotted like adders, which squirmed and squelched underfoot to send up a sickly odour of decay. The only green thing was some ivy, a parasitic vampire which drew its lifeblood from the mouldering corpse of an old church.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It was in this desolate place that the girl conceived her first impression of her father as a stern and silent man who burrowed among old graves like a mole. Robert Turold had fought a stout battle for the secret contained in those forgotten graves on a bleak headland, but the sea had beaten him in the long run, carrying off the stones piecemeal until only one remained, a sturdy pillar of granite which marked the bones of one who, some hundred and fifty years before had been “An English Gentleman and a Christian”—so much of the epitaph remained. Robert Turold hoped that it was an ancestor, but he was not destined to know. One night the stone was carried off with a great splash which was heard far, and left a ragged gap in the cliffside, like a tooth plucked from a giant’s mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("When Sisily first saw the cliffs of Cornwall she was reminded of those early days, with the difference that the Cornish granite rocks stood firm, as though saying to the sea, “Here rises England.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The house Robert Turold had taken looked down on the sea from the summit. It was a strange place to build a house, on the brink of a broken Cornish cliffline, above the grey surges of the Atlantic, among a wilderness of dark rocks, facing black moors, which rolled away from the cliffs as lonely and desolate as eternity. The place had been built by a London artist, long since dead, who had lived there and painted seascapes from an upstairs studio which overlooked the sea.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The house had remained empty for years until Robert Turold had taken it six months before. It was too isolated and lonely to gain a permanent tenant, and it stood in the teeth of Atlantic gales. The few scattered houses and farms of the moors cringed from the wind in sheltered depressions, but Flint House faced its everlasting fury on the top of the cliffs, a rugged edifice of grey stone, a landmark visible for many miles.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The house suited Robert Turold well enough, because it was near the churchtown in which he was conducting his final investigations. It never occurred to him to consider whether it suited his wife and daughter. It was a house, and it was furnished; what more was necessary? It was nothing to him if his wife and daughter were unhappy. It was nothing to him if the sea roared and the house shook as he sat poring at nights over his parchments in the dead artist’s studio. He had other things to occupy his mind than Nature’s brutality or the feelings of womanhood.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Sisily had climbed down to the foot of the rocks. She was sitting in her favourite spot, a spur of rock overhanging a green nook in the broken ugliness of the cliffs, sheltered from the sea by an encircling arm of rock, and reached by a steep path down the cliff. Around her towered an amphitheatre of vast cliffs in which the sea sang loud music to the spirit of solitude. In the moaning waters in front of the cove a jagged rock rose from the incomparable green, tilted backward and fantastically shaped, like a great grave face watching the house on the summit of the cliff.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The rock had fascinated the girl from the first moment she had seen it. In the summer months, tourists came from afar to gaze on its fancied resemblance to one of the illustrious dead. But to Sisily there was a secret brooding consciousness in the dark mask. It seemed to her to be watching and waiting for something. For what? Its glance seemed to follow her like the eyes of a picture. And it conveyed a menace by its mere proximity, even when she could not see it. When she looked out of her window at night, and saw only the shadow of the rock with the face veiled in darkness, she seemed to hear the whisper of its words: “I am here. Do not think to escape. I will have you yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Among the fisher-folk of that part of the coast it was known as the Moon Rock. The old Cornish women had a tradition that when a fishing-boat failed to return to that bay of storms, the spirit of the drowned man would rise to the surface and answer his wife if she hailed him from the shore. It was a rite and solemn ceremony, now fallen into decay. There was a story of one young wife who, getting no answer, left her desolate cottage at midnight and swam out to the Moon Rock at high tide. She had scrambled up its slippery sides and called her husband from the summit. She had called and called his name until he came. In the morning they were found—the wife, and the husband who had been called from the depth of the sea, floating together in one of the sea caverns at the base of the Moon Rock, their white faces tangled in the red seaweed which streaked the green surging water like blood.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Sisily knew this story, and believed it to be true. Sometimes, when the moon lingered on the black glistening surface of the Moon Rock, she fancied she could see a misty fluttering figure on the rock, and hear it calling . . . calling. She would sit motionless at her window, straining her ears for the reply. After a time the response would come faintly from the sea, at first far out, then sounding louder and clearer as the spirit of the husband guided his drowned body back to his wife’s arms. When it sounded close to the rock the evanescent figure on the summit would vanish to join the spirit of her husband in the churning waters at the base. Then the face of the Moon Rock seemed to smile, and the smile was so cruel that Sisily would turn from the window with a shudder, covering her face with her hands.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Her strange upbringing may have contributed to such morbid fancies. In his monstrous preoccupation with a single idea Robert Turold had neglected his duty to his daughter. She counted for nothing in his scheme of life, and there were periods when he seemed to be unconscious of her existence. She had been allowed to grow up with very little education or training. She had passed her childhood and girlhood in remote parts of England, without companions, and nobody to talk to except her mother and Thalassa, who accompanied the family everywhere. She loved her mother, but her love was embittered by her helplessness to mitigate her mother’s unhappy lot. Thalassa was a savage old pagan whose habitual watchful secretiveness relaxed into roaring melody in his occasional cups; in neither aspect could he be considered a suitable companion for the budding mind of a girl, but he loomed in her thoughts as a figure of greater import than her father or mother. Her father was a gloomy recluse, her mother was crushed and broken in spirit. Thalassa had been the practical head of the house ever since Sisily could remember anything, an autocrat who managed the domestic economy of their strange household in his own way, and brooked no interference. “Ask Thalassa—Thalassa will know,” was Robert Turold’s unvarying formula when anybody attempted to fix upon him his responsibility as head of the house. Sometimes Sisily was under the impression that her father for some reason or other, feared Thalassa. She could recall a chance collision, witnessed unseen, through a half-open door. There had been loud voices, and she had seen a fiery threatening eye—Thalassa’s—and her; father’s moody averted face.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("From a child she had developed in her own way, as wild and wayward as the gulls which swooped around the rocks where she was sitting. Nature revealed her heart to her in long solitary walks by sea and fen. But of the world of men and women Sisily knew nothing whatever. The secrets of the huddle of civilization are not to be gathered from books or solitude. Sisily was completely unsophisticated in the ways of the world, and her deep passionate temperament was full of latent capacity for good or evil, for her soul’s salvation or shipwreck. Because of her upbringing and temperament she was not the girl to count the cost in anything she did. She was a being of impulse who had never learnt restraint, who would act first and think afterwards.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Her dislike of her father was instinctive, almost impersonal, being based, indeed, on his treatment of her mother rather than on any resentment of his neglect of herself. But Robert Turold had never been able to intimidate his daughter or tame her fearless spirit. She had inherited too much of his own nature for that.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("At that moment she was sitting motionless, immersed in thought, her chin on her hand, looking across the water to the horizon, where the Scilly Islands shimmered and disappeared in a grey, melting mist. She did not hear the sound of Charles Turold’s footsteps, descending the cliff path in search of her.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The young man stood still for a moment admiring her exquisite features in their soft contour and delicate colouring. He pictured her to himself as a white wildflower in a grey wilderness. He could not see himself as an exotic growth in that rugged setting—a rather dandified young man in a well-cut suit, with an expression at once restless and bored on his good-looking face.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He scrambled down the last few slippery yards of the path and had almost reached her side before she saw him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I have been sent for you,” he explained. “I knew I should find you here.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She got up immediately from the rock where she had been sitting, and they stood for a moment in silence. She thought by his look that he had something to say to her, but as he did not speak she commenced the ascent of the stiff cliff path. He started after her, but the climb took all his attention, and she was soon far ahead. When he reached the top she was standing near the edge looking around her.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“This is my last look,” she said as he reached her side. Her hand indicated the line of savage cliffs, the tossing sea, the screaming birds, the moors beyond the rocks.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Perhaps you will come back here again some day,” he replied.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She made no answer. He drew closer, so close that she shrank back and turned away.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I must go now,” she hurriedly said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Stay, Sisily,” he said. “I want to speak to you. It may be the final opportunity—the last time we shall be alone together here.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She hesitated, walking with slower steps and then stopping. As he did not speak she broke the silence in a low tone—")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What do you wish to say to me?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Are you sorry you are leaving Cornwall?” he hesitatingly began.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She made a slight indifferent gesture. “Yes, but it does not matter. Mother is dead, and my father does not care for me.” She flushed a deep red and hastily added, “No one will miss me. I am so alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You are not alone!” he impetuously exclaimed—“I love you, Sisily—that is what I wished to say. I came here to tell you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He caught a swift fleeting glance from her dark eyes, immediately veiled.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Do you really mean what you say?” she replied, a little unsteadily.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yes, Sisily. I have loved you ever since I first met you,” he replied. “And, since then, I have loved you more and more.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Oh, why have you told me this now?” she exclaimed. “You think I am lonely, and you are sorry for me. I cannot stay longer. Aunt will be waiting for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He sprang before her in the narrow path.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You must hear what I have to say before you go,” he said curtly. “We are not likely to meet again for some time if we part now. I intend to leave England.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She looked at him at those words, but he was at a loss to divine the meaning of the look.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You are leaving England?” A quick ear would have caught a strange note in her soft voice. “Oh, but you cannot—you have responsibilities.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Are you thinking of the title, and your father’s money?” he observed, glancing at her curiously. “What do you know about it, Sisily?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I have heard of nothing but the title ever since I can remember,” she replied.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I learnt for the first time this afternoon that I was brought down here to rob you,” he said gloomily.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I am glad for your sake if you are to have it—the money,” she simply replied.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He answered with a bitter, almost vengeful aspect.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I would not take the money or the title, if they ever came to me. They should be yours. I will show them. I will let them know that they cannot do what they like with me.” He brought out this obscure threat in a savage voice. “If I had only known—if I had guessed that your father—” He ceased abruptly, with a covert glance, like one fearing he had said too much.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She kept her eyes fixed on the lengthening shadows around the rocks.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Do not take it so much to heart,” she timidly counselled. “It is nothing to me—the title or the money. They made my mother’s life a misery. My father was always cruel to her because of them, I do not know why. It is in his nature to be cruel, I think. He has a heart of granite, like these rocks. I hate him!” She brought out the last words in a sudden burst of passion which startled him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What nonsense it all is!” he exclaimed, suddenly changing his tone. “All this talk about a title which may never be revived. Let them have it between them, and the money too. Sisily, I love you, dear, love you better than all the titles and money in the world. I am not worthy of you, but I will try to be. Let us go Sway and start life . . . just our two selves.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I cannot.” She stood in front of him with downcast gaze, and then raised her eyes to his.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Had he been as experienced in the ways of her sex as he believed himself to be, he would have read more in her elusive glance than her words.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You may be sorry if you do not,” he said, with a sudden access of male brutality. “There are reasons—reasons I cannot explain to you—”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Even if there are I cannot do what you ask,” she replied. Her face was still averted, but her voice was steady.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Then do you want to go with Aunt to London?” he persisted, trying to catch a glimpse of her hidden face.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She shook her head.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Or to stay with your father?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No!” There was a strange intense note in the brief word.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Then come with me, Sisily. I love you more than all the world. We have nobody to please except our two selves.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You have your duty to your father to consider.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Let us leave him out of the question,” said the young man hurriedly. “He is as selfish and heartless as—his brother. I tell you again, I’ll have nothing to do with this title or your father’s money. I will make my own way with you by my side. I have a friend in London who would be only too glad to receive you until we could be married. You are leaving your home to-night, and you are as free as air to choose. Will you come?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Of course,” he began again, in a different tone, as she still kept silent, “it may be that I have misunderstood. I thought that you had learnt to care for me. But if you dislike me—”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Do not say that,” she replied, turning a deeply wounded face towards him. “It is not that—do not think so. You have been kind and good to me, and I—I shall never forget you. But I—I have a contempt for myself.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I have a contempt for myself also after this afternoon,” he retorted. “Come, Sisily—”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No, it is impossible. Hark, what was that?” The girl spoke with a sudden uplifting of her head. Above them, from the direction of the house, the sound of a voice was heard.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It is Aunt calling me,” she said, “I must go. Good-bye.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Is it good-bye, then?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It must be. But I shall often think of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He had the unforgettable sensation of two soft burning lips touching the hand which hung at his side, and turned swiftly—but too late. She was speeding along the rocky pathway which led to the house.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Wait, Sisily!” he cried.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("A seabird’s mournful cry was the only answer. He glanced irresolutely towards the path, and then retraced his steps towards the edge of the cliffs.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("A cold sun dipped suddenly, as though pulled down by a stealthy invisible hand. The twilight deepened, and in the lengthening shadows the rocks assumed crouching menacing shapes which seemed to watch the solitary figure standing near the edge, lost in thought.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-6"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  }), _vm._v("Chapter V")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("Through the flowers on the hotel dining-table Mrs. Pendleton was able to watch her niece unnoticed, because the flowers occupied such an unreasonably large space on the little round table set for three. Besides, Sisily had been engrossed in her own thoughts throughout the meal. Mrs. Pendleton was disturbed by her quietness. There was something unnatural about it—something not girlish. She had not spoken once during the drive from Flint House to Penzance, and she sat through dinner with a still white face, silent, and hardly eating anything.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mrs. Pendleton supposed Sisily was fretting over her mother, but she did not understand a girl whose grief took the form of silence and stillness. She would have preferred a niece who would have sobbed out her grief on her shoulder, been reasonably comforted, and eaten a good dinner afterwards. But Sisily was not that kind of girl. She was strange and unapproachable. There was something almost repellent in her reserve, something in her dark preoccupied gaze which made Mrs. Pendleton feel quite nervous, and unfeignedly relieved when Sisily had asked to be allowed to go to her room immediately the meal was concluded.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("As she sat at the table, reviewing the events of the afternoon, after the girl had taken her departure, Mrs. Pendleton regretted that she had consented to take charge of Sisily. She flattered herself that she was sufficiently modern not to care a row of pins for the stigma on the girl’s birth, but there were awkward circumstances, and not the least of them was her own rash promise to break the news to Sisily that she was illegitimate. That disclosure was not likely to help their future relations together. Mrs. Pendleton reflected that she knew very little about her niece, whom she had not seen since she was a small girl, but the recollection of her set face and tragic eyes at the dinner table impelled prompt recognition of the fact that she was going to be difficult to manage.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("But there was more than that. With a feeling of dismay Mrs. Pendleton’s mind awoke to a belated realization of the scandal which would fasten on Sisily and her birth if Robert succeeded in establishing his claim to the title. A peer of the realm with an illegitimate, disinherited daughter! The story would be pounced upon by a sensational press, avid for precisely such topics. In imagination Mrs. Pendleton saw the flaming headlines, the photographs, and the highly spiced reports in which every detail of her brother’s private life was laid bare for a million curious eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Such an exposure was too terrible to be faced. Mrs. Pendleton saw her own comfortable life affected by it; saw her position in her small social circle shaken and overwhelmed by the clamour of notoriety. She saw herself the focus of the malicious tea-table gossip of all her friends. Decidedly, it would not do.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She did her brother the justice to realize that he had overlooked the public effect of the disclosure of his painful domestic secret as completely as she had. He had forgotten that his accession to the peerage would make him, as it were, a public figure, and the glamour which the newspapers would throw over his lifelong quest would invest every act of his life with a publicity from which he could not hope to escape. If he had foreseen this, he would have made some other arrangement for his daughter’s future, not for the girl’s sake, but for the honour of the famous old name of which he was so fanatically proud.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The question remained, what was to be done? Robert would have to be told, of course. Mrs. Pendleton’s first impulse was to retract her promise to take charge of Sisily, and wash her hands of the whole affair. Then she thought of the money, and wavered. Robert had made her a generous offer, and the money would have helped so much! She had already planned the spending of the cheque he had given her that afternoon. She had thought of a new suite of drawing-room furniture, and bedroom carpets. She had a vision of a small motor-car, later on.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("As she pondered over the situation she thought she saw a way out—a way so simple and practical that she was astonished that it had not occurred to her before.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mrs. Pendleton was a woman of decision and prompt of action when she made up her mind. Her mind was made up now. She glanced across the table at her husband. “Joseph!” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mr. Pendleton, hidden behind the sheets of a newspaper just arrived from London, had the temerity not to hear. He was in a grumpy mood, arising, in the first instance, from having been dragged away from his business and his club to Cornwall. It was nothing to him that he was in the Land of Lyonesse. His brief impression of the Duchy was that it was all rocks, and that Penzance was a dull town without a proper seafront, swarming with rascally shopkeepers who tried to sell serpentine match-boxes at the price of gold ones, and provided with hotels where dull tourists submitted to a daily diet of Cornish pasties and pollock under the delusion that they were taking in local colour in the process. Mr. Pendleton’s stomach resented his own rash deglutition of these dainties, and in consequence he was suffering too much with acute indigestion to think of the compensation he would gain at next year’s Academy by standing with a bragging knowing air before pictures of the Cornish coast, expatiating to his bored acquaintances (who had never been to Cornwall) on their lack of merit compared with the real thing. Like most husbands, Mr. Pendleton had been able to reach the conclusion that the real cause of his bodily and mental discomfort was his wife, so he maintained a sulky silence behind the pages of his newspaper.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("With that lack of ceremony which the familiarity of marriage engenders in the female breast, his wife leant across the table and plucked the paper from his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Listen to me, Joseph,” she said, “I want to talk to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Lacking the newspaper screen, Mr. Pendleton’s rebellious tendencies instantly evaporated beneath his wife’s searching eye.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yes, my dear,” he replied meekly. “What about?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“About Sisily. Did you notice that she did not speak a word during dinner?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Perhaps she was overcome with grief, my dear.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Nonsense! Grief does not make a woman speechless. She’s one of the dumb sort of girls. I always mistrust a girl who hasn’t plenty to say for herself.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Well, you know, my dear, she has had a strange sort of life. She hasn’t had the educational advantages of other young women”—Mr. Pendleton was going to add “in her station of life,” but a timely recollection of the afternoon’s disclosures caused him to substitute: “with wealthy fathers.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Robert has neglected his duty to her shamefully. I’ve been thinking it all over, and I’m half sorry now that I consented to take charge of her.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Then why do it?” said her husband placidly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It’s the scandal I fear,” rejoined his wife, pursuing her own thought. “There’s bound to be a lot of talk and newspaper publicity when Robert comes into the title. It would be much better to keep this quiet, after all these years. There is really no occasion for it, if Robert will only listen to reason. Robert wishes to avoid future trouble and complications about the succession. That could be arranged by getting Sisily to sign some agreement renouncing all claim on the title.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I doubt if such a document would be legal, my dear,” said her husband dubiously.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That wouldn’t matter in the least,” replied Mrs. Pendleton, with a woman’s contempt for the law. “It would be purely a family arrangement. Sisily could be assured by somebody in whom she has reliance—not her father, of course—that there was some legal reason why she could not succeed. I do not think there would be any trouble with her. She does not look the kind of girl to delight in a title and a lot of money. Robert would have to settle a handsome allowance on the poor child—indeed, it is the very least he can do! If Robert agreed to this course there would be no need to blurt out the brutal truth, and I would take Sisily under my charge.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mr. Pendleton saw several objections to his wife’s plan, but he had long learnt the futility of domestic argument—on the husband’s side at least. “How much do you consider your brother ought to allow Sisily?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Two thousand a year. Robert can well afford it.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Do you think your brother Austin would agree?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Of course he wouldn’t. Austin is horribly selfish. He wouldn’t give Sisily a penny if he had his way, now that he knows the truth. But I don’t intend to consult Austin in the matter. I thought of asking Dr. Ravenshaw to go with me and try and influence Robert. Robert trusts him implicitly, and he seems to have a great deal of influence with him. I feel sure he would do his utmost to bring Robert to listen to reason. Do you not think my plan a good one?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("In the secret depth of his heart Mr. Pendleton did not, but with the moral cowardice of a husband he forebore from saying so. “It might be tried,” he feebly muttered.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Very well, we will try it, then,” said his wife, rising from her seat as she spoke. “Go and order that motor-car we had this afternoon while I get ready.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mr. Pendleton was accustomed to his wife’s energetic way of doing things on the spur of the moment, but he had never become used to it. “Do you intend to go and see your brother to-night?” he said, with an air of surprise.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mr. Pendleton sought for a reason, but could find none. “It’s rather late, isn’t it?” he suggested.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Nonsense!” Mrs. Pendleton glanced at her wrist watch. “It’s not much past eight.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Why not leave it until the morning?” said her husband, with a lingering glance at the cheery glow of the log-fire in the lounge. “It’s a beast of a night to be out. Hark to the wind!”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“If it is to be settled, it must be settled to-night,” said Mrs. Pendleton decisively. “There’ll be no time in the morning for anything, if we are to catch the ten o’clock train for London. Beside, Austin would see us if we went there in daylight, and I do not want him to know anything about it—he would only try and put obstacles in our way.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What about Sisily?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“She will be quite all right in her room. She looked tired out, and needs a good night’s rest. You had better see about the car at once.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mr. Pendleton said no more, and his wife bustled away to put on her outdoor things. When she descended from her room her husband was awaiting her in the lounge, and the head-light of the hired motor-car gleamed in the darkness outside.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("They set out through the narrow uneven streets, which smelt strongly of mackerel and pitch. In a few minutes the car was clear of the town, and running at an increased pace through the gusty darkness of the moors.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer007"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-7"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _vm._v("Chapter VI")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("With a face grimly immobile as the carved head of a heathen god, Thalassa stood at the front door watching the departure of Sisily and her aunt until the car was lost to sight in a dip of the moors. Then with a glance at the leaping water at the foot of the cliffs, grey and mysterious in the gloaming, he turned and went inside the house.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It was his evening duty to prepare the lamps which lighted up the old house on the cliffs. Sisily generally helped him in that tedious duty, but she was gone, and for the future he must do it alone.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The lamps were kept in a little lowbrowed room off the stone kitchen. There Thalassa betook himself. Robert Turold disliked the dark, and a great array of lamps awaited him: large ones for the rooms, small ones for the passages and staircase. Thalassa set to work with a will, filling them with oil, trimming the wicks, and polishing the glasses with a piece of chamois leather.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("As he filled and trimmed and polished he sang to himself an old sea song:")]), _vm._v(" "), _c('p', {
    staticClass: "extract-flush-left-opener"
  }, [_vm._v("“The devil and me, we went away to sea, ")]), _vm._v(" "), _c('p', {
    staticClass: "extract-flush-left-space-after"
  }, [_vm._v("In the old brig ‘Lizbeth-Jane’—”")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("His voice was gruff and harsh, and the melody, such as it was, did nothing to relax his expression, which remained grim and secret as ever.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Each lamp he lit as he finished it, and their gathered strength gushed in a flood of yellow light on his crafty brown face and deep-set eyes. He placed several of the lamps on a tray, carefully lowered the wicks, and carried them to their allotted places, returning for others until only half a dozen small lamps remained. These he gathered on the tray and took upstairs.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Night had fallen; the wind was rising without, and seemed to rustle and whistle in the draughty passages of the old house. Thalassa placed one lamp at the head of the stairs, and others in the niches of the passage, where they flickered feebly and diffused a feeble light. Halfway down the passage he paused before a closed door. It was the room in which Sisily’s mother had died. With an expressionless face he went in and left the last lamp burning dimly on the mantelpiece, like a votary candle on an altar of the dead. Issuing forth again he cast a look around him and walked to Robert Turold’s study at the end of the passage. The door was closed, but he opened it and entered.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Robert Turold was busily engaged writing at a large table by the light of a swinging lamp. He looked up from his papers as Thalassa entered, and thoughtfully watched him as he trimmed the lamp and tended the fire. With these duties completed Thalassa still lingered, as though he expected his master to speak.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What’s the glass like to-night, Thalassa?” remarked Robert Turold absently.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The allusion was to a weather glass which hung in the hall downstairs. As a topic of conversation it was as useful to master and servant as the weather is to most English people. That is to say, it helped them when they were wordbound.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Going down fast,” replied Thalassa.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Then I suppose we are in for another rough night.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“The glass is always going down in Cornwall, and we are always in for another rough night,” responded the servitor curtly. “Are you going to stay much longer in the forsaken hole?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Not much longer,” replied his master in a mild tone.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It is, perhaps, a dreary spot to you, but not to me—no, never to me. The last link in my long search has been found here—hidden away in this little out-of-the-way Cornish place. Think of that, Thalassa! I shall be Lord Turrald.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I don’t see what good it will do you,” retorted the man austerely. “You’ve spent a mint of money over it. I suppose that’s your own affair, though. But what’s to come next? That’s what I want to know.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“When I leave Cornwall—”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You mean we, don’t you?” Thalassa interrupted.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Of course I mean you as well as myself,” Robert Turold replied almost humbly. “I should be sorry to part with you, Thalassa, you must be well aware of that. It is my intention to purchase a portion of the family estate at Great Missenden, which is at present in the market, and spend the remainder of my life in the place which once belonged to my ancestors. That has been the dream of my life, and I shall soon be able to carry it out.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("A silence fell between them upon this statement, and Robert Turold’s eyes turned towards his papers again. But Thalassa stood watching him, as though he had something on his mind still. He brought it out abruptly—")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“And what about your daughter?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“My daughter is going to London with my sister for a prolonged visit,” said Robert Turold hurriedly. “She needs womanly training and other advantages which I, in my preoccupations, have been unable to bestow upon her. It is greatly to her advantage to go.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Robert Turold gave this explanation with averted face, in a tone which sounded almost apologetic. The relative positions between them seemed curiously reversed. It was as though Thalassa were the master, and the other the man.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Oh, that’s it, is it?” Thalassa turned a cautious yet penetrating eye upon his master. “Well, she’s your own daughter, so I suppose you know what’s the best for her.” He spoke indifferently, but there was an odd note in his voice. He picked up his tray, and carelessly added: “For my part I shall be glad to get out of Cornwall. It’s a savage place, only fit for savages and seagulls. There’s the wind rising again.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("A violent gust shook the house, and rattled the window-panes of the room. It was the eyrie in which the deceased artist had painted his pictures, with two large windows which looked over the cliff. Again the gale sprang at the house, and smote the windows with spectral blows. Downstairs, a door slammed sharply.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Damn the wind!” exclaimed Thalassa peevishly. “There’s no keeping it out. I’m going downstairs to lock up now. You’ll have your supper up here, I suppose?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yes. I have a lot of work to do before I go to bed.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa left the room without further speech, and Robert Turold began rummaging among his papers with a hand which trembled slightly. The table was littered with parchments, old books, and some sheets of newly written foolscap. He picked up his pen and plunged it into a brass inkstand, then paused in thought. His face was perturbed and uneasy. It may be that he was reviewing the events of the day, wondering, perhaps, whether he had paid too high a price for the attainment of his ambition. For it he had sacrificed his daughter and the woman who now slept in the churchyard near by, indifferent to it all. Nothing could restore to him the secret he had divulged that afternoon.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("A shade of apprehension deepened on his downcast face. Then he frowned impatiently, and plunged into his writing again.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer008"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-8"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor007"
    }
  }), _vm._v("Chapter VII")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("On leaving his master’s room Thalassa went swiftly downstairs and disappeared into some remote back region of the lonely old house. He had other duties to perform before his day’s work was finished. There was wood to be chopped, coal to be brought in, water to be drawn. Nearly an hour elapsed before he "), _c('br'), _vm._v("reappeared, candle in hand, and entered the kitchen.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("A little woman with a furtive face, sharp nose, and blinking eyes was seated at one end of the kitchen table with playing-cards spread out in front of her. She looked up at the sound of the opening door, and fear crept into her eyes. She was Thalassa’s wife, but the relationship was so completely ignored by Thalassa that other people were apt to forget its existence. The couple did the work of Flint House between them, but apart from that common interest Thalassa gave his wife very little of his attention, leading a solitary morose life, eating and sleeping alone, and holding no converse with her apart from what was necessary for the management of the house.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("How he had ever come to bend his neck to the matrimonial yoke was one of those mysteries which must be accounted a triumph for the pursuing sex—a tribute to the fearlessness of woman in the ardour of the chase. On no other hypothesis was it possible to understand how such a feeble specimen of womanhood had been able to bring down such an untoward specimen of the masculine brute. Outwardly, Thalassa had more kinship with a pirate than a husband. There was that in his swart eagle visage and moody eyes which suggested lawless cruises, untrammelled adventure, and the fierce wooing of brown women by tropic seas rather than the dull routine of married life. As a husband he was an anomaly like a caged macaw in a spinster’s drawing-room.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mrs. Thalassa’s victory had ended with bringing him down, and she soon had cause to regret her temerity in marrying him. Thalassa repaid the indignity of capture by a course of treatment which had long since subdued his wife to a state of perpetual fear of him—a fear which deepened into speechless shaking horror when he stormed out at her in one of his black rages. Some women would have taken to drink, others to religion. Mrs. Thalassa sought consolation in two packs of diminutive and dog-eared cards. Her shattered spirit found something inexpressibly soothing in the intricacies of patience: in the patchwork of colour, the array of sequences, the sudden discovery of an overlooked move, the dear triumph of a hard-won game.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It was thus she was occupied now, shuffling, cutting, and laying out her rows with quick nervous movements of her worn little hands. She glanced once more at her husband as he entered, and then bent over her cards again.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The night had descended blackly, and the wind moaned eerily round the old house. Thalassa sat in a straight-backed wooden chair listening to the wind and rain raging outside, and occasionally glancing at his wife, who remained absorbed in her patience. Half an hour passed in silence, broken only by the rattling of rain on the window, and the loud ticking of the clock on the mantelpiece. Suddenly the bell of Robert Turold’s room rang loudly in its place behind the kitchen door.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It was one of the old wired bells, and it sprang backwards and forwards so violently under the impulse of the unseen pull that the other bells ranged alongside responded to the vibration by oscillating in sympathy.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa watched them moodily until the sound ceased. He then left the kitchen with deliberate tread, and stalked upstairs.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The door of his master’s study was closed. He opened it without troubling to knock, but started back in astonishment at the sight which met his eyes. Robert Turold was crouching by the table like a beaten dog, whimpering and shaking with fear. He sprang to his feet as Thalassa entered, and advanced towards him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Thank God you’ve come, Thalassa,” he cried.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What’s the matter with you?” said Thalassa sternly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“He’s come back, Thalassa—he’s come back.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“He? Who?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You know whom I mean well enough. It was—” His voice sank suddenly, and he whispered a name in the man’s ear.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa’s brown cheek paled slightly, but he answered quickly and roughly—")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What nonsense are you talking now? How can he have come back? How often must I tell you that he is dead?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You mean that you thought he was dead, Thalassa. But he is alive.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“How do you know?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I heard him.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Heard him! What do you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I heard his footsteps pattering around the house, as clear and distinct as that night on that hellish island. Shall I ever forget the sound of his footsteps then, as he raced over the rocks, looking back at us with his wild eyes, and the blood streaming down his face—running and running until he stumbled and fell? The sound of his running footsteps as he clattered over the rocks have haunted me day and night ever since. I heard them again to-night.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I tell you again that he is dead. What! Do you think that you could hear footsteps on a night like this?” The man stepped quickly across to the nearest window and flung it open. The room was filled with rushing wind, and the window curtains flapped noisily. “And where would he be running to? Do you suppose he could climb up here from outside?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It might have been his spirit,” murmured the other.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Spirits don’t cross the ocean, and their footsteps don’t clatter,” responded Thalassa coldly. “The house is all locked up, and there is no other house near by. Come, what are you afraid of? You are worrying and upsetting yourself over nothing. I’ll bring you up your supper, and some whisky with it. And the sooner you leave this cursed hole of a place, the better it will be.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He crossed over to the fireplace and poked the coal into a red glow, and then turned to leave the room. It was plain that his words had some effect on Robert Turold, and he made an effort to restore his dignity before the witness of his humiliation left him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No doubt you are right, Thalassa,” he said in his usual tone. “My nerves are a little overstrung, I fancy. You said the house was locked up for the night, I think?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Everything bolted and barred,” said Thalassa, and left the room.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He returned downstairs to the kitchen, where he wandered restlessly about, occasionally pausing to look out of the window into the darkness of the night. The rain had ceased, but the wind blew fiercely, and the sea thundered at the foot of the cliffs. The gloom outside was thinning, and as Thalassa glanced out his eye lighted on a strange shape among the rocks. To his imagination it appeared to have something of the semblance of a man’s form standing motionless, watching the house.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa remained near the window staring out at the object. While he stood thus, a faint sound reached him in the stillness. It was the muffled yet insistent tap of somebody apparently anxious to attract attention without making too much noise, and coming, as it seemed, from the front door. Thalassa glanced at his wife, but she appeared to have heard nothing, and her grey head was bent over her cards. He walked noiselessly out of the kitchen, closing the door gently behind him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("His wife remained at the table, unconscious of everything but the lay of her cards; shuffling, dealing, setting them out afresh in perpendicular rows, muttering at the obstinacy of the kings and queens as though their painted faces were alive and sensitive to her reproof. The old house creaked and groaned in the wind, then became suddenly silent, like a man overtaken by sleep in the midst of stretching and yawning. Time sped on. Thalassa did not return, but she did not notice his absence. More rain fell, beating against the window importunately, as if begging admission, then ceased all at once, as at a hidden command, and again there was a profound silence.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("A piece of coal jumped from the fire with a hissing noise, and fell at Mrs. Thalassa’s feet. She got up to replace it, and observed that she was alone.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She thought she heard her husband’s footsteps in the passage, and opened the door. But there was nobody there. The lower part of the house was gloomy and dark, but she could see the lamp glimmering on the hall stand. She was about to return to her seat when the hall lamp suddenly mooned up, cast monstrous shadows, and went black out.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("This fantastic trick of the lamp frightened her. What had made it flare up like that and go out? And whose footsteps had she heard? With a chill feeling of fear she shut the door and turned again to her game. But for once the charm of the cards failed her. Where was Jasper, and why did he not return? Silence held oppressive empire; her fears plucked at her like ghostly hands. The lamp and the footstep—what did they mean? Had she really heard a footstep?")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She thought she saw something white in the uncurtained space of the window. She buried her face in her hands, lacking the courage to cross the room and pull down the blind.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mysterious noises overhead, like somebody creeping on all-fours, drew her eyes back to the door opening into the passage. With dismay she saw it was not properly shut. She wondered if she dared go and lock it. Suppose it was her husband, after all? And the noises? Were they real, or had she imagined them?")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("There came to her ear an unmistakable sound like the slamming of a door above her. A sudden accession in the quality of her fear sent her flying to the passage door to lock it. Before she could get there the door flew open violently, as though hit by a giant’s hand, and then the wind blew coldly on her face. The lamp on the kitchen table sent up a straight tongue of flame in the draught, and also went out. As she stood there with straining eyes a cry rang out overhead, followed in a space immeasurable to the listener in the gulf of blackness, by a shattering sound which seemed to shake the house to its foundations. Then the external blackness entered her own soul, shrouding her consciousness like the sudden swift fall of a curtain.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer009"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-9"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor008"
    }
  }), _vm._v("Chapter VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("It seemed a long wild journey in the dark, but actually only half an hour passed before the car emerged from the wind and rain of the moors into the dimly-lighted stone street of the churchtown. A few minutes later the car stopped, and the driver informed Mr. and Mrs. Pendleton in a Cornish drawl that they had reached Dr. Ravenshaw’s.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Husband and wife emerged from the car and discerned a square stone house lying back from the road behind a white fence. They walked up the path from the gate and rang the bell.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("A rugged and freckled servant lass answered the ring, and stared hard at the visitors from a pair of Cornish brown eyes. On learning their names she conducted them into a small room off the hall and departed to inform the doctor of their arrival.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Dr. Ravenshaw came in immediately. The quick glance he bestowed upon his visitors expressed surprise, but he merely invited them to be seated and waited for them to explain the object of their late visit. The room into which they had been shown was his consulting room, furnished in the simplest fashion—almost shabbily. There were chairs and table and a couch, a small stand for a pile of magazines, a bookcase containing some medical works, and a sprawling hare’s-foot fern in a large flowerpot by the window. Mr. Pendleton seated himself near the fern, examining it as though it was a botanical rarity, and left his wife to undertake the conversation. Mrs. Pendleton was accustomed to take the lead, and immediately commenced—")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I have taken the liberty of coming to ask your advice about my niece, doctor. You heard what my brother said this afternoon?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Dr. Ravenshaw inclined his head without speaking, and waited for her to continue.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“As you are a friend of my brother’s—”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Hardly a friend,” he interrupted, with a gesture of dissent. “Our acquaintance is really too short to warrant that term.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("There was a professional formality about his tone which pulled her up short. Like all impulsive people she was chilled by a lack of responsiveness. Her impulse in visiting him had hoped for an interest equalling her own. She reflected now that she should have remembered that nobody liked being bothered with other people’s affairs. She recovered her feminine assurance and went on, with a winning smile.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“But you are in my brother’s confidence, doctor—you were present at our family gathering this afternoon. It is because of that I have come to see you again, at this late hour. My husband and I are returning to London in the morning, and there would be no other opportunity. I have been thinking over all my brother said this afternoon, and I am very much distressed about my niece.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He gave a short comprehending nod which encouraged her to proceed.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I am extremely desirous of preventing this scandal of my brother’s marriage coming to light after all these years,” she earnestly pursued. “It seems to me that Robert has decided to let the truth be known without first considering all the circumstances. He has forgotten that if he succeeds in restoring the title he will come prominently into the public eye. As the holder of a famous name his affairs will have a public interest, and details will be published in the newspapers and eagerly read. That is why this story about Sisily’s mother would be so terrible for all of us, and especially for Sisily.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I should think your brother had foreseen all this.” said Dr. Ravenshaw, after a short pause.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I do not think Robert has realized it,” Mrs. Pendleton eagerly rejoined. “He is a most unworldly man, and lives in a world of his own. His whole life has been devoted to the idea of restoring the title. He has thought of nothing else since he was a boy. He is quite incapable of understanding what a sensation this story of an earlier marriage will cause if it is made public. Indeed, I did not realize it myself until afterwards. Then I decided to come and see you, and ask your help.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I quite agree with you that it would be better if the story could remain unknown, after all these years. But how can I help you?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She had anticipated that question, and proceeded to unfold her plan.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It might be kept quiet, I think,” she said meditatively. “It is Robert’s duty to keep it secret for Sisily’s sake. I am chiefly concerned about her. Girls are difficult, so different from boys! It wouldn’t be so bad if she were a boy. A boy could change his name and emigrate, go on a ranch and forget all about it. But it is different for a girl. Leaving the shock out of the question, this thing would spoil Sisily’s life and ruin her chances of a good marriage if it was allowed to come out. People will talk. It is inevitable that they should, in the circumstances. I fancy the matter could be arranged in a way to satisfy Robert—so as not to interfere with his plans about the title.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What do you suggest?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Sisily could be told that there is some obstacle which prevents her succeeding to the title. Robert has not brought her up as an heiress with expectations. He has never treated her fairly, poor girl. It was his dream to have a son to succeed him. Not that it would have made any difference if Sisily had been a son, after what’s come to light! Sisily would never question anything that was told her about this wretched title, for I’m quite sure that the idea of inheriting it has never entered her head. It certainly never entered mine. I thought titles descended in the male line. I don’t know, really, but that has always been my idea.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It depends on the terms of the original creation. The Turrald barony originally went into abeyance among several daughters. One daughter could have succeeded. There is nothing in the wording of the original writ to prevent it—no limitation to male heirs. It is now well established by precedent that a daughter can inherit a barony by writ. But for the unhappy obstacle revealed by your brother’s story, his daughter would undoubtedly have succeeded to the restored title on his death.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I’m sure it’s very good of you to explain it to me,” murmured Mrs. Pendleton, in some confusion of mind. “It sounds quite reasonable, too. A woman can inherit the throne of England, so why not a title? But it never occurred to me before. Sisily, of course, cannot succeed to my brother’s title because of her birth. But is there any need for this to be known? Could she not sign a paper renouncing her rights in return for a share of my brother’s fortune?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I doubt if the law would approve of the arrangement if it became known.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“The law should realize that it was done from the best of motives to keep from an innocent girl a secret which would darken her life,” responded Mrs. Pendleton with decision.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I wasn’t looking at it altogether in that light,” replied Dr. Ravenshaw with a slow shake of the head. “But it might have been tried—oh yes, it might have been tried.” He rose from his chair, and paced thoughtfully up and down the room.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Is it too late to try it now?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He looked at her thoughtfully.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“In what way?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“By trying to persuade my brother to change his mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“He is not likely to change his mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That,” responded Mrs. Pendleton, “remains to be put to the test. I intend to see him to-night, before it is too late. I beg you for Sisily’s sake to come with me and try and persuade him.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Such a request as you propose to make should come only from a member of the family,” replied Dr. Ravenshaw. “It is a matter in which I would rather not be involved. If you wish support, I would remind you that there are two other members of your own family—your other brother and his son—staying temporarily in this churchtown, not far from here. Why not go to them?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("With a charmingly feminine gesture Mrs. Pendleton washed her hands of the other members of the family. “I would not dream of going to Austin,” she said in decided tones. “He would not approve of my plan, nor, indeed, would Robert listen to him if he did. But he would listen to you, I feel sure. That is my reason for coming to you.” She rose from her seat, and sought to shepherd him into compliance by approaching him with a propitiatory smile. “Do come, doctor. I have trespassed too much on your kindness already, but oblige me further in this.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It’s rather late for a visit,” he replied.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It’s only half-past nine,” she said, with a glance at her wrist watch. “My brother sits up till all hours over his papers and books. I will take all responsibility upon myself for the visit. I will tell Robert that I literally had to drag you with me, and he will understand that we simply had to see him to-night, as he knows we are going home to London first thing in the morning. Do come, Dr. Ravenshaw. The car is waiting.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He consulted his own watch.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Very well, Mrs. Pendleton,” he assented. “I will accompany you. Please excuse me while I get my coat.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("He rejoined them in a moment or two, and they proceeded outside to the waiting car.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer010"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-10"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor009"
    }
  }), _vm._v("Chapter IX")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("A few minutes later the car stopped in the gloom outside the old house on the cliffs. The storm had passed, but the sea still raged white beneath an inky sky. A faint gleam from a shuttered front window pointed a finger of light to the gravel path which led to the front door.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mrs. Pendleton knocked, and an answer came quickly. The door was partly opened, and Thalassa’s voice from within parleyed: “Who’s there?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Mrs. Pendleton—your master’s sister,” was the reply. “Let us in, Thalassa.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The door was at once opened wide, and Thalassa stood back for them to enter. By the light of the lamp he carried they saw that he was dressed and coated for a journey, with his hat on.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I’m glad you’ve come,” he said to Dr. Ravenshaw. “It’s you I was just going out to fetch.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("There was something strange in his manner, and the doctor looked at him quickly. “What’s the matter with you, man? Is there anything wrong?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That’s what I don’t know. But I’m afeered, yes, by God, I’m afeered.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("His voice broke hoarsely, and he stood before them with his eyes averted from the three wondering faces regarding him. Mrs. Pendleton stepped quickly forward, and grasped his arm.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What is it, Thalassa? Has anything happened to my brother?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“There’s been a great noise in his room, like as if something heavy had crashed down, then silence like the grave. I went up and called—an’ tried to open the door, but I couldn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Why didn’t you try to break in the door?” said Dr. Ravenshaw.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Tweren’t my place,” was the dogged retort. “I know my place. I was just going to St. Fair for you and his brother.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“How long is it since this happened—since you heard the crash, I mean.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Not many minutes agone. Just before you came to the door.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Light us upstairs at once, Thalassa,” said Mrs. Pendleton sharply.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Mrs. Pendleton, will you wait downstairs while we investigate?” suggested Dr. Ravenshaw.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No,” she resolutely answered. “I will come with you, doctor. Robert may need me. Do not let us waste any more time.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She slipped past him to Thalassa, who was mounting the stairs. Dr. Ravenshaw hurried after her. Mr. Pendleton, with an obvious call on his courage, followed last. The lamp in Thalassa’s hand burnt unsteadily, first flaming angrily, then flickering to a glimmer which brought them to a pause, one above the other on the stairs, listening intently, and looking into the darkness above.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“His bedroom is open and empty,” said Thalassa when they had reached the end of the passage above. “See!” He pointed to the gaping door, and then turned to the closed one opposite. “He’s in here.” His voice sank to a whisper. “It was from here the noise came.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He placed the lamp on the floor, and knocked hesitatingly on the dark panel of the closed door, then again more loudly, but there was no reply. Far beneath them they could hear the solemn roar of the sea dashing against the cliffs, but there was no sound in the closed chamber. Its stillness and hush seemed intensified by the clamour of the sea, as though calamity were brooding in the darkness within.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Robert, Robert!” The high pitch of Mrs. Pendleton’s voice shattered the quietude like the startling clang of an unexpected bell. “Knock again, Thalassa, more loudly, very loudly,” she cried, in the shrill accents of tightened nerves.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa approached the door again, but recoiled swiftly. “God A’mighty!” he hoarsely exclaimed, pointing, “what’s that?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("They followed the direction of his finger to the floor, and saw a sluggish thin dark trickle making its way underneath the door. Mr. Pendleton stooped and examined it, but rose immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“There’s been trouble in there,” he said, with a pale face.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“How could anybody get in?” said Thalassa sullenly. “The door is locked from the inside, and it’s two hundred feet from the windows to the bottom of the cliffs.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Oh, for pity’s sake stop talking and do something,” cried Mrs. Pendleton hysterically. “My poor brother may be dying.” She rattled the door-handle. “Robert, Robert, what is the matter? Let me in. It is I—Constance.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“We must break in the door,” said Dr. Ravenshaw. “Stand away, Mrs. Pendleton, please. Now, Thalassa, both together.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The doctor and the servant put their shoulders to the door. Mr. Pendleton watched them with a white face, but did not go to their assistance. At the fourth effort there was a sound of splintering wood, the lock gave, and the door swung back.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("They peered in. At first they could see nothing. The light of the swinging-lamp had been lowered, and the interior of the room was veiled in shadow. Then their eyes detected a dark outline on the floor between the table and the window—the figure of a man, lying athwart the carpet with arms outstretched, face downwards, the spread finger-tips clutching at some heavy dark object between the head and the arms.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa stepped across the threshold, and with shaking hand turned up the lowered wick of the swinging lamp. The light revealed the stark form of Robert Turold. At this sight Mrs. Pendleton broke into a loud cry and essayed to cross the room to her brother’s side.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Keep back, Mrs. Pendleton!” cried Dr. Ravenshaw, interposing himself in front of her. “I begged of you not to come upstairs. Mr. Pendleton, take your wife away at once.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("But Mr. Pendleton’s timorous and inferior mind was incapable of translating the command into action. He could only stare dumbly before him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No, no! Let me stay, I will be calm,” Mrs. Pendleton pleaded. “Is—is he dead, doctor?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Dr. Ravenshaw crossed to the centre of the room and bent over the body, feeling the heart. Husband and wife watched him, huddled together, their white faces framed in the shadow of the doorway. In a moment he was on his feet again, advancing towards them. “We can do no good here, Mrs. Pendleton,” he said gently. “Your brother is dead.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Dead? Robert dead!” Her startled eye sought his averted face, and her feminine intuition gathered that which he was seeking to withhold. “Do you mean that he has been killed?” she whimpered.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I fear that there has been—an accident,” he replied evasively. He stood in front of them in a way which obscured their view of the prone figure, and a small shining thing lying alongside, which he alone had seen. “Come,” he said, in a professional manner, taking her by the arm. “Let me take you downstairs.” He got her away from the threshold, and pulled the broken door to, shutting out the spectacle within.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Are you going to leave him there—like that?” whispered Mrs. Pendleton.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It is necessary, till the police have seen him,” he assured her. “We had better send Thalassa in the car to the churchtown. Go for Sergeant Pengowan, Thalassa, and tell him to come at once. And afterwards you had better call at Mr. Austin Turold’s lodgings and tell him and his son. Hurry away with you, my man. Don’t lose a moment!”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa hastened along the passage as though glad to get away. His heavy boots clattered down the staircase and along the empty hall. Then the front door banged with a crash.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The others followed more slowly, stepping gently in the presence of Death, past the little lamps, hardly bigger than fireflies, which flickered feebly in their alcoves. They went into the front room, where a table lamp gave forth a subdued light. Mrs. Pendleton turned up the wick and sank into a chair, covering her face with her hands.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It was the room where only that afternoon Robert Turold had unfolded the history of his life’s quest: a large gloomy room with heavy old furniture, faded prints of the Cornish coast, and a whitefaced clock on the mantel-piece with a loud clucking tick. Dr. Ravenshaw knew the room well, but Robert Turold’s sister had seen it for the first time that day, and the recollection of what had taken place there was so fresh in her memory that it brought a flood of tears.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Poor Bob!” she sobbed. “He denied himself all his life for the sake of the title, and what’s the good of it all—now?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("That was the only light in which she was able to see the tragedy in the first moment of the shock. Other thoughts and revelations about her brother’s strange death were to come later, when her mind recovered its bearings. For the moment she was incapable of thinking coherently. She was conscious only of the fact that her brother had been cut off in the very moment of success—before it, indeed; ere he had actually tasted the sweets of the ambition he had given all his years to gain.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Silence fell between them, broken only by the clucking of the whitefaced clock and the dreary sound of the wind outside, crying round the old house like a frightened woman in the dark. Nearly an hour passed before they heard the sound of a guarded knock at the front door. Dr. Ravenshaw went and opened it. Austin Turold was standing on the threshold.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“This is bad news, doctor,” he said, stepping quickly inside. “I came ahead of the others—walked over. Thalassa is waiting at the churchtown for the sergeant, who is away on some official business, but expected back shortly. They may be here at any minute.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He spoke a little breathlessly, as though with running, and seemed anxious to talk. He went on—")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“How did it happen? Tell me everything. I could get nothing out of Thalassa. He was detained at the police station for a considerable time, waiting for Pengowan, before he came to me with the news. He gave a great knock at the door of my lodgings like the thunder of doom, and when I got downstairs he blurted out that my brother was killed—shot—but not another word of explanation could I get out of him. What does it all mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I cannot say. Your sister and I reached the house just as Thalassa was about to leave it to seek my assistance. Your sister is in the sitting-room.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Austin Turold brushed past the doctor and opened the door of the lighted room. At his entrance Mrs. Pendleton sprang from her seat to greet him. Grief and horror were in her look, but surprise contended with other emotions in Austin’s face. She kissed him with clinging hands on his shoulders.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Oh, Austin,” she cried, “Robert is dead—killed!”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“The news has shocked me to the last degree,” responded her brother. “What has happened? Did somebody send for you? Is that what brought you here?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mrs. Pendleton shook her head, embarrassed in her grief. She remembered that she wished to keep the object of her visit secret from her younger brother, and she could not very well disclose the truth then.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Not exactly,” she replied, a trifle incoherently. “I wanted to see Robert again before I returned to London in the morning. So we motored over after dinner, and found him—dead.” Fresh tears broke from her.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Austin Turold wandered around the room quickly and nervously, then drew Dr. Ravenshaw to the door with a glance. “I should like to go upstairs before the police come,” he whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Dr. Ravenshaw nodded, and they went upstairs together. The shattered door creaked open to their touch, revealing the lighted interior and the dead man prone on the floor. Austin approached his brother’s corpse, eyed it shudderingly, and turned away. Then he stooped to look at the small revolver lying alongside, but did not touch it. Again he bent over the corpse, this time with more composure in his glance.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("The object on which the outstretched arms rested was an old Dutch hood clock, which had fallen or been dragged from a niche in the wall, and lay face uppermost, the glass case open and smashed, the hands: stopped at the hour of half-past nine. It was a clock of the seventeenth century, of a design still to be found occasionally in old English houses. A landscape scene was painted in the arch above the dial, showing the moon above a wood, in a sky crowded with stars. The moon was depicted as a human face, with eyes which moved in response to the swing of the pendulum. But the pendulum was motionless, and the goggle eyes of the mechanism stared up almost reproachfully, as though calling upon the two men to rescue it from such an undignified position. At the bottom of the dial appeared the name of Jan Fromantel, the famous Dutch clockmaker, and underneath was an inscription in German lettering—")]), _vm._v(" "), _c('p', {
    staticClass: "extract-flush-left-space-after"
  }, [_vm._v("“Every tick that I do give Cuts short the time you have to live. Praise thy Maker, mend thy ways, Till Death, the thief, shall steal thy days.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("“Look at the blood!” said Austin Turold, pointing to a streak of blood on the large white dial. “How did it happen?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I know very little more than yourself. Your sister called at my house about an hour ago and asked me to accompany her here. She wished to see your brother on some private business, and she was very anxious that I should accompany her. Thalassa let us in, and said he was afraid that there was something wrong with his master. We came upstairs immediately, burst in the door, and found—this.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Did Thalassa hear the shot?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“He says not, only the crash.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That would be the clock, of course. Was my brother quite dead when you found him?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Just dead. The body was quite warm.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“The door was locked from inside, I think you said.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“We found it locked.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Then it must have been locked from inside,” returned the other, who appeared to be pursuing some hidden train of thought. “But where’s the key? I do not see it in the door. Oh, here it is!” He stooped swiftly and picked up a key from the floor. “Robert must have taken it out after locking the door.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Perhaps it fell out when we were breaking in the door,” observed the doctor.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Of course. I forgot that. I notice that the clock is stopped at half-past nine.” He bent down to examine it. “My brother kept private papers in the clock-case,” he added. “Yes—it is as I thought. Here are some private documents, including his will. I had better take charge of them.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yes; I should if I were you,” counselled his companion.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Austin rose to his feet and placed the papers in his pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It is plain to me—now—how it happened,” he said. “Poor Robert must have shot himself, then tried to get his will from the clock-case when he fell, bringing down the clock with him.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Is that what you think?” said Dr. Ravenshaw.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I see no other way of looking at it,” returned Austin rapidly. “The door was locked on the inside, and the room couldn’t be reached from the window. This house stands almost on the edge of the cliff, which is nearly two hundred feet high. My feeling is that after my poor brother shot himself he remembered in his dying moments that his will was hidden in the clock-case and might not be found. He made a desperate effort to reach it and dragged it down as he fell.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The doctor listened attentively to this imaginary picture of Robert Turold’s last moments.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“But why should he destroy himself?” he queried.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Grief and remorse. Do you remember the disclosure he made to us this afternoon? It is a matter which might well have preyed upon his mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I see,” said the other thoughtfully. “Yes, perhaps you may be right.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Their conversation was interrupted by the sound of a loud knocking downstairs.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("“That must be the police,” observed Dr. Ravenshaw. “Let us go down.”")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer011"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-11"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor010"
    }
  }), _vm._v("Chapter X")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("“Why should Robert commit suicide?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("That was the burden of Mrs. Pendleton’s cry, then and afterwards. There was an angry scene in the old cliff house between brother and sister before the events of that night were concluded. She utterly refused to accept Austin’s theory that their brother, with his own hand, had discharged the revolver bullet which had put an end to his life and ambitions. Sitting bolt upright in indignant amazement, she rejected the idea in the sharpest scorn. It was nothing to her that the police sergeant from the churchtown shared her brother’s view, and that Dr. Ravenshaw was passively acquiescent. She brushed aside the plausible web of circumstances with the impatient hand of an angry woman. They might talk till Doomsday, but they wouldn’t convince her that Robert, of all men, had done anything so disgraceful as take his own life. Arguments and events, the locked door and the inaccessible windows—pathetically masculine insistence on mere details—were wasted on her. The marshalled array of facts made not the slightest impression on her firm belief that Robert had not shot himself.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Shaking a large finger of angry import at Austin, and addressing herself to him alone, she had said—")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Robert has been murdered, Austin, I feel sure. I don’t care what you say, but if there’s law in England I’ll have his murderer discovered.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("And with that conclusion she had indignantly left the house with her husband, leaving her brother to walk back to his lodgings at the churchtown in moody solitude across the rainy darkness of the moors.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("For herself, she returned to her hotel to pass a sleepless night, tossing by the side of her placidly unconscious husband as she passed the tragic events of the night in review and vainly sought for some clue to the mystery. The dreadful logic of the circumstances which pointed to suicide, hammered at her consciousness with deadening persistence, but she resolutely refused to give it entry. Why should Robert commit suicide? Why indeed? It was the question which had sprung to her lips when she first heard Austin’s belief, and it was to that she now clung in the midst of her agonizing doubts, as though the mere wordless insistence in her mind made it an argument of negation which gathered force and cogency by frequent repetition.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("But in the mass of teeming thoughts which crowded her brain in the silence of the small hours, she long and vainly sought for any other theory which would account for her brother’s death. If he had been murdered, as in the first flush of her indignation she had declared, who had killed him? Who had gone to the lonely old house in the darkness of the night, and struck him down?")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It was not until the first faint glimmering of dawn was pushing its grey way through the closed shutters that there came to her the recollection of an incident of the previous day which had left a deep mark upon her mind at the time, but had since been covered over by the throng of later tremendous events. It was the memory of that momentary glance of a pair of eyes through the slit of the door while her brother was telling of his daughter’s illegitimacy and her mother’s shame. In the light of Robert’s subsequent death that incident appeared in a new sinister shape as a clue to the commission of the deed itself. With the recollection of that glance there sprang almost simultaneously before her mental vision the grim and forbidding features of her brother’s servant, Thalassa.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("If she had been asked, Mrs. Pendleton could not have given a satisfactory reason for linking Thalassa with the incident of the eyes, but she was a woman, and not concerned about reasons. The two impressions had scurried swiftfooted, into her mind together, and there they remained. She was now convinced that she had all along believed it was Thalassa she had seen watching through the door, watching and listening for some fell purpose of his own. She knew nothing about Thalassa, but she had taken an instant dislike to him when she first saw him. That vague dislike now assumed the form of active suspicion against him. She determined, with the impulsiveness which was part of her temperament, to bring her suspicion before the police at the earliest possible moment.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She was essentially a woman of action, and in spite of her sleepless night she was up and dressed before her husband was awake. He came down to breakfast to find his wife had already finished hers, and was dressed ready to go out.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Where is Sisily?” he asked, with a glance at the girl’s vacant place.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I’ve ordered her breakfast to be taken to her room, and sent word to her to rest in bed until I go to her,” his wife replied. “I have a painful ordeal before me in breaking the news of Robert’s death to her. It’s all over the hotel already, unfortunately. Sisily is out of the way of gossip in her room. After I’ve seen her I shall leave her in your charge, Joseph. I shall have plenty on my hands to-day.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mr. Pendleton received this mandate with a blank face, and momentarily regretted that the arrangements for their departure by the morning’s train had been cancelled. Then his better nature asserted itself, and he meekly replied that he would do what he could. “What do you suggest?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Take her for a walk,” responded his wife. “Try and keep her interested and her mind occupied.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("With these words she left the breakfast table and proceeded upstairs to Sisily’s room before going out. On the way there she again regretted having undertaken the responsibility of her niece’s future. She had not disturbed Sisily on the previous night. She had tried her door on her way to her own room, but it was locked, so she had let the girl sleep on, and deferred breaking the tragic news until the morning.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She now paused outside the door reluctantly. But she was not the woman to shrink from a duty because it was unpleasant, and womanly sympathy for her unhappy niece banished her diffidence. She knocked lightly and entered.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Sisily was seated by the window reading. A breakfast tray, still untouched, stood on a small table beside her. She put down her book as her aunt entered, and rose to greet her.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mrs. Pendleton bent over the girl and kissed her, and took her hand. As she did so she observed that Sisily looked worn and fatigued, with black rings under her eyes, as though she, too, had passed a sleepless night. But she was wonderfully pretty, the elder woman thought, and nothing could rob her of the fresh charm of youth and beauty.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Sit down, Sisily,” she said, leading her back to her chair, and taking another one beside her. “I have sad news for you, dear, and you must be a brave girl. Something has happened to your father.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What has happened?” asked Sisily quickly. Then, as if taking in the import of her aunt’s tone, rather than her words, she added: “Do you mean that he is . . . dead?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mrs. Pendleton inclined her head with tears in her eyes. “It is worse even than that,” she went on, her voice drooping to a whisper. “He . . . he has been killed. We found him last night. Listen, dear, I will tell you all.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She gave the cold fingers a comforting pressure as she spoke, but the hand was immediately withdrawn, and Sisily sprang away from her, then turned and regarded her with blazing eyes and a white face.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Tell me about it!” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mrs. Pendleton imparted as much of the facts as she felt called upon to relate. There was something about the girl’s reception of the news which puzzled her, and her own look fell before the sombre intensity of her gaze. Sisily heard the story in silence, and when it was finished, merely said—")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I think I would like to be left alone for a little while, if you don’t mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Oh, you mustn’t sit here moping, my dear,” said Mrs. Pendleton, with an attempt at cheerfulness which she felt to be clumsy and ill-timed, but Sisily’s manner had momentarily disconcerted her. “You had better put on your hat and coat and go out with your uncle. He is waiting downstairs for you. It is very sad, very terrible, but you must let us help you bear it. You must not stay here alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You are very kind”—the girl’s lips quivered slightly, though her face remained calm—“but I would rather not go out. I should prefer to be left alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("There was in her expression a despairing yet calm detachment and resolve which forced Mrs. Pendleton in spite of herself to yield to her wish with a meekness which was almost timidity.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Very well, dear,” she said. “If you feel like a walk later on, you will find your uncle downstairs.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("As she left the room she heard the door shut behind her.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("But Mrs. Pendleton had other things to think about that morning than the strangeness of her niece’s disposition and the manner in which she had received the news of her father’s death. The horror of that event filled her own thoughts to the exclusion of everything else, and she was determined to remain in Cornwall until the mystery was explained.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She glanced at her watch as she reached the bottom of the stairs. She had breakfasted early, and it still wanted a few minutes to ten o’clock. The lobby of the hotel was deserted, and through the glass doors leading to the breakfast-room she could see a few guests still at their morning meal. A porter was sweeping the front entrance, and of him she enquired the way to the police station, and set out for it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It was chill and grey after the storm, with a sky obscured by scudding clouds, but a gleam of truant sunshine was sporting wantonly on the hoary castled summit of St. Michael’s Mount, and promised to visit the town later on. Mrs. Pendleton walked briskly, and soon arrived at the police station.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("A young constable in the office came forward as she entered and enquired her business. She disclosed her name, and her relationship with the inmate of Flint House, deeming that would be sufficient to gain her an interview with somebody in authority. In that expectation she was not disappointed. The constable favoured her with a good hard stare, went into another room, and reappeared to say that Inspector Dawfield would see her at once.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She followed him into the inner room, where a slight man of middle age was seated at a leather-covered table opening his morning correspondence. He looked up and bowed as he saw his visitor, but waited until the constable had retired before he spoke.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Good morning,” he said. “What can I do for you?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("His eye regarded her with a thoughtful glance. His professional interest had been aroused by the strange death of the occupant of Flint House, whose object in visiting Cornwall had been common gossip in the district for some time past.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It is about my brother’s death that I wished to see you.” Mrs. Pendleton spoke earnestly, drawing her chair closer with the feeling that the man before her had sufficient intelligence to give her a sympathetic hearing.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“So I gathered from your card. It seems a very sad case. Sergeant Pengowan’s report has just reached me. Anything I can do for you—” Inspector Dawfield pretended to occupy himself in cutting open an official envelope with scrupulous care.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Sergeant Pengowan regards it as a case of suicide, does he not?” asked Mrs. Pendleton rigidly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Well, yes, I believe he does,” replied Inspector Dawfield. “There is no doubt on that point, is there? Your brother’s revolver was lying near him, and the door was locked on the inside.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“There is the greatest doubt in my mind,” returned Mrs. Pendleton vehemently. “I do not—I cannot believe that my brother has taken his own life. In fact, I am sure he did not.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("On hearing these words Inspector Dawfield looked at his visitor again, with something more than surprise in his eyes, then he pulled a document from a pigeonhole and hastily scanned it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Pengowan’s report states quite definitely that it is suicide,” he said as he replaced it. “In the face of that, do you think—”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I think my brother has been murdered,” she said in a decided voice.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“This is a very grave statement to make, Mrs. Pendleton. Have you anything to support it? Anything which has not been brought to light, I mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mrs. Pendleton proceeded to give her reasons. She had thought over what she was going to say as she came along, and she spoke with growing conviction, intensified by the sight of the earnest attentive face before her. The incident of the person she had detected looking through the door took on a new significance as she related it. By her constant association of the eyes with the disliked face of her brother’s servant, she had unconsciously reached the conclusion that she had all along recognized the eavesdropper as Thalassa.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You say your brother was talking about some family matters at the time?” asked Inspector Dawfield, as she related that part of her story.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yes,” responded Mrs. Pendleton. She had repressed all mention of her brother’s announcement of his daughter’s illegitimacy, but afterwards she tried to persuade herself that it slipped her memory at the time.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It’s common enough for servants to listen at doors,” remarked Inspector Dawfield. “In this case it may seem to have a sinister interpretation because of what happened afterwards. How long has this man been in your brother’s employ?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“A number of years, I believe,” replied Mrs. Pendleton. “But he has a wicked face,” she added hastily, as though that fact cancelled a record of lengthy service. “I took a dislike to him as soon as I saw him.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Inspector Dawfield veiled a slight smile with a sheet of foolscap. “Have you any other reason for suspecting him?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Oh, I wouldn’t like to say that I suspect Thalassa, or anybody else.” Mrs. Pendleton was prompt with this assurance. “But there are certain things which seem to me to need further investigation. There’s the question of the door being locked on the inside. It seems to me that the door might have been locked on the outside, and the key dropped in there afterwards. The door had to be smashed before we could get in, and the key wasn’t in the door then, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Dawfield nodded thoughtfully. “Who has charge of the keys in your brother’s house? This servant with the strange name—Thalassa, is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yes, and he was upstairs in my brother’s room last night, after we came down. And when we got there he was ready to go out, with his hat and coat on. It all seems very strange.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Again the courteous inspector hid a slight smile. His lady visitor might disclaim suspecting anybody, but her inferences carried her to the same point.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What do you wish me to do?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I feel there should be further inquiries. Sergeant Pengowan does not strike me as the kind of man capable of bringing to light any mystery which may be hidden behind my brother’s supposed suicide. He does not look at all intelligent. I thought of sending a telegram to Scotland Yard, but I decided to see you first.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The hint was not lost on Inspector Dawfield, but it was unnecessary. It was his duty to look into her complaint and make further inquiries into the case.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Your statement shall certainly be investigated,” he said emphatically. “I am rather short of men just now, but I’ll see if I can get Bodmin to send over a man. I will inquire immediately, if you will excuse me.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He retired into a curtained recess in a corner of the room, where Mrs. Pendleton could see him holding a colloquy over the telephone. After rather a lengthy conversation he returned to announce that a detective was coming over by the next train to investigate the case.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“The Bodmin office is sending over Detective Barrant, of Scotland Yard,” he explained. “He happens to be in Cornwall on another case, and was just on the point of returning to London. I was able to speak to him personally and relate the facts of your brother’s death. He decided to telephone to Scotland Yard, and come over here at once. He will arrive soon after lunch. I will take him to Flint House myself. He may wish to see you later on. Will you be at your hotel?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“If not, I will leave word where I can be found,” replied Mrs. Pendleton, rising as she spoke. “Good morning, and thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("She left the police station feeling that she had accomplished an excellent morning’s work, and hurried back to the hotel with visions of letters to be written and telegrams to be sent before lunch. But she was destined to do neither. As she entered the lounge, her eye fell upon its solitary occupant, a male figure in a grey lounge suit sitting in her favourite corner by the window. It was her brother Austin.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer012"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-12"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor011"
    }
  }), _vm._v("Chapter XI")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("He rose from his seat as he saw her, but waited for her to approach. Her eyes, dwelling on his face, noted that it was not so angry as she had last seen it, but smoothed into the semblance of sorrow and regret, with, however, something of the characteristic glance of irony which habitually distinguished him, though that may have been partly due to the pince-nez which glittered over his keen eyes. There was something of an art in Austin Turold’s manner of wearing glasses; they tilted, superiorly, at the world in general at an acute angle on the high bridge of a supercilious nose, the eyes glancing through them downwards, as though from a great height, at a remote procession of humanity crawling far beneath.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("At that moment, however, there was nothing superior in his bearing. It was so unwontedly subdued, so insistently meek, that it was to be understood that his mission was both conciliatory and propitiatory. That, at least, was the impression Mrs. Pendleton gathered as her brother informed her that he had been waiting nearly an hour to see her.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She reflected that he must have arrived shortly after she left the hotel to go to the police station, and she wondered what had induced her brother to rise at an hour so uncommonly early for him, in order to pay her a morning visit.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I was up betimes,” said Austin, as though reading her thought. “Sleep, of course, was impossible. Poor Robert!”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mrs. Pendleton waited impatiently for him to disclose the real reason of an appearance which had more behind it, she felt sure, than to express condolences about their common bereavement. Of Robert she had always stood a little in awe, but she understood her younger brother better. As a boy she had seen through him and his pretensions, and he did not seem to her much changed since those days.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I have been upset by our difference last night, Constance,” he pursued. “It seems deplorable for us to have quarrelled—yes, actually quarrelled—over our poor brother’s death.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("His sister’s face hardened instantly. “That wasn’t my fault,” she said distantly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You’ll excuse me for saying that I think it was. You took an altogether wrong view of his—his death; a view which I hope you’ve seen fit to change after a night’s reflection.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You mean about Robert committing suicide?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Austin inclined his head.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I haven’t changed my opinion in the slightest degree,” she retorted. “I am still quite convinced that Robert did not commit suicide.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Austin darted an angry glance at her, but controlled himself with a visible effort. “Have you reflected what that implies?” he asked in a low tone.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What does it imply?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Murder.” He breathed the word with a hurried glance around him, as though apprehensive of being overheard, but the lounge was empty, and they were quite alone.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I am aware of that.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Then is it still your intention to go to the police with this terrible suspicion?” he asked, in a voice that trembled with agitation.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It was on the tip of Mrs. Pendleton’s tongue to reply that she had already been to the police, but she decided to withhold that piece of information until she had heard all that her brother had to say.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Certainly,” she replied.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Then you must be mad,” was his indignant rejoinder. “Have you considered the scandal this will entail upon us all?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Not half such a scandal as that Robert should be murdered and his family permit the crime to go unpunished.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I do not think that you have given this matter sufficient consideration. It is for that reason I have come to see you this morning—before you take action which you may have reason to regret later on. I want you to think it over carefully, apart from a mere feminine prejudice against the possibility of a member of the family destroying himself. If you will listen to me I think that I shall be able to convince you that Robert, deplorable though it may seem, did actually commit suicide.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What’s the use of going through all this again?” said Mrs. Pendleton wearily. “Robert would not commit suicide.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Suicide is always difficult to explain. Nobody can say what impels a man to it.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Robert had no reason to put an end to his life. He had everything to live for—everything in front of him.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You cannot say that a man bordering on sixty has everything in front of him. I know it’s considered middle-aged in this misguided country, where people will never face the facts of life, but in simple truth Robert had finished with life to all intents and purposes.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You won’t say that when you come to sixty yourself, Austin. Robert was a great strong man, with years of activity before him. Besides, people don’t kill themselves because they are growing old.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I never suggested it. I was merely pointing out that Robert hadn’t everything in front of him, to use your own phrase.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“In any case he would not have killed himself,” replied Mrs. Pendleton sharply. “Such a disgrace! He was the proudest of men, he would never have done it.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You always hark back to that.” There was faint irritation in Austin’s tone.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I really cannot get away from it, Austin. Can you conceive of any reason?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“There was a reason in Robert’s case. I did not mention it to you last night in the presence of the police sergeant, but I told Dr. Ravenshaw, and he is inclined to agree with me. Since then I have thought it over carefully, and I am convinced that I am right.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What is the reason?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You recall the disclosure Robert made to us yesterday afternoon?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“About his marriage and Sisily?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yes. It must have been very painful to Robert, more painful than we imagine. It would come home to him later with stunning force—all that it implied, I mean. At the time Robert did not foresee all the consequences likely to ensue from it. It was likely to affect his claim for the title, because he was bound to make it known. When he came to think it over he must have realized that it would greatly prejudice his claim. A body like the House of Lords would do their utmost to avoid bestowing an ancient name on a man, who, by his own showing, lived with a married woman for twenty-five years, and had an illegitimate daughter by her. These are painful things to speak of, but they were bound to come out. My own feeling is that Robert had a bitter awakening to these facts when it was too late—when he had made the disclosure. And he may have felt remorse—”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Remorse for what?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Remorse for giving the secret away and branding his daughter as illegitimate on the day that her mother was buried. It has an ugly look, Constance, there’s no getting away from that.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He lapsed into silence, and awaited the effect of his words. Mrs. Pendleton pondered over them for some moments in manifest perturbation. There was sufficient resemblance between Austin’s conclusions and the thoughts which had impelled her nocturnal visit to Flint House, to sway her mind like a pendulum towards Austin’s view. But that only lasted for a moment. Then she thrust the thought desperately from her.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No, no; I cannot—I will not believe it!” she cried in an agitated voice. “All this must have been in Robert’s mind beforehand. His letters to me about Sisily indicated that there were reasons why he wished me to take charge of her. Robert had weighed the consequences of this disclosure, Austin—I feel sure of that. He was a man who knew his own mind. How carefully he outlined his plans to us yesterday! He was to appear before the Investigations Committee next week to give evidence in support of his claim to the title. And he told me that he was purchasing a portion of the family estate at Great Missenden, and intended to live there. Is it logical to suppose that he would terminate all these plans and ambitions by destroying himself? I, for one, will never believe it. I have my own thoughts and suspicions—”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He turned a sudden searching glance on her. “Suspicions of whom?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I took a dislike to that terrible man-servant of Robert’s from the moment I saw him,” said Mrs. Pendleton, setting her chin firmly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("This feminine flight was too swift for Austin Turold to follow.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What has that to do with what we are talking about?” he demanded.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“When we reached the door last night it was Thalassa who let us in, with his hat and coat on, ready to go out. There was something strange and furtive about his manner, too, for I never took my eyes off him, and I’m sure he had something on his mind. I’m quite convinced it was he who was listening at the door yesterday afternoon. And he’s got a wicked and crafty face.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Good God!” ejaculated Austin Turold, as the full force of his sister’s impressions reached his mind. “Do you mean to say that because you took a dislike to this unfortunate man’s face, you think he has murdered Robert? And yet there are some feminists who want to draw our judges from your sex! My dear Constance, you cannot make haphazard accusations of murder in this reckless fashion.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I am not accusing Thalassa of murder,” said Mrs. Pendleton, with a fine air of generosity. “And there’s more than my dislike of his face in it, too. He was looking through the door in the afternoon—”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You only think that,” interrupted her brother.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I feel sure it was he. It was also strange to see him with his hat and coat on when he answered our knock. He told Dr. Ravenshaw that he was going to the churchtown for him.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That reminds me that I haven’t yet heard what took you up to Flint House last night, Constance,” said her brother, looking at her fixedly. “What were you doing there at that late hour, and why was Ravenshaw with you?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mrs. Pendleton told him, and he listened coldly. “I think you might have consulted me first before Dr. Ravenshaw,” he observed.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I didn’t because I thought you would have put obstacles in my way,” she replied with frankness.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I most certainly should. Of course the whole position may be altered now, with Robert’s death. Have you told Sisily?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yes. She took it almost passively. She is the strangest girl, but after last night I look upon her as a sacred charge—Robert’s last wish.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It will be best for you to take charge of her, I think,” said Austin absently. “I expect she is provided for in Robert’s will. I found that in the old clock case last night, and I’ve handed it to the local lawyer who drew it up. But this is beside the point, Constance. I have come over here this morning to beg of you to let this terrible business rest where it is. There is not the slightest doubt in my mind that our unhappy brother has ended his own life—all the facts point to it only too clearly—and I particularly desire, for all our sakes, that you do nothing to put your ill-informed suspicions into action. Let the thing drop.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It is too late,” said Mrs. Pendleton decidedly. “I have already been to the police. There is a detective from Scotland Yard on his way over from Bodmin.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You might have told me this before and saved my time,” said Austin, rising with cold anger. “In my opinion you have acted most ill-advisedly. However, it’s too late to talk of that. No, there is no need to rise. I can find my way out.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Austin Turold left the hotel, and made his way up the crooked street to the centre of the town. His way lay towards Market Jew Street, where he intended to hire one of the waiting cabs to drive him back to St. Fair. As he neared the top of the street which led to the square, his eye was caught by the flutter of a woman’s dress in one of the narrow old passages which spindled crookedly off it. The wearer of the dress was his niece Sisily. She was walking swiftly. A turn of the passage took her in the direction of the Morrab Gardens, and he saw her no more.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Her appearance in that secluded spot was unexpected, but at the moment Austin Turold did not give it more than a passing thought. He hurried across Market Jew Street and engaged a cabman to drive him home.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The ancient vehicle jolted over the moor road in crawling ascent, and in due time reached the spot where the straggling churchtown squatted among boulders in the desolation of the moors, wanting but cave men to start up from behind the great stones to complete the likeness to a village of the stone age. The cab drifted along between the granite houses of a wide street, like a ship which had lost its bearings, but cast anchor before one where a few stunted garden growths bloomed in an ineffectual effort to lessen the general aspect of appalling stoniness. Austin Turold paid the cabman and walked into this house. He opened the door with his latchkey, and ascended rapidly to the first floor.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Lunch was set for two in the room which he entered, and Charles Turold was seated at the table, turning over the pages of a book. He glanced up expectantly, and his lips formed one word—")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Well?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It is not well,” was the testy response. “My charming sister has called in the assistance of Scotland Yard. You’ll have to stay. We’ve got to face this thing out.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("His son received this piece of news with a pale face. “You should have foreseen this last night,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I saw Sisily in Penzance—near the gardens.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Where was she going?” asked Charles, flushing slightly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I really cannot say. You should be better acquainted with her movements than I,” was the ironical response. “You do not suppose I have been altogether blind to your infatuation, do you? If you choose to go walking and flirting with a girl on Cornish moors you must expect to be observed. As a matter of fact I thought it rather a good move on your part, until I learnt the secret of Sisily’s birth.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I tell you I won’t stand this,” exclaimed Charles, springing up from the table.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("“Won’t?” said his father. “You carry things with a high hand—Jonathan.” His look dwelt coldly on his son. “Do not be a fool. Sit down and let us have lunch, and we’ll discuss afterwards what’s best to be done.”")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer013"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-13"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor012"
    }
  }), _vm._v("Chapter XII")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("With a slightly incredulous air Inspector Dawfield placed his London colleague in possession of his own knowledge of the facts of the case, based on the statements made to him by Mrs. Pendleton that morning and the facts as set forth in Sergeant Pengowan’s report.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Detective Barrant listened attentively, with the air of a man smiling to himself. He was not actually doing so, but that was the impression conveyed by his keen bright eyes. He was a Londoner, with an assured manner, and the conviction that his intelligence was equal to any call which might be made upon it. By temperament he was restless, but his work had given him a philosophical outlook which in some measure counterpoised that defect by causing him to realize that life was a tricky and deceptive business in which intelligence counted for more than action in the long run. He had a wider outlook and more shrewdness than the average detective, and he already felt a keen interest in the case he had been called in to investigate.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("When the inspector had finished his story he picked up the blue foolscap on which was inscribed the sprawling report of the churchtown sergeant. With a severe effort he mastered the matter contained under the flowing curves and flourishes.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“The local man seems certain that it is suicide,” he said, “but the sister’s statement certainly calls for further investigation. How far away is this place?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Flint House? About five miles across the moors. I’ve hired a motor-car to drive you up. Nothing has been disturbed so far. As soon as I learnt you were coming I telephoned to Pengowan to leave things as they were until you arrived.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant nodded approval. “Let us go,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The car was waiting outside. The way lay through the town and then across the moors in undulating ascent until at the highest point a rough track crossed the road at a spot where four parishes met. On one side of these cross-roads was a Druidical stone circle, and on the other was a wayside cross to the memory of an Irish female saint who had crossed to Cornwall as a missionary in the tenth century, after first recording a holy vow that she would not change her shift until she had redeemed the whole of the Cornish natives from idolatry.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("From the cross-roads the way again inclined downward to the sea in increasing savageness of desolation. Stones littered the purple surface of the moors, or rose in insecure heaps on the steep slopes, as though piled there by the hands of the giants supposed to have once roved these gloomy wilds. Solitude held sway, but there was more than solitude in that lonely aspect: something prehistoric and unknown, unearthly, incomprehensible. Cairn Brea and the Hill of Fires brooded in the distance; the remains of a Druid’s altar showed darkly on the summit of a nearer hill. No sound broke the stillness except the faint and distant sobbing of the sea.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("St. Fair lay almost hidden in a bend or fold of the moors about a mile before them, and beyond it Dawfield pointed out to his companion Flint House, standing in gaunt outline on a tongue of coast thrust defiantly into the restless waters of the Atlantic.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“A lonely weird place,” said Barrant, eyeing his surroundings attentively. “An ideal setting for a mysterious crime.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("They drove on in silence until they reached the churchtown. Inspector Dawfield steered the car to the modest dwelling of Sergeant Pengowan, whom they found at his gate awaiting their arrival—a shaggy figure of a rural policeman of the Cornish Celtic variety, with no trace of Spanish or Italian ancestry in his florid face, inquisitively Irish blue-grey eyes, reddish whiskers, and burly frame.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Inspector Dawfield bade him good-day, and added the information that his companion was Detective Barrant, of Scotland Yard. Pengowan greeted Barrant with the respect due to the name of Scotland Yard, and took a humble seat at the back of the car.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("They went on again, and in a few minutes the car stopped at the end of the rough moor track, close to where the black cliffs dropped to the grey sea.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Flint House rose solitary before them, perched with an air of bravado upon the granite ledge, as though defying the west wind which blustered around it. The unfastened gate which led to the little path banged noisily in the breeze, but the house seemed steeped in desolation. A face peeped furtively at them from a front window as they approached. They heard a shuffling footstep and the drawing of a bolt, and the door was opened by a withered little woman who looked at them with silent inquiry.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Where’s your husband?” asked Sergeant Pengowan.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She glanced timidly up the stairs behind her, and they saw Thalassa descending as though in answer to the question. He scanned the police officers with a cautious eye. Barrant returned the look with a keen observation which took in the externals of the man who was the object of Mrs. Pendleton’s suspicions.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You are the late Mr. Turold’s servant?” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Put it that way if you like,” was the response. “Who might you be?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant did not deign to reply to this inquiry. “Take us upstairs,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Pengowan wants us to look at the outside first,” said Dawfield, but Barrant was already mounting the stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You do so,” he called back, over his shoulder. “I’ll go up.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("At the top of the staircase he waited until Thalassa reached him. “Where are Mr. Turold’s rooms?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa pointed with a long arm into the dim vagueness of the passage. “Down there,” he said, “at the end. The study on the right, the bedroom opposite.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Very well. You need not come any further.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The old man’s eyes travelled slowly upward to the detective’s face, but he kept his ground.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Did you hear me?” Barrant asked sharply. “You can go downstairs again.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Again the other’s eyes sought his face with a brooding contemplative look. Then he turned sullenly away with moving lips, as though muttering inarticulate words, leaving Barrant standing on the landing, watching his slow descent.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("When he was quite sure that he was gone, Barrant turned down the passage-way. He had his reasons for wishing to be alone. The value of a vivid first impression, the effect of concentration necessary to reproduce the scene to the eyes of imagination, the mental arrangement of the facts in their proper order and conformity—these were things which were liable to be broken into by the disturbing presence of others, by the vexatious interruption of loudly proffered explanations.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He knew all the facts that Inspector Dawfield and Sergeant Pengowan could impart. He knew of Robert Turold’s long quest for the lost title, the object of his visit to Cornwall, his near attainment to success, his summons to his family to receive the news. In short, he was aware of the whole sequence of events preceding Robert Turold’s violent and mysterious death, with the exception of the revelation of his life’s secret, which Mrs. Pendleton had withheld from Inspector Dawfield. Barrant had heard all he wanted to know at second hand at that stage of his investigations, and he now preferred to be guided by his own impressions and observations.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("His professional interest in the case had been greatly quickened by his first sight of Flint House. Never had he seen anything so weird and wild. The isolation of the place, perched insecurely on the edge of the rude cliffs, among the desolation of the rocks and moors, breathed of mystery and hinted at hidden things. But who would find the way to such a lonely spot to commit murder, if murder had been committed?")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Reaching the end of the long passage, he first turned towards the study on the right. The smashed door swung creakingly back to his push, revealing the interior of the room where Robert Turold had met his death. Barrant entered, and closed the broken door behind him. It was here, if anywhere, that he might chance to find some clue which would throw light on the cause.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The profusion of papers which met his eye, piled on the table and filling the presses and shelves which lined the musty room, seemed, at the outset, to give ground for the hope that such an expectation might be realized. But they merely formed, in their mass, a revelation of Robert Turold’s industry in gathering material for his claim. There were genealogical tables without number, a philology of the two names Turold and Turrald, extracts of parish registers and corporation records, copies from inscriptions from tombstones and mural monuments, copied pedigrees from the British Museum and the great English collections, a host of old deeds and wills, and other mildewed records of perished hands. But they all seemed to have some bearing on the quest to which Robert Turold had sacrificed the years of his manhood.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He had died as he lived, engrossed in the labour of his life. A copy of Burke’s “Vicissitudes of Families” was lying open on the table, and beside it were two sheets of foolscap, covered with notes in thin irregular handwriting. The first of these depicted the arms of the Turrald family, as originally selected at the first institution of heraldry, and the quarterings of the heiresses who had married into the family at a later date.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The second sheet was headed “Devonian and Cornwall branch of the Turolds,” and contained notes of Robert Turold’s ancestral discoveries in that spot. The notes were not finished, but ended abruptly in the middle of a sentence: “It is necessary to make it clea—”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Those were the last words the dead man had written. He had dropped the pen, which lay beside the paper, without finishing the word “clear.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The sight of this unfinished sheet kindled Barrant’s imagination, and he stood thoughtful, considering the meaning of it. Was it the attitude of a man who had committed suicide? Was it conceivable that Robert Turold would break off in the middle of a sentence, in the middle of a word, and shoot himself? It seemed a strange thing to do, but Barrant’s experience told him that there were no safe deductions where suicides were concerned. They acted with the utmost precipitation or the utmost deliberation. Some wound up their worldly affairs with businesslike precision before embarking on their timeless voyage, others jumped into the black gulf without, apparently, any premeditated intention, as if at the beckoning summons of some grisly invisible hand which they dared not disobey. Barrant recalled the strange case of a wealthy merchant who had cut his throat on a Bank holiday and confessed before death that he had felt the same impulse on that day for years past. He had whispered that the day marked to him such a pause in life’s dull round that it seemed to him a pity to start again. He had resisted the impulse for years, but it had waxed stronger with each recurring anniversary, and had overcome him at last.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Every suicide was a law unto himself. Barrant willingly conceded that, but he could not so easily concede that a man like Robert Turold would put an end to his life just when he was about to attain the summit of that life’s ambition. It was a Schopenhauerian doctrine that all men had suicidal tendencies in them, in the sense that every man wished at times for the cessation of the purposeless energy called life, and it was only the violence of the actual act which prevented its more frequent commission. But Barrant reflected that in his experience suicides were generally people who had been broken by life or were bored with it. Men of action or intellect rarely committed suicide, not because they valued life highly, but because they had so much to do in their brief span that they hadn’t time to think about putting an end to it. Death usually overtook them in the midst of their schemes.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Robert Turold was not a man of intellect or action, but he belonged to a type which, as a rule, cling to life: the type from which zealots and bigots spring—men with a single idea. Such men shrink from the idea of destroying the vital engine by which their idea is driven forward. Their ego is too pronounced for that.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It was true that Robert Turold believed he had realized the aim for which he had lived, and therefore, in a sense, had nothing more to live for. But that point of view was too coldly logical for human nature. Its presumption was only applicable to a higher order of beings. No man had ever committed suicide upon achieving the summit of an ambition. There were always fresh vistas opening before the human mind.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant left the study for the opposite room where the body of Robert Turold had been taken. It was his bedroom, and he had been laid upon the bed.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Death had not come to him easily. His harsh features were set in a stern upward frown, and the lower lip was slightly caught between the teeth, as though bitten in the final rending of the spirit. But Barrant had seen too much of violent death to be repelled by any death mask, however repellent.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He eyed the corpse closely, and then proceeded to examine the death wound. In doing so he had to move the body, and a portion of the sleeve fell back, exposing the left arm to the elbow. Barrant was about to replace it when his eye lighted upon a livid mark on the arm. He rolled back the garment until the arm lay bare to the shoulder. The disclosure revealed four faint livid marks running parallel across the arm, just above the elbow.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The arms had been straightened to the body to the elbows, and then crossed decorously on the breast. Barrant walked round to the other side of the bed, knelt down by the edge of it, and examined the underneath part of the arm. A single livid mark was imprinted upon it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The inference was unmistakable. The four upper marks were fingerprints, and the lower one a thumb mark. Somebody had caught the dead man’s arm in such a strenuous grip that the livid impression had remained after death.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The discovery was significant enough, but Barrant was not at that moment prepared to say how much it portended. It seemed certain that the marks had not been made by Robert Turold himself. Their position suggested a left-hand clutch, though only a finger-print expert could definitely determine that point. Even if they were not, it was too far-fetched a supposition to imagine a man gripping his own arm hard enough to bruise it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The relative weight of this discovery was, in Barrant’s mind, weakened by the fact that the marks might have been caused by the persons who had carried the body from the next room. Nevertheless, the marks must be regarded as infirmative testimony, however slight, of the fallibility of the circumstantial deductions which had been made from the discovery of the body in a locked room, with windows which could not be reached from the outside.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The presumption of suicide rested on the theory that the circumstances excluded any other hypothesis. But Barrant reflected that he did not know enough about the case to accept that assumption as warranted by the facts. The one certainty was that the study could not have been reached from the outside. Barrant had noted the back windows before entering the house; his subsequent interior examination had strengthened his conviction that they were inaccessible. Underneath the study windows there was only the narrowest ledge of rock between that side of the house and the edge of the cliffs. A descent from the windows with a rope was hazardously possible, but ascent and entrance by that means was out of the question.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("On the other hand, the theory of interior inaccessibility had a flaw in it, due to the presence of five different people in the room before the police arrived. Their actions and motives would have to be most carefully weighed and sifted before the implication of the discovery of the finger-marks could be determined.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The rather breathless entrance of Inspector Dawfield put an end to Barrant’s reflections. He explained that Sergeant Pengowan, in his anxiety to maintain the correctness of his official report, had taken him to various breakneck positions at the back of the house and along the cliffs in order to demonstrate the impossibility of anybody entering Robert Turold’s rooms from outside. The sergeant was at that moment engaged in a room downstairs drawing up his reasons for that belief. “A kind of confirmatory report,” Dawfield explained. “He fears that his reputation is at stake.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“He can save himself the trouble,” said Barrant. “The solution of Robert Turold’s death lies in these two rooms, if anywhere.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Something in his companion’s tone caused Inspector Dawfield to direct an interrogative glance at him. “Have you discovered something?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Finger-marks on the left arm, a left-hand impression, I should say.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He drew back the loose sleeve of the dead man, and Dawfield examined the marks attentively. “This is strange,” he said. “It looks suspicious.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Strange enough, and certainly suspicious. The point is, is it suspicious enough to upset the theory of suicide? The marks are too faint to enable us to determine whether they are of recent origin. But I think that we must assume that they are. It has occurred to me that they may have been caused when the body was picked up from the floor of the other room and carried in here.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“In that case the marks would have been underneath the arm. In lifting a heavy weight like a corpse it would be natural to place the hands under the shoulders, for greater lifting power.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“There’s something in that, but it’s by no means certain. It would depend on the position of the body. According to Pengowan’s report, Robert Turold was found lying face downward. The body would have to be turned over before it was lifted, and the grip might have been made in pulling it over. We must find that out.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It’s a point which can be settled at once by questioning Thalassa. He helped Pengowan carry the body into this room.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That is the very thing I do not wish to do,” rejoined Barrant quickly. “We have to remember that Thalassa is, for the time being, suspect. Mrs. Pendleton’s suspicions of him may be based on the slightest foundation, but we are bound to keep them in mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Do you not intend to question him at all?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Not at present. His attitude when he brought me upstairs was that of a man on his guard, expecting to be questioned. I saw that at once, and decided to say nothing to him. I will take him by surprise later on, when he is off his guard, and if he is keeping anything back I may be able to get it out of him. But we must not be too quick in drawing the conclusion that those marks were made by him.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What makes you say so?” asked Inspector Dawfield.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Thalassa has a long bony hand, with fingers thickened by rough work. I noticed it when he was pointing to these rooms from the passage. This grip looks as if it might have been made by a smaller hand, with slim fingers. Look how close together the marks are! Unfortunately, that’s about all we’re likely to deduce from them, and I doubt if a finger-print expert will be able to help us. Observe, there are no fingerprints—merely faint marks of the middle of the fingers, and a kind of blur for the thumb. But the thing is suspicious, undoubtedly suspicious.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Still, the door was locked from inside,” said Dawfield. “We mustn’t lose sight of that fact.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“And the key was found in the room. We must also remember that there were several people in the room after the door was burst open, including the dead man’s brother. It seems that it was he who first propounded the suicide theory to Dr. Ravenshaw, and subsequently to Pengowan. Do you know anything about the brother?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I know nothing personally. Pengowan tells me that Robert Turold secured lodgings for his brother and his son in an artist’s house at the churchtown about six weeks ago. They arrived next day, and are still there. I understand that the brothers have been in pretty close intimacy, meeting each other practically every day, either at the churchtown or in this house.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Do you know what took place at the family gathering which was held in this house yesterday afternoon, after the funeral?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“All I know is that Robert Turold informed his family that he was likely to succeed in his claim for the title. Mrs. Pendleton was rather vague about the details, but she did say that her brother had placed his daughter in her charge, and had made a long statement to them about his future plans.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“She did not indicate what those plans were?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Only in the vaguest way. I remember her saying that her brother was a wealthy man: the one wealthy member of the family, was the way she put it. Her principal preoccupation was her suspicion of the man-servant, based on seeing him listening at the door. She was very voluble and excited—so much so that I did not attach much importance to what she said, and did not ask her many questions.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It is of the utmost importance that we should find out all we can about this family council yesterday. It is possible that it may throw some light on Robert Turold’s death. I am not prepared at present to say whether it is suicide or not, but apart from any suspicious circumstances, I feel that there is some justification for Mrs. Pendleton’s belief that a wealthy and successful man like her brother was not likely to take his own life, unless there was some hidden reason for him to do so. If we knew more of what happened downstairs yesterday we might be in a better position to judge of that. The case strikes me as a very peculiar one—indeed, it has some remarkable features. My first task will be to interview all the persons who were present at yesterday’s gathering. Can you tell me if the brothers were on good terms?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I believe so.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Is Austin Turold a poor man?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I know nothing about him. But what has that got to do with it?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It may have much to do with it. He may have stood to inherit a fortune from Robert.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You surely do not suspect the brother?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I suspect no one, at present,” returned Barrant. “I am merely glancing at the scanty facts within our knowledge and seeing what can be gathered from them. Robert Turold is found dead in his study, with his hands on an old clock, where he kept important papers, including his will. We are indebted to Austin Turold for that knowledge. But how did Austin Turold come to know that his brother kept his will in the clock-case? Did Robert tell him, or did he find it out? Was Austin aware of the contents of the will? Why did Robert go to the clock? Was his idea to destroy the will? And was that after or before he was shot, or shot himself?")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“These are questions we cannot answer without further knowledge, but they seem to point to the existence of some family secret of which we know nothing. We must find out what it is. I shall first interview Austin Turold, and then call on Dr. Ravenshaw, if time permits. You’d better drop me at the churchtown on your way back to Penzance. There’s really nothing to detain you any longer.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("They returned to the churchtown in the motor-car, and Pengowan from the back seat directed the way to Austin Turold’s lodgings.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer014"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-14"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor013"
    }
  }), _vm._v("Chapter XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("“Oh yes, I’m modern enough,” said Austin Turold, balancing his cigarette in his white fingers, and glancing at Barrant with a reflective air—“that is to say, I believe in America and the League of Nations, but not in God. It’s not the fashion to believe in God or have a conscience nowadays. They both went out with the war. After all, what’s a conscience to a liver? But here I am, chattering on to distract my sad thoughts, although I can see in your eye that you have it in you to ask me some questions. Well, go ahead and ask them, and I will answer them—if I can.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I do wish to ask you some questions,” said Barrant—“questions connected with your brother’s death.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I know very little about it. It was a most terrible shock to me, I assure you, and is likely to detain me in this barbarous place longer than I intended—greatly against my will.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I understand you came to Cornwall at your brother’s request?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yes. My brother sent for me and my son more than a month ago, so we came at once. I’ll forestall the further inquiry I see on your lips, and tell you why I came so promptly. My brother Robert was the wealthy member of the family, and I was the poor one—a poor devil of an Anglo-Indian with nothing on this side of the grave but a niggardly Civil Service pension!")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“When we arrived I found that Robert had already taken these lodgings for us, which was as near as he could get accommodation to his own house. I did not object to that arrangement, because I do not like hotels nowadays—not since the newly-rich started to patronize them. So here I’ve been rusticating ever since, conferring daily with my poor brother, and eating the four meals a day which are provided with the lodgings by the estimable people of this house. My landlord is an artist. That is to say, he’s forever daubing pictures which nobody buys. I’ve come to the conclusion that most people dislike Cornwall because of the number of bad pictures which are painted here. You see some samples of my host’s brush on these walls. They are actually too bad to be admitted to the Academy. My poor host and hostess, being unable to make ends meet, were obliged to take in lodgers. The fact, however, is not unduly obtruded. We discuss Art at night, and not the scandalously high price of food. I get on very well, but then I can adapt myself to any society. I pride myself on being a philosopher. But my son is not so facile. My worthy entertainers regard him as a Philistine, and bestow very little of their attention upon him. He spends his time in taking long walks through the wilds. He is out walking at present. I am sorry he is not here.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The conversation was suspended by the entrance of an elderly maid servant with a long and melancholy white face, thickly braided hair, strongly marked black eyebrows, wearing a black dress with white apron, and a white bow in her hair, who came to ask if Mr. Turold required any more tea. On learning that he did not she withdrew as noiselessly as she had entered.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I see you are looking at our parlour-maid,” said Austin Turold, following the direction of his visitor’s glance.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“She’s a strange sort of parlour-maid,” admitted the detective. “She reminds me of—of—”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“A study in black and white,” suggested his host. “Her face is her fortune. She’s sitting to Brierly—that’s my host—for his latest effort. He’s painting her as the Madonna or Britannia—I really forget which. A new type, you know. The servants in this house are engaged for their faces. They had a villainous scoundrel of a man-servant—a returned soldier—engaged as Judas Iscariot, who bolted last week with the silver spoons. But all this is beside the point, Mr. Barrant, and I must not waste your time. You have come here for a specific purpose—to turn me inside out. What can I tell you?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I want to know all that you can tell me about your brother’s death,” said the other, with emphasis.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“But what can I tell you that you do not already know?” exclaimed Austin, raising his eyebrows with a helpless look. “Ask me what questions you like, and I’ll endeavour to answer them. When the famous Detective Barrant—for I understand from the newspapers that you are famous—takes an interview in hand I expect him to handle the situation in a masterly fashion, as befits his reputation. So ask your questions, my dear fellow, and I’ll do my utmost to respond.” Austin Turold took off his glasses, and posed himself in an attitude of expectation, with his eyes fixed upon the detective’s face.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant eyed the elder man with a puzzled curiosity which was tolerably masked by official impassivity. Barrant had his own methods of investigation and inquiry. He brought an alert intelligence, a seeing eye, and a false geniality to bear in his work. Unversed in elaborate deduction, he flattered himself that he knew enough about human nature to strike the balance of probabilities in almost any case. His cardinal article of faith was that there was nothing like getting on good terms with those he was interviewing in order to find out things. Most people were on their guard against detectives, who too often took advantage of their position to assume offensive airs of intimidation, whereas the great thing was to disarm suspicion by a friendly manner. Barrant had cultivated pleasantness with considerable success. Some who were not good judges of physiognomy were apt to overlook the watchful eyes in his smiling affable presence, and talk freely—sometimes too freely, as they later on discovered to their cost. A chance word, a significant phrase, was sufficient to set him burrowing underground with the activity of a mole, to burst into the open later on with all his clues complete, to the confusion of the trusting person with an unguarded tongue.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He had put these tactics into execution with Austin Turold. Austin, taking tea when he called, in a bright blue room hung with pictures, had received his visitor with a charming cordiality, insisted on his taking tea with him, and then let loose a flood of small-talk, as though he were delighted with his visitor. His welcome was so perfect, his manners so gracefully unforced, that Barrant had an uneasy suspicion that he was being beaten at his own game, and was slightly out of countenance in consequence. Up to that moment he could not, for the life of him, decide whether Austin Turold’s polished self-assurance was a mask or not. It seemed too natural to be assumed.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Your own opinion is that your brother committed suicide?” he asked again.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No other conclusion is possible, in my mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“But did he have any reason, that you know of, to commit suicide?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Austin shrugged his shoulders. “Suicide is not usually associated with reason,” he observed. “But in Robert’s case there is a reason, or so it seems to me. I have not seen him for many years, but during my recent close association with him I was struck by two things: the solitary aloofness of his mind, and his overwhelming pride—pride in the family name. These two traits in his character coloured all his actions. In the first place, he disliked opening his mind to anybody, but the stronger influence, his family pride, overcame his habitual secretiveness when he thought it necessary and desirable to do so in furtherance of his darling ambition—the restoration of this title. Men who lead a solitary, self-contained life, like my brother, become introspective and ultra-sensitive, and face any intimate personal revelation with the utmost reluctance. They will nerve themselves to it when the occasion absolutely requires, but the after effects—the mental self-probings, the agonized self torture that a self-conscious proud man can inflict on himself when he comes to analyze the effects of his disclosure on other minds, are sometimes unendurable.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Austin put forward this analysis of his brother’s state of mind with a gravity which was in complete contrast with the light airiness of his tea-table gossip, and Barrant felt that he was speaking with sincerity.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yes, I can understand that,” he said with a thoughtful nod.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I think that is what happened in my brother’s case, when he felt called upon to reveal, as he did yesterday, a shameful family secret which hurt him in his strongest point—his family pride.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Stop a minute,” interrupted Barrant, in a surprised voice. “I really do not follow you here. What is this shameful secret to which you refer?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Austin Turold looked surprised in his turn. “It had to do with his marriage and his daughter’s legitimacy,” he slowly replied. “Surely my sister imparted this to the Penzance police inspector, when she besought his assistance?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I know nothing about it,” replied Barrant quickly and emphatically. “I shall be glad if you will tell me.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Certainly.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Austin Turold related the story of his brother’s. Again he spoke in careful grave words, and with a manner completely divested of any trace of his habitual flippancy.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It appears to me that this revelation must have had a very painful effect on Robert’s mind,” he added. “You must remember that he was an abnormal type. An ordinary man would not have made such a disclosure on the day of the funeral of the woman who was supposed to be his wife. But all Robert’s acts hinged on his one great obsession. He allowed nothing to come between him and his one ambition—not even his wife (let us call her so) and child. But it would come home to him afterwards—I mean the normal point of view—the way the world would regard such a disclosure—and I have no doubt that his belated mental anguish and morbid thoughts impelled him to take his life. Understand me, Mr. Barrant, I do not mean that he did this through remorse, but through the blow to his pride. He couldn’t face the racket—the gossip, the notoriety and all the rest of it.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“But according to your story, your brother had nothing to blame himself for,” said Barrant. “You say that he was ignorant of this earlier marriage until recently?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Public sentiment will not look at it that way. People will say he sacrificed a dead woman and his daughter to his own selfish ends—threw them over when he had attained his ambition. That’s what came home to him, in my opinion.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I see.” Barrant was silent for a while, turning this over in all its bearings. “Yes. There may be something in that point of view. But did not your brother confide this story to you before yesterday?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“When we were alone together during the last few days he frequently seemed on the point of telling me something. I could see that by his manner. But he never got beyond a certain portentousness, as it were. It’s my belief now that he wanted to tell me, but couldn’t quite bring himself to it. I am very sorry that he didn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Do you know how long your brother has been aware of this earlier marriage?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Quite recently, I believe. He gave us to understand yesterday that it was a death-bed confession.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Are there any proofs of the earlier marriage?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I am afraid I cannot enlighten you on that point either.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“This is very strange,” said Barrant. “The proofs are very important. This disclosure vitally affected your brother’s ambitions, and was therefore likely to influence his views regarding the disposition of his property.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He shot a keen glance at his companion. Austin laid aside his glasses and bent earnestly across the table.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I will be frank with you,” he said, “quite frank. My brother told me a little more than a week ago that he had made a new will, and that I was his heir.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Where is this will?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I found it in the clock-case at Flint House last night, and I have since handed it to the lawyer who drafted it.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Your brother gave you no indication of this before?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No. He told me when I came that he had summoned me to Cornwall because of the great change in the family fortunes. As I was his only brother he desired my presence in the investigation of the final proofs and the preparation of his claim for the House of Lords. Nothing was said about the succession then. Robert was very excited, and talked only of his own future. I feel sure that he was not then thinking of who was to succeed to the title after his death. He looked forward to enjoying it himself. I certainly did not give it a thought, either. Who could have foreseen this tragic event?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Do you know anything about this peerage?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Not till latterly. I never took it seriously, like Robert. I looked upon it as a family fiction. I understand that the Turrald barony was a barony by writ—whatever that may be. The point is that if my brother had lived to restore it, the title, on his death, would have descended to his only daughter, if she had been born in wedlock. As she is illegitimate, the title would have descended to me, and after me to my son.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You were here last night when they brought you the news of your brother’s death, I understand?” remarked Barrant, in a casual sort of way.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yes; I did not go out again after I returned from the funeral.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Was your son home with you?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Most of the time. He came in later than I, and then went out for a walk when the storm cleared away. I did not see him again until this morning. Thalassa came for me with the news of my brother’s death, and I did not get back from Flint House until very late.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I suppose you are aware your sister does not share your view that your brother committed suicide?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I understand she has some absurd suspicion about Thalassa, my brother’s servant.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Why do you call her suspicion absurd?” asked Barrant cautiously.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It is more than absurd,” replied Austin warmly. “I am ashamed to think that my sister should have given utterance to such a dreadful thought against a faithful old servant who has been with Robert for half a lifetime, and was devoted to him.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Mrs. Pendleton saw him looking through the door.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“She only thought so. She went to the door immediately to find out who it was, but there was nobody there.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Do you think she imagined it?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No; I think somebody was there, but it is by no means certain that it was Thalassa. It might have been Thalassa’s wife. It might even have been Robert’s daughter.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Was not Miss Turold present at the family gathering?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No; my brother naturally did not wish her to be present, and she went upstairs. She went out while we were in the room. The door was slightly open, and she may have glanced in as she passed.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“But this person was listening.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Austin Turold shrugged his shoulders.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Was your brother talking about his marriage at the time?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Could Miss Turold have heard what he was saying?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Anybody could. The door was partly open.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“There is some mystery here.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant spoke with the thoughtful air of one viewing a new vista opening in the distance. These surmises about the listener at the door, by their manifest though perhaps unintended implication, pointed to a deeper and more terrible mystery than he had imagined.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Austin Turold did not speak. Darkness had long since fallen, and a lamp, which had been brought in by the maid who was also the model, stood on the table between the two men, and threw its shaded beams on their faces. A clock on the mantel-piece chimed eight, and aroused Barrant to the flight of time.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I must get back,” he said. “I intended to see Dr. Ravenshaw, but I shall leave that until later. Can I get a conveyance back to Penzance?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“There is a public wagonette. I am not sure when it goes, but it starts from ‘The Three Jolly Wreckers’ at the other end of the churchtown.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“‘The Three Jolly Wreckers!’ That’s rather a cynical name for a Cornish inn, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Oh, the Cornish people are not ashamed of the old wrecking days, I assure you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("He accompanied Barrant to the door with the lamp, which he held above his head to light him down the garden path. Barrant, glancing back, saw him looking after him, his face outlined in the darkness by the yellow rays of the lamp.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer015"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-15"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor014"
    }
  }), _vm._v("Chapter XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("Barrant found the inn at the dark end of a stone alley, with the sound of tipsy singing and shuffling feet coming through the half-open door. He made his way up three granite steps into a side-entrance, catching a glimpse through a glass partition of shaggy red faces and pint pots floating in a fog of tobacco smoke. A stout landlord leaned behind the bar watching his customers with the tolerant smile of a man who was making a living out of their merriment. He straightened himself as he caught sight of Barrant, and opened the sliding window. The detective inquired about the wagonette, and learnt that it had not yet arrived.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“The roouds is rough, and old Garge Crows takes his time,” said the landlord, eyeing Barrant with a heavy stare. “’Tain’t as thow ’e had a passel of passergers to be teeren rownd after.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Can you give me some supper while I’m waiting?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Sooper?” The innkeeper scratched his chin doubtfully. “’Tis late in the ebenin’ to be getting sooper. There’s nawthing greut in the howse. You could ’ave some tay—p’raps an egg.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That will do.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The innkeeper roared forth a summons, which was answered by a rugged Cornish lass from the kitchen. She cast a doubtful glance on the young man when she learnt what was required, and took him into a small sitting-room, where she left him to gaze at his leisure upon a framed portrait of Cecil Rhodes, a stuffed gannet in a large glass case, and a stuffed badger in a companion case on the other side of the wall. In about twenty minutes she returned with a tray, and placed before the detective a couple of eggs, some bread and butter, saffron cake, and a pot of tea. The eggs were of peculiar mottled exterior, and when tasted had such a strong fish-like flavour as to suggest that they might have been laid by the gannet in its lifetime, and stowed away by a careful Cornish housewife until some stranger chanced to visit that remote spot. Barrant was hungry enough to gulp them down, though with a wry face. He had just finished a second cup of very strong tea when he heard the clatter of a vehicle outside, and the girl thrust a tousled dark head through the door to announce the arrival of Mr. Crows and his wagonette.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant paid for his food and went out. An ancient hooded vehicle filled the narrow way, drawn by a large shaggy horse which turned a gleaming eye on the detective as he emerged, and snorted loudly, as though resenting the prospect of having to drag his additional weight back to the town. The driver sat motionless on the box, watching the caperings of the tipsy tin-miners through the half-open door: a melancholy death’s head of a man, with a preternaturally long white face, and a figure shrouded in a dark cloak, looking as though he might be Death itself, waiting for the carousers to drop dead of apoplexy before carrying them off in his funereal equipage. In reply to Barrant’s question he informed him that the vehicle was destined for Penzance, and immediately the detective entered the dark interior he drove off with disconcerting suddenness, as though he had been waiting for him only, and was determined to make sure of him before he had time to escape.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The shaggy horse lumbered forward at an unwilling trot, like an animal disillusioned with life. Soon they cleared the churchtown and entered the darkness of the moors. A long and tiring day disposed Barrant to slumber. He had begun to nod sleepily when the wagonette stopped with a jerk which shook him into wakefulness. He was able to make out that they had reached the highest elevation of the moors—the cross-roads from where Inspector Dawfield had shown him Flint House in the distance that afternoon. He could just discern the outlines of the wayside cross and the old Druidical monolith, both pointing to the silent heavens in unwonted religious amity.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Good ebenen’, Garge.” A lusty voice hailed out of the darkness, and then Barrant was aware of somebody entering the wagonette, a large male body which plumped heavily on his knees as it started again.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Bed pardin, I’m sure. Aw dedn’t knaw Crows had another passenger to-night.” A husky voice spoke unseen. “’Taint often it ’appens.” There was the splutter of a match, and as it flared up Barrant saw a pair of twinkling grey eyes regarding him from a brown and rugged face. “Old Garge never reckons on haavin’ passengers back by th’ laast wagonette, so ’e never lights up inside. I’ll make a light now, then we’ll be more comfortable.” He struck another match and lit the candle in the wagonette lamp, and was revealed to Barrant’s eyes as a stout and pleasant-faced man of fifty or so, with something seamanlike, or at least boatmanlike, in his appearance. He gave the detective a smile and a nod, and added, “Old Crows is fullish mean about candles.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It’s a wonder he drives the wagonette at all, if there is no demand for it,” remarked Barrant.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Aw, there’s a’plenty demand for it—always lots of passergers except by this one,” rejoined the man in the blue suit. “You’d be surprised how people gets about in these paarts.” He was studying the detective’s face with interest. “You be a Londoner,” he said quickly. “What braught you down here?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“How do you know that I’m a Londoner?” said Barrant, parrying the latter part of the question.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I can tell a Londoner at once,” returned the other.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“’Twould be straange if I couldn’t. I’m Peter Portgartha. P’raps you haven’t heard of me, but I’m well known hereabouts, and if you want to see any of the sights, you’d best coome to me, and I’ll show you round.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“A guide, eh?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“There be guides and guides. I’ll say nathin’ about th’ others, but there’s nobody knaws this part of Cornwall like me. I was born and bred and knaw every inch of it. Before the waar I’ve had London ladies say to me: ‘’Ave you ever seen the Bay of Naples, or the Canaries? Oh, you should see them, Mr. Portgartha, they’re ever so much more grand than Cornwall.’ Well, while the war was on I did see the Canaries and Bay of Naples at Government’s expense on a minesweeper, and they’re not a patch on the Cornwall coast. There’s nathin’ to beat it in the world.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It’s good, is it?” said Barrant, with his accustomed affability to strangers. “If I want to see any of it I’ll get you to show me round.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Just came along to th’ Mousehole and ask for Peter Portgartha. There’s a great cave at the Mouse’s Hole—that’s what we call it hereabouts, that ain’t to be beaten in the whole world. If your good lady’s here, bring her with you to see it. There ain’t nobody else can show it to her like I can. The London ladies don’t like goin’ down the Mousehole cave as a rule, because it’s a stiffish bit of a climb, and in the holiday season there’s always a lot of raffish young fellows hangin’ round to see the ladies go down—to see what they can see, you knaw. But I never ’ave no accidents like that. No bold-eyed young chap ever saw the leg of any lady in my charge—not so much as the top of a boot, because I knaw how to taake them down. I’m well known to some of the ’ighest ladies in the land because I ’ev been aable to take care of their legs when they were goin’ down. I’ve had letters from them thaankin’ me. You’ve no idea how grateful they be.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("This startling instance of the stern morality of aristocratic womanhood was unfortunately wasted on Barrant, whose thoughts had reverted to the principal preoccupation of his mind. Mr. Portgartha rambled on.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Aw, but it’s strange to be meetin’ you like this, in old Garge’s wagonette. For twelve months I’ve been goin’ acrass the moors to see a sister of mine, who’s lonely, poor saul, havin’ lost her man in the war—drawned in a drifter ’e was—and catchin’ this wagonette back every night, with never a saul to speak to, until last night. Last night there was a passerger, and to-night there’s you. Tes strange, come to think of it.” He looked hard at Barrant as if for some confirmatory expression of surprise at this remarkable accession to the wagonette’s fares. He waited so long that Barrant felt called upon to say something.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Who was your fellow passenger last night?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Now you’re asking me a question which takes a bit of answerin’,” replied Mr. Portgartha. “’Twas like this. I was waitin’ at the crass-roads for old Garge to come along, when a young womon came up out of th’ darkness and stood not far from me—just by the ol’ crass. I tried to maake out who she was, but it was too daark. So I just says to her, ‘Good ebenin’, miss, are you waitin’ for the wagonette too?’ She never answered a word, and before I could think of anything else to say old Garge came along, and we both got in. She sat in a corner, silent as a ghooste. Well, then, I went to light th’ lamp, same as I have to-night, but as luck would ’ave it, I hadn’t a match. I knaw it was no use askin’ old Garge, ’cos he’d pretend not to hear, so I turned to the young womon sittin’ opposite, and asked her if she had a match in her pocket. And do you knaw, I declare to gudeness she never said nawthen, not so much as a word!”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Perhaps she was dumb?” Barrant suggested.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Aw, iss, doomb enough then,” retorted Mr. Portgartha. “I tried her two or three times more, but couldn’t get a word out of her. Well, at last I began to get narvous, thinkin’ she might be a sperit. So I leant across to her an’ says, ‘Caan’t you say a word, miss? It’s only Peter Portgartha speaking, he’s well known for his respect for your sect. No young womon need be frightened of speakin’ to Peter Portgartha.’ And with that she spaaks at last, with a quick little gasp like a sob—I’m thinking I can hear it at this minute—‘Aw,’ she says, ‘why caan’t you leave me alone?’ ‘Never be afraaid,’ I says, for I have my pride like other folk, ‘I’ll say no more. Peter Portgartha has no need to foorce his conversation where it ain’t welcome.’”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“A strange girl!” said Barrant, beginning to feel an interest in the story. “Have you no idea who she was?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Wait a bit,” continued Mr. Portgartha, evidently objecting to any intrusion on his right, as narrator, to a delayed climax. “Well, there we sat, like two ghoostes, till we got to Penzance, but all the time I was thinkin’ to mysel’ that I’d find out who she was. I sed to myself I’d ride on to the station, instid of gettin’ out a piece this side of it so as to make a short cut across to the Mouse’s Hole, as I usually do. But that stupid old fule Garge pulled up as usual and bawls through the window, ‘Are you going to keep me here all night, Peter?’ Before I could say a word the young womon says: ‘I’ll get out here.’ With that she puts the fare into his hand through the open window, and slips out afore I knew what she was going to do. If it hadn’t been for my rhoomatics, which I got in the war, I’d ‘a followed her. As it was, I couldn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“So you didn’t see her face, after all?” asked Barrant quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I didn’t, in a manner of speakin’. But I did get a glimpse of her as she passed near the lamp-post—just a half-sight of two big dark eyes in a white face as she went past. I wouldn’t ’a thought no more of it,” added Mr. Portgartha, laying an impressive hand on his companion’s knee, “but for what happened at Flint House last night.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What’s that got to do with it?” In his quickened interest Barrant vainly strove to make his voice appear calm.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Because the young womon must have coome from Flint House.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant scrutinized his companion sharply in the dim light. “Why do you think so?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“For’n thing, the wayside crass where she picked up the wagonette is not far from Flint House by acrass the moors—closer’n goin’ from the house on the cliffs t’ the churchtown, which is a good slant to the north of it. From Flint House to the crass-roads it’s straight as a dart, if you know yer way, with only one house twixt it till you come arver to it—old Farmer Bardsley, who ain’t got no wemmenfolk, so it’s sartin she didn’t come from theer. She wasn’t a maa’iden from any of the farms of the moors, for I know them all. But it weren’t till this marning that I got a kind of notion who she was. I dropped into the "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Tolpen Arms")]), _vm._v(" to have a drop of something for a cawld I’ve got, and some of the fishermen were talkin’ about th’ old gentleman of Flint House blowing his head off last night with a gun. It made me feel queery-like when I heerd aboot it. ‘Why,’ I says, ‘that’ll be about the time I saw the strange young womon in ol’ Crows’ wagonette. She must ’ave come from Flint House, now I coome to think of it.’ ‘What young woman was that?’ asked ’Enery Waitts. So I told them what had happened to me, just like I’ve told it to you. Mrs. Keegan, the land-lady, who was list’ning, says, ‘I shouldn’t be surprised if it was Mr. Turold’s daughter that you saw. I heard yesterday that his sister was staying at Penzance, so p’raps she was going to her, after it happened. So if it was her it’s not surprisin’ she didn’t want to speak to you in her grief.’”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Did you ever see Miss Turold?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I’ve never see any one of the Flint House folk, though I’ve heerd of them, often enough.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Did you notice in which direction this girl went?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No. She passed the lamp-post as if she were maakin’ up Market Jew Street, but I suppose she ced ’ave turned off anywhere to the right or left.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What time was it when the wagonette reached the cross-roads on the moor, where she got in?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“About the same time as to-night, getting on for ten, mebbe.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“She was quite alone?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“As lonely as any she ghooste, standin’ theer by the old crass. ’Twaas because I thought she’d feel feersome that I spoke to her.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant relapsed into a thoughtful silence which lasted until the wagonette pulled up and his fellow-traveller prepared to alight. Then he turned to him and said—")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Good-night. I may see you again.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He fumbled at the interior window as he spoke, opened it, and touched the driver on the shoulder. “Drive me to the Central Hotel,” he said. “Go as fast as you can, and I’ll give you ten shillings!”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("Mr. Crows nodded a cold acquiescence, and they rattled off down the silent street, leaving on Barrant’s mind a receding impression of a startled red face staring after them from the footpath. The wagonette jolted round a corner, and ten minutes later stopped at the entrance of the hotel where Mrs. Pendleton was staying.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer016"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-16"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor015"
    }
  }), _vm._v("Chapter XV")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("When Barrant learnt from the trembling lips of Mrs. Pendleton that she had not seen her niece since that morning, his first step was to get Sisily’s full description, and call up Dawfield on the hotel telephone with instructions to have all the railway stations between Penzance and London warned to look out for her. That was a necessary precaution, but it did not need Dawfield’s hesitating information about time tables to convince him that it was almost futile. The later of the two trains by which Sisily might have fled from Cornwall had reached London and discharged its passengers somewhere about the time that Mr. Peter Portgartha, in the depth of the rumbling wagonette, was paying his tribute to shrinking female modesty as exhibited on Mousehole rocks.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("After doing this Barrant returned to the empty lounge, where Mrs. Pendleton sat in partial darkness with tearful face. All the other guests had retired, and a lurking porter yawned longingly in the passage, waiting for an opportunity to put out the last of the lights and get to bed.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("In the first shock of Barrant’s violent apparition and angry questions, Mrs. Pendleton had tried, in a bewildered way, to insist that her niece had not left her room on the previous night. But now, in her troubled consideration of the new strange turn of events surrounding her brother’s death, she saw that she might have been deceived on this point. Barrant, for his part, had not the slightest doubt of it when he heard that her belief rested on no stronger foundation than Sisily’s early withdrawal from the dining-room on the plea of fatigue, and the fact that her bedroom door was locked when Mrs. Pendleton returned from her own visit to Flint House. Sisily’s subsequent flight eliminated any uncertainty about that, and established beyond reasonable doubt her identity with the silent girl who had entered the returning wagonette at the cross-roads. The "), _c('br'), _vm._v("coincidence of those two facts had a terrible significance. Barrant had no doubt that Sisily had gone to her own room early in order to find an opportunity to pay a secret visit to her home, for a purpose which now seemed to stand sinisterly revealed by her disappearance. He also thought he saw the motive—that vital factor in murder—looming behind her nocturnal expedition. But that was a question he was not inclined to analyze too closely at that moment. He wanted to know how she had been able to disappear that day without the knowledge of her aunt.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mrs. Pendleton had a ready explanation of that. She said that after returning from her visit to the police station that morning she had been engaged with her brother Austin until nearly lunch-time, and when she went up to Sisily’s room she found it empty. She concluded that her niece had gone out somewhere to be alone with her grief—she was the type of girl that liked to be alone. After lunch Mrs. Pendleton had letters to write, and then she had gone to her bedroom and fallen sound asleep till dinner-time, worn out by the shock of her brother’s death, and the sleepless night which had followed it. When Sisily did not appear at dinner she began to grow uneasy, but sought to convince herself that Sisily might have gone on a "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("char-à-banc")]), _vm._v(" trip to Falmouth which had been advertised for that day. The incongruity of a sad solitary girl like Sisily nursing her grief in a public vehicle packed with curious chattering trippers did not seem to have occurred to her. But as time passed she grew seriously alarmed, and sent her husband out to make enquiries.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She had sat in the lounge listening with strained ears for the girl’s footsteps until Barrant arrived.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Has your niece any friends in Cornwall or London, or anywhere, for that matter, who would receive her?” Barrant abruptly demanded.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I really do not know,” said Mrs. Pendleton.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She wiped the tears from her eyes with a large white handkerchief. She was overwhelmed by the shock of her niece’s disappearance, and the terrible interpretation Barrant evidently placed upon it. But Barrant was in no mood to allow for her confused state of mind.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You had better try and remember,” he said irritably. “It seems to me that I’ve been kept in the dark. You went to the police to demand an investigation into your brother’s death, but you did not say anything of the disclosure he made to you yesterday of his daughter’s illegitimacy. Instead of doing so, you only directed suspicion to his man-servant. Meanwhile your niece, who was placed in your care, disappears to heaven knows where, and you took no steps to inform the police. You have acted very indiscreetly, Mrs. Pendleton, to say the least.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I did not know—I did not think,” gasped Mrs. Pendleton. She endeavoured to commence a flurried explanation of the mixed motives and impulses which had swayed her since her brother’s death, but Barrant cut it short with an impatient wave of the hand.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Never mind that now,” he said. “I have lost too much time already. Have you no idea where your niece is likely to have sought refuge?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mrs. Pendleton shook her head. “Robert had no friends,” she said, “and Sisily led a very lonely life. Robert told me that yesterday. That was the reason he wanted me to take charge of her—so as to give her the opportunity of making some girl friends of her own age.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She paused, embarrassed by the recollection that her brother’s real intention in placing Sisily in her charge was altogether different. Barrant noted her hesitation, and interpreted it aright.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No,” he said. “The real reason of your brother parting with his daughter provides the motive for her return to his house last night. What happened between them is a matter for conjecture, at present. Apparently she was the last person who saw him alive before he was shot, and now she is not to be found.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("There was something so portentously solemn in his manner of speaking these last words that his listener quaked in terror, and gazed at him with widened eyes. Barrant turned abruptly to another phase.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Are you quite sure that it was the man-servant you saw looking through the door yesterday afternoon?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It was proof of the fallibility of human testimony that Mrs. Pendleton had sincerely convinced herself that she was quite sure. “Yes,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant looked doubtful. By reason of his calling he was well aware of the human tendency to unintentional mistake in identity. With women especially, the jump from an impression to a conclusion was sometimes as rapid as the thought itself.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Did you see his face?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Only the eyes. But I am sure that they were Thalassa’s eyes.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant did not press the point. He did not doubt the honesty of her belief, but the words in which it was conveyed suggested hasty impression rather than conviction. Such proofs of identity were not to be relied upon.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Had your brother’s servant any reason, so far as you know, to be listening at the door?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“All servants are curious,” murmured Mrs. Pendleton. She shook her head wisely, as one intimating a wide knowledge of their class.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“All curious servants are not murderers,” returned Barrant. “This man has been in your brother’s service for a long time, has he not?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“For a great number of years. Almost ever since Robert returned to England, I think.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“So Mr. Austin Turold informed me. Had he any grudge against his master?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Thalassa? I really couldn’t tell you, because I do not know. But he has a most truculent and overbearing manner—not at all the kind of manner you expect in a servant, and he seemed to do just what he liked. I disliked him as soon as I saw him. I’m sure he looks more like some dreadful old sea pirate than a gentleman’s servant. I would not have him in my household.” Mrs. Pendleton set her lips firmly. “No, not for a single moment. But I suppose poor Robert was attached to him from long association.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant nodded in an understanding way. “Then this man Thalassa must have known your niece from childhood,” he said in a casual tone. “Was he attached to her, do you think?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I know nothing of that.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That’s rather a pity,” he said with a gentle shake of the head. He looked at her knowingly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I do not understand you,” she faltered.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You had grounds for your suspicions of Thalassa—reasonable "), _c('br'), _vm._v("grounds. He must have admitted your niece into the house last night, you know. I must get it out of him.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She gave a start, for she saw now where his drift of questions was taking them. With a sickening sense of horror she realized that her slight suspicions were being used by him to help fashion a case against her own flesh and blood.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What are you suggesting?” she breathed, with a nervous look.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Nothing at present,” he said, with a quick realization of the fact that he was in danger of talking too much. “Can you tell me if your niece is provided with money?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“My brother gave her twenty-five pounds in bank notes yesterday—he told me.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That is enough to keep her for some weeks. You are quite sure you cannot form any idea where she has gone?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No,” said Mrs. Pendleton coldly, with a belated inward resolve not to be so ready in volunteering information to the police in future.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I should like to see the room your niece occupied last night,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("That was a search which brought nothing to light. Barrant left the hotel just as little Mr. Pendleton returned to it with an alarmed face and a feeling of personal guilt at his failure to find Sisily.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant passed him with a side glance, his mind full of the problem of the girl’s disappearance. He left the hotel in a state of thoughtfulness, fully realizing the difficulties of the task which lay before him in tracing Sisily’s movements on the previous night, and discovering where she had flown. The deeper questions of motive and the inconsequence of some of her actions he preferred to leave till later. Action, and not mental analysis, was the need of the moment. Barrant prided himself on being a man of action, and he was also a detective. The thrill of pursuit stirred in his blood.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("His later activities that night and the following day brought to light many things, but not all that he wanted to know. He convinced himself, in the first place, that it was possible for the girl to have left her room and returned to it on the night of her father’s death without any of the inmates of the hotel being aware of her absence. That lessened the complexity of the case by absolving Mrs. Pendleton from the suspicion of pretended ignorance. Barrant was also convinced the aunt believed her niece to be in bed and asleep during the time of her own visit to her brother’s house. Sisily had to pass the office of the hotel in going out and returning, but she could easily have done so unobserved. There were few guests at that season of the year, and the proprietor’s daughter, who looked after the office, was in the dining-room having her dinner at half-past seven. She went to bed shortly after ten, leaving the front entrance in charge of the porter, who had duties to perform in various parts of the house. And it was possible to descend the stairs and leave the hotel without being seen from the lounge or smoking-room.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("There was a wagonette to St. Fair from the railway station at half-past-seven. The hotel dinner was at a quarter to seven for the convenience of some permanent guests, and Sisily, who left the table before the meal was concluded—about a quarter-past seven, according to Mrs. Pendleton—had time to catch the wagonette. On the assumption that even a Cornish wagonette would cover the journey of five miles across the moors in less than an hour, Sisily had probably reached her father’s house at half-past eight or a little earlier. The stopped clock in the study indicated that he met his death at half-past nine. If so, Sisily must have left Flint House shortly before her aunt’s arrival to catch the returning wagonette at the cross-roads where the young woman was seen waiting by Peter Portgartha.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("But that plausibly conceived itinerary of events needed the support of proof, and there Barrant found himself in difficulty.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The morning’s enquiries made it manifest that Sisily had left Penzance by the mid-day train on the previous day. After leaving Mrs. Pendleton, Barrant had gone to the station. The sour and elderly ticket-clerk on duty could give him no information, but let it be understood that there was another clerk selling tickets for the mid-day train, which was unusually crowded by farmers going to Redruth. The other clerk, seen in the morning, had no difficulty in recalling the young lady of Barrant’s description. She was pretty and slight and dark, with a pale clear complexion, and she carried a small handbag. She asked for a ticket to London. The clerk understood her to ask for a return ticket, but as she picked it up with the change for the five pound note with which she paid for it, she said that she thought she had asked for a single ticket. He assured her that she had not, but offered to change it. At that moment the departure of the train was signalled, and she ran through the barrier without waiting to change the ticket. The incident caused him to observe her, and his description tallied so completely with Mrs. Pendleton’s description that Barrant had not the least doubt that it was Sisily.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("On the strength of this information Barrant applied to a local magistrate for a warrant for the girl’s arrest. He was well aware that he had not yet gathered sufficient evidence to satisfy the law that she had murdered her father, but his action was justified by her flight and the presumption of her secret visit to her father’s house when she was supposed to be in bed and asleep at the hotel.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("These things fulfilled, Barrant then applied his mind to the question of Thalassa’s complicity. If Sisily’s actions on the night of her father’s death, and her subsequent flight, simplified matters to the extent of deepening the assumption of murder into a practical certainty, they added to the complexity of the case by giving it the appearance of a carefully planned crime in which Thalassa seemed to be deeply involved.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The insistent necessity of motive which should explain the events of that night with apt presumptions, threw Barrant back on the suggestion, made by Austin Turold, that it was really Sisily whom Mrs. Pendleton had detected looking through the door of the downstairs room when the other members of the family were assembled within listening to Robert Turold. Barrant told himself that Mrs. Pendleton’s suspicion of Thalassa rested on nothing more substantial than feminine prejudice, an unreasoning impulse of dislike which would leave few men alive if it always carried capital punishment in its train.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The substitution of Sisily for Thalassa provided a convincing motive for murder. The overheard revelation of her mother’s shame and her own precarious condition in the world when she might reasonably have been counting on becoming an heiress of note, were sufficient to account for the nocturnal return and an effort to entreat justice or compel silence—the alternatives depended on the type of girl. From what Mrs. Pendleton had told him of Sisily and her love for her mother—poor Mrs. Pendleton had insisted, all unwittingly, very strongly on that—Barrant had pictured her as a brooding yet passionate type of girl who might have committed the murder in a sudden frenzy of determination to prevent her father making public the unhappy secret of her mother’s life. That was an act by no means inconsistent with the temperament of a strongwilled and lonely girl, whose stormy passions had been wrought to the breaking-point by disclosures made on the very day that her loved mother had been buried in a nameless grave. There was, additionally, the motive of self-interest, awakened to the lamentable fact that she had no claim on her father beyond what generosity might dictate. In short, Barrant believed the motive for the murder to be a mixed one, as human motives generally are. At that stage of his reasoning he did not ask himself whether worldly greed was likely to enter into the composition of a girl like Sisily.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("This reconstruction of the crime pointed to an accomplice, and that accomplice must have been the man-servant. Nobody but Thalassa could have let the girl into the house; and he could have dropped the key in the room after the door was broken open. That theory not only presupposed strong devotion on Thalassa’s part for a girl he had known from childhood, which was a theory reasonable of belief, but it also suggested that he bore a deep grudge against his master on his own account, sufficient to cause him to refrain from doing anything to prevent the accomplishment of the murder, and to risk his own skin afterwards to shield the girl from the consequences. This aspect of the case struck Barrant as very strange and deep, because it failed to account for Sisily’s subsequent flight. If Thalassa had jeopardized himself by keeping silence about her visit, and had returned the key to her father’s room in order to create the idea of suicide, why had she dispelled the illusion by running away, bringing both her accomplice and herself into danger? Had she been, seized with terror, perhaps due to Mrs. Pendleton’s insistence on her belief of murder, or had Thalassa conveyed some warning to her that inquiries were likely to be put afoot?")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("These were questions to which Barrant felt he could find no answer until he had seen Thalassa and attempted to wrest the truth from him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He postponed his visit to Flint House until the evening. He wanted to make the journey as Sisily had made it on the previous night, in order to find out, as nearly as possible, the exact moment she had arrived at her father’s house. He was not even in a position to prove that she had gone by the wagonette until he had questioned the driver.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He took his way to the station that evening with the feeling that it would be difficult to get anything out of Thalassa, whatever the reasons for his silence. He instinctively recognized that the authority of the law, which strikes such terror into craven hearts, would not help him with this old man whose glance had the lawless fearlessness of an eagle. But he had confidence in his ability to extract the truth, and Thalassa, moreover, was at the disadvantage of having something to hide. It would be strange if he did not succeed in getting the facts out of him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The St. Fair wagonette was pulled up outside the station. Mr. Crows, master of his destiny and time-tables, reclined in front, regarding with a glazed eye his drooping horse. Inside, some stout women with bundles waited patiently until it suited the autocrat on the box seat to start on his homeward way. Mr. Crows showed no indication of being in a hurry. His head nodded drowsily, and a little saliva trickled down his nether lip. He straightened himself with a sudden jerk as Barrant climbed up beside him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What be yewer doin’ yare?” he demanded.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I’m going to St. Fair,” said Barrant.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I doan’t allow no passergers to sit alongside o’ me.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You’ll have to put up with it for once,” returned Barrant curtly, in no way softened by the odour of Mr. Crows’ breath.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("As this was a reply which no resident of St. Fair would have dared to make, Mr. Crows bent a muddled glance on his fare, and by a concentrated effort recalled the face of the man who had given him ten shillings on the previous night. He decided to pocket the present indignity in the hope of another tip.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Aw right,” he said, with unwonted amiability, “yewer can stay where yew are—for wance.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He applied himself to driving the wagonette. Sobriety was not an essential of the feat. The horse knew the way, drew clear of the town without accident, and jogged into the long winding road which stretched across the moors. The shadows deepened into night, and Mr. Crows lighted a solitary lamp in the front of his vehicle.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Aren’t you going to light up inside?” asked Barrant, when the lamp was flickering faintly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No,” replied Mr. Crows shortly. “It don’t pay. Let ’em set in the dark.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Not enough passengers, eh?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Moren enough fat old wommen on the out journey,” declared Mr. Crows passionately. “That’s because it’s all up-hill. But they walk in downhill to save a shellen. "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("I")]), _vm._v(" know them.” He brooded darkly. “It’s all part of the plan,” he went on. Then, as though feeling that this latter statement, in itself, erred on the side of vagueness, he added—“to worrit a man.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“How many passengers did you have on your last journey in, last night?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Two on ’em.” Mr. Crows, with forefinger and thumb, snuffed his nose as he had previously snuffed the candle in the lamp. “There was Peter Portgartha and a young woman. I happen to know it was a young ’un because she went away at such a rate when she got out. When wommen begins to get up in years they go in the legs, same as harses.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Would you know her again if you saw her?” asked Barrant eagerly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Not if you was to sware me on the Howly Trinity.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Did this young woman travel up with you by this wagonette last night?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mr. Crows couldn’t say for that. There were six insides, that was all "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("he")]), _vm._v(" knew. He disremembered anything about them.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Surely you notice the passengers you carry?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mr. Crows, with the air of one propounding an insoluble riddle, asked his fare why should he take notice of his passengers? He weren’t paid for that—no, not he. What’s more, the night was a dark one. He knew there was six insides because six fares was put through the winder, but whether they was put through by men or ma’adens or widder wommen was moren he cud say.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He again called on the Trinity to attest his ignorance.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Their shellens is nuthin’ to me”—the reference was to the passengers. “They wouldn’t pay for the harse’s feed. I work for the Duchy, I do, which is almost the same as being in Guvverment, ain’t it? I remember yew, thow—because yew gave me ten shellens for driving yew to the Central hotel last night.” Mr. Crows cast a quick glance at his fare to see how he took this artful reminder of his munificence. “But as for their bobs—” He spat into the night in order to express his contempt for the insignificance of such small sums.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("There was a tap at the window behind him. He unfastened the pane, and a spectral hand came through with a coin. Mr. Crows took it, the hand disappeared, to be replaced by another, more dirty than spectral, with a coin in the outstretched palm, like its predecessor.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You see,” said Mr. Crows, when he had collected six shillings in this manner. “What’s the need for to look at them? I’ve learnt them to hand in their fares this way. Saves time and talk for nothing. Why should I look at a lot of fat old wommen? I ain’t paid for that. It’s quite enough to let them set in my cab, wearing out my cushions with their great fat bodies, without looking at them.” He eyed Barrant with some sternness.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“But this was not a fat old woman,” said Barrant. “She was a pretty young girl.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Ma’ad or widder, it’s all the same to me,” returned the misogynist. “Some holds with the sex and finds them soothing, but I was never took up with them myself. I prefers beer. Every man to his taste.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Did any of the passengers alight at the crossroads?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("They were nearing the cross-roads as he spoke, and the rude outline of the wayside cross loomed out of the shadows directly ahead.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I couldn’t tell you that, neither. I always stop at the cross-roads, in and out. It’s one of my regular stopping-places. Come to think of it, though, somebody did get out at the cross-roads last night.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“A man or woman?” asked Barrant with eagerness.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“A woman. She went off acrass the moors that way.” Mr. Crows pointed an indifferent whip into the blackness which rested like a pall between the white road and the distant roaring sea. “She was a wunner to go, too—out of sight in a moment, she was.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Thank you. I’ll get down here, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("As the wagonette stopped at the cross-roads Barrant jumped down from his seat and disappeared in the indicated direction before Mr. Crows could summon his slow wits to determine the value of the coin which the detective had pressed into his passively expectant palm.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer017"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-17"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor016"
    }
  }), _vm._v("Chapter XVI")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("The twilight had deepened into darkness when Barrant reached Flint House. A faint ray of light flickered from the kitchen window on the giant cliffs, like a taper from a doll’s house. He approached the window by a line of rocks which guarded it like sentinels, and looked in.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Within, Mrs. Thalassa sat alone by the table in a drooping attitude of dejection or stupor. Her head was bent over her crossed hands, which rested on the table, and her grey hair, escaping from the back comb which fastened it, fell on both sides of her face. An oil lamp smoked on the table beside her, sending forth a cloud of black vapour like an unbottled genie, but she did not heed it. There was something uncanny in her complete detachment from the restless activity of life. The dead man lying upstairs was not more still.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Had Barrant known her better he would have had matter for surprise and conjecture in the fact that her patience cards stood untouched in their shabby leather case, but knowing nothing of that he fell to wondering what her husband had seen in such a queer little creature to marry her. The consideration of that question led him to the conclusion that perhaps Thalassa had been impelled to his choice by the realization that she was as good-looking a wife as he could afford. Barrant reflected that women resembled horses in value. The mettlesome showy ones were bred to display their paces for rich men only. Serviceable hacks, warranted to work a lifetime, could not be expected to be ornamental as well as useful. So long as they pulled their burdens without jibbing overmuch, one had to be content.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He began to wonder where Thalassa was, and moved closer to the shadow of one of the rocks in case he happened to be prowling around the house. In the silence of the night he listened for the sound of footsteps on the rocks, but could hear nothing except the moan of the sea and the whimper of a rising wind. His eye, glancing upwards, fell upon a chink of shuttered light in the back of the house which looked down on the sea. The light came from the dead man’s study, and had not been there a few moments before.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant walked to the kitchen door and tapped lightly. There was no answer, but somewhere within the house a dog howled dismally. The door handle yielded to his touch when he tried it, and he walked in.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The little old woman at the table made a sudden movement at his appearance, but he gave her a reassuring smile and nod. She sat quite still, with a look of fear in her eyes. Above his head he heard someone moving in the study.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Your husband is upstairs?” he asked in a voice which was little more than a whisper. “I want to see him—I am going up to him.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He did not wait for her to reply, and she watched him out of the room with staring eyes. Stealthily he directed his steps to the staircase, and with infinite precautions for silence commenced to ascend. But midway he stumbled in the dark, and the stair creaked loudly. Above his head a door opened sharply, and when he reached the landing he saw the figure of Thalassa framed in the lighted doorway at the far end of the long passage, listening.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Who’s there?” he cried; then his eye fell on Barrant, advancing swiftly from the darkness towards the light. “What do you want?” he said. “How did you get in?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant looked past him into the room. There was a litter of papers on the table and shelves, as he had last seen it, but it did not seem to him that anything had been disturbed. The door of the death chamber opposite was closed.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What are you doing up here?” he said sternly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa did not deign to parley. “What do you want?” he repeated, looking steadily at the detective.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Did you hear what I said to you?” angrily demanded Barrant. “Were you not told not to interfere with these rooms in any way? You have no right up here.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“More right than you have to come into a house like a thief,” retorted Thalassa coldly. “I have my work to do. The place must be looked after, whether I’m spied on or not.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I advise you not to take that tone with me,” replied the detective. “As you are here, you had better come into this room again, and shut the door behind you. I have some questions I want to put to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa followed Barrant into the room and stood by the table, the rays of the swinging-lamp throwing his brown face into sharp outline. “What do you want to know?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I want you to tell me everything that happened in this house on the night your master was found dead.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“There’s not much to tell,” began Thalassa slowly. “When it happened I was down in the cellar, breaking some coal. I heered my wife call out to me from the kitchen. I went up from the cellar, and she was standing at the kitchen door, shaking like a leaf with fright. She said there’d been a terrible crash right over her head in Mr. Turold’s study. I took a lamp and went upstairs, and knocked at the door, but I got no reply. I knocked three times as loud as I could, but there wasn’t a sound. At that I gets afeered myself, so I put on my hat and coat to go across to the churchtown to fetch Dr. Ravenshaw. Then a knock come to the front door, and when I opened the door there was the doctor and Mr. and Mrs. Pendleton.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“How long was that after the crash upstairs?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No longer than it took me to go upstairs, knock at the door, and getting no answer, go downstairs to put on my coat and hat. I was just winding a comforter round my throat when I heered the knock.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It did not occur to you to break in the door of your master’s room when you got no answer and found it locked?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No it never, and you wouldn’t have done it in my place.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You heard no sound of a shot?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Not down in the cellar. I fancy I heered the sound of the clock falling. It came to me all muffled like, though it frightened her rarely.” He pointed downward to the kitchen. “And it frightened the dog, too, started it barking.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Is that the dog I heard whining downstairs?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Maybe it is. I’ve got it shut up in the cellar.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Whose dog is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“His.” Thalassa’s eyes travelled towards Robert Turold’s bedroom.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Is it howling through grief?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“More like from fright. Dogs are like people, frightened of their own shadows, sometimes. I shut it up because it kept trying to get upstairs to his room. It’s a queer surly sort of brute, but fond enough of him. He used to take it out for long walks.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What kind of dog is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“A retriever.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“So that’s all that happened that night, is it?” said Barrant, in a meditative voice. “You have told me all?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa nodded. His brown face remained expressionless, but his little dark eyes glittered warily, like a snake’s.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Think again, Thalassa,” urged Barrant, in a voice of the softest insistence. “It may be that you have forgotten "), _c('br'), _vm._v("something—overlooked an incident which may be important.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I’ve overlooked nothing,” was the sullen response.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“There’s just an odd chance that you have,” said Barrant, searching the other’s face from raised contemplative eyebrows. “The best of memories plays tricks at times. It’s always better not to be too sure. Think again, Thalassa, if you haven’t something more to tell me.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I’ve told you everything,” Thalassa commenced, then straightened his long bony frame in a sudden access of anger, and brought his hand sharply down on the table. “What are you trying to badger me for, like this? You’ll get nothing more out of me if you question me till Doomsday.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“But why should you keep anything back?” asked Barrant softly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa looked at him with a startled air, then recovered himself quickly. “I’m not keeping anything back,” he said. “Why should you say that?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I did not say it. You said I’d get no more out of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Because there is nothing more to be got. Is that plain enough?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Quite. Well then, let us go over the events of this night once more. Perhaps that will help you to recall something which you have forgotten.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That’s not likely.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Nevertheless, we will try. You were busy in the coal cellar at the time, I think you said?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“At what time?” said Thalassa with a quick glance.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“At the time the crash happened upstairs.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What time was that?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“How should I know? Do you suppose there’s a clock in the coal cellar? It must have been about half-past nine.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“According to the clock upstairs. Did you think I had overlooked that? Then you heard your wife call, and went to the kitchen. Next, you went upstairs, tried your master’s door, found it locked, and decided to go for assistance. But before you could do so Mr. and Mrs. Pendleton and Dr. Ravenshaw arrived. Have I got it right?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That be right.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“All except one thing, Thalassa.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa met Barrant’s look steadily, with no sense of guilt in his face. “Well?” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I see that you do not intend to be frank. Let me help your memory a little. Did you have no other visitors—before Mr. and Mrs. Pendleton and Dr. Ravenshaw arrived?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Visitors?” There was scorn now in his straight glance, but nothing more. “Is this a place where there’s likely to be visitors?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Not in the ordinary course of events”—Barrant was still smilingly affable—“but the night your master met his death was not an ordinary night. Somebody may have come to the house.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He paused, again searching for some sign of guilty consciousness in the face revealed in such clear outline near him, but saw none. Again, Thalassa met him with answering look, but remained mute.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Thalassa”—Barrant’s voice remained persuasive, but to an ear attuned to shades, there was a note of menace underlying its softness—“you know there was somebody else here that night.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Somebody? Who?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Your master’s daughter—Miss Sisily Turold.” Barrant brought it out sharply and angrily.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa turned a cold glance on him. “If you know that why do you ask me?” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Because you let her in!”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa surveyed him with the shadow of a smile on his motionless face. “Do you take me for a fool?” he said. “I let nobody in.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Thalassa,” said the detective earnestly, “let me advise you, for your own sake, to tell the truth now. You may be keeping silence through some mistaken idea of loyalty to your master’s daughter, but that will do her no good, nor you either. I know more than you think. If you persist in keeping silent you will put yourself in an awkward position, and it may be the worse for you. You were seen listening at the door of the room downstairs on the day of your master’s death.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“So that’s it, is it? You think you’ll fit a rope round my neck? I’m to say what you want to save it? To hell with you and your policeman’s tricks! I don’t care that for them.” He snapped his long brown fingers in Barrant’s face.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You’ve a bold tongue, you scoundrel,” said Barrant, flushing angrily. “Take care where it leads you. Once more, will you tell me the truth?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I’ve told you all I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Do you mean to tell me that you did not see your master’s daughter, or let her into the house?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I did not.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Could anybody have got into the house without your knowledge?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Maybe.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Did you hear anybody?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“How could I hear anybody when I was down in the coal cellar?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The open sneer on Thalassa’s face suggested that he was not to be caught by verbal traps. Barrant perceived, with a smouldering anger, that the man was too clever to be tricked, and too stout of heart to be frightened. By accident or design he had a ready story which was difficult to demolish without further knowledge of the events of that night. Barrant decided that it would be useless, at that moment, to apply himself to the effort of worming anything out of Thalassa. He had shown his own hand too freely, and placed him on his guard. There was also the bare possibility that he had told the truth, so far as he knew it. One last shot he essayed.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You are acting very foolishly, but I shall not arrest you—yet,” he said impressively. “I shall tell the local police to keep an eye on you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Is it the Cornish savage from the churchtown—him with the straw helmit?” said Thalassa, with a harsh laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The last shot had missed fire badly. The lawless spirit of the man was not to be intimidated by a threat of arrest—a threat which the detective had reason for not putting into effect just then. Barrant moved towards the door with the best dignity he could command.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Light me downstairs to the kitchen,” he said. “I want to see your wife.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa seemed about to say something at that, then thought the better of it, and walked out of the room. Outside in the passage he picked up a small lamp glimmering in a niche of the wall, and led the way downstairs. They reached the kitchen in silence, and went in.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The little grey woman at the table was seated in the same posture as Barrant had last seen her, her hands crossed in front of her, her head bent. She glanced up listlessly as they entered. Barrant crossed the room, and touched her arm. She shook in a pitiful little flurry of fear, then became motionless again.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Mrs. Thalassa, I want to speak to you,” said Barrant, raising his voice, as though to a deaf person. “Is this where you were sitting the night before last, when you heard the crash in your master’s room upstairs?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Put the knave on the rubbish heap,” she muttered without looking up.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Listen to me, Mrs. Thalassa”—he spoke still louder. “Did you hear the shot before the crash?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The loud tone seemed to reach the remote consciousness of her being, and she started up in another flurry. . . . “Coming, coming, sir. Jasper, where’s the tray. . . ?” she stood thus for a moment, then dropped back into her chair, her eyes fixed on the opposite wall.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What’s the matter with her?” said Barrant, turning to her husband.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“She’s been like it ever since it happened,” said Thalassa, in a low tone. “That’s how I found her when I came from the cellar.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Did she hear the shot—or see anything?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That’s more than I can tell you. When I came from the cellar she seemed mazed with fright, and kept pointing to the ceiling. All I could make out from her was that there’d been a great crash upstairs. When I came down again after trying the door she was lying on the floor in a faint, and I carried her in to her bed. It’s floored her wits.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“She’s had a very bad shock,” said Barrant gravely. He regarded her attentively, her vacant eyes, mouthing lips, trembling hands, her uncanny fixed glance which seemed to behold something unseen. Strange suspicions flowed through his brain as he watched her. What terrible experience had befallen her? What did she know of the mysterious events that had happened in that silent house? He endeavoured to follow the direction of her gaze, but it seemed to be fixed on the row of bells behind the kitchen door. Then, like a half-awakened sleeper released from the horror of a nightmare, she sank back in her previous listless attitude, and fell to muttering again.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("As Barrant watched her, Thalassa watched them both with an anxiety which would have aroused Barrant’s suspicions if he had seen it. But Thalassa’s face was again closely guarded when he did look up.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You’ll get neither rhyme nor reason out of her,” said Thalassa, as their glances met.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I’ll try once more,” murmured Barrant, almost to himself. He turned to her again, but this time he did not lay his hand on her arm. “Mrs. Thalassa”—he spoke more gently—“will you try and understand me?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Red on black . . . black on red.” Her hands moved restlessly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("In a sudden recognition of the futility of trying to gather anything from that clouded brain, Barrant turned abruptly away without another word. And the black gaze of Thalassa followed him through the door and out into the darkness of the night.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer018"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-18"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor017"
    }
  }), _vm._v("Chapter XVII")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("The bell in the darkened chambers rang with the insistent clamour of mechanism responding with blind obedience to a human hand, but Mr. Anthony Brimsdown suffered it to pass unnoticed. As an elderly bachelor, living alone, he was sufficiently master of his own affairs to disregard the arrival of the last post, leaving the letters as they were tumbled through the slit in the door downstairs until he felt inclined to go and get them.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He was standing in the centre of the room examining an unusual trinket—a gold hoop like a bracelet, with numbers and the zodiac signs engraved on the inner surface. Mr. Brimsdown had discovered it in a Kingsway curiosity shop a week before. It was a portable sun-dial of the sixteenth century. A slide, pushed back a certain distance in accordance with the zodiac signs, permitted the sun to fall through a slit on the figures of the hours within—a dainty timekeeper for mediaeval lovers. Mr. Brimsdown was no gallant, nor had he sufficient imagination to prompt him to wonder what dead girl’s dainty fingers had once held up the bright fragile circle to the sun to see if Love’s tryst was to be kept. His joy in the sun-dial was the pride of the collector in the possession of a rare thing.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("But that night it failed to interest him. He put it down with a sigh, and resumed his restless pacing of the room.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It was his office, but he preferred it to his chambers at the end of the passage. He said the air was better, but it is doubtful whether that was the reason. Perhaps Mr. Brimsdown felt less lonely among his legal documents, meditating over battles he had won for dead legatees. As a solicitor he was “strong on the Chancery side” and had gained some famous judgments for notorious litigants—men who had loved the law so well that their souls might well have been found—knowing no higher heaven—in the office where the records of their forgotten lawsuits were buried. And in death, as in life, they would have been glad to confide their affairs to the man whose lot it had been to add “Deceased” to so many of the names on the black steel deed-boxes which lined the shelves.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mr. Brimsdown lived for the law. As a family lawyer he was the soul of discretion, an excellent fighter, wary and reticent, deep as the grave, but far safer. The grave sometimes opens and divulges a ghastly secret from its narrow depths. There was no chance of getting anything out of Mr. Brimsdown, dead or alive. He had no wife to extract bedroom confidences from him, no relations to visit in expansive moments, he trusted nothing to paper or diary, and he did not play golf. He was a solitary man, of an habitual secretiveness deepened by years of living alone.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("His lips moved now, and he spoke aloud. His voice sounded sharply in the heavy silence.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“A calamity—nothing less. How did it happen? Was it grief for his wife?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("His face showed unusual agitation—distress even. It was well his clients could not see him at that moment. To them he was a remote enigmatic figure of conveyances and legal deeds; one deeply versed in human follies and foibles, but impervious to human feeling, independent of human companionship. The reserved glance of his cold grey eye betokened that he guarded his own secrets as closely as he guarded the secrets entrusted to him professionally. But there was human nature in him—deep down. It was not much—a lock of hair in a sealed packet in his pocket-book. The giver was dead and gone to dust, sleeping in an old churchyard near the Strand, forgotten by all who had ever known her—except one. Sometimes in the twilight a tall figure would stand musing beside that forgotten grave for awhile, then turn away and walk swiftly up the narrow river street, across the Strand, and through the archway to Grey’s Inn.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Thirty years!” he murmured. Then his mind seemed to hark back to his previous thought, after the fashion of a man who thinks aloud—“No, no; not his wife. He did not care enough for her for that. Thirty years—wasted. My heart bleeds when I think of it. Ought I to go down? Did he wish for me? I wonder—”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("His distress as he paced the room was more apparent than ever. Again, his clients would have been astonished if they had witnessed it. In their opinion he was hard as nails and a stranger to the softer feelings of the heart. They would as soon thought of attributing sentiment to one of the japanned deed-boxes. But they would have accepted the surprising revelation with well-bred English tolerance for eccentricity, not allowing it to affect their judgment that Mr. Brimsdown was one of the soundest and safest lawyers in England.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("His agitation arose from the death of Robert Turold—his client. He had gathered that piece of news from an evening newspaper in the restaurant where he had dined. Mr. Brimsdown had reached an age when the most poignant events of human life seem little more than trifles. It was in the nature of things for men to die. As a lawyer he had prepared many last wills and testaments—had helped men into their graves, as it were—unmoved. But that unexpected announcement of Robert Turold’s death had come to him as an over-whelming shock. He had left his meal unfinished, and returned to his chambers to seek consolation, not in prayer, but in his collection of old clocks and watches. In the dusk he had set out his greatest "), _c('br'), _vm._v("treasures—the gold sun-dial, a lamp clock, an early French watch in blue enamel, and a bed repeating clock in a velvet case. But the solace had failed him for once. Even the magic name of Dan Quare on the jewelled face of the repeater failed to stir his collector’s heart.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("His regard for Robert Turold was deep and sincere. His dead client had been his ideal of a strong man. Strong and unyielding—like a rock. That was the impression Robert Turold had conveyed at their first interview many years before, and his patience and tenacity in pursuit of his purpose had deepened the feeling since. The object of his search had the lawyer’s sympathy. Mr. Brimsdown had a reverence for titles—inherited titles, not mere knighthoods, or Orders of the British Empire. For those he felt nothing but contempt. He drew the sharpest distinction between such titled vulgarians and those who were born into the world with the blood running blue in their veins. He regarded Robert Turold as belonging to this latter class. It was nothing to him that he was a commoner in the eyes of the world, with no more claim to distinction than a golf-playing city merchant. He had believed in his story from the first, and had helped him in that belief. Turrald of Missenden! It was a great old name. Mr. Brimsdown rolled it round his tongue as though it were a vintage port—pronounced it lingeringly, rolling the “rr’s” sonorously, and hissing the “ss’s” with a caressing sibilant sound.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Turrald of Missenden! Robert Turold was the lineal descendant of the name, and worthy of the title. Mr. Brimsdown had always felt that, from the very first. There was something noble and dominating in his presence. Blood told; there could be no doubt of that.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("What stronger proof of it could be found than the dogged strength with which the dead man had persisted for thirty years in his effort to claim as his rightful due a baronial title which had been in abeyance for four hundred years?")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("And he would have succeeded—was on the verge of success—but for this unlucky stroke of Death’s.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("With a sigh for the frailty of human hopes, Mr. Brimsdown put an end to his reflections and went downstairs for the post.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("By the dim light of the lowered hall gas he saw an envelope lying on the floor—a thick grey envelope addressed to himself in a thin irregular hand. The sight of that superscription startled him like a glimpse of the unseen. For it was the handwriting of the subject of his thoughts—Robert Turold.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("With the stiff movement of an ageing man he picked up the letter and went upstairs again. In some subtle way the room seemed changed. He had a sudden inexplicable sensation of nervousness and depression. Shaking it off with an effort, he opened the envelope in his hand with an odd reluctance—the feeling that he was prying into something which was no concern of his. He drew out the single grey sheet and unfolded it. The letter was dated from Flint House on the previous day. There was but a few lines, but the lawyer was pulled up at the beginning by the unusual familiarity of the address. “My dear Brimsdown” was unusual in one so formal as Robert Turold. But the handwriting was his—undoubtedly. Mr. Brimsdown had seen it too often to be mistaken. With the growing idea that the whole thing was confounding to sober sense and reason, he read on—")]), _vm._v(" "), _c('p', {
    staticClass: "extract-flush-left-space-after"
  }, [_vm._v("“Can you postpone all your other engagements and come to Cornwall on receipt of this? If you will telegraph the train you travel by I will have a conveyance to meet you at Penzance and bring you to Flint House. This is a matter of importance.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-space-after"
  }, [_vm._v("A postscript followed in the strangest contrast to the formal note—a postscript hasty and blotted, which had evidently been added in extreme agitation of mind—")]), _vm._v(" "), _c('p', {
    staticClass: "extract-flush-left-space-after"
  }, [_vm._v("“For God’s sake lose no time. Come at once.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("The tremulous urgent words stared out from the surface of the grey paper in all the piteous futility of an appeal made too late. Glancing up, Mr. Brimsdown’s eye rested on the shelf where the deed box of Robert Turold reposed, and he mechanically reflected that it would be necessary to have the word “Deceased” added to the white-lettered inscription on the black surface. Mr. Brimsdown sighed. Then, shaking off the quiescence of mind which his brooding had engendered, he applied his faculties to the consideration of a situation which at first sight seemed fantastic as a nightmare.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The letter was not more remarkable than its despatch after the writer’s death, but the summons to Cornwall was not in itself surprising. He recalled a similar visit to Norfolk some years before, and the recent correspondence between them made it clear that the claim had reached a stage which required careful legal handling. Robert Turold had forwarded copies of the final proofs of the family descent discovered in Cornwall, and Mr. Brimsdown had prepared the claim for the termination of abeyance which was to be heard by the House of Lords. Mr. Brimsdown was also aware of the summoning of the other members of the family to Cornwall to impart the news to them. A very natural and proper proceeding on Robert Turold’s part, he had deemed it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He believed he knew every intimate detail of the ambition on which Robert Turold had immutably set his heart. Had they not been discussed between them, again and again, in that room—his bitterness that he had no son, his fear that the regained title might be extinguished again in female descent, his grievance that the succession could not be altered. It was his dream to found a new line of Turralds, and be remembered as the head of it. “If you could only get the descent taken outside the limits of the original creation, Brimsdown—” The harsh voice, uttering these words, seemed to reach Mr. Brimsdown in the muffled silence at that moment. He had told him, again and again, that the thing was impossible. If the Turrald barony was called out of abeyance it was an act of Royal grace and favour. They had no rights—he insisted on that—and any attempt to influence the Crown about the line of succession might endanger the claim.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("And now Robert Turold was dead in the midst of his plans—dead when he had almost gained the peak of his dreams.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It seemed incredible, almost impossible. Death at such a moment assumed an unexpected reality as an actual and tangible mocker of human ambitions. And this letter with its postscript—what was the meaning of it? The lawyer knew nothing of Robert Turold’s announcement to his family on the previous day. If he had, it would have intensified his feeling that the letter hinted at some terrible secret hidden behind the thick curtain of his client’s strange and sudden death. The hasty postscript suggested a quickened sense of a growing danger which Robert Turold had seen too late to avert.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("What danger? Mr. Brimsdown could form no idea. He reflected that he really knew very little of Robert Turold’s private life in spite of the long association between them. He must have had other interests at one time or other beside the eternal question of the title. Mr. Brimsdown had vaguely understood that the money he had invested for Robert Turold had been gained abroad—in the wilds of the earth—in his client’s early life, but his client had never confided to him the manner of the gathering. That was a page in the dead man’s life of which his trusted legal adviser knew nothing whatever. It was unsafe to assume that the page, if revealed, would throw any light on his tragic death, but there was a possibility that it might.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The evening newspaper he had brought home lay on the carpet at his feet exposing the headline—“A Cornish Mystery”—which had caught his eye at the restaurant. Mr. Brimsdown picked up the sheet and read the report again. There was nothing in it to help him. It was only a brief notification of the facts—of a death which, in the words of the newspaper’s local correspondent, “pointed to suicide.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Suicide! The letter on which the ink was still bluish and fresh, seemed to convey Robert Turold’s denial of the suggestion that he had taken his life. It was the cry of a man who had looked into the dark place of fear and seen Death lurking within. Only mortal terror could have called forth that passionate frantic appeal. And that appeal accomplished its purpose, although it came too late. Robert Turold was dead, but the call for elucidation rang loudly from his coffin. The dead man’s hand beckoned him, and he dared not disobey. He determined to go to Cornwall.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Outside in the darkness a clock chimed, and one of his own treasures repeated the hour with a soft mellifluous note. Eleven! He had an idea that there was—or used to be—a midnight train to Cornwall. He crossed to his bureau and consulted a time-table. Yes—to Penzance from Paddington. He decided to catch it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("His preparations for departure were quickly made. The writing of a note to his clerk and the packing of a bag were matters soon accomplished. In a quarter of an hour he had picked up a taxicab at the Holborn stand near his chambers and was on his way to the station.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("There was plenty of light and stir at Paddington, which appeared like a great and glowing cavern in the cold darkness of the night. There were engines shunting, cabs arriving, porters and passengers rushing about with luggage, throngs of people. It happened that the midnight train from Cornwall was overdue, and fluttered women waiting for friends were importuning bored officials about the delay. Sleepy children stared with wondering eyes at pictorial efforts to beguile the tedium of waiting for trains. There were geographical posters comparing Cornwall favourably to Italy; posters of girls in bathing costume beckoning to “the Cornish Riviera;” posters of frolicsome puppies in baskets ticketed “Lucky Dogs, They’re Off to Penzance.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The passengers waiting for the midnight train to that resort did not do equal justice to this flattering assumption of its delights. They seemed, on the whole, rather to regard themselves as unlucky dogs (if the term could be applied to parties of women), and were huddled together on the station seats in attitudes suggestive of despair. Men flirting with barmaids in the bars may have considered themselves lucky dogs, but whisky played an important part in their exhilaration.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The belated train came rushing in with an effusion of steam, like a late arrival puffing out apologies, bringing a large number of passengers back to London from Penzance. They scrambled on to the platform with the dishevelled appearance of people who had been cooped up for hours. First-class passengers eased their pent-up energy by shouting for luggage porters and bundling their women into taxicabs. The third-class passengers, whose minor importance in the scheme of things did not warrant such displays of self-importance, made meekly and wearily for the exits.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("They were dammed back at the barriers by two ticket collectors, whose adroit manipulation of the gates prevented more than one person trickling through at a time, and turned the choked stream of humanity within into a whirlpool of floating faces and struggling forms. As Mr. Brimsdown stood regarding this distracting spectacle from the outside, he saw one of the ticket collectors grasp the arm of a girl who was just emerging, at the same time shutting the gate on a stout woman following, thus effectually blocking the egress of those behind.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The girl turned quickly at the touch of the detaining hand, and there was fear in her face.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What do you want?” she said, framing the words with an obvious effort.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The ticket collector was a man whose natural choleric temperament was accentuated by the harassing nature of his employment. He tore in two portions the ticket which the girl had just given him, and thrust half into her hand.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Here’s your return half. Why don’t you look what yer doin’ when givin’ up yer ticket? You women are the limit. Now, mother, for God’s sake don’t be all night getting through that there barrier. There’s others want to get ‘ome, if you don’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Having by this adroit remonstrance spiked the wrath, as it were, of the stout and angry woman he had jammed in the gate, he permitted the resumption of the trickle of impatient passengers.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mr. Brimsdown followed with his eye the pretty girl who had been forgetful enough to give up a return ticket instead of a half one. She had stopped outside the barrier, gazing round with a troubled face at the immensity of the station and the throngs of hurrying people.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The lawyer looked at her hard, from a little distance. “Where have I seen that face before?” he murmured to himself.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Her beauty was of a sufficiently rare type to attract attention anywhere, except, perhaps, at a London railway station at midnight. She was unused to her surroundings and she was not a city product. So much was obvious, though her clear pale face and slim young figure did not suggest rusticity. Her dark eyes glanced quickly and nervously around her, and then she started to walk slowly towards one of the main entrances.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("A luggage porter hurried towards her, intent on tips. The broad back of a policeman was outlined in the entrance. The girl looked wistfully from the policeman to the porter, then appeared to make up her mind. She extracted a silver coin from her purse, and proffered it timidly to the porter. The porter showed no timidity in accepting it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Luggage, miss, in the van?” he asked. “Just you wait ’ere.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I have no luggage,” Mr. Brimsdown heard her say. Her eyes wandered downward to the little handbag she carried. “I wanted to ask you—I am a stranger to London. Can you tell me a place where I could stay; for the night—somewhere quiet and respectable?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mr. Brimsdown found himself listening anxiously for the porter’s reply. By all the laws of Romance he should have had an old mother in a clean and humble home who would have been delighted to give the girl shelter for the sight of her pretty face. But pretty girls are plentiful in London, and kind-hearted old women are rare. The porter seemed surprised at the inquiry. He pushed his blue cap back from a shock of red hair, and pondered the question deeply. Then he made a valiant feint of earning his shilling by throwing out suggestions of temperance hotels in Russell Square and the Euston Road. He warmed to the subject and depicted the attractions of these places. Quiet and cheap, and nothing respectabler in the ’ole city of London. They was open at all hours. His own sister stayed in one when she come to town.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Would you give me the address?” the girl wistfully asked.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The porter shook his head cautiously. He had evidently no intention of pawning his sister’s reputation for a shilling given him by a strange girl who might have designs on the spoons of temperance hotels.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“How do I get to Euston Road?” asked the girl with a quick realization of the fact that she had obtained London value for her shilling.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“By the Metropolitan.” He pointed to a blazing subterranean archway which at that late hour was still vomiting forth a mass of people. “Book at the first winder.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mr. Brimsdown watched the girl until she disappeared out of sight down the steps. He then turned away to seek his own train, the insistent feeling still haunting him that he had seen her pretty wistful face before. He taxed his memory to recall where, but memory made no response. It seemed a long time ago—like a glimpse from the face of the dead. Mr. Brimsdown strove to put the idea from him as a trick of the imagination.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("He beckoned to a porter, who took his bag to a first-class carriage in the Penzance train. Mr. Brimsdown settled himself comfortably in a corner seat. A few minutes later the train moved out on the long night journey to Penzance.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer019"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-19"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor018"
    }
  }), _vm._v("Chapter XVIII")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("The clock in Dr. Ravenshaw’s study ticked loudly in the perfect stillness and then struck ten with a note of metallic derision as though rejoicing in the theft of an hour from a man who prided himself on knowing the value of time. Startled to find that it was so late, Barrant sprang to his feet and rang the bell. A sleepy Cornish maid appeared in answer, and Barrant informed her that he could not wait any longer.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“The doctor may be in at any time now, sir,” the girl eagerly assured him, as though she were in league with the clock to steal more of his time.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I will call again,” said Barrant curtly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Any message, sir? Oh, here’s the doctor now. A gentleman to see you, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Dr. Ravenshaw advanced into the room. He looked tired and weary, as if he had spent a long vigil by a patient. He dismissed the girl with a nod, and turned inquiringly to his visitor.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I am Detective Barrant, doctor; I have waited to see you on my way back from Flint House. I am investigating the case.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yes?” said the doctor inquiringly. “Please be seated.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It is a strange case, you know,” began the detective. “And one of the strange things about it is that the dead man’s relatives differ whether it is murder or suicide. That’s what brings me to you. You are a medical man, and you knew Robert Turold intimately. Would you consider him a man of suicidal tendencies?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Many men have tendencies towards suicide at odd moments,” replied the doctor, “particularly men of Robert Turold’s temperament.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Was there anything in Robert Turold’s demeanour which suggested to you recently that he valued his life lightly, or was likely to take it?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I would rather not give a definite opinion on that point. I have to give evidence at the inquest, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant nodded. He realized the force of the doctor’s objection to the expression of a view which might be proved erroneous later. So he turned to another phase of the case.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You saw Robert Turold’s body soon after you arrived at Flint House?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Within a few minutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“How long had he been dead?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“About ten minutes, I should say.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What was the cause of death?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“He was shot through the main blood vessel of the left lung. It was possible to arrive at that conclusion from the very severe haemorrhage. The blood was still flowing freely when we broke into the room. That would cause death from heart failure, following the haemorrhage, within two or three minutes, in all probability.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“He was quite dead when you entered the study?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Quite.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“How long after was the body carried into the bedroom?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“An hour or more. It was some time before Pengowan arrived, and Thalassa and he removed the body a little later.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant looked disappointed at his reply. “Would it be possible to make marks on a corpse after that length of time?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What sort of marks?” asked the doctor.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“There was a mark of five fingers on the left arm, made by a left hand.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Then you have fingerprints to help you?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Unfortunately no. It’s a grip—a clutch—which, will not reveal print marks in the impressions. I thought they might have been caused during the removal of the body.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It is not possible to make such marks on a corpse. Reaction sets in at the moment of death. Sometimes blue spots appear on a dead body, and such appearances have been occasionally mistaken for bruises.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Did you observe any marks when you examined the body?” asked Barrant as he rose to his feet.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No, but my examination was confined to ascertaining if life was extinct.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant thanked him and said good night. The doctor rose also, and escorted him to the door.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Outside, a wild west wind sprang at him. Barrant pulled his hat over his eyes and hurried away.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The following morning he sought out Inspector Dawfield at his office in Penzance and disclosed to him his conclusions about the case.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I intend to go to London by this morning’s train, Dawfield,” he announced. “We must find Robert Turold’s daughter.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You think she has gone to London?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I feel sure of it, and I do not think it will be difficult to trace her. I shall try first at Paddington. I will get the warrant for her arrest backed at Bow Street, and put a couple of good men on the search before returning here. You had better have the inquest adjourned until I come back. This is no suicide, Dawfield, but a deep and skilfully planned murder.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I should think the flight of the girl makes that pretty clear,” said Dawfield, as he made a note on his office pad.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant shook his head. “It’s too strange a case for us to have any feeling of certainty about it yet,” he said. “There is some very deep mystery behind the facts. Every step of my investigation convinces me of that. The disappearance of Miss Turold does not explain everything.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“She was up at Flint House on that night, and now she is not to be found. Surely that is enough?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“This is not a straightforward case. It’s going to prove a very complicated one. But I have come to the conclusion that the quickest way to get at the truth is to find Sisily Turold. Her flight suggests that she is implicated in the crime in some way, and it may even mean that she is guilty.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Do not the circumstances point to her guilt?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Circumstances can lie with the facility of humanity, at times. Moreover, we do not know all the circumstances yet. But let us examine the facts we have discovered. We believe that the girl visited her father’s house on the night of his death, and has since disappeared. We must assume that it was she who was seen listening at the door during the afternoon by Mrs. Pendleton, because that assumption provides strong motive for the murder by giving the key of interpretation to Miss Turold’s subsequent actions. We must picture the effect of that overheard conversation on the girl’s mind. She had been kept in ignorance about the secret of her birth, and she suddenly discovers that instead of being a prospective peeress and heiress, she is only an illegitimate daughter, a nameless thing, a reproach in a world governed by moral conventions. Her prospects, her future, and her life are shattered by her father’s act. The effect might well be overwhelming. She broods over the wrong done to her, and decides to go to Flint House that night and see her father, though not, I think, with the premeditated idea of murder. Her idea was to plead and remonstrate with him.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Why do you think that?” asked Dawfield.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“She could not have foreseen that her absence from the hotel would pass unnoticed. That was pure luck, due to Mrs. Pendleton’s chance visit to Flint House. It was just chance that the girl did not encounter her aunt there. She must have got away from Flint House shortly before Mrs. Pendleton arrived. But the strongest proof that there was no premeditation is to be found in the fact that Miss Turold made the journey openly, in a public conveyance.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“And returned the same way,” put in Dawfield.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I confess that her action in taking that risk after the murder strikes me as remarkable,” observed Barrant thoughtfully. “But she would be anxious to return as speedily as possible, and perhaps she was aware that the last wagonette from St. Fair to Penzance is generally empty. But we can only speculate about that. She must have reached Flint House not later than half-past eight or perhaps a few minutes earlier, if she walked quickly across the moors. I ascertained that by taking the same wagonette last night, and walking across the moors from the cross-roads, as she did. The murder was not committed until half-past nine, according to the stopped clock, which is another point suggesting lack of premeditation. Let us assume that up to the time she arrived at Flint House she had no intention of murdering her father. She knocked, and was perhaps admitted by Thalassa, and went up to her father’s room. What happened during that interview? We do not know, but we are told that Robert Turold was a man of harsh, unyielding disposition, the slave of his single idea, which was the acquisition of a lost title. Such a man was not likely to be moved by pleading or threats. We must imagine a long and angry scene, culminating in the daughter snatching up her father’s revolver and shooting him.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Thalassa told Pengowan that Robert Turold kept the revolver in the drawer of his writing table,” Dawfield remarked.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I have read Pengowan’s report,” returned Barrant impatiently, “and I am assuming that Robert Turold’s daughter knew where it was kept. This is a purely constructive theory of her guilt, and we have to assume many things. We must further assume that when she left the room she locked the door behind her and brought away the key in order to suggest suicide. When she got downstairs she told Thalassa the truth, and begged him to shield her. He promised to do so, and when the door of the study was broken open he took an opportunity to drop the key on the floor, in order to suggest the idea that Robert Turold had locked himself in his room before shooting himself, and that the key was jolted out of the lock when the door was burst in. It was an infernally clever thing to do. That’s the case against the girl, Dawfield. What do you think of it?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It sounds convincing enough.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It would sound more convincing to me if it was entirely consistent with the other facts of the case. Have you those sheets of unfinished writing which were found in Robert Turold’s study?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Dawfield produced two sheets of foolscap from his desk. Barrant laid them on the table, and examined them with a magnifying glass.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It is certain that Robert Turold did not put down his pen voluntarily,” he said. “He stopped involuntarily, in the midst of a word. That suggests great surprise or sudden shock. The letter ‘e’ in the word ‘clear’ terminates in a sprawling dash and a jab from the nib which has almost pierced the paper. Could the unexpected appearance of his daughter have startled him in that fashion? It rather suggests that somebody sprang on him unawares, surprising him so much that he almost stuck the pen through the paper.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Might not that have been his daughter?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Women scratch like cats when they use violence, but they do not spring like tigers. I have been examining those marks on Robert Turold’s arm again, and I have come to the conclusion that they were made by somebody in a violent passion.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I have the photographs here,” said Dawfield, rummaging in a drawer. “They do not help us at all. There are no fingerprints—nothing but blurs.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant glanced at the photographs and pushed them aside.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I have been thinking a lot about those marks,” he said. “They strike me as a very important clue. I have been examining them very closely, and discovered the faint impression of finger-nails in the marks left by the first and second fingers. That suggests that the owner of the hand was in a state of ferocity and tightened nerves.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I do not see that.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Allow me to experiment on your arm. When I grip you firmly, as I do now, you can feel my fingers pressing their whole length on your flesh, can you not?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I can indeed,” said Dawfield, wincing. “You’ve a pretty powerful grip. I shall be black and blue.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“The grip on Robert Turold’s arm is quite a different thing,” pursued Barrant earnestly. “Do not be afraid, I am not going to demonstrate again. It was more in the nature of a pounce—a sort of tiger-spring hold, made by somebody in a state of great mental excitement, with tightened muscles which caused a tense clutch with the finger-tips, the nails digging into the skin, the fingers bent and wide apart. My opinion is that it is a man’s grip.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Thalassa?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That I cannot say. He’s a cunning and wary devil, and I could get nothing out of him last night. He says he was in the coal cellar when his master met his death. That’s where he showed his cleverness in protecting himself as well as shielding the girl, because if he was actually down in the coal cellar she might have gained entrance to the house and left it again without Thalassa knowing anything about it. He says that he admitted nobody, and heard nobody.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Perhaps he helped in the murder, and sprang on his master.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That is possible. But why should Thalassa spring on his master in maniacal excitement? To secure the revolver to shoot him? I can see no other reason. What happened afterwards? Robert Turold wasn’t shot immediately. Some seconds, perhaps minutes, elapsed. What took place in that brief yet vital space of time? Did Thalassa hold his master in a grim clutch while the girl took the revolver out of the drawer and shot him? What took Robert Turold to the clock in his dying moments? These are questions we cannot answer at present. But it is certain that whoever committed the murder left the room immediately after firing the shot, and the door was locked on the outside and the key removed. If the daughter committed the murder it was probably Thalassa who replaced the key in the room afterwards.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Have you any doubt on that point?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“The probabilities point to Thalassa, but it was Austin Turold who actually picked up the key. It is as well not to lose sight of that fact.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Inspector Dawfield looked up quickly, but his colleague’s face revealed nothing of his thoughts.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Hadn’t you some idea that the marks on the arm might have been caused by the removal of the body into the next room?” he hazarded.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Not now,” Barrant replied. “That theory was only tenable on the supposition that life was not completely extinct when the body was removed. But I interviewed Dr. Ravenshaw on that point last night, and what he told me disposes of that theory.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I heard something from one of my men this morning which may have some bearing on the case,” remarked Dawfield. “There has been a lot of local gossip about it. Robert Turold was generally regarded as very eccentric. When he crossed the moors from the churchtown to Flint House it was his custom to go almost at a run, glancing over his shoulder as he went, as if afraid.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I have heard nothing of this,” commented Barrant. “Is the story to be believed, do you think?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“A fisherman of the churchtown told my man in a graphic sort of way. He says that Robert Turold had a dog which he used to take with him on these walks, and he says that the master used to cover the ground with such great strides that the dog had to run after him panting, with lolling tongue.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("“That sounds stretched,” said Barrant. “Most fishermen exaggerate. However, I’ll look up this man when I return, and question him. It never does to throw away a chance.” He glanced at his watch and rose to his feet. “I’ll be off now to catch the train. If anything important occurs during my absence you’d better send me a wire to Scotland Yard.”")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer020"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-20"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor019"
    }
  }), _vm._v("Chapter XIX")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("It was from Mrs. Pendleton that Mr. Brimsdown gained his first real knowledge of the drama of strange events surrounding Robert Turold’s death. In response to his call at the hotel she came down from her room fingering his card nervously, her eyes reddened with weeping, and an air of tremulous bewilderment about her which sat ill on her massive personality.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The lawyer greeted her with formal courtesy. He was newly shaved and bathed, his linen was spotless, and his elderly grey eyes looked out with alert watchfulness on a world of trickery.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“As your late brother’s legal adviser for many years, I felt it incumbent upon me to come down,” he said, fixing a grave glance on the distracted lady before him. “It seemed to me that I might be of some use, perhaps, assistance. That is the object of my call.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The fact that she had not seen Mr. Brimsdown before did not lessen the hysterical gratitude with which Mrs. Pendleton received this piece of information. The events of the last forty-eight hours had shaken her badly. Her brother’s tragic death, and the terrible suspicion which enveloped Sisily, had stripped her of her strength, and left her with a feminine longing to cast her burden on a man’s shoulders. She had discovered to her dismay that a husband who has been snubbed and kept under for twenty years is apt to prove a thing of straw when a woman likes to feel that the male sex was devised by Providence to take the wheel from female hands if the barque of life drifts on the breakers. But Mr. Pendleton had revealed no latent capacity to play the part of the strong man at the helm in the crisis. He had shown himself a craven and kept out of the way, leaving his wife to her own resources. The appearance of Mr. Brimsdown was as timely to her as the arrival of a heaven-sent pilot in a storm.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Thank you,” she murmured incoherently. “Such a dreadful end. Poor dear Robert.” She sobbed into her handkerchief.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“A deplorable loss to his family—and England,” assented the lawyer. “I am glad to see you. They ascertained your address for me at the hotel where I am staying. I have been resting after travelling all night, and I shall go and see the police in the morning. So far I have only read the reports in the London evening papers, and there may be intimate particulars which were not disclosed to the press. If such exist, perhaps you will impart them to me. You need not hesitate to disclose to me all you know. Your late brother honoured me with his confidence for nearly thirty years.” Mr. Brimsdown coughed discreetly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("His tone invited confidences which Mrs. Pendleton, in her perplexity of spirit, was only too anxious to impart to a sympathetic ear. Mr. Brimsdown, sitting stiffly upright, his eyes fixed on a portrait of Royalty glimmering inanely down at them through a dirty glass frame on the opposite wall, listened with unmoved front. Yet the story had its surprises, even for him. Not the least of them was the fact that Mrs. Pendleton’s description of her niece tallied with the appearance of the girl whose identity he had tried to recall at Paddington. He was chagrined to think he had failed to recognize his late client’s daughter, but he recalled that it was ten years since he had seen Sisily, who was then a dark-eyed little girl. At Norfolk. Oh, yes! he remembered her readily enough now, playing innocently about some forgotten tombstones in a deserted graveyard on a wild grey coast, while her father wrested savagely with the dead for his heritage. Strange that he should have met her again at the moment of her flight, when he was setting out for Cornwall in response to her dead father’s letter! Life had such ironical mischances.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He said nothing of this chance encounter, or of Robert Turold’s letter, to the dead man’s sister who was now pouring out her fears and suspicions to him. He was a receptacle into which confidences might be emptied, but he gave nothing in return. Mrs. Pendleton did not need that. Her state of mind compelled her to speak, and her impulsiveness hurried her along on the high tide of a flood of words. The story she had to tell oppressed her listener with the sense of some great unknown horror. It was like trying to see a dark place by lightning. The flashes of her revelations revealed a distorted surface, but not the hidden depths. Mrs. Pendleton’s agitated mind, doubling in and out a maze of conjectures like a distracted hare, turned again and again to the question of Sisily’s complicity in her father’s death.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I can hardly believe it even now,” she said with a shudder. “Such a sweet pretty girl! And yet—there was something strange in her manner. I remarked it to Joseph—my husband—before this happened.” She pressed her handkerchief to her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The lawyer, with a sideways glance at the Royal portrait opposite, which seemed in the act of smiling blandly at his companion’s grief, reflected, soberly enough, that sweet and pretty girls were as human as the rest of creation, if it came to that.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Charlie Turold—my nephew, you know—will have it that she is innocent.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“In spite of her disappearance?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yes. He came this morning, before I was up, to see if I knew where Sisily had gone. After tea he came again in a terrible state, raving against the detective for taking out a warrant for her arrest. He said it was madness on his part to imagine that a girl like Sisily would kill her father. I told him that as Sisily had disappeared he could hardly blame the police for looking for her. He turned on me when I said that, and used such violent language that I was quite frightened of him. But I make allowances, of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Why?” the lawyer asked, looking at her.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I think Charlie is very fond of Sisily,” murmured Mrs. Pendleton with womanly intuition.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Do you mean that they love each other?” said the lawyer, regarding her attentively.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I cannot say about Sisily. And I never guessed it of Charlie until this morning. I’m sure poor Robert had no idea of it. He would never have agreed—after what he told us on the day of the funeral, I mean.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mr. Brimsdown gave a tacit unspoken assent to that. Some men might have welcomed such a solution of an ugly family scandal, but not Robert Turold, with his fierce pride for the honour of the title which he had sought to gain.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Is your nephew’s belief in Miss Turold’s innocence based on anything stronger than assertion? Does he suspect any one else?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“He did not say so. He was very excited, and talked on and on, without listening to me in the least. He seems very impulsive and headstrong. I noticed that on the day of the funeral. When Robert told us about his marriage, Charles said to him that his first duty was to his daughter. Robert looked so angry.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I can well believe it,” murmured the lawyer. “The young man must have courage.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Oh yes, he served with distinction in the war,” Mrs. Pendleton innocently rejoined. “In temperament he takes after me, I think, more than after his father. Austin and I never did think alike. We even disagreed over poor Robert’s terrible death. Austin thought he had . . . destroyed himself.” Her voice dropped to a shocked whisper.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“On what grounds did he base that belief?” Mr. Brimsdown cautiously asked.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“He thought the circumstances pointed to it,” she rejoined. “But I knew better—I knew Robert would never do anything so dreadful. Besides, had I not seen that horrible old man-servant glaring through the door? That is why I went to the police.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("As Mrs. Pendleton showed a tendency to repeat herself, Mr. Brimsdown rose to terminate the interview. Mrs. Pendleton rose, too, but she had not yet reached the end of her surprises for him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“And then there’s Robert’s will—so strange! Really—”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“The will! What will?” interrupted the lawyer testily. “Did your brother make his will down here?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yes. A will drawn up by a local lawyer—a man with the extraordinary name of Bunkom—a most terrible little creature. Bunkom, indeed!” continued Mrs. Pendleton, shaking her head with a feeble assumption of sprightliness. “Everything is left to my brother Austin. I do not mind in the least about myself. After all, Robert and I met almost as strangers after many years, and I want nothing from him. But his treatment of this unfortunate girl, his daughter, is really too dreadful. I do not wish to speak ill of the dead, but I must say that much, whether Sisily had anything to do with Robert’s death or not, for, of course, Robert couldn’t have known about that at the time—when he made his will, I mean,” concluded Mrs. Pendleton, in some confusion of mind.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It is strange that your brother did not consult me before drawing up this will,” said Mr. Brimsdown.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Perhaps he imagined you might persuade him against it,” sighed Mrs. Pendleton. “It is all very strange. I do not understand it a bit.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mr. Brimsdown thought it strange, then and afterwards. Next day, after going to the police station and handing Robert Turold’s letter to Inspector Dawfield, he sought out the Penzance lawyer who had drawn up the will. Mr. Bunkom was a spidery little man who spun his legal webs in a small dark office at the top of Market Jew Street, a solicitor with a servile manner but an eye like a fox, which dwelt on his eminent confrère from London, as he perused the will, with an expression which it was just as well that Mr. Brimsdown didn’t see, so sly and savage was it. The Penzance spider knew his business. The will was watertight and properly attested. The bulk of the property was bequeathed to Austin Turold unconditionally. There were only two other bequests. Robert Turold had placed Thalassa and Sisily (“my illegitimate daughter”) on an equality by bequeathing to them annuities of £50 a year each. Austin Turold and Mr. Brimsdown were named as joint executors, and that was all.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mr. Brimsdown would not have occupied such a distinguished place in the legal profession if he had not been a firm believer in the sacred English tradition that a man has the right to dispose of his own property as he thinks fit. Moreover, his legal mind realized the folly of speculating over the reasons which had prompted this hurried will when the man who had made it was beyond the reach of argument, reproof, or cross-examination.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("But the lack of all mention of the title was a different matter, calling for investigation. It was remarkable that a man like Robert Turold should have gone to the grave without binding his heir to prosecute the claim for the Turrald title. To that end Robert Turold had devoted his life, and to the upkeep of the title he had proposed to devote his fortune. The absence of this precaution puzzled Mr. Brimsdown considerably at first, but as he pondered over the matter he began to see the reason. Robert Turold was so close to the summit of his ambition that he had not thought it necessary to take precautions. He was a strong man, and strong men rarely think of death. Once the title was his, it descended as a matter of course to his brother, and then to his brother’s son—provided, of course, that the proofs of his daughter’s illegitimacy were in existence.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("That conclusion carried another in its wake. If Robert Turold had not safeguarded his dearest ambition because he hoped to carry it out himself, it followed as a matter of course that he did not take his own life. Mr. Brimsdown had never accepted that theory, but it was strange to have it so conclusively proved, as it were, by the inference of an omission. That brought the lawyer back to the position that some foreboding or warning of his murder had caused Robert Turold to summon him to Cornwall by letter. The next step of his investigations led Mr. Brimsdown to the dead man’s study, where that frantic appeal had been penned.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He engaged a vehicle at the hotel and drove over to Flint House in the afternoon. The impression of that visit remained. Flint House, rising from the basalt summit of the headland like a granite vault, its windows coldly glistening down on the frothy green gloom of the Atlantic far beneath, the country trap and lean black horse at the flapping gate, the undertaker’s man (dissolute parasite of austere Death) slinking out of the house, and Thalassa waiting at the open door for him to approach—all these things were engraved on Mr. Brimsdown’s mind, never to be forgotten. Who was it that had staged such a crime in such a proscenium, in that vast amphitheatre of black rocks which stretched dizzily down beneath those gleaming windows?")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Then came other impressions: the dead man upstairs, the disordered dusty study, the stopped clock, the litter of papers. It was in the room where Robert Turold had been murdered that Mr. Brimsdown questioned Thalassa about the letter, and heard with a feeling of dismay his declaration that he had not posted it. Where was the nearest pillar box? Nearly a mile away, at the cross-roads. Could his late master have gone there to post it that night? If he had, Thalassa hadn’t heard him go out. Could anybody else have posted it? No; there was nobody else to post it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It was like questioning a head on an old Roman coin, so expressionless was Thalassa’s face as he delivered himself of these replies. But the lawyer had the feeling that Thalassa was deriving a certain grim satisfaction from his questioner’s perplexity, and he dismissed him somewhat angrily. Then, when he had gone, he turned to an examination of some of the papers and documents which littered the room, but that was a search which told him nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("When the shades of evening warned him to relinquish that task, he told himself that he really ought to go and see Austin Turold before returning to Penzance. But he shrank, with unaccountable reluctance, from the performance of that obvious duty. He felt very old and tired, and his temples were throbbing with a bad nervous headache. He therefore decided to postpone his visit to Austin Turold until later.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer021"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-21"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor020"
    }
  }), _vm._v("Chapter XX")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("When the interview with Austin Turold did take place, Mr. Brimsdown learnt with a feeling which was little less than astonishment that Robert Turold had died without confiding to his brother the proofs, on which so much depended, of the statement he had made on the day of his death.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I cannot understand it,” he murmured, putting down his tea-cup as he spoke.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Austin had received him in the blue sitting-room, hung with the specimens of Mr. Brierly’s ineffectual art, and had given him tea, as he had given Barrant tea some days before. But there was a subtle difference in the manner of Mr. Brimsdown’s reception; the tone was pitched higher, with fine shades and inflections attuned for a more gentlemanly ear.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It disposes of the suicide theory finally and utterly,” added the lawyer thoughtfully.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“The suicide theory disappeared with Robert’s daughter,” said Austin, glancing at his son, who had taken no part in the conversation.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You think her disappearance suggests guilt?” asked Mr. Brimsdown.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It hardly suggests innocence, does it?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I would not like to hazard an opinion,” responded Mr. Brimsdown, with a thoughtful shake of the head. “My experience of women is that they are capable of the strangest acts without weighing the consequences.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That was before the war, when women were delightfully irrational creatures, but now they’re no longer so. They’ve become practical and coarse, like men. They smoke, drink, and tell improper stories with demure expression and heads a little on one side like overwise sparrows.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Was Robert Turold’s daughter a girl of this sort?” asked the lawyer in surprise.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“She was not.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It was Charles Turold who made answer, with an angry glance at his father. Austin, looking at him, gave an almost imperceptible shake of the head. Slight as the warning was, it was intercepted by Mr. Brimsdown’s watchful eye, and he wondered what it meant.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I do not think any useful purpose can be gained by discussing my brother’s death,” Austin interposed, turning to him. “It is a very painful subject, and does no good. The police are endeavouring to unravel the mystery—let us leave it to them.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I was merely going to say that your brother would have given you the proofs of this statement about his marriage if he had meditated self-destruction,” Mr. Brimsdown observed. “The proofs must be in existence, of course, but I do not think that they are at Flint House. Did your brother confide the information to you beforehand—before his public announcement, I mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Shortly before his death he hinted to me of some very important disclosure which he intended to make at the proper time—some family matter—but he did not say what it was, nor did I ask him.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("His son looked at him quickly, and the lawyer doubtfully, as he made this statement, but his own glance sustained both looks serenely and equably.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“My brother did inform me, a week ago, that I would succeed to his fortune,” he added.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That proves that your brother was aware of the illegality of his marriage at that time,” said Mr. Brimsdown, with an air of conviction.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Why so?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Because you could not succeed to the Turrald title if your brother’s daughter was legitimate.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That would not prevent my brother disposing of his property as he thought fit,” remarked Austin coldly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I am aware of that,” replied Mr. Brimsdown guardedly. He refrained from stating what was obvious to him, that Robert Turold had intended his fortune for the upkeep of the title when gained, and for no other purpose. “After all, it does not matter very much how long your brother was aware of the fact. The great point is—where are the proofs? I cannot understand why your brother did not send them on to me. I intend to make another and longer search among his papers at Flint House. They must be found. The House of Lords will require the most convincing proof on this head before terminating the abeyance in your favour.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“If I proceed with the claim, you mean,” said Austin.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The lawyer turned on him a startled glance which had something of consternation in it. His own interest in the title, was, by force of long association with Robert Turold, so deep and intimate that it had never occurred to him to suppose that the younger brother might not share in the obsession of the elder.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Titles are at a discount nowadays—like virtuous women,” proceeded Austin. “The most extraordinary people have them. Are you aware that there were nearly four thousand names in the last Royal bestowal of Orders of the British Empire? There’s kingly munificence for you! It’s the same with the Masonic order. The gentleman you address as ‘Right Worshipful Sir’ overnight delivers poultry and rabbits at your back door next morning. Democracy has come into its own, Brimsdown. Sooner or later we shall have a king wearing a cloth cap.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Your remarks do not apply to the old nobility,” returned Mr. Brimsdown austerely. “They will never become common. It would be a pity not to prosecute your brother’s claim to the Turrald title. He gave thirty years of his life to establishing the line of descent.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“My brother had the temperament of a visionary,” replied Austin. “I am more practical. But I shall respect his wishes, if possible, though from what you say it would seem to be quite useless to go on with the claim if the missing proofs about his wife’s previous marriage are not recovered.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That is quite true,” Mr. Brimsdown admitted. “But I feel sure that they are in existence, somewhere. Your brother Robert was not the man to make a statement of that kind without the proofs. He knew the value of documentary evidence too well for that.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“But so far the proof of his daughter’s illegitimacy rests on his unsupported statement, which would be quite valueless in a court of law?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That is so.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“If these proofs are found, do you think that my chance of regaining the title is as good as Robert’s?” Austin asked. “Are the circumstances of his death likely to tell against my succeeding? I ask you because I know nothing about peerage law.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“The House of Lords has inherent rights of its own in regard to the granting of any claim,” replied the lawyer carefully, “rights as the guardian of its own privileges. I do not think, however, that your claim would be rejected. The line of descent is clear, if the proofs of your brother’s statement are found. The Turrald barony is a parliamentary peerage which descends to a sole daughter. You can only succeed your brother in the line of descent if she is illegitimate.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“In any case the present claim could not be gone on with, could it?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No. That must be withdrawn. I will write to the Home Secretary acquainting him with your brother’s death. Later on, if we find the proofs, another claim can be prepared on your behalf.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“If I decide to go on with it.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I trust that you will,” said the lawyer. “It was your brother’s dream to restore the title with a male line of descent.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“His dream will be fruitless so far as I am concerned,” said Charles Turold, who had been listening intently to this conversation. “I shall have nothing to do with this title.” He got up, and strode abruptly from the room without another word.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mr. Brimsdown was a little surprised at the lack of manners evinced by this precipitate departure, but arose without speaking to take his own leave. Austin did not offer to escort him downstairs. He rang the bell, which was answered by the gaunt maid who had been engaged to sit as Britannia or the Madonna, and to her he consigned his departing visitor after a soft pressure of his white hand.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The maid preceded the lawyer down the staircase with a martial step which outstripped his, and waited at the foot for him to complete the descent. As Mr. Brimsdown reached the last stair, a door immediately opposite opened, and a lady came out. Mr. Brimsdown glanced at her casually in passing, and encountered her glance in return. In that brief look he observed the dawn of swift surprise in her eyes. Her careworn face flushed, and she made an eager step forward, as though about to speak. Somewhat surprised at this action on her part, Mr. Brimsdown hesitated, then, reflecting that he had probably misinterpreted a chance movement on the part of a perfect stranger, went towards the door, which the maid was holding open for him. As he passed through he glanced back, and to his astonishment saw the woman in the passage still standing in the same spot, staring fixedly after him, apparently in a state of consternation or amazement, he could not say which.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He went out of the door with a vision of her questioning gaze following him as far as she could see him. He did not think any more of it just then. A lowering sky suggested rain, and he set off at a round pace for the inn where he had left the vehicle which had brought him to the churchtown.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("But quickly as he walked, a footstep behind him was quicker still, and he turned involuntarily to see who was following. Another surprise was in store for him. The tall figure hurrying after him, with the evident intention of overtaking him, was Charles Turold. The lawyer stood still and waited for him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I have come after you to tell you something,” Charles said abruptly, “something that you ought to know. You were questioning my father about the facts of this case—about my uncle’s death. You did not learn anything from him, but I can tell you my cousin Sisily is innocent.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He brought out these words with a breathlessness which may have been the result of his haste. The calmness of the lawyer’s reply was in marked contrast.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Is this merely an assertion, Mr. Turold?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It is more than an assertion. I can prove it to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mr. Brimsdown was startled. “What do you mean by that?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“If you will come to Flint House I will show you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mr. Brimsdown stroked the cautious chin of an old man plunged into a situation which he could not fathom. “Would it not be better to consult the police first?” he temporized.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“The police are now searching the country for Sisily, and there is no time to be lost.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("There was something so profoundly unhappy in his appearance that pity stirred in the lawyer’s heart. “Very well,” he said, with another look at the lowering sky, “let us go.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("That afternoon remained with the lawyer as another unforgettable memory. It was all of a piece, sombre, yet of a sharp-edged vividness: the desolation of the moors, the sting of the rain, the clamour of the sea, the seabirds soaring slowly with harsh cries. Then they stood, the pair of them, in Robert Turold’s bedroom, looking down on the dead man, swathed in his graveclothes, with a wreath of flowers from Mrs. Pendleton on his breast. Removing this symbol of human pretense against the reality of things, Charles Turold bared the arm of the corpse, and pointing to it exclaimed—")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Could those marks have been made by Sisily?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("In his examination of the marks thus revealed to him, Mr. Brimsdown had the strange feeling that their existence was, in some way, the justification of the dead man’s summons to him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Do you know how these marks were made?” he said, turning to Charles.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I do not. But I do know that they prove that Sisily is innocent.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Charles Turold spoke defiantly, but there was a slight note of interrogation in his voice which the lawyer chose to ignore.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“They were made by a man’s hand,” the young man persisted, looking earnestly at him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Do the police know of them?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That I cannot tell you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Another question was in Mr. Brimsdown’s mind, but the young man’s haggard face, the mingled misery and expectation of his glance, checked the utterance of it. He had the idea that Charles’s manner suggested something more—some revelation yet to come. But the young man did not speak.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Is this all you wanted to show me?” Mr. Brimsdown hinted.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Is it not enough?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I do not see that it throws any light on Miss Turold’s disappearance. Can you explain that?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“How can I explain what I do not know?” Charles was silent for a moment, then added bitterly. “It may be because of her father’s inhuman conduct.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Robert Turold is dead—do not use that tone in speaking of him,” the lawyer counselled.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Charles turned on him a peculiar look. “Do you think the world is the loser by his death?” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mr. Brimsdown was moved out of himself to declare that the death of Robert Turold was a distinct loss to the world. “He was a wonderful man—a notable personality,” he said emphatically.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Charles gave him a moody glance, and there fell upon them a silence so complete that the dead man in the bed seemed to share in it. The lawyer had an acute perception of the fact that he had handled the situation badly. He intuitively realized that he had put himself into the opposite camp to Charles’s sympathies by the uncompromising partisanship of his last remarks. He was convinced that until that moment, Charles had been meditating the question of some further disclosure. Mr. Brimsdown regretted afterwards that he made no effort to gain his confidence. He felt that if he had done so events might have taken a different course. But it is difficult to bring youth and age together. Youth sometimes yields to impulse, but not age. The lurking devil of self-consciousness whispers caution as the safer quality. Mr. Brimsdown hearkened to the whisper, and stood there in silence, while the minutes slipped by which might have bridged the gap.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("There was a quick step in the passage outside, and the door opened to admit Detective Barrant. He looked inquiringly from one to the other, and addressed himself to the lawyer.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Are you Mr. Brimsdown?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That is my name,” the lawyer replied.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I am Detective Barrant of Scotland Yard. I wish to speak to you privately.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("His emphasis on the last word was not lost on Charles Turold. With a slight indifferent nod to Mr. Brimsdown he went out of the room, closing the door quietly behind him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I have come to see you about this letter which you left with Inspector Dawfield.” Barrant produced the letter and took the single sheet from the grey envelope.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That is the reason of my presence in Cornwall,” said Mr. Brimsdown.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“So I imagined. What can you tell me about it?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Very little, except that I received it by the last post at my chambers in Lincoln’s Inn Fields the night after Robert Turold’s death.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“But why did he send for you?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That I cannot even guess.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You surely must have some idea.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“If I had I should be only too happy to assist the course of justice by imparting it to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("There was a dryness in the tone of this reply which warned Barrant that he had made a blunder in allowing his irritation to get the better of him. But his private opinion was that the letter was the outcome of some secret of the dead man’s which he had imparted to his lawyer. He changed his mood with supple swiftness, in order to extract the information.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“This letter suggests certain things,” he said, “some secret, perhaps, in Robert Turold’s life, of which you may have some inkling. If you will give me some hint as to what it was, it might be very helpful.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Unfortunately, I am as much in the dark as yourself,” returned Mr. Brimsdown, rubbing his brow thoughtfully. “I cannot make the faintest guess at the reason which called forth this letter. I know next to nothing of my late client’s private life. He was a man of the utmost reticence in personal matters. My relations with him were not of that nature.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("This reply was delivered with a sincerity which it was impossible to doubt. In palpable disappointment Barrant turned to a renewed scrutiny of the letter, which he held open in his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It is very strange,” he muttered.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Not the least strange part of it is that I cannot ascertain who posted it,” said Mr. Brimsdown, glancing earnestly at the letter. “I asked Thalassa, but he says he knows nothing about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Thalassa is probably lying to you as he has lied to me. One lie more or less would not weigh on his conscience.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Why should he tell a lie over such a small thing as the posting of a letter?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant did not reply. He was apparently absorbed in examining the postmarks on the envelope. “Indistinguishable, of course,” he muttered, returning the letter to the envelope. “Had Robert Turold any enemies?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I never heard him speak of any.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“How did he come by his money?” asked Barrant, struck by a sudden thought. “His sister tells me that he made his money abroad.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That I cannot tell you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“But you invested his fortune for him, did you not?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I did,” the lawyer agreed.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“In what circumstances?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It is rather a strange story,” replied Mr. Brimsdown slowly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I should like to hear it then. It may throw some light on this letter.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Let us go into the other room.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("Mr. Brimsdown made this suggestion with a quick glance at his departed client on the bed, as though he feared some sardonic reproof from those grey immobile lips.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer022"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-22"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor021"
    }
  }), _vm._v("Chapter XXI")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("Barrant had returned with a feeling of irritation against the mischances of events which had brought an important piece of evidence to light after his departure for London. He had chosen to commence inquiries into Sisily’s disappearance as soon as he had reached London instead of going to Scotland Yard, where a guarded telegram from Inspector Dawfield awaited him, and although he had hastened to obey the summons back to Cornwall as soon as he received it, two valuable days had been lost. It was true that in that time he had found traces of the girl which he believed would lead to her early arrest, but the letter, with its implication that the dead man was aware of his impending doom, was a highly significant clue, and strengthened Barrant’s original belief that the real mystery of Robert Turold’s death lay much deeper than the plausible surface of events indicated.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He sat now, with a kind of sombre thoughtfulness, listening to Mr. Brimsdown’s account of his first meeting with his dead client. That story carried with it a suggestion of adventure and mystery, but it was difficult to say whether those elements had anything to do with Robert Turold’s death, thirty years later. It brought up the image of a man, rugged and dominant even in youth, winning his way into the heart of a middle-aged lawyer by the story of his determination to possess an old English title. Most men have the spirit of Romance hidden in them somewhere, and chance or good luck had sent Robert Turold, on his return to England, to the one solicitor in London to whom his story was likely to make the strongest kind of appeal. The spirit of Romance in Mr. Brimsdown’s bosom was no shimmering thing of thistledown and fancy, but took the concrete shape of the peerage law of England, out of which he had fashioned an image of worship to the old nobility and the days of chivalry.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant gathered so much from the lawyer’s description of that first meeting. And if Robert Turold had found in the solicitor the man he most needed in his search for the missing title, it was equally clear that his own great quality of rugged strength had exercised the most extraordinary sway on the lawyer—a species of personal magnetism which had never lost its original effect. It was not until the second or third meeting—Mr. Brimsdown was not quite sure which—that the question of money was introduced. The lawyer had pointed out to his client that the search for the title was likely to be prolonged and expensive, and Robert Turold had indifferently assured him that he had money at his command for that purpose lying on deposit at a London bank. The amount, when he did mention it, was much greater than Mr. Brimsdown imagined—nearly £50,000 in fact. It was at Robert Turold’s suggestion that Mr. Brimsdown undertook to invest the sum at better rates of interest, and thus, before a year had passed, the whole of Robert Turold’s business affairs were in the hands of the solicitor.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("On one point Mr. Brimsdown was clear. He had never heard from Robert Turold how he first came into possession of this large sum of money, and his client had never encouraged inquiry on the subject. Mr. Brimsdown had once ventured to ask him how he had made his fortune, and Robert Turold, with a freezing look, had replied that he had made it abroad. Mr. Brimsdown had never again referred to the subject, deeming it no business of his.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant, listening to this with the air of a man who was not to be deceived, could not see that the narration threw any illumination on the letter or the other circumstances of Robert Turold’s death. It seemed too far-fetched to suppose there was any connection between the fortune which Robert Turold had brought from abroad thirty years before and the letter he had sent to his solicitor on the night of his death. The idea did indeed cross his mind that some iniquity in that money-getting may have been responsible for a belated revenge, but he dismissed that thought as too wide for the scope of his inquiry. Abroad! That was a vague word, and thirty years was a long while back.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("As he contemplated the manifold perplexities of the case, Barrant tried to shut out the more sinister inference of the letter by asking himself, if after all, the postscript was not capable of some entirely innocent interpretation. But his conscientious mind refused to permit him to evade responsibility in that way. The letter could not be dismissed with a wave of one’s wishing wand. It remained stubbornly in Barrant’s perspective, an unexplained factor which could be neither overlooked nor ignored.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("These thoughts ran through his mind as Mr. Brimsdown talked of his dead client. At the same time, the detective’s attitude towards the lawyer underwent a considerable change. His professional caution, amounting almost to suspicion, became modified by the more perceptive point of view that as the dead man had turned to Mr. Brimsdown for assistance, it would be better for him to trust the lawyer also—to look upon him as an ally, and make common cause with him in the search for Robert Turold’s murderer.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("This changed attitude, carrying with it a seeming friendliness, the establishment, as it were, of an understanding between them, was not lost upon Mr. Brimsdown. But it had its awkward side for him, by giving added weight to the responsibility of deciding whether he should reveal or withhold his chance encounter with Sisily at Paddington. Till then, Mr. Brimsdown had been unable to make up his mind about that. There were some nice points involved in the decision. In an effort to reach a solution he broached the subject.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Is it still your opinion that Miss Turold is guilty—after this letter?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Her disappearance lays upon her the obligation of explaining her secret visit to her father on the night of the murder,” was the guarded reply.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Then you intend to arrest her?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Do you know where she is?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("A quick consideration of this question led Barrant to the conclusion that it would do no harm to let the lawyer know the scanty truth.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“She is in London. I have traced her to Paddington.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mr. Brimsdown decided that, as the detective knew that much, it absolved him from any obligation to betray the daughter of his dead client. His feeling of relief unsealed his lips, and led him into an indiscretion.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It seems incredible that she can be guilty.” As he spoke the memory of Sisily’s tender and wistful face, as he had seen it that night, came back to him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“She had some justification, you know, if she was listening at the door that afternoon,” replied Barrant thoughtfully.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It is hardly possible that she could have inflicted those marks on the arm,” Mr. Brimsdown said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“How did you learn of them?” asked the detective quickly, in a changed tone.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Too late Mr. Brimsdown realized that in contrast to his silence with Charles Turold, he had now gone to the other extreme and said too much. He hesitated, but his hesitation was useless before the swiftness of Barrant’s deduction.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Was Charles Turold showing you the marks when I found you in the other room?” he asked with a keen glance.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mr. Brimsdown’s admission of that fact was coupled with an assurance that the young man had shown him the marks because he was convinced of Sisily’s innocence.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant dismissed young Turold’s opinions about the case with an impatient shake of the head. “Who told him about the marks?” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It was the thought which had occurred to Mr. Brimsdown at the time, but he did not say so then. “How did you discover them?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“When I was examining the body. But Charles Turold had no reason to examine the body. Perhaps Dr. Ravenshaw told him. I must ask him.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It is a terrible and ghastly crime,” said Mr. Brimsdown, in an effort to turn the mind of his companion in another direction. “There is something about it that I do not understand—some deep mystery which has not yet been fathomed. Was it really his daughter? If so, how did she escape from the room and leave the door locked inside? Escape from these windows is plainly impossible.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He crossed to the window, and stood for a moment looking down at a grey sea tossing in futile restlessness. After an interval he said—")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Do you suspect Thalassa as well?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The detective looked at him with a cautious air: “Why do you ask that?” he said, with some restraint in his tone.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It might account . . . for certain things.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant shook his head in a way which was more noncommittal than negative. He wanted to ascertain what the lawyer thought, but he was not prepared to reveal all his own thoughts in return.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Do you think that Robert Turold invented this story about his marriage?” he asked suddenly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“For what purpose?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“He did not want his daughter to succeed him in the title. His announcement about the previous marriage strikes me as just a little too opportune. Where are the proofs?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You would not talk like that if you had known Robert Turold,” said the lawyer, turning away from the window. “He was too anxious to gain the title to jeopardize the succession by concocting a story of a false marriage. He had proofs—I have not the slightest doubt of that. I believe he had them in the house when he made his statement to the family.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Then where are they now?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“They may have been stolen.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“For what reason?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“By some one interested.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“The person most interested is Robert Turold’s daughter,” said Barrant thoughtfully. “That supposition fits in with the theory of her guilt. Robert Turold is supposed to have kept valuable papers in that old clock on the wall, which was found on the floor that night. Apparently he staggered to it during his dying moments and pulled it down on top of him. For what purpose? His daughter may have guessed that the proofs of her illegitimacy were kept there, and tried to get them. Her father sought to stop her, and she shot him.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That theory does not account for the marks on the arm,” said the lawyer.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It does, because it is based on the belief that there was somebody else in the room at the time, or immediately afterwards.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Thalassa?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yes—Thalassa. He knows more about the events of this night than he will admit, but I shall have him yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“But the theory does not explain the letter,” persisted the lawyer with an earnest look. “Robert Turold could not possibly have had any premonition that his daughter intended to murder him, and even if he had, it would not have led him to write that letter with its strange postscript, which suggests that he had a sudden realization of some deep and terrible danger in the very act of writing it. And if Thalassa was implicated, was he likely to go to such trouble to establish a theory of suicide, and then post a letter to me which destroyed that theory?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“We do not know that Thalassa posted the letter—it may have been Robert Turold himself. As for premonitions—” Barrant checked himself as if struck by a sudden thought, stood up, and walked across the room to where the broken hood clock had been replaced on its bracket. He stood there regarding it, and the round eyes in the moon’s face seemed to return his glance with a heavy stare.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“If that fat face in the clock could only speak as well as goggle its eyes!” he said, with a mirthless smile. “We should learn something then. What’s the idea of it all—the rolling eyes, the moon, the stars, and a verse as lugubrious as a Presbyterian sermon on infant damnation. The whole thing is uncanny.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It’s a common enough device in old clocks,” said the lawyer, joining him. “It is commoner, however, in long-cased clocks—the so-called grandfather clock. I have seen all sorts of moving figures and mechanisms in long-cased clocks in old English country houses. A heaving ship was a very familiar device, the movement being caused, as in this clock, by a wire from the pendulum. I have never seen a specimen with the rotating moon-dial before, though they were common enough in some parts of England at one time. This is a Dutch clock, and the earlier Dutch makers were always fond of representing their moons as human faces. It was made by a great master of his craft, as famous in his native land as old Dan Quare is in England, and its mechanism has outlived its creator by more than three hundred years.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Would it be an accurate timekeeper, do you think?” asked Barrant, looking mistrustfully at the motionless face of the moon, as though he suspected it of covertly sneering at him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I should think so. These old clockmakers made their clocks to keep perfect time, and outlast Time himself! And this clock is a perfect specimen of the hood clock, which marked a period in clock-making between the old weight clocks and the long cases. Hood clocks were popular in their day in Holland, but they have always been rare in this country. It would be interesting to trace how this one came into this house. No doubt it was taken from a wreck, like so much of the furniture in old Cornish houses.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You seem to know a lot about old clocks.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mr. Brimsdown, astride his favourite hobby, rode it irresistibly. He discoursed of clocks and their makers, and Barrant listened in silence. The subject was not without its fascination for him, because it suggested a strange train of thought about the hood clock which was the text, as it were, of the lawyer’s discourse. He looked up. Mr. Brimsdown, in front of the clock, was discoursing about dials and pendulums. Barrant broke in abruptly with the question on his mind—")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Can you, with your knowledge of old clocks, suggest any reason which would cause Robert Turold to go to it? Are the works intricate? Would such a clock require much adjustment?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Robert Turold was not likely to think of adjusting a clock in his dying moments,” returned Mr. Brimsdown, with a glance which betokened that he perfectly understood his companion had some other reason for his question.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“There’s a smear of blood on the dial,” said Barrant, staring at it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Was that made by the right or left hand?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“The right hand was resting on the clock-face. Why do you ask?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mr. Brimsdown hesitated, then said: “The thought has occurred to me that Robert Turold may have gone to the clock for a different purpose—not for papers. Perhaps his last thought was to indicate the name of the murderer on the white face of the clock.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“In his blood? Rather a melodramatic idea, that! He had writing materials before him if he wanted to do that, if he thought of it. He was shot down in the act of writing, remember.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("A silence fell between them on this declaration—a silence terminated by Barrant remarking that it was really late, and he must be getting back to Penzance. Mr. Brimsdown made no suggestion to accompany him. Instead he rustled papers in Robert Turold’s cabinet as though to convey the impression that the sorting and searching of them would take him some time. Barrant, from whose eyes speculation and suspicion looked out from a depth, like the remote glance of a spider which had scurried to a hole, gave a slight sign of farewell, and wheeled out of the apartment without another word.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Downstairs he went, plunged in the deepest thought. Looking downward, he saw Thalassa escorting Dr. Ravenshaw to the front door. The doctor’s voice reached him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“. . . She must not be left alone on any account—understand that. You ought to get somebody to look after her.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I can’t afford nobody,” Thalassa made reply.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Dr. Ravenshaw was about to say something more, but the figure of the descending detective caught his eye. Barrant made a detaining gesture, and the doctor waited in the passage for him. Barrant, with a slight glance at the motionless figure of Thalassa, led the way into the front room. He closed the door before he spoke.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Doctor,” he said, “have you told anybody about those marks on Robert Turold’s arm?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I have not,” said the doctor promptly, looking up. “Why do you ask?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("His glance carried conviction, and interrogation also. But it was Barrant’s province to ask questions, not to answer them. He ignored Dr. Ravenshaw’s.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“There’s another matter, doctor,” he continued. “One of the coast fishermen has a story that when Robert Turold was out on the moors he used to hasten home with great strides, like a man who feared pursuit. Did you ever observe this peculiarity in him?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I have observed that he used to walk at a quick pace.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“This was more than a quick pace—it was almost a run, according to the fisherman—looking backward over his shoulder as he went.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I did not notice that, but I should not be surprised if it were true, with a man of Robert Turold’s temperament.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“He feared pursuit—some unknown danger, then?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I cannot say. He may have suffered from agoraphobia.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What is that?” asked Barrant.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“The dread of open spaces.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I have heard of claustrophobia—the dread of closed spaces—but not of this.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It is common enough—an absurd but insurmountable aversion to open spaces. The victims are oppressed by a terrible anxiety when crossing a field. I have known a man who would be terrified at the idea of crossing Trafalgar Square.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What is the cause of agoraphobia?” asked Barrant.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It is a nervous disorder—one of the symptoms of advanced neurasthenia.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Did Robert Turold suffer from neurasthenia?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“His nervous system was in a state of irritable weakness through the monomania of a fixed idea,” was the reply—“too much seclusion and concentration on one object, to the exclusion of all other human interests.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“How’s your patient?” said Barrant, giving the conversation an abrupt turn.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What patient do you mean—Mrs. Thalassa?” asked Dr. Ravenshaw in some surprise.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yes. I gathered from what I overheard you say to Thalassa that you have been attending her.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I have been attending her since Mr. Turold’s death.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“She is in a strange condition,” observed Barrant reflectively. “I was questioning her the other night, but I could get nothing out of her. She seems almost imbecile.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“She is not a woman of strong mind, and she is now suffering from a severe shock. She should be looked after or taken away from here altogether, but her husband seems quite indifferent.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Do you think she will recover?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It is impossible to say.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“How do you think the shock was caused?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I should not like to hazard an opinion on that point, either,” replied Dr. Ravenshaw gravely. He glanced at his watch as he spoke. “I must be going,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("They left the house together, but branched off at the gate—Dr. Ravenshaw to visit a fisherman’s dying wife, and Barrant to seek the "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Three Jolly Wreckers")]), _vm._v(" for supper before returning to Penzance.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("From the kitchen window Thalassa watched them go: the doctor walking across the cliffs with resolute stride, the detective making for the path over the moors with bent head and slower step, as though his feet were clogged by the weight of his thoughts. Thalassa watched their dwindling forms until they disappeared, and then stood still, in a listening attitude. The sound of the lawyer stirring in the study overhead seemed to rouse him from his immobility. He closed the door, and stood looking up the staircase with the shadow of indecision on his face.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer023"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-23"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor022"
    }
  }), _vm._v("Chapter XXII")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("Upstairs Mr. Brimsdown made unavailing search among Robert Turold’s papers for proofs of his statement about his marriage. The lawyer believed that they existed, and his failure to find them brought with it a belated realization of the fact that he, too, had been cherishing hopes of Sisily’s innocence. It was the memory of her face which had inspired that secret hope. That was not sentiment (so Mr. Brimsdown thought), but the worldly wisdom of a man whose profession had trained him to read the human face. Sisily’s face, as he recalled it now, had looked sad and a little fearful that night at Paddington, but there was nothing furtive or tainted in her clear glance. He felt that a judge would look with marked attention at such a face in the dock. Judges, like lawyers, and all whose business it is to trip their kind into the gins of the law, scan faces as closely as evidence in the effort to read the stories written there.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("But the disappearance of certain papers which had probably been abstracted from that room weighed more in the scale of suspicion against Sisily than her look of innocence. She stood to gain most by the suppression or destruction of the proofs of her mother’s earlier marriage. But Mr. Brimsdown could not see that this rather negative inference against the girl brought the actual solution of the mystery any nearer. It did nothing to explain, for instance, the marks on the dead man’s arm and his posthumous letter. The letter! What was the explanation of the letter? Was it not an argument of equal weight for Sisily’s innocence, suggesting the existence of some hidden avenging figure glimpsed by Robert Turold in time to give him warning of his death, but not in time to enable him to avert it?")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("There were other things too. What was the meaning of that sly and stealthy shake of the head which Austin Turold had given his son that afternoon. A warning obviously—but a warning for what purpose? Mr. Brimsdown could not guess, but his contemplation of the incident brought before him the image of the restless and unhappy young man, as he stood by the bedside in the next room, pointing to the marks on the dead man’s arm. Even in his vehement assertions of Sisily’s innocence Mr. Brimsdown had conceived the impression that he was keeping something back. What did Charles Turold know? Did his father share his secret knowledge? Mr. Brimsdown could not answer these questions, and he was greatly perturbed at the way in which they brought a host of other thoughts and doubts in their train. He reflected that the Turolds, father and son, were after all the greatest gainers by their relative’s death. The father came into immediate possession of a large and unexpected fortune which he would bequeath to his son. And Austin Turold was not anxious apparently to proceed with his brother’s claim for the title.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("These were facts which could not be gainsaid, but where did they lead? The trouble was that no conceivable theory covered the facts of the case, so far as they were known. So far as they were known! That was the difficulty. Any line of thought stopped short of the real solution, because the facts themselves were inconclusive. There was much that was still concealed—Mr. Brimsdown felt sure of that.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("As he applied his mind to the problem, the definite impression came back to him, and this time with renewed force, that the mystery surrounding Robert Turold’s death was something which might not bear the light of day. He set his lips firmly as he considered that possibility. If that proved to be the case it would be his duty to cover it up again. He was an adept at such work, as many of his clients, alive and dead, could have approvingly testified. He had spent much time in safeguarding family secrets. Several old families had found him their rock of refuge in distress. If he had been a man of the people, baby lips might have been taught to call down Heaven’s blessings on his discreet efforts. Those members of the secluded domain of high respectability for whom he strived showed their gratitude in a less emotional but more substantial way—generally in the mellow atmosphere of after-dinner conferences . . . “You had better see my man, Brimsdown. I’ll give you a note to him. He’ll square this business for you. Safe? None safer.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mr. Brimsdown did not accept the axiom of a great English jurist that every man is justified in evading the law if he can, because it is the duty of lawmakers not to leave any loophole for evasion. That point of view of justice as a battle of wits, with victory to the sharpest, was a little too cynical for his acceptance. But he believed it to be his duty to safeguard the interests of his client. Robert Turold was dead, and no longer able to protect his own name. It might be that the facts of his death involved some scandalous secret of the dead man’s which was better undivulged, and if so it would remain undivulged, could Mr. Brimsdown contrive it. For the time being he would pursue his investigations and keep his own counsel.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The sound of an opening door and a shadow athwart the threshold disturbed his meditations. He looked up, and was confronted by the spectacle of Thalassa advancing into the room with his eyes fixed upon him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Well, Thalassa,” he said, “what do you want?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“To ask you something,” was the response. “It’s this. It’s every man for himself—now that he’s gone.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He jerked his thumb in the direction of the next room. “He took this house for twelve months, and so it’ll have to be paid for. Can I stop here for a bit? I suppose it’s in your hands to say yes or no.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("His face was hard and expressionless as ever, but there was a new note in his voice which struck the lawyer’s keen ear—an accent of supplication. He looked at Thalassa thoughtfully.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You wish to stay on here until you have made other arrangements for your future—is that so?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That’s it,” was the brief reply.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mr. Brimsdown felt there was more than that—some deeper, secret reason. Before granting the request it occurred to him to try and get what he could in exchange. Self-interest is the strongest of human motives, and men wanting favours are in a mood to yield something in return.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Well, Thalassa,” he said, amiably enough, but watching him with the eye of a hawk, “I do not think your request is altogether unreasonable—in the circumstances. I dare say it could be arranged. I’ll try to do so, but I should like you to answer me one or two questions first.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What do you want to know?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Was your master’s daughter here—in the house, I mean—on the night of his death?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa’s face hardened. “You, too?” he said simply. “I say again, as I said before, that she was not.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You said so,” rejoined Mr. Brimsdown softly. “The question is—are you telling the truth? If you know anything of the events of that night you may be injuring Miss Turold by your silence.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("For a moment Mr. Brimsdown thought his appeal was going to succeed. He could have sworn that a flicker of hesitation—of irresolution—crossed the old man’s stern countenance. But the mood passed immediately, and it was in an indifferent voice that Thalassa, turning to go, replied—")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“If that’s what you’re reckoning on, I’d better go and pack my traps.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Oh, I don’t make that a condition,” replied the lawyer, acknowledging his defeat in a sporting spirit. “You can remain here and look after the house until you decide what to do. As Robert Turold’s old servant you are entitled to consideration. I will help you afterwards, if you will let me know your plans. I am sure that would have been your late master’s wish.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I want nothing from "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("him")]), _vm._v(",” Thalassa rejoined, “a damned black scoundrel.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mr. Brimsdown was shocked at this savage outburst, but there was something so implacable in the old man’s air that the rebuke he wished to utter died unspoken. Thalassa regarded him for a moment in silence, and then went on—")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Thank’ee for letting me stop on here a bit. Now I’ll tell you something—about him.” Again his thumb indicated the next room. “It was the night after.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Do you mean the night after he met his death?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yes. Some one was upstairs in his room—in this room.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mr. Brimsdown gave a startled glance around him, as though seeking a lurking form in the shadows. “Here?” he breathed.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Here, sure enough. I woke up in my bed downstairs, staring wide awake, as though somebody had touched me on the shoulder. I was just turning over to go to sleep again, when I heered a noise up here.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What sort of a noise?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Like the rustling of paper. I listened for a bit, then it stopped. I heard a board creak in the next room, where we’d carried him. Then the rustling started in the other room again, right over my head. The dog downstairs started to bark. I got up, and went upstairs as quickly as I could, but there was nobody—except "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("him")]), _vm._v(". The dog frightened whoever it was, I suppose. Next morning I found the front room window wide open.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Were there any footprints outside the window?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“A man doesn’t leave footprints on rocks.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What time was it?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It would be about midnight, I reckon.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Did your wife hear the noise?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No. She was in bed and asleep.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Are you sure you didn’t dream this?” Mr. Brimsdown asked, with a shrewd penetrating glance.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“The open window wasn’t a dream,” was the dogged reply.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You might have left it open yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No, I didn’t. I close the windows every night before dark.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“And lock them?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Not always.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The incident did not sound convincing to Mr. Brimsdown, but his face did not reveal his scepticism as he thanked Thalassa for the information. Thalassa lingered, as if he had something still on his mind. He brought it out abruptly—")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Has anything been seen of Miss Sisily?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Nothing whatever, Thalassa.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("On that he turned away, and went out of the room, leaving the lawyer pondering over his story of a midnight intruder. Mr. Brimsdown came to the conclusion that it was probably imagination, and so dismissed it from his mind.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He resumed his work of working over the papers, but after a few minutes discontinued his search, and walked restlessly about the room. The air seemed to have the taint of death in it, and he crossed over to one of the windows and flung it up.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The window looked out on the sea, though far above it, but the slope of the house embraced in the view a portion of the cliffs at the side. As Mr. Brimsdown stood so, breathing the sea air and looking around him, he espied a woman, closely veiled, walking rapidly across the cliffs in the direction of the house.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She vanished from the range of his vision almost immediately, but a few minutes later he heard footsteps and an opening door. He was again confronted by the presence of Thalassa on the threshold. But this time Thalassa did not linger. “Somebody to see you,” he announced with gruff brevity, and turned away.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The open door now revealed the figure of the woman he had seen outside. She advanced into the room.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Mr. Brimsdown?” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That is my name,” said the lawyer, eyeing her in some surprise. He recognized her as the woman who had stared after him when he left Austin Turold’s lodgings, but he could not conjecture the object of her visit.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I see you do not remember me,” she sadly remarked.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You are Mrs. Brierly, I think.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yes. But I was Mary Pleasington before I was married. I remember you very well, but I suppose that I have changed.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mr. Brimsdown recalled the name with a start of surprise. He found it difficult to recognize, in the faded woman before him, the pretty daughter of his old client, Sir Roger Pleasington, whose debts and lawsuits had been compounded by death ten years before. He remembered his daughter as a budding beauty, with the airs and graces of a pretty girl who imagines her existence to be of some importance in the world. He recollected that her marriage to an impecunious young artist had caused some sensation in Society at the time. Marriage had dealt hardly with her, and no trace of her beauty or vivacity remained.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You are the late Mr. Turold’s legal adviser?” she continued, after a pause.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mr. Brimsdown, always chary of unnecessary words, replied with a slight bow.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I suppose you have come to Cornwall to investigate the cause of his death?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mr. Brimsdown remained silent, waiting to hear more.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I—I wish to speak to you about that.” Her lips quivered with some inward agitation.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Will you not be seated?” he said, placing a chair for her.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Will you regard what I have to say to you in strict confidence?” she queried, sinking her voice to a whisper.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Is it about Mr. Turold’s murder?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It—it may be.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("With the recollection of previous eavesdropping in that house, the lawyer rose and closed the door. “I cannot make a promise of that kind,” he said firmly, as he returned to his seat.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No, no—of course not,” she hurriedly acquiesced. “I was wrong to ask it. I have come here to tell you. When I saw you this afternoon I realized that Providence had answered my prayers, and sent somebody in whom I could safely confide. I will tell you everything. I have come here for that purpose.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She seemed to have a difficulty in commencing. Her pale grey eyes wandered irresolutely from his, and then returned. It was with a perceptible effort that she spoke at last.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What I am about to tell you I have known for some days, but I could not bring myself to the extreme step of going to the police. Sometimes I am inclined to think that it may be only a trifling thing, easily explained, and of no importance. But sometimes—at night—it assumes a terrible significance. I need counsel—wise counsel—about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She paused and looked at him wistfully. As though interpreting his nod as encouragement, she went on—")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Mr. Austin Turold and his son have been inmates of my household for the last six weeks. Mr. Robert Turold arranged it with me beforehand. I had never done anything of the kind before, but our means—my husband’s and mine—are insufficient for the stress of these times. After all, people must live.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mr. Brimsdown’s slight shake of the head seemed to imply that this last statement was by no means an incontrovertible proposition, but Mrs. Brierly was not looking at him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Therefore, to oblige Mr. Turold we decided to afford hospitality to his brother and son. The terms were favourable, and they were gentlefolk. These things counted, and the money helped. But if I had only known—if I could have foreseen . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Mr. Turold’s death?” said Mr. Brimsdown, filling in the pause.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I mean—everything,” she retorted a little wildly. “My name is well known. I was in Society once. There is my husband’s reputation as an artist to be considered. I would not be talked about for worlds. I acted against my husband’s advice in this matter—in taking Mr. Turold and his son. My husband said it was a degradation to take in lodgers. I pointed out that they were gentlefolk. There is a difference. I wish now that I had listened to my husband’s advice.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mr. Brimsdown listened with patient immobility. His long experience of female witnesses withheld him from any effort to hasten the flow of his companion’s story.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“They were very nice and quiet—particularly Mr. Austin Turold,” she went on. “The son was more silent and reserved, but we saw very little of him—he was out so much. But Mr. Turold did my husband good—his breeding and conversation were just what he needed to lift him out of himself. A man goes to seed in the country, Mr. Brimsdown, no matter how intellectual he may be. Nature is delightful, but a man needs to be near Piccadilly to keep smart. Cornwall is so very far away—so remote—and Cornish rocks are dreadfully severe on good clothes. I am not complaining, you understand. We had to come to Cornwall. It was inevitable—for us. No English artist is considered anything until he has painted a picture of the Land’s End or Newquay. The Channel Islands—or Devon—is not quite the same thing. Not such a distinctive hallmark. So we came to Cornwall, and my husband went to seed. That was why I welcomed Mr. Turold’s conversation for him. It did him good. My husband said so himself. He derived inspiration—artistic inspiration—from Mr. Turold’s talk. He conceived a picture—‘Land of Hope and Glory’ it was to be called—of a massive figure of Britannia, standing on Land’s End, defying the twin demons of Bolshevism and Labour Unrest with a trident. He was working at it with extraordinary rapidity—when this happened.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“On the day of his brother’s death we did not see much of Mr. Austin Turold. There was Mrs. Turold’s funeral in the afternoon, and when he came home I thought he would prefer to be left to himself.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“He went to his sitting-room, and stayed there. My husband and I retired early that night, but later we were awakened by a very loud knock at the front door. We heard Mr. Austin Turold, who was still up, go down and open it. Then we heard a very loud voice, outside—Mr. Robert Turold’s man-servant, it appears. We heard him tell Mr. Austin that his brother had been found shot. Mr. Turold returned upstairs, and some time afterwards we heard him go down again and out.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I was so upset that I arose and dressed myself to await Mr. Turold’s return. I thought he might like a cup of coffee when he returned, so I decided to go downstairs myself and prepare it. As I passed the passage which led to Mr. Charles Turold’s room, I noticed a light underneath his door. I rather wondered, as he was still up, why he had not gone with his father, but I was passing on without thinking any more about it when I happened to notice that the light beneath the door was fluctuating in the strangest way. First it was very bright, then it became quite dim, but the next moment it would be bright again.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That alarmed me so much that I walked along the passage to see what it meant. I thought perhaps the young man had fallen asleep with the window open and left the gas flaring in the wind. I stood for a moment outside the door wondering what I ought to do. Then I heard a crackling sound, and smelt something burning. That alarmed me still more, because I knew no fire had been lit in the room that day. I wondered if the bedroom was on fire, and I knelt down and tried to see through the keyhole.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“At first I could see nothing except a bright light and the shadow of a form on the wall. Then I made out the form of Charles Turold, standing in his dressing-gown in front of the fireplace, in which a fire of kindling wood was leaping and blazing. I could not make out at first what he was doing. He seemed to be stooping over the fire, moving something about. Then I saw. He was drying his clothes—the suit he had worn that day. They must have been very wet, for the steam was rising from them.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I must have made a noise which startled him, for I saw him turn quickly and stare at the closed door, then walk towards it. I went away as quickly and noiselessly as I could, and as I turned the corner of the passage, out of sight, his door opened, and then closed again. He had looked out and, seeing nobody, gone back into his room.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I went downstairs to make the coffee and wait for Mr. Turold. I had to wait some time. When I did hear the sound of his key in the door, I went up the hall with a cup of coffee in my hand. Mr. Turold seemed surprised to see me. He looked at me in a questioning sort of way as he took the coffee, and stood there sipping it. As he handed me back the cup he told me in a low voice that his brother was dead. I said that was why I had waited up—because I had heard the knock and the dreadful news. Mr. Turold, in the same low voice, then said he was very much afraid his brother had taken his own life.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“He then went upstairs. I again retired shortly afterwards, but I could not sleep. I was too upset—too nervous. I could not get Mr. Robert Turold’s suicide out of my head. It seemed such a dreadful thing for a wealthy man to do—so common and vulgar! Suicide sticks to a family so—it is never really forgotten. It is much easier to live down an embezzlement or misappropriation of trust funds. The thought of it put the other thing—the fire and young Mr. Turold and his wet clothes—out of my head completely, for the time.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“As I was lying there tossing and thinking I heard a light footstep pass my door. I slipped out of bed, and opening the door a little, looked out. I saw Mr. Turold, fully dressed, a light in his hand, turning down the passage which led to his son’s room. Then I heard the sound of a creaking door, the murmur of a low conversation, cut short by the shutting of the door. I stood there for a few minutes, and then went back to my bed and fell asleep.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“The next day it all came back to me. I had gone into Charles Turold’s room for some reason when he was out, and there, on the hearth, I could see the remains of the fire he had lit overnight to dry his clothes. He had made some clumsy man-like attempt to clean up the grate, but he left some ends of the charred kindling wood lying about.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("This final revelation brought a silence between Mrs. Brierly and the lawyer; a silence broken only by the distant deep call of the sea beneath the open window. The silence lengthened into minutes before Mr. Brimsdown found his voice.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You have said nothing to anybody else about this?” He spoke almost abstractedly, but she chose to regard this question in the light of a reproach. She hurriedly rejoined—")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I did not see the necessity—then. If young Mr. Turold got caught in the storm, and chose to dry his clothes in his room, instead of putting them out for the maid, why should I tell anybody? I did not connect it with his uncle’s death. I was under the impression that Mr. Robert Turold had taken his own life. It was not until the detective called to see Mr. Austin Turold that I learnt there was a suspicion of—murder. My maid overheard the detective say something while she was in and out of the room serving tea, and she told me what she had heard. I saw things in a new light then, and I was terribly upset. But I could not see my way clear until you came to the house to-day. Then I decided to tell you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Can you tell me what time Charles Turold came in that night?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I have no idea. He and his father have separate keys of the front door.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It was evident that she had told all she knew. She rose to her feet in agitation.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I must go. My husband will be wondering where I am. But tell me, Mr. Brimsdown, do you imagine . . . Is it possible . . .” Her voice dropped to the ghost of a frightened whisper.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He evaded this issue with legal caution.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You have done quite right in coming to me,” he replied, as he opened the door for her departure. He held out his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She touched it with trembling fingers, and went away.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Mr. Brimsdown closed the door behind her, and wearily sat down. He had been prepared to do much to shield the name of Turold, but he had not bargained for this. He did not doubt the truth of the story he had just heard, and it gave him a feeling of nausea. What a revelation of the infamy of human nature! The stupendous depth of such villainy overwhelmed him with dismay. The extent of the criminal understanding between father and son he did not attempt to fathom. His mind was filled with the monstrous audacity by which Charles Turold, apparently at the dictate of remorse, had sought to convince him of Sisily’s innocence by directing attention to the marks on the dead man’s arm which he had probably made himself. Could human cynicism go farther than that? A great wave of pity swept over the lawyer as he thought of the unhappy Sisily, and all that she had been compelled to endure. But why had she fled?")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Long he sat there without stirring, until the shadows deepened and the grey surface of the sea dissolved in blackness.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("“The police must be told of this,” he said at last, in an almost voiceless whisper.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer024"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-24"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor023"
    }
  }), _vm._v("Chapter XXIII")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("“And suppose the police call during your absence?” said Austin Turold, glancing sharply at his son.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Then you had better tell the truth. I am tired of it all.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I might ask, with Pilate, What is truth?—in your case.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You know it already, father, whether you believe me or not.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Austin Turold looked strangely at him—a look in which anger was mingled with something deeper and more searching, as though he sought to reach some secret in the depth of his soul. Impatiently he crossed the room to the fireplace, and stood with his back to the fire, facing his son.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I do not see that there’s any more risk than there was before,” said Charles gloomily.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I say there is,” returned his father sharply. “What! Do you suppose you can go off to London like this, leaving me here alone, at such a moment? Do you not see that your unexplained absence, in itself, is likely to bring suspicion upon you, indeed, upon both of us?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I cannot help that,” returned the young man desperately. “I must go and find Sisily.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You are not likely to find her. You do not even know that she has gone to London.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yes. I have found out that much. She took a ticket by the midday train on the day after—it happened.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“And why do you wish to find her?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Because she is deeply wronged—she is innocent.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You should be able to speak with authority on that point,” said Austin, with a cold glance, which the other did not meet. “You are acting very foolishly, rushing off to London on this quixotic mission. You won’t find her. Besides, no woman is worth what you are risking in this wild-goose chase. You are jeopardizing your future by an act of the maddest folly.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“There is nothing in life for me but the shadow of things—now,” returned the young man in low tones. “I want nothing except to find Sisily and prove her innocence. I’m going to look for her, whatever you say.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Austin Turold made an impatient gesture.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Very well,” he said. “If Providence has made you a fool you must fulfil Providence’s decree. Only, I warn you, I think you are going the right way to bring trouble on yourself. That lawyer who was here to-day—what’s his name, Brimstone, Brimsdown?—has his suspicions, unless I’m very much mistaken.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Charles turned pale. “What makes you think that?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“By the way he watched both of us.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That accounts for his attitude when I saw him afterwards,” said Charles in a startled voice.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Afterwards—where?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I went after him to tell him that Sisily was innocent.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“And what else did you tell him?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Nothing but that—nothing that counted, at least.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Really, Charles, your lack of intelligence is a distinct reflection on me as a parent. Fancy a son of mine trying to make a lawyer’s bowels yearn with compassion! I’m positively ashamed of you. Why are you so elementary? The situation must have contained some elements of humour, though. I should like to have witnessed it. Did you call down Heaven’s vengeance on the murderer in approved fashion? How did the man of parchments take it?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You have no heart,” said his son, flushing darkly under this sarcasm. He walked towards the door as he spoke. “I am going,” he said. “There is an excursion train through to Paddington to-night, and I shall catch it.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You are determined on it, then?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I should be in an unendurable position if I didn’t,” replied the young man, and without another word he left the room.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Austin looked after him a little wistfully, as though remembering that the other was, after all, his son. He remained motionless for a moment, then crossed over to the window and looked out. As he stood so his eye was caught by two figures beneath. One was his son, walking down the garden path. The other was Mrs. Brierly, returning to the house. She walked past Charles with downcast eyes, but Austin from the window saw her turn and cast a frightened fluttering glance at the young man’s retreating figure. She had seen him, then, but did not want to recognize him. As she hurried up the garden path Austin caught a glimpse of her face, and observed that it was white and drawn.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What’s the matter with my estimable landlady?” he murmured as he withdrew from the window.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("His quick intelligence, playing round this incident and seeking to pierce its meaning, grew alarmed. There seemed to be a menace in it. Did she know or guess something of the hidden events of that night, or had she played the spy since? He turned pale as he considered these possibilities. Women had an unerring instinct for a secret once their curiosity was aroused. But he had been careful, very careful. What did she suspect?")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He thought over this problem until night fell, and retired to bed with it still unanswered.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("But the solution flashed into his mind at breakfast next morning, suddenly, like light in a dark place. He was amazed that he had not seen it before. “If it is that . . .” he whispered. But he knew it was that; knew also, that it meant the worst. He got up from the table, then forced himself to sit down again and eat. An untouched breakfast tray might quicken the suspicions in the mind of that most treacherous woman downstairs, might hasten her hand. But why had she delayed so long?")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He passed the morning between his chair and the window, watching, and listening for footsteps. He saw Mrs. Brierly leave the house early, and wondered if she would return with the police. Another reflection came to his mind. Charles had some inkling, and had fled in time. Perhaps that was just as well, if he got out of England. For himself there was no such retreat, nor did he wish it. He would have to face things out, if they had to be faced, and he did not yet despair of saving the situation, so far as it affected himself. What did that diabolical female know, really? He had a momentary vision of her stealing about the house, prying, watching, listening. He sank into a motionless brooding reverie.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The day passed its meridian, but he still sat there in solitude with his anxious thoughts. As the afternoon declined his hopes rose. Could it be that he was mistaken, that his fears were imaginary? Perhaps, after all—")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("At that sharp ring of the doorbell downstairs he walked noiselessly to the window, and shrank back with the startled look of a man who has had his first glimpse of the bared teeth of the law. He stood still, listening intently. He heard the door opened, a sharp question, then the sound of ascending footsteps. When the knock came at his own door he was in complete command of himself as he went to open it. He was well aware of the ordeal before him, but he did not show it. There was nothing but ironical self-possession in the glance which took in the figures of Detective Barrant and Inspector Dawfield, revealed on the threshold of the opening door.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant lost no time in coming to the point. “I want to see your son,” he said, entering and glancing quickly round the apartment.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I am afraid that is impossible.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“He is not here.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Where is he?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I think he has gone to London.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant was plainly taken aback at this unexpected piece of news. “When did he go?” he demanded.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yesterday evening.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant cast a look at Dawfield, which said plainly: “He’s had word of this and bolted.” His glance returned to Austin. “Can you tell me where he is staying in London?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I have not the least idea,” returned Austin negligently.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Does he not live with you?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“As a rule—yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What is your London address?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Austin took a card from his case and laid it on the table. Barrant picked it up, glanced at it, and said: “Is your son likely to be there?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“He may be, but he said nothing to me about going there. He has his own liberty of action, like every other young man of his age. May I ask the reason of these questions, Detective Barrant?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant did not choose to reply. He drew Inspector Dawfield to the doorway and conferred with him in an undertone. Austin saw Barrant slip the card into his colleague’s hand, and Dawfield then hastened away. The inference was plain. Dawfield had been sent off to intercept the flight or start the pursuit. Austin found himself profoundly hoping that his son was by that time out of England.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He had not much leisure to think of that, for Barrant turned towards him again with an annoyance that he did not attempt to dissemble. “Why has your son gone to London—perhaps you can tell me that much?” he exclaimed.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I gathered from him that it is his intention to look for his cousin Sisily.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“For what purpose?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Because he strongly believes in her innocence.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It is strange that he should have rushed off like this.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Without waiting for your visit, do you mean? Really, Detective Barrant, may I constrain you to give me some explanation of all this? I want to help you all I can, but your actions savour too much of a peremptory jack-in-the-box, even in these bureaucratic days. What is the object of this visit? Why did you want to see my son?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I wished to interview him.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“About what, may I ask?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant did not immediately reply, but Austin, scanning him furtively, sought to reach his thoughts by the varying shades of expression on his face. It was the state of mind of a man who was at once chagrined, amazed, suspicious, and wondering. The older man could picture Barrant thinking to himself: “This man before me—how far is he involved in this?” And, watching him mutely, Austin steeled himself for a sudden outburst: “You picked up the key. You declared it was suicide. What does that mean—now?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("But he under-estimated Barrant’s intelligence. Barrant had no intention of doing anything so crude. The situation was sufficiently awkward as it stood without putting the father on his guard. Austin might guess that he was under suspicion as well as his son, but that did not matter so much. Barrant instinctively realized that flight was impossible for Austin Turold, though he might seek to warn his son not to go near their London home because the police were after him. But that was a warning which would be useless, for the police were ahead of him there. Barrant reflected that he gained nothing by not divulging the object of his visit when the inference of it was so transparently palpable. The disclosure might even serve a useful purpose by lessening Austin’s apprehensions in his own case. With this consideration in view he brought it out frankly—")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I wished to question your son about his movements on the night of the murder.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Is my son suspected—now?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant winced under the delicate inflection of irony which conveyed in that brief reply the inference of another blunder in his own changing suspicions. That sneer roused the official in him, and it was in a curt tone of command that he said—")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What time did your son get home on the day of the murder?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I am unable to say.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“He did not return with you after the funeral?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No, he did not.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Where did he go?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“These are strange questions, Detective Barrant. I really cannot tell you that either, because I do not know.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He put up his glasses to look at Barrant with an assumption of resentment, but the detective’s return glance was hard and searching. “Was your son in to dinner that night?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“We have midday dinner, in this house.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Well, supper. Was he in to supper?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Austin reflected rapidly. He dared not refuse to answer the question, and any attempt to mislead the questioner would only make things worse when the two women in the house knew the truth.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yes. He was in to supper.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“And went out afterwards?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("This was put more as a simple statement of fact than a question. Again, Austin’s subtle intelligence could see no better course than truth.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“He did. My son frequently goes out walking of an evening after supper.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What time did he return—on this evening?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I do not know.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Do you mean that?” Barrant’s tone was incredulous.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I do.” The impulse which had dictated his previous answer sprang from the thought that the foolish females downstairs could not contradict it, and he adhered calmly to the course now he was committed to it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What time did Thalassa come for you from Flint House with the news that your brother was dead?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I do not know the exact time. He called at the police station first.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Had not your son returned by then?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I am unable to inform you. He frequently goes straight to his room when he returns from an evening walk.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Then you do not know whether he was in or out when you left the house?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I assumed he was in, as it was after his usual time for returning.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You did not go to his room, to see?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No. I did not wish to disturb him.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant looked as though there was only one possible construction to be placed on these replies, but he still did not utter the question which Austin feared and dreaded most. In a harsh peremptory voice he said—“Show me your son’s room.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("In those words he stood revealed as one with all the resources of the law at his back, able to issue commands which other people must obey. The rights of liberty and freedom were in his hands. It needed not that to show Austin Turold how near he stood to the edge of the precipice. The strain of the interview had told on him. This was the first actual buffet of the beast’s paw. He led the way to his son’s room and watched Barrant go through his intimate belongings with the feeling that intelligence was a flimsy shield against the brutal force of authority. The law in search of prey cared nothing for such civilized refinements as intellect or self-respect. As well try to stop a tiger with a sonnet.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("The search revealed nothing, and Barrant went away without another word. A moment later Austin heard him questioning the frightened women on the floor beneath. Listening intently, he made out a fragment of the conversation, sufficient to remove all doubts of the origin of the detective’s present visit. Austin’s mind flew to the episode he had seen from his window on the previous afternoon. Why in the name of heaven had this Brierly woman been such a fool? Why had she not come to him with her story, and asked for money to shut her mouth? Why was she sobbing and snivelling downstairs now, when it was too late?")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer025"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-25"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor024"
    }
  }), _vm._v("Chapter XXIV")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("Austin Turold was wrong in supposing that his son had left Cornwall to fly from England. Charles had stated his intention truly enough when he said he was going to London to look for Sisily, but he did not disclose to his father the real reason that led him there.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("His visit to London was the pursuit of a definite plan. He was animated by the hope that he knew where Sisily was likely to have sought shelter. Ever since her disappearance this idea had lurked in his imagination and occupied his secret thoughts.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It was the fruit of one of their last talks together—a memory they shared in common. How well he remembered the occasion! They had been on the cliffs looking down at the Gurnard’s Head wallowing like a monster with a broken back in the foam of a raging sea. It was the day after the death of Sisily’s mother, and Sisily had clung to him as if he were the only friend she had in the world. She had spoken to him from the depth of an overburdened soul impelled to confide in another, telling him of her mother’s sad life, unintentionally revealing something of the unhappiness of her own. And she told him a strange thing about her mother’s last hours.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("On her death-bed the unhappy woman must have had her fears concerning the future of her daughter—belated uneasy premonitions arising after her dying confession to the man supposed to be her husband, perhaps causing her to doubt the wisdom of that revelation. That seemed plain enough to Charles afterwards, though not apparent at the time Sisily had confided in him, for she had died without giving the girl the slightest indication of her life’s secret, as if in some inscrutable hope that the tangle might be made straight.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("What she did do was to make a feeble effort to save her daughter from the consequences of her own unhappy act, or at least to help her if those results arose. She had whispered a name, the name of an old friend of her girlhood who would befriend her child if ever she needed help. At her urgent request Sisily had propped her up in bed while she wrote down the address. Having performed this feat with infinite labour, she dropped back on her pillow, clinging fast to the hand of the child she loved and whose future she had blasted at the command of conscience.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Charles recalled how Sisily had taken that pathetic little scrap of paper from her blouse, kissed it with quivering lips, and handed it to him in silence. He had deciphered the pencilled scrawl with difficulty. The name was Catherine Pursill, Charleswood, Surrey. It remained in his mind for a special reason. Sisily was afraid she might lose the paper (perhaps, like her mother, she had some prescience of the future) and he had endeavoured to divert her thoughts by making “memory pictures” of the name and address after the method of a thought reader. He had told her to picture a cat sitting on a window ledge, and that would fix the name in her mind. “Purr”—“Sill”—there it was! As for the place, it was only necessary to imagine him wandering in a wood (he slyly suggested it)—Charleswood, and there they were again!")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Sisily had smiled wanly at these “memory pictures” and said she would always be able to remember the address of her mother’s old friend by their means.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("They were effectual enough in his own case. The grotesque association of ideas brought the address to his mind when he first thought of seeking Sisily in London. He decided to go to Charleswood as soon as he reached there. The dying woman seemed quite certain her old friend was still in Charleswood, although it was twenty years since she had heard from her. She had told Sisily that Mrs. Pursill’s house was her own, and it had belonged to her parents before her. She had assumed that she was not likely to move. The possibility that Death might have moved her without consulting her convenience did not seem to have occurred to her.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It did to Charles Turold though, on his journey up from Cornwall. But he thrust the chilling thought resolutely from him, clinging to his slight clue because he had nothing else to sustain him, building such hopes upon it that by the time he reached London scarcely a doubt remained. He spent the last hour of his journey picturing his meeting with the runaway girl, holding her, kissing her, sheltering her in his arms from the world. And afterwards? He refused to contemplate what was to happen afterwards, and how he was to shield her from the unsentimental clutch of the law which was also seeking her. He declined also to allow his thoughts to dwell upon his own position, which was invidious and threatening enough in all conscience for a man setting out to be the buckler and shield of a girl in Sisily’s plight. He put these obtrusive contingencies out of his mind. Time enough for those bitter reflections afterwards. The great thing was to find Sisily first, before shaping further action. So he reasoned, with the single purpose of a man mastered by love, and the desperate instinct of a reckless temperament which gambled with life, never looking beyond the next throw.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He retained sufficient caution to refrain from going to his father’s house in Richmond when he reached London. His father’s parting words lingered unpleasantly in his mind to serve as a warning against the folly of that course. The same unusual prudence compelled him to leap out of a taxi-cab as soon as he had leapt into it. For himself he did not care, but he had to be careful for Sisily’s sake. So he clambered on top of a ’bus with his suit case. The same sobering feeling of responsibility directed his choice of an hotel when he descended from the vehicle into the seething streets. He chose a quiet small place off Charing Cross, and booked a room. After a bath and some lunch he went out to a neighbouring bookstall and bought a railway time-table. The next train to Charleswood left Charing Cross in less than half an hour. He walked across to the station, purchased a ticket, and took his seat. In a few minutes the train started.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Now that he was actually on the way of putting his idea to the test his former doubts assailed him again with renewed force, but he refused to listen to them. He told himself that a dying woman’s idea was not likely to be wrong, and that he would find Sisily at Charleswood. She was sure to be there, because she had nowhere else to go. So he reasoned, or sought to reason, until the train slowed down at the station which held the solution of his hopes and fears.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It was a small wayside station at which he alighted—a mere hamlet set in the slumberous calm of English rural scenery, passed by express trains with a roar of derision by day and contemptuously winking tail-lights at night. On the dark green background of the distant heights an eruption of new red bungalows threatened to spread and destroy the beauty of Charleswood at no remote date. But at present the sylvan charm of the spot was unspoiled. Its meadows and fields seemed to lie happily unconscious of the contagion flaming on the billowy hills.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The porter who emerged from a kind of wooden kennel and clattered up to Charles to collect his ticket, stared hard when the young man asked if Mrs. Pursill lived at Charleswood. He appeared to give the matter deep thought before nodding affirmatively, and accompanied him to the station entrance to point out an old house lying behind a strip of white fence and a clump of dark-green trees half-way up a distant hill (not where the bungalows were cropping up, but in the opposite direction), with the intimation that it was the residence of the lady he was looking for. He then watched Charles down the rambling village street until he was out of sight.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It was a long walk—more than a mile—before Charles reached the white fence and the group of trees which shielded the house behind dark-green foliage. He caught a glimpse of partly shuttered windows peeping through this leafy screen, but it was not until he had passed through the trees that he had a clear view of the house.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The place was dreary and dilapidated, with a partly shuttered front. The green-stained walls and a mask of ivy gave the place a resemblance to a large ivy-grown tomb. Charles’s spirits were depressed as he looked at it. There was something so wan and melancholy in its appearance that his high anticipations rapidly faded. In the face of that reality he could no longer picture a silver-haired gracious old lady welcoming Sisily with tears in her eyes for the sake of her dead mother. The human qualities of warmth and tenderness did not accord with that chilling neglected exterior.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He approached the door, his sensations painful enough in the mingled tumult of suspense, hope, and fear. There was no bell, only an old-fashioned brass knocker, which, with a kind of surly stiffness, resisted his attempt to use it. He managed to wrench one knock out of it, and left it suspended in the air.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("There was a considerable pause before the knock was answered. Then the door was opened by a pretty slim servant girl. There was nothing funereal in her appearance except her black dress, and that was set off by a coquettish white apron. She looked at the young man with questioning bright eyes, as though surprised at his appearance there.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Does Mrs. Pursill live here?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yes, sir,” she replied with a trace of hesitation.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The barometer of hope went up several degrees in Charles’s breast. “Could I see her?” he eagerly said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I’ll ask, sir. What name, please?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No name. Mrs. Pursill would not know it. But my business is very important.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The maid looked at him doubtfully, and left him standing there while she disappeared within. From the depth of the house an agitated feminine murmur reached him through the half-open door. “What’s he like, Ruby?” ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Quite the gentleman, miss—young and very good-looking.” ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("A pause, and the first voice rejoined: “Show him into the drawing-room, and ask him to sit down.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The maid came back with this message, and took Charles into a large sombre room. She gave him a fluttered glance of coquetry as she offered him a chair, as though she would have liked to linger with such an unusual visitor, then went out softly, closing the door behind her.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The room into which he had been ushered was furnished after some faded standard of departed elegance with tapestried chairs, and couches, painted screens, landscapes worked in black lutestring on white silk, and collections of stuffed humming-birds which gazed wanly at the intruder from glassy eyes. A massive dead Christ in Gobelin tapestry covered the whole side of one wall, and from the opposite one the threaded features of Joseph and his brethren stared gloomily down. These subjects accorded ill with several pieces of marble statuary scattered about the room—a reeling Bacchus, a nude Psyche, and an unchaste presentment of Leda drooping her head over an amorous swan. A broken statue of a pastoral shepherd had been laid on a table in the corner and partly covered with a cloth, where it looked very much like a corpse awaiting its turn in a dissecting-room.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Charles had a dreary wait in these surroundings. At first he sat still, but as the time passed he endeavoured to distract his anxious thoughts by walking round the room looking at the extraordinary collections of objects it contained. He was earnestly scrutinizing a lutestring picture depicting “The Origin of the Dimple”—a cupid poking his forefinger into the double chin of a fat languishing female—when the door opened and a woman entered.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She was tall and thin, and had reached that period of life when it costs a woman an effort to look in a mirror because of the menace of approaching age which stares back from the depth of frightened eyes. Her dress, however, suggested that she could not bring herself to believe she was yet out of the hunt, but was still trying to follow it breathlessly on the back of that broken-kneed and sorry steed, late middle-age. There was something ridiculous in the girlish attire intended to convince her fellow creatures that her day was not over; something terrible in the low blouse, short skirt, silk stockings, gauze, lace and fluttering ribbons with which she sought to delude the sneering figure of waiting Time.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Charles’s first startled thought was that he had unwittingly entered one of those neglected shuttered houses of romance, where an eccentric female recluse sits with a waiting wedding breakfast in readiness for a bridegroom who has disappeared thirty years before. But the face of the woman advancing towards him suggested that she was not particular about the identity of the form emerging from the mists of time to rescue her from virginity. She looked as if she would have gladly surrendered that jewel to any freebooter in return for a passage in the ship of matrimony, and gone off flying the proud signal, “All’s well.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She approached with a smile, and heaven knows what agitation in her breast at the sight of a handsome well-dressed young man in her lonely nest. “You wished to see me?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Mrs. Pursill?” he said interrogatively.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She made a negative sign. “I am Miss Pursill. My mother is an invalid.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I am most anxious to see her.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“My mother keeps to her bedroom.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I have come down from London purposely to see her,” he said anxiously. “My business is very important.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Could you not tell me?” she murmured.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I am afraid not.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She fidgeted and came a little closer, as though she liked the nearness of his handsome presence.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Very well, you shall see her, but you won’t be able to talk to her. Come with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("They went from the room and upstairs. Miss Pursill opened a door on the first floor and beckoned Charles to enter. It was a bedroom, furnished on the same scale of antique magnificence as the drawing-room downstairs. In a deep armchair in front of a fire sat an old woman, tucked up in an eiderdown of blue and white satin. She did not look round as they entered, but remained quite still—an immobile figure with a nodding head.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That is Mrs. Pursill,” said her daughter.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Charles glanced at the old woman in the chair and turned away. She was past anything except waiting for death, and it was impossible to speak to her or question her. She was in the last stage of senile decay. He masked his disappointment with an effort, conscious that the eyes of the younger woman were fixed on his face.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“If there is anything I can tell you—” she simpered, as she met his glance.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("His face betrayed his anxiety.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I had some reason to think that a young lady of my acquaintance, the daughter of an old friend of your mother’s, might be staying with her.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“There is no young lady here,” said Miss Pursill with a hard look. “I know nothing about it. What is her name?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I have made a mistake, I am afraid.” Charles was instantly on his guard. “I am really very sorry—”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She was not altogether proof against the winning smile with which he tendered an apology, but she looked at him strangely as she accompanied him downstairs to the front door.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Charles went back to London with a dark and angry face. His anger was directed against Fate, which had arranged such a fantastic anticlimax for his cherished hopes. The blow was almost too much for him. He had deceived himself into thinking that he would find Sisily at Charleswood, and he felt that he had really lost her. He was now reduced to searching for her in the great wilderness of London, which seemed a hopeless task.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("By the time the train reached Charing Cross he rallied from his fit of despondency. He refused to despair. Sisily was somewhere in London, at that moment walking alone among its countless hordes, perhaps thinking of him. He would find her—he must! Where to commence? She had reached Paddington only a few nights ago, so that was obviously the logical starting-point of any inquiries. To Paddington he went, this time in a taxi-cab.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He had an extraordinary initial piece of luck. Fortune, either regretting her previous treatment or tantalizing him in feminine fashion with the expectation of greater favours to come, threw him at the very outset of his inquiries against the red-headed luggage porter who had spoken with Sisily on her arrival from Penzance. The porter, leaning against the white enamelled walls of a Tube passage, pictured the scene with much loquacity, and a faithful recollection of his own share in the interview. Charles anxiously asked him if the young lady he had encountered was very pretty—pale and dark. The porter, with a judicial air, responded that looks in women was, after all, a matter of taste—what was one man’s meat was another man’s poison, as you might say—but this young lady had dark hair and eyes, and her face hadn’t too much colour in it, so far as he remembered. He apologized for this vagueness of description on the plea that one girl was very like another to a man who saw them in droves every day, as he did. But one or two minute particulars of her dress which he was able to supply convinced Charles that he had seen Sisily. The man added that as far as he knew the young lady went on to Euston Square, though he couldn’t say he’d actually seen her catch the train for there.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It was not until he had pocketed the half-crown Charles gave him that he added a piece of information of some importance.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You’re not the first who’s been inquiring about this particular young lady,” he said. “There was somebody before you—let me see—Thursday it was. He came strolling along, affable as you please, and seemed to know all about it before he started. ‘That young lady who arrived by the Cornwall train on Tuesday night, porter, and asked you the way to Euston Square—what was she like?’ That took me back a bit, but I told him, just as I’ve told you. He asked me another question or two, and then went into the station-master’s office.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What was he like?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Not much older than yourself, in a brown suit, tall and thin, with sharpish features and quick smiling eyes.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant! Charles recognized the description with a sinking heart. He turned away with a sickening sense of the impotence of his own efforts. Scotland Yard was searching for Sisily, and no doubt had warned all the London police to look out for her. She might be arrested any minute. Outside the station he bought an evening paper from a yelling newsboy, and hastily scanned the headlines under the flare of a street lamp. There was nothing about the Cornwall murder. So far they were safe. His own departure from Cornwall had apparently caused no suspicion, and Sisily was still free—somewhere in London.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Where? To find her—that was his task. He rallied sharply from his despondency. He would pit himself against the police. A desperate man, guided by love, could do much—might even outwit the tremendous forces of Scotland Yard. He would not be worthy of Sisily if he lost heart because the odds were against him. Fortune’s wheel might have a lucky turn in store for him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He beckoned a passing taxi-cab. “Euston Square,” he said as he entered. That was obviously the next point of his search.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("But Fortune vouchsafed him no more favours that day. His dive into the crowded depths of Euston Square brought forth no result—no clue which would help in his search. He interviewed many keepers of the “temperance hotels” and boarding-houses which abounded in that quarter, all sorts of women, but all alike in their quick suspicious resentment of his guarded inquiries and in their pretended ignorance of past visitors to their dingy portals. He had little experience of the embittered sordid outlook of a class which earned its own bread by supplying indifferent food and shelter to London’s floating population, but after his fiftieth repulse he had no difficulty in reaching the conclusion that the police were again ahead of him with their inquiries.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Nevertheless he persevered fruitlessly until a late hour before returning to his hotel to pass a sleepless night in a fever of baffled excitement. Not till then did he realize how much he had been upheld by the hope of finding Sisily at Charleswood. He was lost in a maze of conjectures, fears, and impossible plans, though his intelligence told him that no plan of search he could form was likely to be of the slightest use. Only luck could help him there, and it was part of the hopelessness of the situation that he dared not invoke the aid of any of those agencies or organizations which make it their business to find persons who have disappeared in London. His search must be a solitary one.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The morning saw him enter upon it with a feverish energy borrowed from the future and the desperate optimism of a temperament willing to gamble with Fortune against such incalculable odds. At first he attempted to divine the motives likely to actuate a girl ignorant of London in seeking a hiding-place there, and shaped his search accordingly; but he gave that up after a while, and decided to search the streets of the inner suburbs, in the hope of encountering her sooner or later. His method was to purchase a map of each district, and explore it thoroughly from one end to the other. He got his meals anywhere, and slept in the nearest hotel where he happened to find himself late at night. But his meals were often missed and his broken sleep haunted with nightmare visions of the pitfalls and snares spread for inexperienced girls in London.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("So Charles passed nearly a week of interminable tramping of London streets, scanning the endless medley of faces in the hope of a chance glimpse of Sisily’s wistful eyes and pale features. But it is one thing to gamble with Fortune, and another to win from her. Sometimes she flattered Charles with a chance resemblance which sent him flying across the traffic at the risk of his life, and once he sprang off a ‘bus after a girl he saw vanishing into an Underground lift, but it was not Sisily. The end of the week saw him returning from uncharted areas of outer London to the more familiar thoroughfares of the city’s life, for in that time his dauntless spirit had realized the colossal folly of any attempt to search London by system. He had no intention of abandoning his quest, but he now felt that it did not matter where his footsteps led him, because it was only by a piece of wonderful luck that he could ever hope to meet Sisily. He did not even know if she was in London. But he believed she was, and some indomitable inward whisper kept assuring him that he would find her sooner or later. So he kept on—and on, seeking the vision of his desires with the insatiable eagerness of a man pursuing the unreachable horizon of a hashish dream.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It was towards the end of this time that it occurred to Charles to wonder if Sisily had made her way to Charleswood since his first visit there. He was resting in a Lambeth public-house after an exhausting day’s wanderings over South London when this thought came to him. He sat up, slapping his thigh with excitement, asking himself why he had not thought of that before. It was a chance—certainly a chance. He decided to run down to Charleswood again on the following afternoon.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He did, and found himself disappointed once more. The elegant Miss Pursill had gone to Brighton for change of air, but the pretty maid, who had been left behind to look after the house and the decayed old lady, assured him that there had been nobody to see Mrs. Pursill since his last visit. Miss Pursill went away the very next day after he was down, and there had been no callers or visitors.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("She imparted this information at first with a sparkle of coquetry in her eye, then with a glance of compassion as she noticed how much the debonair visitor had changed for the worse since she saw him last. She looked at him solicitously, as though she would have liked to remove with womanly hands the marks of neglect from his apparel. From the door she watched him making his way back to the station. She stood there in the shade of the evening, following him with her eyes until the bend of the road hid him from view.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer026"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-26"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor025"
    }
  }), _vm._v("Chapter XXV")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("The train was moving out after the briefest stop at a place so unimportant, and he swung himself into one of the carriages gliding past him. At first he thought the compartment was empty, but as the train emerged from a tunnel immediately beyond the station gates he observed a man with glasses reading a newspaper in the opposite corner seat. That reminded him to buy an evening paper at the next stopping place, a town of some importance, where a number of intending passengers were waiting on the platform. Several pushed past him into the compartment. He did not heed them. He sat in a deep reverie, his paper unfolded in his hand, past scenes flowing through his brain as the train sped on towards London. The carriage and its occupants receded from his vision, and he was back again on the Cornwall cliffs with Sisily. Her face appeared before his eyes just as he had seen it in their last parting.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He came back with an effort to the world of events, and unfolded his newspaper. That was a daily ordeal from which he shrank, yet dared not evade. During the past week he had faced it in all sorts of places: street corners, public squares, obscure restaurants, the burrowed windings of Underground stations, and once in the dark interior of a cinema where he had followed a girl with a vague resemblance to Sisily. As the days went on and he read nothing to alarm him, his tension grew less. It really looked as if Scotland Yard and the newspapers had forgotten all about the Cornwall murder, or had relegated it to the list of undiscoverable mysteries.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He now glanced at the headlines listlessly enough. The editor could offer nothing better on his front page that night than Ireland and the industrial situation. Charles opened the sheet and looked inside. His listlessness vanished as his eye fell upon his own name. In the guise of fat black capitals it headed a half-column article about his uncle’s death. Charles read it through, slowly and deliberately, to the end. He learnt that there had been what the writer called fresh developments in the case. The police were now looking for another suspect—himself. The detective engaged upon the case had suspicions of the murdered man’s nephew for some time past, but had his reasons for reticence—reasons which had now so completely disappeared that Scotland Yard had made public a full description of the young man and the additional information that he was supposed to be in London. Charles found himself reading the description of himself with the detached, slightly wondering air with which a man might be supposed to read his own death notice. He weighed the personal details quite critically. Young and tall. Yes. Good-looking. Was he? Dark blue eyes. Were they? He had never thought about them. Of gentlemanly appearance. That read like the advertisement of a Cheapside tailor—what was a gentlemanly appearance, if he had it? He had always associated it with a cheap lounge suit and a bowler hat. Very well dressed—then followed the description of his clothes. But he couldn’t be well dressed and of gentlemanly appearance at the same time!")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("These preoccupations floated lightly, almost playfully, on the surface of his mind, but the great fact had sunk to the depths like lead. His father’s fears had been right, and his departure from Cornwall had drawn attention to his actions on that night. He was—what was the phrase?—wanted by the police. So was Sisily. He was searching for Sisily, and the police were searching for both of them.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("What had the police discovered about him? His lips framed the reply. Everything. That was to say, all there was to find out. Obviously they had discovered his visit to Flint House on that night, or at least, that he was out in the storm during the time the murder was committed. His commonsense told him the reason for Barrant’s reticence. He had kept quiet in the hope that he would go to his father’s house at Richmond, which no doubt had been closely watched. Now that Barrant had come to the conclusion that the man he was after was too clever to walk into that trap, he had confided his suspicions to the newspapers in order to guard all avenues of escape by putting the public on the watch for him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("A feeling of helplessness crept over Charles as he contemplated the incredible ingenuity of the mesh of events in which he and Sisily were entangled. Any moment might terminate his liberty and see him placed under lock and key. Would it help Sisily if he gave himself up and told all he knew? That was a question he had asked himself before, and dismissed it because he realized that his own story might involve her more deeply still. And the loss of time since then, coupled with his own disappearance, intensified the risk which such a course would entail. There was no hope for her in that direction. Where, then, were they to look for hope?")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He was recalled to his surroundings by a hand laid on his arm. He started and looked round. The man next to him, with a glance at the paper in his hand, asked him if he could tell him the winner of the second race at Lingfield. “It ought to be in the stop-press,” he murmured. Charles turned the sheet to the indicated column, and the inquirer glanced at it with a satisfied smile, and the remark that it was only what he had expected, in spite of the weight. “A good horse,” he remarked approvingly. “But perhaps you don’t go in for racing yourself?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Charles resisted an insane impulse to shout with laughter. Didn’t go in for racing! He was going in for racing with a vengeance—a race against time and the police. What was he to do now?")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He glanced round him restlessly. The swaying noisy train and the compartment packed with stolid faces jarred on his overburdened nerves. Why were those women in the next compartment laughing like hyenas? What was there in life to laugh over at any time? It was a thing to impose silence on all by its desolation, its unescapable doom. His eye was caught by an advertisement above the rack opposite him—an advertisement which depicted a smiling grotesque face, and advised him to buy the comic journal it represented in order to dissipate melancholy and gloom.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Fools—fools all!")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("While he was thus looking around him his eyes encountered a curious glance from the man in the opposite corner seat, who had been in the compartment when he entered the train at Charleswood. The man dropped his gaze at once, but there was something in the quality of the look which put Charles on his guard. Charles did not turn his head again, but, leaning back in his seat, kept the other under view from seemingly closed eyes. He was soon convinced that the man in the corner seat was watching him—shooting furtive glances across the carriage from behind the screen of his newspaper.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Was he a detective? Not if Barrant was a usual representative of the tribe. Yet there was something infernally quizzical in the scrutiny which reached him through those gold-rimmed glasses. Stay, though! Did detectives wear glasses? Wasn’t there an eyesight test or something like that for officers of the law? He had never seen a policeman wearing glasses. If he was not a detective, why was he watching him? There was no reward offered for his arrest. Perhaps he belonged to the wretched type of beings who pride themselves on their public spirit—men who wrote letters to the newspapers and interfered in other people’s business. The beast might have guessed his identity and wanted to show his public spirit by handing him over to the police. The newspaper in his hand! Of course. He had read his description there, and identified him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Charles found himself conjecturing how the man would set about carrying out his task of public watchdog, if that was in his mind. He pictured the possibility of him appealing to the others in the compartment. He might get up and say: “There is a murderer in this compartment. I recognize him from the description in this paper, and I call upon you all as public-spirited citizens to see that he does not escape justice.” The torpid passengers would start up, staring and looking foolish after the fashion of English people when asked to do something unusual. Would they help? There was a stout man opposite with the symptoms of a public spirit lurking in the creases of his fat self-satisfied face. Charles promised himself that he would give them a fight for it. He counted his chances. He was aware from his previous journey to Charleswood that the train he was in now ran through to Charing Cross without another stop. Perhaps the man in the corner seat would wait until they arrived there, and then give him in charge. That was a disconcerting possibility, but he could see no way of guarding against it unless he chose to drop from the train, now travelling at nearly forty miles an hour, taking the risk of being maimed or killed. He considered the advisability of that. It was a chance he might have taken casually enough on his own account, but he had also to think of Sisily. She would be quite friendless if he were killed. Besides, there was also the chance that he might be mistaken in interpreting the man’s intentions by his own fears. At all events he seemed to have no thought of springing up and denouncing him. Charles decided to wait and trust to luck to escape in the crowd at Charing Cross if the man made any move there.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("In ten minutes the train was running into Charing Cross station at slowing speed. Charles’s mouth closed tightly, and his face flushed.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The man in the corner seat flattened his newspaper into a pocket, opened the carriage door, and sprang out on to the platform. Charles followed him quickly, and stood still watching him make his way towards the barrier. He saw him press through, give up his ticket, and disappear without so much as a backward glance.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("There was something so ridiculous in this anticlimax to his poignant fears that the young man was for the moment actually exasperated. But his face and linen were wet with perspiration. Then a great feeling of relief swept over him like a cooling wave. He followed in the wake of the other passengers and emerged from the station into the street.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It was early enough for the shops to be still open, but the streets were thronged with pleasure-seekers going to restaurants and places of amusement. As he stood there a painted girl touched him on the arm with an enticing smile for such wares as she had to sell, and her solicitation awakened him sharply to the folly of standing in the lighted Strand at that hour in full view of every passing policeman. He walked slowly away, debating where to turn his steps. An outfitter’s shop displaying overcoats gave him a bright idea. He walked inside and selected a long dark coat which reached to his heels, putting it on over the light and fashionable coat he was wearing. The shopman seemed surprised at his choice, but made no comment as he took his money and handed him his change. Charles caught a glimpse of himself as he went out, and was satisfied with his changed appearance. In that shapeless garment he was no longer likely to catch the eye of any unduly curious observer as a “well-dressed” man.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He now walked swiftly. Turning out of Chandos Street from the Strand, he avoided the brightly lit proximity of Leicester Square, and plunged into the crooked dark streets on the other side of Charing Cross Road. He reached New Oxford Street, crossed it, and continued along obscure streets, his head bent forward, in the unconscious habit of a man thinking deeply as he went.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("In the first feeling of dismay at the discovery that the police were looking for him he had been overwhelmed by a sense of catastrophe. With the passing of that phase he was able to consider the situation with a cooler brain, and it now seemed to him that his position was not so precarious as he deemed it in the light of that shock. He knew London, and might be able to evade arrest indefinitely if he took precautions and avoided risks. But Sisily was in different case. He recalled her telling him that she had only been in London once, as a child with her father. Her inexperience of London was her greatest danger, because it was likely to attract attention. The only one to whom she could look for help was himself.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("His determination to find her was doggedly renewed as he thought of that. He accepted the lengthened odds against him with the desperate dark courage of a spirit which had always regarded life as a gamble against unseen forces holding marked cards. The police were searching for him? Very well. He would pit his wits against theirs, and continue his own search for Sisily with a caution he had hitherto disdained to use.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Courage and caution! Those were the two qualities he must use in adroit combination. The plight of both Sisily and himself was desperate enough now without giving the enemy a chance by recklessness. He was like a man rowing a small boat in the immensity of a dark sea which threatened every moment to engulf him. Sisily was somewhere in that darkness, and she must be rescued. If his own cockleshell went down there could be no succour for her. That was a thought to make him keep afloat—to keep on rowing.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("And suppose that he did find her, as he believed he would, sooner or later—given time. What was to happen then?")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("That thought pursued him in his walk that night, and was his constant companion in the lonely days and nights of his wanderings which followed. He had banished it before, but that course was no longer possible. The impalpable yet terribly real menace of authority overshadowing them both now made it imperative that all the facts should be faced. All the facts—but what were they? It was the question he asked himself again and again as he strove to twist out of the black fantasy of that horrible night some tangible shred of truth which might help them both. His own incredible share in it was forever being re-enacted in his mind, and haunted his dreams. In the night, at early dawn, at odd moments of his eternal quest, the curtain of his mind would rise on that unforgettable scene—the cliffs, the rocks, the darkling outline of Flint House, with a feeble beam of light slanting down from the upstairs window at the back which looked out on the sea. Then the gush of light from the open door, and her shape stealing forth into the darkness, followed by another—Thalassa’s. And then, the final phase—the desolate house, the wind rushing noisily along dark passages, the dead form of Robert Turold in the room upstairs. What did these things mean, and what was to be the end?")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("His hope was that Sisily could reveal something which would furnish the key to the enigma of that night’s events. From her lips he might learn enough to guide him to the hidden truth, and save them both. Sustained by the feeling that she existed somewhere near him, he continued his search day after day until in the abstracted intensity of his fancy London assumed the appearance of a wilderness of unending streets filled with pallid faces which flitted past his vision like ghosts. But the face he was seeking was never among them.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He searched with the wariness of one whose own liberty depended upon his watchfulness. A second glance, an indignant look, a turn of the head, a policeman’s casual eye—any of these things would place him immediately on his guard and turn his footsteps in a different direction. He chose his sleeping places with care at the last minute, and left them at early morning when only a yawning night porter or a sleepy maid servant was astir. He never returned to the same place, nor did he go to the same restaurant twice. Most carefully did he read the newspapers, but nothing appeared in their columns to alarm him; merely an occasional perfunctory paragraph about the Cornwall murder. The favourite adjective in the journalistic etymological garden was culled for the heading, and it was described as an amazing case. Charles felt that the definition was correct enough. Early developments were faithfully promised—by the newspaper. Charles understood very well what was meant by that. It was hoped he would provide the development by falling into the hands of the police. He smiled a little at that, but the unintended warning increased his vigilance.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("On the whole he felt tolerably safe in the crowded London streets. It was not as though there was any real hue and cry after him. The lonely Cornwall tragedy had not come into sufficient public notice for that, and now it seemed almost forgotten.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He had his hazards and chances, though in a different way. One was an encounter with a young man of good family whose acquaintance, commenced in France during the war, had continued in London afterwards. The two young men had seen a great deal of each other—dining and going to music-halls together. It was in Leicester Square that Charles saw him getting out of a taxi-cab to enter a hall where a professional billiard match was in progress. He paused midway at the sight of Charles, exclaiming: “Why, Tur—” The second syllable of the name was nipped off in mid-air, and the outstretched arm was dropped, as the patron of billiards took in the cut of his former friend’s coat. He gazed at the ill-fitting garment with a kind of astonished animosity, and then his puzzled look shot upwards to the face surmounting it, no doubt with the feeling that he may have been deceived by a chance resemblance. Charles went past him without a sign of recognition, but he felt that the other was still staring after him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Another day a street musician regarded him curiously from behind a barrel organ which he was turning with the lifeless celerity of one without interest in the sounds created by the process. His card of appeal—“Wanted in 1914; not wanted now”—helped Charles to recall him as a soldier of his old regiment. They exchanged glances across the card. The man gave no sign that he knew his former officer, but Charles had no doubt that he did. He placed a coin on top of the organ and went swiftly on.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("A week of increasing strain slipped by, and another commenced. Then Fortune, with a contemptuous good-humoured spin of her wheel, did for Charles Turold what he could hardly have hoped to achieve in a year’s effort without her aid.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It was late at night, and he was in a despondent mood after one of his recurring disappointments—this time a graceful slender shape which he had earlier in the evening pursued in a flock of home-going shop-girls until she turned and revealed a pert Cockney face which bore no resemblance to Sisily’s. Several hours later he paid another of his visits to Euston Square, which he believed to be the starting-point of Sisily’s own wanderings. He felt closer to her in that locality because of that. From Euston Square he walked on aimlessly, engrossed in impossible plans for finding Sisily by hook or crook, until the illuminated dial of a street clock, pointing to half-past ten, reminded him of the passage of time.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He paused and looked round. He was in an area of darkened suburban streets converging on a distant broader avenue, where occasional taxi-cabs slid past into the blackness of the night with the heartless velocity of years disappearing into the gulf of Time.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He turned his steps in the direction of this thoroughfare in order to find out the locality, but stopped half-way at the sight of a coffee-stall on the opposite side of the street. He was hungry and thirsty, and he had learnt to like the safety of these places in his wanderings. The food might be coarse, but there were no lengthy waits between courses; no curious glances from the other patrons. A couple of half-drunken young men were feeding at this stall, and a girl of the streets was standing near them. In the light of a swinging lamp the scene shone clearly in the surrounding darkness—the brass urn, the thick crockery, the head of the stall-keeper bent intently over a newspaper, the munching jaws of the customers, the girl in the background with splashes of crimson paint like blood on her white drawn face.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Charles was about to cross the street, but at that moment a policeman’s helmet emerged slowly from the surrounding darkness as if irresistibly attracted by the concentric glow of the light. At the sight of him Charles shrank back into the friendly shadow of his own side of the road. The policeman emerged into the fulness of the light, serene in his official immobility. His slow yet seeing vision dwelt on the painted girl with a gaze as penetrating as that of Omnipotence in its profound knowledge of evil. He strolled towards her with a kind of indifferent benignity with which Providence has also been credited. He raised a hand, omnipotent with the authority of the law. “Better get away from here,” Charles heard him warn her, and she disappeared from view in obedience to this command.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("So did Charles, but in quite another direction. There was something about these chance manifestations of authority, so lightly exercised, so unhesitatingly obeyed, which never failed to thrill and impress him, as they would have thrilled and impressed any other man in his present position. They seemed to intensify the hopelessness of his own situation. He had a slight feeling of creepiness about the spine as he thought of the narrowness of that escape—though, of course, the policeman might not have identified him. But some day or other it was bound to come—that accidental confrontation which might mean his arrest.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He walked swiftly until he reached the avenue. It was a part of London that he did not know, and appeared quite deserted. He wondered which way he should turn to get back to that area of London where he usually sought a bed.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("As he stood there glancing about him irresolutely, his eye caught a glimpse of somebody walking swiftly along—a slight girlish figure dimly visible in the dark vista of the empty street. There was something familiar in the girl’s outline—something which caused his heart to give a great maddening jump. As he looked she turned into one of the converging streets.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He raced up the broad road, indifferent at that moment whether the eyes of all the policemen in London were upon him. When he reached the street which had swallowed her he could see nothing of the form which had excited him. Then, far ahead, he again saw it passing under a distant lamp-post and merge once more into the darkness. He ran quickly in pursuit.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The girl heard him coming and looked back anxiously. This time he saw her face. In a bound he was at her side.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("“Sisily, Sisily!” he cried. “Oh, Sisily, I have found you!”")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer027"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-27"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor026"
    }
  }), _vm._v("Chapter XXVI")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("He saw her white face sharply uplifted in the darkness, and caught the startled gleam of her dark eyes. Then she recognized him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You!” she breathed. “Oh, Charles, how did you find me?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It was chance, Sisily—but no, it was something deeper and stranger than chance.” He spoke in a tone of passionate conviction. “I have been walking London day and night, seeking for you. I felt sure I should find you sooner or later. I had given up hope for tonight, though. It was so late—so late—” The tumult of his feelings checked his utterance.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I dare not go out earlier,” she whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("That was a reminder which brought him back sharply to the reality of things. He looked anxiously around him in the dark and empty street. In the vulgar expression they were both “wanted”—wanted by the police. The danger was doubled now that they were together. That was a freezing thought which had not occurred to him during his search for her. It occurred to him now.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I wonder where we could go and talk in safety?” he murmured—“and decide what is best to do.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“We might go to where I am staying,” she unexpectedly suggested. “It is at the end of this street.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Would that be quite safe?” he hazarded doubtfully.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I think so. Mrs. Johns told me that she would be very late to-night. She goes to spiritualistic meetings, and does not return home until early morning sometimes. We should be alone, and free to talk. There is nobody else in the house.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He was too eager to raise any doubts of the safety of the suggested harbourage. Their conversation, which had been carried on in suppressed and whispered tones, ceased as they advanced along the quiet street. Near the end Sisily turned into the small garden of an unlighted house. She unlocked the hall door, and they entered. He saw her bending over the hallstand, and guessing her intention, struck a match. She took it from him in silence, lit the hall gas, and shut the front door carefully. Then she struck another match from a box on the hallstand, and preceding him into a room on the right, lit the gas there.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It was a small sitting-room, simply and almost shabbily furnished, remarkable for some strange articles which were heaped at random on various small tables. There was a planchette, a tambourine, and other more mysterious appliances which suggested that the inmate spent much time with the trappings and rappings of spiritualism. Papers and journals devoted to spiritualism were scattered about the room, and framed “spirit photographs” hung on the walls.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Charles was not thinking of the interior of the room. His one thought was of Sisily. He had not seen her clearly in the dark street. She appeared to him now unchanged, her dear face as he had last seen it, her features luminous with tender feeling, her dark eyes dwelling gravely on him, just as she used to look. As she stood there, the realization of his haunting dreams, he had to fight down an impulse to take her in his arms. But it was not the moment for that. Because of the graveness of their situation, love had to stand aside.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Sisily, why did you go away?” he asked at length.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She did not immediately reply, but lowered her glance as though collecting her thoughts. His look fastened with anxious scrutiny on her downcast face. She did not raise her eyes as she answered.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I had to go, Charles,” was all she said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Why did you not tell me, Sisily?” he said in a tone of reproach. “Why did you not let me know, that last day on the cliffs?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He failed to understand the glance she cast at him as he asked these questions, but it seemed to contain an element of surprise, almost astonishment. Absorbed in his own gloomy thoughts, he went on.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Do you remember what you told me about your mother’s old nurse, and our memory pictures of her name? I thought you had gone there. So I went to Charleswood to look for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I did think of going there. I intended to when I left Cornwall,” she hurriedly rejoined. “Then, afterwards, I thought it best not to. I stayed at a private hotel in Euston Road on my first night in London, but did not like it, and next day I went to a boarding-house near Russell Square. I meant to write to Mrs. Pursill from there, telling her my mother was dead. But that night after dinner I heard some of the boarders talking of—the murder, and I knew I couldn’t go to Charleswood—then. I left that place early next morning, and came here. I had been walking about all the morning, not knowing what to do, when I saw the card in this window saying that there was a room to let. Mrs. Johns told me she wanted to let the room more for company than anything else, because she lived alone. I was glad to find it, and grateful to her.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You have known all along that the police are looking for you?” he said gravely.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“After I heard them talking at the boarding-house,” rejoined simply. “One of the women had an evening paper, and read it aloud to the others. I knew then, of course. The woman kept looking at me as she read as though she suspected that I was the missing girl. I was very nervous, but tried to pretend that I didn’t notice, and left the room as soon as I dared.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What about this Mrs. Johns—does she suspect anything?” he asked anxiously.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Oh, no. She is a very unworldly kind of woman, and thinks of nothing but spiritualism. She never reads newspapers.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Do not talk about it,” he said suddenly, as though this picture of her wanderings was too much to be borne. “Why did you go away from Cornwall without a word? You said you had reasons. What were they, Sisily?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I will tell you—now.” The soft difference in the tone of the last word was too femininely subtle for him to understand. “That afternoon, when my father was talking to you all in the front room downstairs—do you remember?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yes, yes,” he said impatiently.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I heard something—I was at the door.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It was you, then, and not Thalassa, who looked through the door!” he said, glancing at her curiously.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I did not mean to listen,” she replied, flushing slightly. “I was going out to the cliffs—to the Moon Rock. I was very unhappy, and wanted to be alone with my thoughts. On my way past the door something my father was saying reached me. It concerned me. I did not take it in at first, or understand what it really meant. As I stood there, wondering, my eyes met my aunt’s through the opening in the door, and I saw her spring to her feet. I hurried away because I did not want to see her. I wanted to think over what I had just heard, to try and understand what it meant.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I went down to the Moon Rock, and sat there, thinking and thinking. They were so strange and terrible, those words I had overheard, but they were so few that I did not really guess then all that they meant. All I knew was that there was some dreadful secret behind them, some secret of my mother’s which had something to do with me. I wished that I had heard more. As I sat there, wondering what I ought to do, you came—”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“To tell you that I loved you, that I shall love you as long as I live,” he interrupted eagerly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Again a faint flush rose to her cheeks, but she hurried on: “I could not tell you that I loved you while those dreadful words of my father were ringing in my ears. I wanted to see him first, to question him, to know if I had partly guessed the truth, or if there was any loophole of escape for me. Oh, do not think any worse of me now if I tell you that I loved you then and shall always love you. I wanted to tell you so that day by the Moon Rock, but I knew that I must not.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Why not?” His louder voice broke in on her subdued tones impetuously. “You should not have sent me away, Sisily. That was wrong. It has brought much misery upon us both.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It was not wrong!” she replied, with unexpected firmness and a momentary hardness of glance, which reminded him of her father’s look. “It was because I was nobody—less than that, if what I thought was true. There was your position to think of. You were to come into the title—my father told me that before.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Damn the title!” the young man burst out furiously. “I told you that day I would have nothing to do with it. Why did you think about that?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Because I’ve heard of nothing else all my life, I suppose,” she rejoined with the ghost of a smile. “I couldn’t tell you then that I loved you, because of it, and other things. Now, it is different. It does not matter what I say—now.” She spoke these words with an underlying note of deep sadness, and went on: “When you told me that you loved me I saw my duty plainly. I knew I must go away and hide myself from you, from everybody, go somewhere where nobody knew me, where I would never be known. But I wanted to see my father first, to make sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I understand,” he muttered in a dull voice.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I thought it all out on the way to the hotel with my aunt. I determined to go back and see my father that night. I felt that I could not sleep until I knew the whole truth. I left the dinner table as soon as I could, and hurried down to the station to catch the half-past seven wagonette to St. Fair.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I got out of the wagonette at the cross-roads, and walked over the moors. When I reached Flint House I knocked at the door, and Thalassa let me in. I told him I wanted to see my father, and he said he would wait downstairs and take me back across the moors when I came down.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I ran upstairs and knocked at the door of my father’s study. He did not reply, so I opened the door and went in. He was sitting at his table writing, and when he looked up and saw me he was very angry. ‘You, Sisily!’ he said—‘what has brought you here at this hour?’ I told him I had come to hear the truth from his own lips. I asked him to tell me everything. He gave me one of his black looks, but it did not frighten me—nothing would have frightened me then. He seemed to consider for a moment, and then said that perhaps, after all, it would be better if he told me himself.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“So he told me—told me in half-a-dozen sentences which seemed to burn into my brain. I sat still for a while, almost stunned, I think; then, as the full force of what he had told me came home to my mind, I did something I had never done before. I pleaded with my father—not for my own sake, but for my mother’s. I told him I would go anywhere, do anything, if he would only keep her secret safe. I might as well have pleaded with the rocks. He sat there with a stern face until I went down on my knees to him and begged him to think about it—to keep it secret for a little while at least. He grew angry, very angry, at that. I remember—I shall never be able to forget—his reply. ‘A little while?’ he said, ‘and the claim for the title is to be heard next week. I’m to postpone my claim for the sake of your mother, a—’”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Sisily broke off suddenly, her white face flaming scarlet, her eyes widely distended, as though that last terrible scene was again produced before her vision. Charles Turold watched her mutely, with the understanding that nothing he could say would bring comfort to her stricken soul.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She continued after a pause—")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I left him then. I knew that I should never be able to speak to him again. Downstairs, Thalassa was waiting for me. He had a letter in his hand. He looked at me, but did not speak, just opened the door, and we went out across the moors. We went silently. Thalassa was always kind to me, and I think that somehow he understood. It was not until we were nearing the cross-roads that I turned to him and said quickly, ‘Thalassa, you must not tell anybody that I saw my father tonight.’ I wanted to keep it secret, I wanted nobody to know—never. I knew my father would not talk, it was not of sufficient consequence to him. He thought of nothing but the title. Thalassa promised that he wouldn’t. ‘Nobody will ever find out from me, Miss Sisily,’ he said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Thalassa went back, across the moors, and I waited by the cross-roads till the wagonette came. When I got back to the hotel I went up to my room and to bed. I do not know what time it was next morning when my aunt came into my room, and told me that my father was dead. She did not tell me much. There had been a terrible accident, she said, and he had been found dead in his room. I did not feel shocked, only . . . indifferent. I did not even wonder what had happened—not then. Afterwards I overheard one of the maids in the corridor telling another that it was suicide.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That made no difference to me, except that I wanted more than ever to get away. I formed my plans quickly, to go to London that day, but not by the express. I knew my aunt would not go back that morning after what had happened, but I thought her husband might have to go on business. And the express is always crowded. I did not wish to be seen and brought back. So I decided the slow midday train would be safest for me. I waited for a time, and then I was able to slip away from the hotel without being noticed, while my aunt was out. I got to London that night, feeling lonely and miserable. I knew I had done right, but I could not help thinking . . . of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She ceased. Charles Turold got up from his seat and took a turn round the room, then came back and stood looking down at her as she sat with her hand resting on the dark polished surface of the table. His first words seemed to convey some inward doubt of the adequacy of the motive for disappearance which her story revealed.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You should not have gone away like that, Sisily,” he said soberly. “There was no reason, no real reason, I mean. Where was the necessity, after what I told you? Why should your father’s death have made you more anxious to go? It seems to me that you had no reason then.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She looked at him sadly in her first experience of masculine incomprehension of woman’s exaltation of sacrifice in love, but she did not speak. He continued. “But we must think of what’s to be done.” He walked up and down the room again, considering this question with compressed brows. He stopped, struck by a thought, and looked at her. “The police have been trying to find out from Thalassa whether you went back to Flint House that night, but he will not tell them anything. So they suspect him also.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She roused at that. “Oh, they must not!” she cried in distress. “Poor Thalassa! He must tell them the truth.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“The question is—what is the truth?” It flashed through his mind as he spoke that his interrogation was the echo of one put to him by his father before he left Cornwall.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“The truth is, that Thalassa and I left the house together that night before it happened. Oh, cannot they believe that? Cannot it be proved?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I could tell them when you left,” he said in a low tone.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You!” she cried, looking at him with a kind of fear. “How do you know?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Because I saw you. I was standing outside, close to the house.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Why were you there?” she put in quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He was slower in answering. “I had gone to see your father—about you. I was standing there, thinking . . . waiting, when the front door opened, and you and Thalassa came out. I was surprised to see you, but it seemed to me an opportunity—a final chance—to speak to you again. I started after you, Sisily, once more to ask you to consider my love for you, but you and Thalassa were swallowed up in the darkness of the moors before I could reach you. I followed with the intention of overtaking you, but I got lost on the moors instead, and was wandering about in the blackness for nearly half an hour before I found my way back to Flint House again.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Could you not tell them—the police—that?” she asked, a little wistfully.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It would be useless,” he solemnly replied.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What do you mean?” she said breathlessly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("His rejoinder was a long time in coming. When his set lips moved the words were barely audible. “Because I would not be believed. Because I went straight up the path to the house, determined to see your father before it grew later. The front door was open, and the house seemed in complete darkness. I entered, and went upstairs. There was a light in your father’s study. I found your father—dead.” He fixed care-worn eyes upon her. “That story sounds incredible, even to you, doesn’t it? But—”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Oh!” That startled cry seemed wrung from her involuntarily. Then, swiftly, as if her mind had detached itself to look on her own actions that night through his eyes: “You thought, you believed that I—” She checked herself, but her look completed the thought.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I did not know what to think, but I did not think—that,” he gloomily rejoined. “Afterwards, the next night, I found out something which made me think—” He paused.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yes, yes, tell me what you thought,” she said nervously.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I thought it was Thalassa.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She shook her head.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Who was it then? The latest theory of the police is that I had something to do with it. They’re looking for both of us. They must have found out that I was at Flint House that night. It’s too late to tell them the truth now, not that they were likely to have believed me at any time. Why, my own father believes that I did this thing.” He laughed discordantly. “I tried to convince your father’s lawyer of your innocence, and I might have told him the truth if he had been sympathetic. I don’t know, though,” he added anxiously. “I had to consider your position all along. If my story was disbelieved it only made it worse for you. If it was not Thalassa, who could it have been? Have you any idea—the faintest suspicion?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Again she shook her head. She made an effort to look at him, but there were tears in her eyes for the first time. His hand was resting on the table, and she touched it gently with her fingers.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“We must find out.” He spoke loudly, as if with the idea that a firm utterance lessened the tremendous difficulty of that performance.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What can we do?” Her tone was hopeless enough.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Let me think.” He fiddled with the planchette on the table as though he had some notion of invoking the shade of Robert Turold to answer the question. “Had your father any enemy? Did he fear anybody?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She raised thoughtful eyes to his in reply.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“My father feared nobody,” she said, “at least, I do not think so. Nobody had any real influence over him except Thalassa.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What sort of an influence?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It is difficult to describe,” she hesitatingly answered. “Thalassa could take liberties which nobody else would have dared. He used to go into his room at any time. Sometimes I have awakened late at night and heard the murmur of their voices coming from my father’s study.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Anything else?” he said, looking at her keenly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“There was never any question of Thalassa leaving us,” she went on. “Wherever we went, and we were always going to some fresh part of England about the title, Thalassa went also. Perhaps it was because he had known him for so long that my father allowed Thalassa to do things which nobody else could do. Thalassa used to sneer about the title, and say no good would come of it. They had a quarrel once, long, long ago. I was a very little girl at the time, and I can just remember it,” she added dreamily.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She was apparently unconscious of the significance of these revelations, but they made a deep impression upon Charles. There was something expectant and cruel in his face as he listened—the aroused instinct of the hunter. He addressed her—")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“This bears out what I have believed all along. Thalassa knows about the murder. He is mixed up in it in some way.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Oh, why do you think that?” she exclaimed, clasping her hand in distress.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Why?” he echoed. “Because your father was not the man to stand insolence from Thalassa or anybody else unless he had to. Thalassa must have had him under his thumb in some way. Why did I not know of this before? It’s clear enough now. Thalassa, even if he did not commit the murder—”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“He did not,” she said quickly. “He left the house with me, so he could not have done it.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Then he knows who did. He and your father shared some secret together—some dreadful secret which brought about your father’s death. That is one reason why Thalassa will not speak—because he is implicated in this mystery, whatever "), _c('br'), _vm._v("it is.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No, no. He is keeping silence because of me—I feel sure. I made him promise not to tell.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Charles Turold shook his head decidedly. “He may have more than one reason for keeping silent,” he said with a swift flash of intuition. “If it is as you say, he is shielding himself as well as you. If your father was killed while Thalassa was out of the house that night, Thalassa knows who did it.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Her eyes met his in an agony of perplexity and distress. “Oh, no, I cannot think you are right,” she said. “If I could only see Thalassa—for five minutes—”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What good would that do?” he abruptly demanded.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“He would tell me the truth—if he knew.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He shook his head incredulously. “You do not know all,” he murmured. He shrank from telling her of the marks on her father’s arm. “I know Thalassa,” she eagerly replied. “He would tell me if he thought it would help me.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“If you think that I will go down and see him—and get it all out of him.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No, no! You must not go,” she cried in affright. “It would not be safe for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Would it be any more dangerous than hiding in London like a skulking rat?” he bitterly replied. “This cannot go on. We are both in a dangerous position, and might be arrested at any moment. What would happen then? Who would believe my story—or yours? They sound improbable even to ourselves. Here, at least, is a chance of discovering the truth, for I most solemnly believe that Thalassa knows it, or guesses it. What other chance have we of finding out the hideous mystery of that night? I must go, Sisily. I will be careful, for your sake.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She knew by his voice that he was not to be deterred from the hazardous enterprise, so she did not attempt to dissuade him further. But she clung to him trembling, as though she would have shielded him from the menace of capture. He was thinking rapidly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It may be that I shall fail,” he said. “I do not think so, because I shall take every precaution, but the police will be watching for me in Cornwall as well as here. If I fail—if I do not come back . . . you will understand?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Her look answered him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You had better watch the papers. And be careful on your own account.” He eyed her anxiously. “Do you think you will be safe here till I get back?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yes—I think so,” she murmured sadly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Very well. I will go down by to-night’s train—I’ve just time to catch it.” He glanced at his watch with an assumption of cheerfulness. “When you wake up in the morning I shall be in Cornwall.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I shall not sleep,” she said, in a miserable broken voice. “I shall lie awake, thinking of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He caught her swiftly in his arms, and kissed her on the lips. “If I find out the truth, nothing shall come between us then, Sisily?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No, nothing,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He turned with a sudden swift movement as though to go, but she still held him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Tell Thalassa . . . that I ask him to tell you the truth, if he knows it. . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("She released him then, and stood looking after him as he walked from the room and out of the house.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer028"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-28"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor027"
    }
  }), _vm._v("Chapter XXVII")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("Flint House looked a picture of desolation in the chill grey day, wrapped in such silence that Charles’s cautious knock seemed to reverberate through the stillness around. But the knocking, repeated more loudly, aroused no human response. After waiting awhile the young man pulled the bell. From within the house a cracked and jangling tinkle echoed faintly, and then quivered into silence. He rang again, but there was no sound of foot or voice; no noise but the cries of the gulls overhead and the hoarse beat of the sea at the foot of the cliffs.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("A cormorant, sitting on a rock near by, twisted its thin neck to stare fearlessly at the visitor. But Charles Turold was not thinking of cormorants. Where was Thalassa? Where was his wife? He believed they were still in Cornwall, but they might have left the house. He had been in London a long while. Not so long, though—only twelve days. Twelve days! Twelve eternities of unendurable hopelessness and loneliness, such as the damned might know. Was he to fail, now, after finding Sisily? He had a responsibility, a solemn duty. He had reached Cornwall safely from London—run the gauntlet of all the watching eyes of the police—and he would not go back without seeing Thalassa. His mind was thoroughly made up. He would find him, if he had to walk every inch of Cornwall in search of him. And when he found him he would wrest the truth out of him—yes, by God, he would! When he found him, but where was he to be found? The crafty old scoundrel might be in the house at that moment, lurking there like a wolf, perhaps grinning down at him from behind some closed window. . . . A sudden rage surged over him at that thought, and he fell savagely on the shut door, beating it with insensate fury with his fists. Damn him, he would force his way in!")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The cormorant ruffled its greenish feathers and watched him curiously. The faint cries of the gulls overhead seemed borne downward with a note of mocking derision. Charles Turold stepped back from the door with an uneasy look at the cormorant, as though fearing to detect in its unreflecting beadiness of glance some humanly cynical enjoyment at his loss of self-control. The wave of feeling had spent itself. Not thus was victory to be won. He paused to consider, then tried the knocker again. The knocker smote the wood with a hollow sound, like a stroke on the iron door of a vault, loud enough to rouse the dead. Charles Turold had a disagreeable impression of Robert Turold starting up in his grave-clothes at the summons, listening. . . . But no! The dead man was safe in his grave by this time. He had forgotten that.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("A sudden silence fell on the house: a deep and profound stillness, as though seas and wind had hushed their wailing speech to listen for the answer to the knock. The birds, too, were silent. The house remained immutably quiet. Charles Turold bent down, and peered through the keyhole, but could see nothing within but darkness. Then, as he looked, a sound reached his ears, a sound like a thin cackle of laughter from the interior of the house. In the gathering gloom within he had a momentary impression of a stealing greyish shape—a shape which vanished from his vision as he looked.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He rose to his feet, his mind groping blindly for some tangible explanation of this spectral thing, but finding none. A ghost? He shook off that feeling roughly. God knows, that house might well be haunted, but not by a ghost that could laugh, though there was no merriment in that ghastly cackle. The reality of the thing, whatever it was, could not be worse than the sound. Had he really seen anything, after all? Was there some trap about it, some danger to himself? He would have to risk that.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The distant sight of a human figure far away on the wide space of the moors, clambering over the granite slabs of a stile, turned his thoughts to a more perceptible danger. If he could see that man more than half a mile away, his own figure must be apparent over a long distance in that clear brown expanse. Perhaps at that very moment the policeman from the churchtown was prowling about the moors in search of him. His actions at that lonely house were suspicious enough to attract anybody’s attention. That was an act of imprudence which he had no right to commit. He had not evaded the keen eyes of the London police to be trapped like a rat by a rural constable. It was too dangerous for him to remain there. He determined to spend the rest of the day among the cliffs, and return to Flint House when night fell.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He walked away, briskly at first, but with a more laggard step as he plunged into the shelter of the great rocks, for he had had nothing to eat since the night before, and was beginning to be conscious of his weakness. But he strode on, doggedly enough, for more than an hour, until he found himself at a part of the coast he had not seen before—a theatre of black rocks, with dark towering walls, and a hissing sea whitening at the base.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("At the foot of these cliffs three jagged conical rocks rose bare and glistening, the spray from the broken sea dashing far up their sides. As Charles stood there, looking down, he saw a man appear from the edge of the furthest one and walk rapidly across the sloping shelf of rock which spanned the narrow bay near the surface of the sea. His heart leapt within him as he took in the figure of the man. It was Thalassa.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("As Charles climbed down from the higher cliffs to intercept him, there came to his mind an imperfectly comprehended fragment of conversation which he had overheard, between waking and dozing, in the train that morning. The voices drifted to his dulled hearing from the next compartment, where some men seemed to be discussing somebody of whom they stood in dread, somebody who was forever striding along the cliffs with his eyes fixed on some distant horizon, as though seeking some one. The object of the mysterious being’s quest, if it was a quest, nobody who met him cared to ask. So much he had gathered. He had heard one of the speakers say: “I’ve met ’un, ever so laate, stalkin’ aloong like th’ devil. Tes aw token o’ a bad conscience. Tes dreadful to think about. I got owt o’ his way. . . . I’d as soon speak to th’ devil. Iss, aw’d.” Charles had thought nothing of this chatter at the time, but he wondered now if they were talking of Thalassa. Did the local fisherfolk believe that he had something to do with the murder, and shunned him like Ishmael in consequence?")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He looked like Ishmael at that moment, crossing that wild place, earnestly scanning every nook of those seamed and riven walls, sometimes glancing stealthily behind him. His preoccupation in this search—if it was a search—was so great that he never once glanced ahead, and he did not see Charles until the young man leaped down the last few paces of his slippery descent and stood plainly forth before him. Thalassa’s brown face did not move a muscle as he looked at him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Thalassa,” said Charles sternly, “I have been looking for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa went on, still scanning the secret places of the towering cliffs as he walked forward with Charles beside him. When the rugged passage was crossed, and the narrow wild bay left behind, he spoke.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“For what?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“To have the truth out of you, you infernal scoundrel!” cried the young man fiercely, his self-control suddenly vanishing at that indifferent tone. “You know all about the murder of your master; you’re going to tell me, or I’ll throw you off these cliffs into the sea.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He gripped the other’s arm as he spoke, but Thalassa tore off his fingers, and leapt backward against a rock, a knife in his hand, snarling like a wild beast.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Keep off!” he cried. “Keep off, or by Christ, I’ll—” He hooked the air with his knife.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Charles eyed him across the space, affected almost to nausea by his evil glance. What a fool he had been to lose his temper! Not in that way was the truth to be reached. The man before him was not to be terrorized or intimidated. Sisily’s way would have been the best. He wondered whether it was too late to attempt it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I was hasty, Thalassa,” he said. “Come, do not let us quarrel after I have risked everything to get down here to see you. I have a message for you—from Sisily.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The face of the man crouching by the rock changed instantly. He made a step forward, as if to speak, then cast a gleaming eye of unbelief at his companion.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It’s a lie!” he said. “You haven’t seen her.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I’m speaking the truth,” Charles earnestly replied. “Do you think I’d have come back to Cornwall otherwise, knowing the police are searching for me?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Ay, you know that, do you?” muttered the other. “They’ve been watching Flint House for you. You were a fool to come back here.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I’d risk more than that to learn the truth, Thalassa. It’s for Sisily’s sake. I’ve seen her. She’s in London, and I’ve come from her. She gave me this message to bring to you. She said: ‘Tell Thalassa that I ask him to tell the truth—if he knows it.’ The police are looking for her as well as me.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I’ve heered so.” With these words, uttered quickly, Thalassa fell into the silence of a man on his guard and pondering. Charles approached nearer.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Thalassa,” he pleaded, “if you are keeping anything back you must tell me for Sisily’s sake.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“How do I know you’ve seen her?” retorted Thalassa, darting a dark crafty look at him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Charles was overwhelmed by a sense of catastrophe. Here was a possibility which had been overlooked. How was he to instil belief that he spoke the truth? A moment passed. Thalassa cast another black look at him, and turned as if to walk away. “I’ll keep my word,” he muttered to himself.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The young man’s quick ear caught the whispered sentence, and saw the way. “I’ll prove it to you,” he said. “You promised Sisily that you’d tell nobody she was at Flint House to see her father on the night he was killed. How could I know that unless I’d seen her?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What else?” said Thalassa, facing him with a strange and doubtful glance.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You let her in,” Charles rapidly continued, “and you waited downstairs for her. Afterwards you took her back across the moors to catch the wagonette. It was on the way, near the cross-roads, that Sisily made you promise not to tell anybody that she’d been there that night.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Suppose it’s true—what then?” Thalassa’s voice was edged with the craftiest caution. “She’s sent you to me to ask for the truth, say you. ‘Twould have been safer not. What else is there to say, when she’s told you everything?” He cast a look of savage jealousy at the young man.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Much.” Charles spoke rapidly, but his glance was despairing. “What happened while you were away from the house? What sent your wife mad? What did you find when you returned? You know these things, Thalassa.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Happen I did, what good’d come of telling them?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“To save Sisily.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“They’d not help to save her.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Do you think she shot her father?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa gave him another dark look, but remained silent.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You know she didn’t, you hound!” cried Charles, anger flaring up in him again. “It was you—it must have been you. Listen to me! I know almost enough to hang you. I was in the house while you were away, and found your master lying dead in his study, and the key of the door in the passage outside. Who could have dropped it there except you?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“’Tweren’t me. ’Twas done afore I got back to the house,” answered Thalassa.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What time was it when you left the house with Sisily?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Agone half-past eight: perhaps ten minutes after. She came running downstairs, her eyes staring and blazing. ‘Thalassa, dear Thalassa, for pity’s sake let me out,’ she said half-sobbing. ‘Oh, what did I come for? He’s wicked—wicked.’ ’Twasn’t for me to say anything between father and daughter, so I just opened the door without a word, and went out with her.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What time did Sisily catch the wagonette?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That’s what I don’t know. She made me go back when we got to the cross-roads. She knew as well as I did that the old fool who drives it wasn’t particular as to time, and she worried about my old woman getting scairt if she found herself alone, and me out. ‘Go back to her, Thalassa,’ she said, ‘I shall be all right now.’ That was just after she’d made me promise to tell nobody that she’d been to see her father that night. And, by God, I kept my word. Nobody got anything out of me, though they tried hard enough. Well, when she sent me back I went, leaving her standing, for I had my own reason for going. When I looked back after a bit I saw her standing there by the light of the dirty little lamp above the cross-roads.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Did you see the wagonette on the road?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Not a sign of it. Just her—alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("A faint hope died in Charles’s breast. Even the drunken irregularity of a Cornish cabman told against Sisily. But that point was not so immediately important as Thalassa’s story that the murder had been committed during his absence from Flint House. Although his own experience supported that supposition, Charles was reluctant to accept a theory which plunged the events of that night into deeper mystery than ever.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Well, go on,” he said. “What did you find when you got back?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“The house was dark and the door open. The wind was coming in from the sea sharp enough to take your head off your shoulders, and I thought perhaps I’d jammed the door without closing it, and it had blowed open with the wind. But when I got inside I heered something like moaning. I thought that might be the wind too, for it’s for ever screeching up and down the passages like a devil, specially o’ nights. I—” He stopped suddenly, with a cautious sidelong look at his listener.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yes, yes!” cried Charles. “And what then?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa went on, but a little moodily.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I went along to the kitchen and found the old woman lying on the floor, in a kind of fit or faint, making the queer noise I’d just heered. When I picked her up she opened her eyes, laughing and crying and making mouths as she pointed to the ceiling. I could get nothing out of her for a while. Then she mutters something about a crash upstairs, and goes off into another fit. I carried her into her bedroom and went upstairs as fast as my legs would take me. There was a light under his door, but he didn’t answer when I knocked. I tried to open it, but it was locked inside. In a bit there was a knock downstairs. You know what happened after that.” He lapsed into silence again, with another look at the young man.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That was when my aunt and her husband and Dr. Ravenshaw came to the door?” said Charles, filling in the pause. “But how was it that you told them that you feared something had happened to your master? Was that pure guesswork on your part? You hadn’t been in the room, you say.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I had to tell them something, hadn’t I?” retorted the other sullenly. “If I hadn’t told them that, it would a’ all come out about me going out with Miss Sisily, and not into the coal cellar, as I said.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It is astonishing that your story should have been so near the truth when you knew nothing of what had taken place.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I did know something. The door was open, the house dark, and she in a fit on the floor, saying there’d been a crash upstairs. Then his door was locked, and I couldn’t get an answer. Wasn’t that enough?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Hardly enough to warrant your saying that you feared your master had been murdered—unless you expected him to be murdered.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I didn’t say that,” replied Thalassa with unusual quickness. “All I said was that I was afeered something had happened to him. There was reason for thinking that. I had to make up my story quick—that part about just going for Dr. Ravenshaw. That was because I’d still got my hat and topcoat on, just as I’d come in from the moors, and I wasn’t going to break my promise to Miss Sisily.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Did you see the blood under the door when you went up and tried to get in?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I’ve told you all there is to tell,” was the dogged response.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What frightened your wife so much? Do you think she saw the murderer?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That’s what I would like to know,” responded Thalassa, with a swift cunning glance.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He turned his face away and looked across the sea, the brown outline of his hooked profile more than ever like an effigy carved by savage hands. Charles scanned him despairingly. The feeling was strong within him that he was still keeping something back.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Thalassa,” he said, “you should have told this story before. You have done wrong in keeping it back.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“’Twould a’ been breaking of my word to Miss Sisily.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It was of more importance to clear her. You could have done that if you had come forward and told the police, as you’ve just told me, that she left the house with you before nine o’clock on that night.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“’Twouldn’t a’ helped if I had. I found out next day that the wagonette didn’t get to the cross-roads that night till nearly ten o’clock. ’Twas after half-past nine when it left the inn.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What made you find out that?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Do you think I didn’t put my wits to work when the damned detective was trying to put me into it as well as her? I thought it all out then—about telling the truth. But I saw ’twould a’ been no good for her, but only made matters worse. Who’d a’ believed me? There be times when a man can say too much, so I kept my mouth shut.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("There was so much sense in this that Charles had nothing to say in reply. In silence they tramped along till they reached the dip of the sea in which the Moon Rock lay. Here they paused, as if with the mutual feeling that the time had come for the interview to end. Behind them towered the cliffs, with Flint House hanging crazily on the summit far above where they stood. The eye of Charles ranged along the shore to the spot where he had said good-bye to Sisily not so very long ago, then returned to rest doubtingly on Thalassa. The old man stood with his hand resting on a giant rock, his dark eyes fixed on the rim of the waste of grey water where a weak declining sun hung irresolutely, as though fearing the inevitable plunge.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I’d a’ given my right arm to have saved her from this,” Charles heard him mutter.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Charles found himself looking down at Thalassa’s brown muscular arm, corded with veins, stretched out on the rock by which he stood. It was as though it had been bared for his inspection, which was not, indeed, the case. If that arm could save Sisily, it was at her service. But what was the good of that? What was the good of his own efforts to help her? Charles had a suffocating feeling of the futility of human effort when opposed by the malignity of Fate. He asked himself with aching heart what was to be the outcome of it all? He had failed. What then? It was not until that moment that he realized how strongly he had been buoyed up by the false optimism of hope. His consciousness, as though directed by the power of a devil, was forced to look for the first time upon the hideous inevitability of the appointed end.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No, no! Not that—not that,” he shudderingly whispered to himself.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Neither moved. The minutes passed leaden-footed. It was silent and still in that wild spot, as if theirs were the only two human hearts beating in a dead world. It seemed as though neither could bring it upon himself to terminate the interview. Charles was the first to break the silence. He spoke like a man coming out of a dream.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Did that clock upstairs keep good time?” he asked in a low voice.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa turned on him as if not understanding the purport of the question.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It was going shipshape and Bristol fashion in the afternoon. What’s that got to do with it? What does it signify if it was five minutes fast or slow?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The logic of the answer was apparent to Charles, who knew he was only attempting to pluck something by chance out of the dark maze. But another and shrewder idea started up in his mind.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What was your reason for hurrying back across the moors that night?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Miss Sisily told me to go.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“But you had another reason—a reason of your own,” said Charles, turning quickly to regard him. “You said so yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“If I had I’ve forgotten what it was,” said Thalassa with a black look.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You cannot have forgotten!” cried Charles. “What was it?” Hope sprang up in his heart again like a warm flame as he detected something confused and irresolute in the other’s attitude. “Thalassa, you are keeping something back. You know, or you guess, who the murderer is!”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I’m keeping nothing back.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You are. I can see it in your face. What is it that you will not tell? What do you fear?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“The gallows—for one thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You’d sooner see Sisily lose her life on them?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("This bitter taunt, wrung from the depth of the young man’s anguished heart, had an instantaneous and unexpected effect on his companion.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No, no!” he hoarsely cried, “I couldn’t a’ bear that. But it’s nothing to tell, nothing to help. It was earlier that night, before she came. I was looking out of the kitchen window, when I thought I saw a rock move. Then I looked again, and it seemed like a man—though I couldn’t see his face.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Is that all?” Bitter disappointment rang in Charles’s voice. “That might have been me. I was out on the rocks that night, close to Flint House.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“’Tweren’t you.” Thalassa’s reply was so low as to be almost inaudible. “I don’t know who it was, but I’ll take my Bible oath it weren’t you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Who was it then?” Charles asked breathlessly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“A dead man, or his spirit. I know that now, though I laughed when "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("he")]), _vm._v(" said it. I know better now.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He stopped suddenly, like one who has said too much, and looked moodily out to sea.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What do you mean by that?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Never mind what I mean. It’s nothing to do with you. A man’s a fool when he gets talking. The tongue trips you up.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Thalassa,” said Charles solemnly, “if you know anything which might throw the remotest light on this mystery it is your duty to reveal it.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It’s easy to talk. But I swore—I swore I would never tell.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“This is the moment to forget your oath.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It’s fine to talk—for you. But he’d come back to haunt me, if he knew.” He jerked his thumb in the direction of the distant churchyard where Robert Turold lay.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Charles looked at his grim and secret face in despair. “I hope you realize what you are doing by keeping silence,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I’m keeping a still tongue in my head, for one thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("“For one thing—yes. For another, you’re injuring Sisily—you’re doing more than injure her. You’re letting her remain under suspicion of her father’s death, in hiding in London, hunted by the police. Yet she believed in you. It was she who sent me to you, it was she who said: ‘Tell Thalassa from me to tell the truth, if he knows it.’ Is she mistaken in you, Thalassa? Do you think more of your own skin than her safety?”")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer029"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-29"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor028"
    }
  }), _vm._v("Chapter XXVIII")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("It was a strange story which Charles Turold heard by that grey Cornish sea—a story touched with the glitter of adventurous fortune in the sombre setting of a trachytic island, where wine-dark breakers beat monotonously on a black beach of volcanic sand strewn with driftwood, kelp, dead shells, and the squirming forms of blindworms tossed up from the bowels of a dead sea. It was there in the spell of solitude thirty years before that Robert Turold’s soul had yielded to temptation at the beck of his monstrous ambition.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("That, however, was the end—or what Robert Turold imagined to be the end—of the story. The listener was first invited to contemplate a scene in human progress when men gathered from the four corners of the earth and underwent incredible hardships of hunger, thirst, disease, lived like beasts and died like vermin for the sake of precious stones in the earth. Thalassa brought up before the young man’s eyes a vivid picture of an African diamond rush of that period—a corrugated iron settlement of one straggling street, knee-deep in sand, swarming with vermin and scorpions, almost waterless, crowded with a mongrel, ever-increasing lot of needy adventurers brought from all parts of the world by reports of diamonds which could be picked out with a penknife from the dunes and sandy shingle which formed the background of the villainous “town.” In the great waves and ridges of sand which stretched everywhere as far as the eye could reach, runaway scoundrels of every shade of colour wormed on their bellies with the terrible pertinacity of ants, sweating and groping in that choking dust for the glittering crystals so rarely found.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa had been infected by the diamond fever like so many more. Like other young men he wanted plenty of money for women and grog—what else, he asked, could a man get for money that was worth having? In those days he was a sailor before the mast, lacking the capital for such delights. So he deserted his timber tramp when she touched at Port Elizabeth, and set out for the diamond fields with another runaway—the ship’s cook, who had an ambition to have his meals cooked for him for the rest of his life, instead of cooking meals for other people.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The fields were far to the north. Thalassa reached them after a terrible journey through the stony veldt and sandy desert, broken by barren hills. His companion died of the hardships, and was buried in the desert which stretched to the wandering course of the Orange River. Thalassa secured his license and went “prospecting.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Dost a’ know anything about diamonds—digging for them?” he broke off to ask.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Charles Turold shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa lapsed into silence for some moments, his eyes fixed on the sea hissing among the black wet rocks at his feet, then said—")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“A man’s a fool most of his days, but sometimes he can be such a fool that the memory ‘ll come up to mock him when he lays dying. Here was I, deserting my ship and throwing away a year’s wages and a’most my life to get to these damned fields, thinking to pick up diamonds cut and glittering like I’d seen them in London shops, when as soon as I’d clapped eyes on the first diamond I saw dug up I knew that I’d left behind me at the other end of the world as many rough diamonds as there was in the whole of that dustbin of a place—diamonds that didn’t have to be dug for, either, only I didn’t know them when I saw them.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("His narrowed eye gleamed craftily, a mere pin’s point of expression in the direction of Charles, as though expecting a question. But Charles kept silence, so he went on with his story. He let it be understood that his luck on the fields was of the worst possible description—never a solitary stone came his way. But he had no heart for digging. He was always thinking of the diamonds in that remote spot which he had ignorantly let slip from his grasp, like the dog in the fable dropping the substance for the shadow. He would have gone back to look for them, but he’d spent most of his little capital in that wild-goose chase, and the miserable remnant oozed away like water in a place where the barest necessaries of life cost fabulous prices. Soon he became stranded, practically penniless.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It was this precarious moment of his fortunes which his star (his evil star, he insisted on that) selected to bring him into juxtaposition with the man whose life was to be inexorably mingled with his own from that time henceforward. The actual meeting place was a tin-roofed grog shanty kept by a giant Kaffir woman and a sore-eyed degenerate white man, whose subjection to his black paramour had earned for him among the blacks on the field the terrible sobriquet of “White Harry.” Here, one night, Thalassa sat drinking bad beer and planning impossible schemes for returning to his diamonds at the other end of the world. The place was empty of other customers. The Kaffir woman slumbered behind the flimsy planking of the bar, and “White Harry” sat on the counter scraping tunes out of a little fiddle. Thalassa remembered the tune he was playing—“Annie Laurie.” Upon this scene there entered two young men, Englishmen. Thalassa discerned that at once by the cut of their jib. Besides, they ordered Bass beer. Who else but Englishmen would order Bass beer at five shillings a bottle in a God-forsaken place like that?")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("He")]), _vm._v(" was one of them.” Thalassa moved his hand vaguely in the direction of St. Fair churchyard. “Smart and lively he was then—not like what he was afore he died. I took a fancy to him as soon as I set my eyes on him. He was a man in those days, and I knowed a man when I saw ’un. I didn’t care so much for the looks of the other ’un—Remington was his name, as I heered afterwards. Well enough for some tastes, but too much of the God Almighty Englishman about him to suit me. A handsome chap he was, this Remington, I’m bound to say—young and slim, wi’ a pink face like a girl’s, not a hair on it, and lookin’ as though he might a’ turned out of a bandbox. Him—Turold—had a moustache, and his face was a dark ’un, but I liked him for all his black looks—though not so black in those days, either. More eager like.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Charles Turold found himself trying to picture Robert Turold in the part of a smart lively young fellow, and failing utterly. But Time took the smartness out of a man in less than thirty years. It had also taken the liveliness out of Robert Turold for good and all.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa went on with his story. The young men were served with their beer at five shillings a bottle, and sat down in a corner to drink it. They talked as they sipped, and Thalassa listened. His original idea that they were young men of wealth (because of the Bass) was soon dispersed by the trend of their conversation. They had gone out from England to make their fortunes on the fields, but had come a cropper like himself, and were discussing what they’d do next. The fair-haired one, Remington, was all for getting back to England while they had any money left, but Turold was dead against it. There were plenty of diamonds to be found, and he was going to have some of them. He’d been talking to a man who was just back from the interior with a story of a river beach full of diamonds, and he was fitting up an expedition to go back and get them. Turold wanted to join in, but Remington said he’d heard too many stories of diamonds to be picked up for the asking. Had he forgotten about the cursed Jew who got a hundred pounds out of them? Turold said this was different—the man had brought back a little bottleful of diamonds. Remington replied with a sneer about “salting.” They argued. “Suppose we dropped the last of our money?” Remington asked. “No worse than crawling back to England like whipped curs, poorer than we set out,” said the other. Remington said he didn’t want to go back to England like that, but he’d sooner face it than run the risk of being stranded in that hell of a place. Turold answered he was not going back till he’d made a fortune. He said (Thalassa remembered his exact words): “I don’t care how I do it, Remington, but I will do it—mark my words.” “Show me a more sensible plan than this, and I’m with you,” Remington had replied.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It was at this stage that Thalassa was seized with an inclination to thrust himself into the dialogue. Striving to explain his reasons at that distance of time, he said it was Robert Turold’s last remark which really decided him—did the trick, as he phrased it. Actually it must have been a prompt recognition of the kinship between two lawless souls.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He left his seat and went across to where the two young Englishmen were earnestly talking, unaware that they had been overheard. He approached them as one shipwrecked sailor might approach two other castaways marooned on the same rock. They all wanted money, and they all wanted to get away from that God-forsaken hole. Diamonds they were after? Well, he could take them to a place at the other end of the world where there were enough diamonds in the rough to make them all rich for life.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("After the first surprise at his interruption they heard him in silence, and then plied him with questions. Where were these diamonds? In a volcanic island in the South Pacific. Where about? They couldn’t expect him to tell them that. It was Robert Turold (Thalassa seemed to have addressed himself principally to him) who asked him how he knew that the diamonds were still there. Thalassa’s reply was that they were buried in a big box, and the island was out of the run of ships. What sort of a big box? Turold had asked. Thalassa replied (perhaps reluctantly) that the box was “a kind of a coffin,” and that there was a dead man inside of it as well as the diamonds, but he, at all events, was not likely to run off with them.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Remington and Turold were startled by this answer, and conferred hastily apart. They returned to ask more questions. They wanted to know how the body and the diamonds had got there in the first instance, but that was a story which Thalassa refused to reveal. That had nothing to do with it, he said. The ship which had buried the man there had gone down afterwards with all hands, so nobody knew about the diamonds except him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("After that Remington became the chief questioner, Robert Turold merely looking on, his dark eyes frequently meeting Thalassa’s. It seemed as though he must have realized that these last replies concealed a story better left unprobed. But Remington wanted to know why Thalassa had come searching for diamonds in that part of the world when he knew of plenty in another, and Thalassa had replied, in all simplicity, that it was because the Almighty had endowed him with more muscles than brains, and he hadn’t recognized the worth of the stones at the time. In fact, he didn’t know that they were diamonds. His experience on the fields had improved his knowledge in that respect, and he now knew that he had left behind him on the lonely island enough diamonds in the rough to make them all rich—two bottlesful, and some in a leather bag, where the dead man also kept one of those digging licenses which the damned German officials sold you—what did they call it? Prospector’s license—a "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("schurfschein")]), _vm._v("? said Remington. Yes, that was it. He knew it again as soon as he got one on the fields.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Turold and Remington again talked together in whispers, and then Turold asked Thalassa how he proposed to get the diamonds. Thalassa had his plan ready. They must get down to the Cape and get a boat to Sydney from Capetown. That was the jumping-off place. From Sydney they were to take a boat to—another place. The island was a bare two days’ sail from the “other place,” and Thalassa proposed to hire a cutter on the mainland and sail over to it. He was no navigator, but he could find his way back to that island again at any time.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Turold seemed inclined to agree, but Remington put in another of his sharp questions. Why did he want to bring two strangers into the business? What was to prevent him getting the diamonds on his own account, without sharing with anybody? Thalassa replied that he had no money to finance the expedition, and even if he got the diamonds they’d be no use to him. How could a rough seaman like himself, who could hardly write his own name, turn the stones into the large sum of money they represented? That was an enterprise which called for civilized qualities of education and address which he did not possess. From his standpoint it was an even deal between them. They were to supply the money and intelligence in return for his knowledge, and they would share and share alike.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It was Robert Turold who ultimately settled the decision—winning over the reluctant Remington with words which Thalassa had never forgotten. He also recognized the risk, but he thought it was well worth taking. It seemed that the two had a little more than £200 left between them—just about enough to carry the thing through. What was the use of returning to England with that paltry sum, he had asked. He spoke of a girl—some girl who was waiting in England for Remington while he made his fortune abroad. Was he going to go back to her penniless? “Even if this doesn’t turn out right,” he went on, “we’ll have reached another part of the world, with a fresh chance of making money, instead of being poor in England, that breeding-ground for tame rabbits, where poverty is the unforgiveable sin.” “I liked him for those words,” said Thalassa, “for they came from a man whose thoughts were after the style of my own. ’Twas they decided the other chap, and next morning we set out for Capetown. From there we got passages in a cargo boat for Sydney.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Charles found it easier to visualize this picture than the former. The departure of the three upon such a wild romantic venture had in its elements all the audacity, greed, and splendour of youth, and he also was young.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa went on with his story.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("During the voyage to Sydney, Robert Turold used to talk to him on deck at nights after Remington had gone to his bunk. It was in these solitary deck tramps under glittering stars that Thalassa first heard from the other’s lips of the Turrald title: the title for which the fortune he was seeking was merely a stepping stone—the means to obtain it. “Night after night he talked of nothing else,” said Thalassa, “and I knew he would do what he wanted to do.” It was easy to gather from his story that his original admiration for Robert Turold soon grew into a deeper and stronger feeling. There was something in the dead man’s masterful ambitious character which exercised a reluctantly conceded but undoubted fascination upon his companion’s fierce spirit.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Such were their relations when they reached Sydney and set out on a further voyage to the other place which Thalassa was so reluctant to name. On arriving at the “other place” they made their way to its east coast, which was the starting point of their journey to the island. From a brown man living on the coast Thalassa hired a smart little ketch which the three of them could easily handle, and in this they embarked for the island from a beach which curved like a white tusk around a blue bay.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("They did not reach the island for six days—through baffling winds, and not because they did not steer a right course. As Thalassa had said, there was no difficulty in finding it, for they had only been one day at sea when the smouldering smoke of the distant volcanic cone came into vision, making an unholy mark against the clear sky which they never lost again. Gradually they beat nearer until they made it—a circular ragged high ridge jutting abruptly from a deep sullen sea, with a red glow showing fitfully in the smoke of the summit.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("There was an outer reef, but Thalassa knew the passage, and steered the ketch through a tortuous channel above sunken needle-pointed rocks to a little sheltered harbour inshore. Here they made the ketch fast, and landed on a beach of volcanic violet, where they sometimes sank knee deep into sulphuric water, and felt squirming sea things squelch beneath their tread. Above this margin of violet-black sand, deposits of volcanic rock and lava rose almost perpendicularly, enclosing the central cone in a kind of amphitheatre.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The stones they had travelled so far to obtain were there waiting for them. Thalassa hurried over that part of the story, narrating it in barest outline with suspicious glances directed at his listener’s intent face. Apparently he led his companions to the spot as soon as they landed—up a path through a gap in the crater wall, across a furrowed slope all a-quake, where jets of steam issued from gurgling fissures in snaky spirals. On the other side of this dreary waste Thalassa led the way across a ledge to firmer ground and a grave. Charles gathered that the occupant of the grave had been coffined in a seaman’s chest in his clothes: “There he was, with his bottles of diamonds in his coat pockets, and more in his leather bag in his breast pocket, just as I left him twelve months afore to go to the other end of the world looking for what I’d buried.” A grim smile curved Thalassa’s face as he uttered these words; the idea seemed to contain elements of humour for him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“They were diamonds, then?” said Charles curiously.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Ay; they were diamonds right enough. Him—Turold—said they were diamonds as soon as he uncorked one of the bottles and poured a few into the palm of his hand. There was some rare big ones in one of the bottles—enough to have brought all those fools tumbling out of Africa if they’d know of them. From some papers they found on the chap Turold said he’d must a-been prospecting in nigh every part of the world.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“How did he come to be buried there with his diamonds, in that lonely spot?” asked Charles wonderingly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“He was a passenger, and died as we was passing the island. ’Twas the skipper’s fancy to give him a land burial. But that doesn’t matter a dump—it’s outside the story.” He turned his eyes away from Charles.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Dusk had fallen before they finished their search, and Thalassa would not undertake the risk of threading the boat out from the tortuous reef passage in the darkness. They decided to camp on the island for the night, preferring the sulphur-impregnated air (“A lighted match would blaze and fizzle in it like a torch,” Thalassa declared) to the cramped discomfort of their little craft. They brought some food ashore, and made a flimsy sort of camp above high water, at the foot of the encircling walls of the crater. There they had their supper, and there, as they lounged smoking, Remington in an evil moment for himself suggested that they should sort the diamonds into three heaps—share and share alike. Robert Turold agreed, and they emptied the stones out of the bottles and leather bag into a single heap. Remington took one bottle and Robert Turold another; to Thalassa fell the empty bag. As the stones were sorted one was to be placed in each receptacle until the tally ran out.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It must have been a strange spectacle—so strange that it made a lasting impression on the least imaginative mind of the three, for he tried in his rude way to reproduce it on that Cornish beach after the lapse of thirty long years. He threw bits of rock on the sand to indicate the positions in which they had sat. From his description Charles pictured the scene adequately enough: the violet-black beach, exhaling sulphuric vapours, the yellow-grey volcanic rocks, the gurgling ebullitions of a geyser throwing off volumes of smoke high above them, and the faces of the three men (ruddy in the fire-glow, white in the moonlight) intent on the division of the heap of dull stones scattered on a flat rock between them. Thalassa remembered all these things; he remembered also how startled they were, the three of them, at the unexpected sound of a kind of throaty chuckle near by, and turned in affright to see a large bird regarding them from the shadow of the rocks—a sea bird with rounded wings, light-coloured plumage, and curiously staring eyes above a yellow beak. When it saw it was observed it vanished swiftly seaward in noiseless flight.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The division, commenced good-humouredly enough, soon developed the elements of a gamble between Robert Turold and Remington. They forgot Thalassa’s existence as they argued and disputed over the allotment of certain stones. The foot or so of flat rock became the circumference of their thoughts, ambitions, and passions—their world for the time being. In that sordid drama of greed Thalassa seemed to have comported himself with greater dignity than his two superiors by birth and education. He even took it upon himself to reason with them on their folly. Perhaps he knew from his own seamy experience of life what such things developed into. At all events, he urged his companions to defer the division until they returned to civilization and could get the spoils appraised by eyes expert in the knowledge of precious stones. But they would not listen, so, not liking the look of things, he withdrew a little distance off and watched them, leaning against a rock. That was his tacit admission (so Charles interpreted this action) that he was on Robert Turold’s side, and felt that his own interests were identical with those of the master mind. The two, left to themselves, wrangled more fiercely than ever. There were unpleasant taunts and mutual revilings. The listener by the rock learnt definitely what he had previously suspected—that there was bitter blood and bad feeling between the two men, buried for a time, but now revived with a savageness which revealed the hollowness of their supposed reconciliation. It was about a girl, some girl in England with whom they had both been in love. Thalassa gathered that Remington had left England as the favoured suitor. He had (in Thalassa’s words) “cut Turold out.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Charles Turold could not forbear a faint exclamation of astonishment. His brain reeled in trying to imagine the austere figure of Robert Turold squabbling over a girl and some diamonds on a lonely island in the South Pacific. He was too amazed at the moment to see the implications of this part of the story.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“They went on snarling and showing their teeth, but not biting,” continued Thalassa, “sorting out the little stones all right, but quarrelling over the bigger. There was two—the biggest in the bunch by far—which they kept putting aside because they couldn’t agree about the sharing of them. At last it came about that there was only these two big ’uns left, lying like two beans on the bit o’ rock, side by side. Before I could guess what was likely to happen Turold grabbed them up quick, and put them in his bottle. ‘These two are mine, Thalassa’s and mine,’ he said. ‘You’ve had your share, Remington.’ Remington sprang from the rock quick as a snake. ‘One’s mine,’ he said. But Turold was up as quick. ‘It’s not for you,’ he says, with his dark smile. ‘We’ll put it against the girl you filched from me, and call it an even deal. What does a happy lover want with diamonds?’ ‘Damn you!’ cries the other, and hit him in the face. They both went down, scuffling and panting in the sand. I stood where I was, for I weren’t going to come between them till I saw how it was going to be. Presently I could see that Remington was stronger, and that Turold was getting the worst of it. After a bit Turold called out, ‘Thalassa!’")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I ran down at that fast enough, and got out my knife as I went. They’d slipped down the sloping beach half-way to the sea, writhing like a couple of the blind-worms that I kept stepping on, going over and over so quick that I couldn’t do anything at first. But one of them was sobbing in his breath as though he was pretty well finished, and I guessed it was Turold. Then I saw Remington’s face on top, and before they could swing round again I got a good stroke in his neck where it gleamed white in the moonlight. The blood jumped out warm on my hand, and he rolled over so quick that I thought I had killed him. But as I stooped over him he was up like a flash, staggering up the steep beach, his feet plopping and sucking in the water underneath. Turold was on his feet by that time, breathing hard, getting back his breath. ‘After him—quick!’ he says to me, his face black with rage—‘he’s got the diamonds.’")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I ran after him up the beach, but he heard me coming and had the start of me. He had firm ground under him by then, and was tearing along the rocks towards the path I’d taken them that afternoon, turning round now and again to look back, the blood glistening in the moonlight on his white face. There we was—him going higher and higher, me after him, and Turold standing below on the beach, staring up at the two of us.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Run my best, I couldn’t get near him. I suppose he thought he was done for if I caught him, and by that time my blood was pretty well up. I had one pull over him—I knew the island, and he didn’t. The path he was taking led to the top of the island, where the crater was, with a kind of wall of rocks round it. But before you came to that there was a great hole which fell down God Almighty knows how deep, and was supposed to have been another volcano at some time or other. This hole was divided into two by a narrow ridge running right across it, and the path Remington was on took him straight to the edge. So he’d either got to go across this ridge when he come to it or turn back and be caught.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“He was a long way ahead when he come to it, but he never stopped. He just gave one glance down at me, and went on to the ridge. I watched him balancing along it like a man on a tight rope, mounting higher and higher, for the ridge went up steep on the far side. Thinks I to myself, ‘You’re a plucky one,’ then all of a sudden I heard a shout from below, and looked down. There stood Turold, waving me out of the way. He’d been to the boat for a gun we’d brought with us, and was taking aim at Remington. The next thing I saw was Remington turning round on the ledge to come back to my side, having found out, I suppose, that the ridge would take him into the crater. Just as he turned I heard the shot. It must have winged Remington pretty bad, because he went tumbling off the ridge head first, like a man taking a dive into the water. I turned and climbed down to where I’d left Turold. His face was all aglow with rage. ‘The infernal scoundrel!’ he said, then—‘Did you get the diamonds?’ ‘How was I to get them when I never caught him?’ I said. ‘Then we’ll get them off his body in the morning,’ he said in a low tone. ‘You’ll never do that,’ says I. He asks me why not, turning on me a face as savage as a dog’s. ‘Because whichever side he’s dropped he’s safe from us,’ I said. ‘There’s a hole that no man’s ever seen the bottom of on one side of the ridge, and on the other a stinking lake of green boiling sulphur. When you shot him you sent him into one or the other, so you can say good-bye to him and the diamonds.’ ‘Oh!’ he cries, when he heard that—just like that; then after a bit he points up the path, and asks me to go back and have a look for him. I went back as far as the ridge. The moon was clear as day, shining on that infernal green lake on the one side, and into the deep hole on the other. The lake was bubbling and stewing in the moonlight like a witchpot, and the other side of the ridge was just black emptiness, and there was no sign of Remington—I knowed there couldn’t be. Back I went again, and as I was climbing down the path to where Turold was standing I saw something glinting in the black sand at his feet, and when I got there I picked up the bottle of diamonds where Remington must have dropped them when struggling with Turold. I gave them to Turold. ‘And now,’ says I, ‘let’s get out of here. The moon’s bright enough to let me find my way through the reefs, and this island ain’t a healthy place to stay too long on. I know it, and you don’t.’ He was glad enough to follow me to the boat, and we got through on a good flowing tide.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa stopped abruptly, as though to leave on his listener’s mind an impression of that furtive departure on a dark whispering sea beneath a blood-red moon.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You got back to the mainland?” queried Charles, as he remained silent.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Ay—and to England. Afore we got there Turold had persuaded himself that Remington slipped off the ridge accidental, and that he missed him when he fired.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Perhaps his conscience pricked him. Go on.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“There’s nowt much more to tell. Turold got me my share of the money, and then we parted. He offered to invest it for me, but I wasn’t going to trust no banks—not I. It took me two years to waste it on gambling and women. Then I took to sea again. That lasted another year. Then I found myself in ’Frisco, where I shipped in a four-masted barque and come home round the Horn. I was pretty sick of the sea after two bad goes of rheumatic fever, so I made up my mind to hunt up Turold. I found him after a while. He didn’t seem best pleased to see me at first, but he said I could stay till he had time to think out what he could do for me. That was the beginning of it. We never parted again, him and me, until he was carried out of yon house feet first. We got used to each other’s ways, and I was worth all he paid me because I saved him worry and expense. He was all for saving, in those days. Married he was too, to a little timid thing of a girl who was in fear and trembling of him. ’Twas a black day for her when she married that headstrong stubborn devil. ‘Mr.’ Thalassa she always called me, poor woman. I married a maid-servant they had. That was Turold’s idea—he thought by that way he could get his household looked after very cheaply by the pair of us. I wasn’t keen on marrying, but it didn’t make much odds one way or the other, for no living woman, wife or no wife, would have kept me in England if I’d wanted to get out. As it happened, I never did. I stayed on, going from place to place where they went—where Turold took us.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Whom did my uncle marry?” asked Charles.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You might a’ guessed that. ’Twas the girl t’other had cut him out of. I thought the masterful devil’d get her when Remington was out of the way, but I asked him once straight out, and he said yes, it was the same girl. She was a pretty timid little thing in those days, but I don’t know why they was both so mad after her. However, there it was.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“And do you think that after all these years, Remington is really alive?” said Charles, looking at him earnestly. “Do you think it was he who murdered my uncle?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Happen maybe, happen not. The night he was killed I found him in a rare funk in his room. He rang his bell like a fury, and when I went up he swore he heard the footsteps of Remington just afore, running round the rocks outside of Flint House just as he heard him pattering along the rocks on the island that night. I didn’t believe ‘un then, but I’m not so sure since. If he’s come back to get Turold it’s for sure he’s still somewhere about, waiting his chance to get me as well. I’m keeping my eye open for ’un—walked the coast for miles, I have, looking for him. He won’t take me unawares, same as Turold.” His eyes searched the cliffs behind them.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You may not recognize him if you meet him. It is thirty years since you saw him. A man changes a lot in thirty years.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That’s true, ’tis a thought which never crossed my mind.” Thalassa’s look was troubled.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“As you’ve told me this story you’d better leave it in my hands, and not go looking for anybody with that knife of yours.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What be you going to do?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I must go to Scotland Yard and tell them your story. It’s the only chance.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“And get me into trouble?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“There’s not much fear of that. In any case, you must stand that, for Sisily’s sake.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa nodded his acquiescence. “Better be careful yersel’ getting back to London. The police here is watching for you. They’ve been a’ Flint House more than once, looking for both of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It’s a risk I must take, nevertheless,” said the young man, rising from his seat as he spoke. “It’s for Sisily’s sake. Good-bye, Thalassa, and thank you for what you’ve told me.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("Thalassa did not reply or offer to accompany him. From his seat on the rocks he followed Charles’s ascent up the narrow path with contemplative eyes.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer030"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-30"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor029"
    }
  }), _vm._v("Chapter XXIX")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("Barrant returned to London in the mental disposition of a man who sees an elaborate theory thrown into the melting-pot by an unexpected turn of events. The humbling thought was that he had allowed a second fish to glide through his hands without even suspecting that it was on his line. He had never remotely connected Charles Turold with the murder until Mr. Brimsdown had imparted Mrs. Brierly’s disclosure to him. He had acted promptly enough on that piece of information, but once again he was too late.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Austin Turold might have felt reassured if he had known how little his share in the events of that night occupied Barrant’s mind during their last interview. The complexion Austin’s conduct bore to the detective’s reflection was that of a father who had intentionally misled the power of authority in order to shield his son. The law took a serious view of that offense, but it was a matter which could be dealt with at leisure in Austin’s case. By his brother’s death Austin Turold had become a man of property and standing. It was the drawback of his wealth that he could not disappear like his son. He was to be found when wanted. The main thing just then was to catch the son, or the girl—or both. Barrant went back to London for that purpose.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("As the days slipped away without that end being achieved he became worried and perplexed. His own position was an unenviable one, and his thoughts were far from pleasant. He felt that he had failed badly, and that his standing with his superiors in Scotland Yard was under a cloud in consequence. But he could not see where he had actually been at fault. It was such a damned amazing case. In most crimes the trouble was to find sufficient clues, but in this case there were too many. And the inferences pointed different ways. That was the trouble. He was not even sure that in this latest discovery, so annoyingly belated, he had reached the ultimate solution of the facts. It was not that the theory of these two young people committing murder for love was too cynical for belief. He had encountered more incredible things than that in his professional career. Life was a cynical business, and youth could be brutal in pursuit of its aims, especially when the aim was passion, as it usually was. In his experience youth and age were the dangerous periods—youth, because it knew nothing of life, and age because it knew too much. There were fewer surprises in middle-age. That was the period of responsibility—when humanity clung to the ordered way with the painful rectitude of a procession of laden ants toiling up a hill. Youth was not like that—nor age.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("No, it was not that. His difficulty was to fit all the circumstances into any compact theory of the case. Try as he would, there were always some loose ends left over, some elements of uncertainty which left him perplexed. He fashioned a new view of the murder, with Charles Turold as the principal figure in it—the actual murderer. He assumed that Charles and Sisily had gone to Flint House that night to prevent the truth about Sisily’s birth becoming known. The assertion of her illegitimacy rested upon her father’s bare statement, but his lawyer was convinced he would not have made the statement without having the proofs in his possession. These proofs had not been found. Very well. What inference was to be drawn from that? Sisily knew that they were kept in the clock-case, and pointed out the hiding place to her lover. In a struggle for their possession Robert Turold was shot down, or he might have been shot first and staggered to the clock afterwards to see if they had been stolen. Either supposition accounted for the fallen clock, and fitted in with nearly all the known facts of the murder.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Nearly all, but not all! In face of Mrs. Brierly’s disclosure it seemed a condition precedent to the elucidation of the mystery to substitute Charles Turold for Thalassa as the person whose undisciplined love for Sisily had led him to shoot her father to shield her name. Nor was it incredible to suppose that he had remained in Cornwall to cover her flight in the hope of diverting suspicion from her. But the loose end in the theory was Thalassa’s share in that night’s events, and his dogged silence since under strong suspicion.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa knew more than he had yet revealed, but what did he know? What was his share in the business? It was difficult to say. Barrant was unable to accept the assumption that three people were concerned in the murder. That idea, if not impossible, was at least contrary to reason. But if it was excluded, how was the silence of Thalassa to be explained? Was he afraid? It was as difficult to associate that quality with him as with an eagle or beast of prey.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("And the theory failed to explain the reason for Robert Turold’s frantic letter to his lawyer on the night of the murder. That was another loose end.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("What a case! It was an abnormal and sinister mystery in any light, with no absolute or demonstrative certainty of proof by any of its circumstances, however regarded. The effect of its perplexing clues distorted the imagination, outraged the sense of possibility and experience. To reach conclusiveness in it seemed as impossible as an attempt to scale an unending staircase in a nightmare. The facts were there, but they were inexplicable, or at least they stared at him with the aspect of many faces.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("As he weighed these doubts he found his thoughts reverting with increasing frequency to the hood clock in Robert Turold’s study and the question of its connection with the crime. He pondered over the point with the nervous anxiety of a puzzled brain, and it seemed to him now that he had not devoted as much investigation to this peculiar clue as it deserved. He recalled Mr. Brimsdown’s conversation on the matter. He remembered that he had been struck at the time by the penetration of his remarks about the clock, and while not accepting his fantastic theory, had determined to give more careful thought to the point. But Mrs. Brierly’s disclosure put the idea out of his head.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It recurred to him with renewed force when he found himself in Exeter nearly a fortnight later on another case. It was a good opportunity to go on to Cornwall, and he took it. His business completed, he caught the early train, and in due time arrived at Penzance. With an obscure instinct for solitude he hastened through the town and struck out across the moors.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The afternoon was waning when he reached Flint House and pulled the old-fashioned bell-handle of the weatherbeaten door. There was no reply, and a second ring passed disregarded. That was disconcerting and unexpected. He wondered whether Thalassa and his wife had left the place. Then he noticed that the door was merely closed and not shut. He lifted the heavy iron knocker, and knocked loudly. The repeated knocking sent the door flying open, and Barrant found himself looking into an empty hall. Half-way down a pair of curtains stirred slightly and parted suddenly, revealing a narrower passage which led to the door of the kitchen. The curtains streamed horizontally, twisting and coiling like snakes. Barrant stepped quickly inside and closed the door. The curtains fell together again.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("There was something so startling in this action of the wind that Barrant stood motionless, looking round him. The cold current of air he had admitted died away in the draughty passages with queer gasping noises, like a wind strangled. Then there was the most absolute silence. The curtains hung perpendicular, as thickly motionless as blankets. Barrant noticed that the hallstand and a chair beside it were thick with dust. Evidently the house was empty.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Turning first to make quite sure that the front door was securely shut, he took his way upstairs to Robert Turold’s study.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("A point of light, falling through the shattered panel of the closed door, pierced the vague gloom of the passage and hovered on the door of the bedroom opposite—the room into which the dead man had been carried.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant entered the study and looked around him. It was intolerably dirty and neglected; everything was covered with a thick grey dust. Barrant walked over to the clock and regarded it attentively.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("What a rascally fat face that moon had! It must have seen some queer sights in old houses during its two hundred years of life. Strange that those old clockmakers could make clocks to last so long, but couldn’t keep their own life-springs running half the time! The moral verse was curious enough. Why should a man who spent half his lifetime putting together a clock presume to tell his fellow creatures to make the most of the passing hour?")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("His reflections took a more practical turn. The clock was the sole witness to the time of the murder. There were two other clocks in Flint House, but nobody had thought of looking at them when the crime was discovered. Barrant regarded that as a regrettable oversight. It was always important to know the exact time when a murder was committed. Thalassa said that the hood clock was going and kept excellent time, but the value of that secondary testimony was impaired by the fact that Thalassa might not be telling the truth. On the other hand, there was certain presumptive evidence which suggested that he was. It was a proved fact that Mr. and Mrs. Pendleton and Dr. Ravenshaw left the doctor’s house in a motor-car for Flint House not later than half-past nine on the night of the murder. Assuming that they covered the journey across the moors in five or six minutes and occupied another five minutes in getting upstairs and breaking in the door, the testimony of the hood clock seemed correct, because Dr. Ravenshaw said death had just taken place, and he and the doctor who made the post-mortem examination were both agreed that Robert Turold could not have lived many minutes after he was shot. Therefore the presumptive evidence seemed to determine the time of death accurately enough.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("But that was only a minor phase of the mystery. The real problem was the hidden connection between the clock and the murder. What had brought the clock down, and why had Robert Turold fallen almost on top of it, his outstretched hands resting on the dial? The complete elucidation of the mystery lay behind the obscurity in which these two points were shrouded. To find the answer to them was the surest and quickest way of reconciling all the contradictory facts of the case. But Barrant racked his brains for the reason in vain.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He examined the room. There was a leather-topped writing-table with drawers, several cabinets filled with manuscripts and papers, some walnut chairs with carved legs, and a tall deep bookcase filled with dreary-looking books. His eyes wandered over the titles of the volumes. They also belonged to a bygone period—a melancholy accumulation of works as dead as their writers. Two whole shelves were occupied with the numbers of a forgotten periodical which claimed to give “ample details of the unhappy difference between Queen Caroline of Great Britain and her consort George the Fourth.” Barrant wondered idly why human nature was always so interested in the washing of dirty linen. Above these was ranged a row of published sermons. Barrant’s eye roamed higher and fell on a fat sturdy volume wedged in between some slimmer books. The title of this book was “Clocks of All Periods.” Clocks!")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He reached for the volume and placed it on the table. A cursory glance through the pages conveyed the suggestion that it contained more information about clocks than was worth acquiring or writing down. There was a chapter on water clocks, to begin with: “Known to the Egyptians and the Holy Land.” Barrant turned the leaves. “The Ancient Chinese used a smouldering wick as timekeeper.” Barrant shook his head impatiently. “King Alfred’s supposed device of measuring Time by Candles—a Myth.” Would to heaven his invention of juries was a myth, too. Scotland Yard would get on much better without them. “A Lamp-clock was another Simple and Ingenious Design.” How intolerably long-winded the writer was. What had he to say about hood clocks? “Very few of the Early Clocks had Dials. The Device was generally a Mechanical Figure which struck the Hour on a Bell.” Evidently the forerunner of the devilish alarum clock. “Early clockmakers—Old English monks as Clockmakers.” The pages flowed rapidly through Barrant’s fingers. “Introduction of Minute Hand Marks—Period of Clocks Showing Tides—Longfaced Clocks.” Ah, here it was at last—“Hood Clocks.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He began to read the chapter with interest, but as he was about to turn the first page the silence of the room was broken by a faint cackling laugh—an elfin sound which died away instantly. He looked up, startled. His surprise was not lessened at the sight of Mrs. Thalassa watching him from the open doorway. She entered on tiptoe, with a strange air of caution, examining him with restless eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I heard you,” she mumbled. “I saw you go upstairs. Mr. Thalassa was out, and I was afraid to go to the door. I’ve been playing patience, and it won’t come out.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She showed her apron full of small cards. She placed them on the table, and arranged them in rows.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("A new idea came into Barrant’s mind as he looked at her. If the poor creature had recovered sufficient wits to take to her cards again she might be coaxed to recall what she had seen on the night of the murder. He drew near her. “Can I help you?” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She nodded sideways at him like a child—a child with withered face and grey hair.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Together they bent over the cards. A gull flashed past the window with a scream, as though it had seen them and was repelled at the strange sight.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Only kings can go into vacant spaces,” murmured Barrant’s companion, intent on the game.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The result of the game was inconclusive. A king remained surrounded by small cards, like a real monarch overwhelmed by the rabble on May Day. Mrs. Thalassa’s eyes strayed mournfully over the rows, then she gathered up the cards and shuffled them again.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Do you know any other games of patience?” Barrant asked.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She shook her head.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Then this is the game you were playing on that night?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What night?” she whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“The night Mr. Turold was killed.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I don’t want to think of that—it frightens me.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She remembered, then! Her face went grey, but her eyes were alert, watching his.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Listen to me”—he spoke very gently—“I want to help you get rid of your fear and terror, but to do so I must talk to you about that night. Do you understand?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The kindness in his voice seemed to reach her feeble consciousness, and she looked at him earnestly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Will you try and recollect?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She seemed to search his eyes for courage, and gave a trembling nod.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What time was it when you heard the crash upstairs? Think well.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She seemed to make an effort to remember. “I don’t know,” she said at last.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Think again. You were playing patience—the game you have just shown me?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Her eyes turned to the cards on the table. “Yes,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What time did you commence—can you think?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She shook her head. “I seem to remember it was half-past eight by the kitchen clock when I started my last game. I was alone in the kitchen then. The game was just coming out when I heard a crash—”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She broke off suddenly with a painful sigh and a frightened glance at the hood clock on the wall.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“One game!” Barrant glanced at his watch with an air of mistrust. “You mean two, don’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Her eyes returned to his. She shook her head with a rapid tremulous motion. “No!” she exclaimed excitedly. “One, only one!”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant cast another glance at his watch, which he still held in his hand. “You are quite sure you did not play two?” he persisted, with a puzzled glance.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No, no—one!” She sprang to her feet excitedly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Very well—one,” acquiesced Barrant soothingly. “One. Go on.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("But his effort to calm her came too late. She cast a wild and fearful glance at the wall behind her, as if there was something there which frightened her.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“How it rings—how it rings!” Her indistinct utterance grew louder. “Yes, Jasper, I hear. Yes, sir, I’m coming. Where’s the supper tray?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Don’t be afraid, Mrs. Thalassa,” said Barrant, approaching her, but she backed hurriedly away towards the door.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Coming with the supper tray—coming with the supper tray. . . . What’s that? Ah-h-h-h-h!”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Her disjointed mutterings ended in a shrill scream which went ringing through the stillness and seemed to linger in the room after she had disappeared. Barrant heard her muttering and laughing as she descended the stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The sounds died away into a silence so absolute as to suggest the impression of a universe suddenly stricken dumb. Barrant crossed the room to the window, where he stood looking out, deep in thought.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("What was the meaning of it all—of this latest scene in particular? The game of patience so tempestuously concluded had occupied half-an-hour. He had noted the time. Yet Mrs. Thalassa insisted she had played only one game after half-past eight on the night of the murder. If he dared accept such a computation of time an unimagined possibility in the case stood revealed. But—a demented woman. “A parable in the mouth of a fool.” Perhaps it was because she was a fool that he had stumbled on this revelation. She lacked the wit to lie about it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("If so—")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("His eyes, straying incuriously over the outstretched panorama of sea and cliffs beneath the window, fell upon a man’s outline scaling the cliff path near the Moon Rock. Disturbed in his meditations, Barrant watched the climber. He reached the top and appeared in full view on the bare summit of the cliffs. Barrant stared down upon him, amazed beyond measure. The advancing figure was Charles Turold.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer031"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-31"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor030"
    }
  }), _vm._v("Chapter XXX")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("Barrant hastened from the room downstairs to the front door. From the open doorway he saw Charles Turold advancing across the rocks in the direction of the house, and he ran swiftly down the gravel path to intercept him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Charles looked up and came on as if there was nothing to turn back for. His clear glance dwelt on the figure by the gate without fear—with seeming gratification. Barrant was amazed. He had been prepared for an attempt at flight, but not this welcoming look. Never before had he known a man show joy at the prospect of arrest. The experience was so disturbing that he went across the intervening space to meet Charles, and laid a hand upon his arm.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I suppose you know you are wanted by the police?” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I am aware of it,” was the quiet reply. “I was going to give myself up.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Did you come back to Cornwall for that purpose?” asked the detective, shooting another puzzled glance at him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I came back to try and discover the truth.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“About what?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“About my uncle’s death.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“And have you discovered it?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I have.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant did not understand the young man’s attitude, or the tone of heartfelt relief in which he uttered these words, but he felt that the conversation in its present form had gone far enough.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Do you propose to tell me the truth?” he asked, with a slight cynical emphasis on the last word.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I do.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant’s surprise kept him silent for a moment, but when he spoke he was very incisive—")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“In that case it is my duty to warn you—”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“There is no need to warn me,” Charles quickly interrupted. “I know. Any statement I make will be taken down and used against me. That’s the formula, isn’t it, or something to that effect? Let us go into the house—my story will take some time in the telling.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He made this request as a right rather than a favour, and Barrant found himself turning in at the gate with him. In silence they walked to the house, and it was Charles Turold who led the way to the sitting-room.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It was here it began,” he murmured, glancing round the deserted apartment, “and it seems fitting that the truth should be brought to light in the same place.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Provided that it is the truth,” commented his companion.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Charles did not reply. They had been standing face to face, but he now drew a chair to the table and sat down. Barrant walked to the door and locked it before seating himself beside him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You can begin as soon as you like,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I think I had better tell you about my own actions, first of all, on that night,” said Charles, after a brief silence. “It will clear the way for what follows. I was up here that night—the night of the murder.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I know that much,” was Barrant’s cold comment.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You suspected it—you did not know it,” Charles quickly rejoined.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He remained profoundly silent for a moment, as if meditating his words, and then plunged into his tale.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The account of his own visit to Flint House on the night of the murder he related with details withheld from Sisily. The visit was the outcome of a quarrel between father and son over Robert Turold’s announcement about his wife’s previous marriage. Charles was shocked by his uncle’s decision to make the story public, and had wandered about the cliffs until dark trying to decide what to do. Ultimately he returned home and asked his father to use his influence with his brother to keep the secret in the family. His father called him a fool for suggesting such a thing, declined to offend his brother or blast his own prospects by such damned quixotic nonsense. On this Charles had announced his intention of seeing his uncle and telling him he would leave England immediately and forever unless the scandal was kept quiet. That made his father angry, and they quarrelled violently. Charles cut the quarrel short by flinging out of the house in the rain, to carry out his intention of interviewing his uncle. He walked across the moors to Flint House. The front door was open, the downstairs portion of the house in darkness, and his uncle lying upstairs in his study—dead.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He hurried over all this as of small importance in the deeper significance of Thalassa’s story. That was to him the great thing—the wonderful discovery which was to clear Sisily and put everything right. He believed that the plan which had brought him to Cornwall was working splendidly. The chance encounter with the detective was really providential—a speeding up, a saving of valuable time.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The possibility of disbelief did not dawn upon him. He overlooked that his listener was also his custodian and judge—the suspicious arbiter of a belated story told by one whose own actions were in the highest degree suspicious. His overburdened mind forgot these things in the excitement of hope. He talked with the candour and freedom of one young man confiding in another. When he had finished he looked at his companion expectantly, but Barrant’s eyes were coldly official.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“A strange story!” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“A true one,” Charles eagerly rejoined. “Thalassa has been walking along the coast ever since in the expectation of finding this man. He will kill him if he meets him.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It was Barrant’s lot to listen to many strange stories which were always true, according to the narrators, but generally they caused him to feel ashamed of the poverty of human invention. He was not immediately concerned to discover whether Thalassa’s story was true or false, or whether it had been concocted between him and Charles with the object of deceiving the authorities. The consideration of that infamous brownfaced scoundrel’s confession could be postponed—if it had ever been made. The present business was with Charles Turold. There was something infernally mysterious in his unexpected reappearance in that spot. He had gone to London when he disappeared—he admitted that. What had brought him back? To see Thalassa, as he said, in order to try and get at the truth? Nonsense! He—Barrant—was not simple enough to believe that. What then?")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant was not prepared to supply a ready answer to that question. But his trained ear had detected many gaps in the young man’s own narrative which, filled in, might give it. Turold knew more than he had said—he was keeping things back. Again—what things? Behind him stood the shadowy figure of the girl and her unexplained flight. Barrant’s instinct told him that Charles was shielding her. He turned to the task of endeavouring to reach the truth.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Let’s go back a bit,” he said casually. “You’ve left one or two points in your own story unexplained. What about the key?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“The key?” Charles started slightly. “You mean—”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I mean the key of the room upstairs. You said you found the key in the passage outside. You must have locked the door after you and taken it away with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I did,” replied the young man, in some hesitation.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“For what reason?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Charles realized that he was on very thin ice. In his intense preoccupation with Thalassa’s story he had forgotten that his own impulsive actions on that night must be construed as proof of his own guilt or bear too literal interpretation of having been done to shield Sisily. He saw that he was in a position of extraordinary difficulty.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I was hardly conscious of what I was doing, at the time,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You took the key away with you?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Charles nodded with the feeling that the ice was cracking beneath him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“And how did it get back into the room afterwards?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Charles paused to consider his reply, but the detective supplied it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“The inference is fairly obvious,” he said. “The key was found inside the study after the locked door was burst open. It was your father who found it, on the floor. At least, he pretended to find it there. It was your father who started the suicide theory.” He paused, then added in a smooth reflective voice, “Really, the whole thing was very ingenious. It reflects much credit on both of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Charles spoke with an air of sudden decision.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“My father did these things to shield me,” he said. “I did not want to reveal that, but I see that concealment will only direct unmerited suspicion to him. When I returned from Flint House that night I let myself in with my latchkey and went straight to my bedroom. My clothes were wet through, and I lit a fire in my room to dry them. As I was spreading them out in front of the blaze the key of the study dropped out of the waistcoat pocket on to the floor. I had forgotten all about it till then. I picked it up and placed it on the mantel-piece.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Some time after I was aroused by my father entering the room. He had come to tell me of my uncle’s death—the news had just arrived from Flint House. His face was very white. ‘Your uncle has been found dead—shot in his study,’ he said. I had jumped up when he came in and was standing in the centre of the room. As he spoke his eyes travelled past me to my wet clothes in front of the fire, and then returned to my face with a strange expression. ‘Did you go to Flint House?’ he asked sharply. I could only nod. ‘And did you see him—your uncle?’ was his next question. On that, I told him the truth—told him what I had found. I told him about locking the door, and showed him the key on the mantel-piece. He slipped it in his pocket, then turned and gave me a terrible look. ‘I am going over to Flint House,’ he said, ‘but you had better stay here.’ And he left the room.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What time did you reach Flint House that night?” asked Barrant.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Charles Turold realized that the critical moment had come. He had foreseen it when he saw the detective standing at the gate of Flint House. The relation of Thalassa’s story to Barrant had carried with it the inevitable admission that Sisily was at Flint House on the night of her father’s death. The point Charles had to decide was whether he should divulge the additional information that he had seen her leave Flint House with Thalassa on that night. As he covered the space which intervened between him and Barrant waiting at the gate, he decided that the moment had come to tell all he knew.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I know now that it couldn’t have been much after half-past eight,” he said in reply to Barrant’s question.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Did you see Miss Turold there?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I was coming to that. I was standing outside, considering what I would say to my uncle, when the door opened and she and Thalassa came out.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Did you not speak to them?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I went to do so, but they disappeared in the darkness of the moors before I could reach them. I hastened after them, but I got off the road track and wandered about the moors for nearly half an hour before I could find my way back to Flint House.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“And found the door open and your uncle lying dead upstairs?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Why have you not come forward with this story before?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“How could I expect any one to believe a story which sounds improbable in my own ears? Even my father refused to believe it—then, or afterwards.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Still, you might have cleared Miss Turold on the question of time. There was the stopped clock, you know. You reached Flint House shortly after half-past eight, and went upstairs thirty minutes later.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Charles Turold was subtle enough to see that this remark covered more than a trap. It suggested that Barrant discredited the whole of his story. The hood clock in the dead man’s study had pointed to half-past nine on the night he was killed. Thalassa’s story, as it stood, proved that Sisily must have left the house long before then. But Charles’s story threw suspicion back on to Sisily by suggesting that the police had been misled about the time of the murder, which must have been committed at least half an hour earlier than they assumed. Charles did not attempt to point out this supposed flaw in the detective’s reasoning. He confined himself to a reply which was a strict statement of fact, so far as it went.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Until I heard Thalassa’s story to-day I had no idea of the time of my own arrival at Flint House on that night,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“The clock found lying on the floor upstairs was stopped at half-past nine,” remarked Barrant with a reflective air, as though turning over all the facts in his mind. “According to the story told you by Thalassa, he and Miss Turold left the house shortly after half-past eight. Thalassa could not have returned until after half-past nine. He found the house in darkness, his wife lying unconscious in the kitchen, and his master dead upstairs. Thalassa, retracting his previous statement that he was not out of Flint House that night, for the first time tells of some mysterious avenger who, he thinks, killed Robert Turold while he was out of the house with Miss Turold. Thalassa now suggests (if I understand you rightly) that this man Remington, wronged by Robert Turold many years before, was lurking outside in the darkness, and seized the opportunity of Thalassa’s absence to enter the house and murder the man who had wronged him. Have I got it right?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yes,” said Charles, “you have it right.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“The story rests on Thalassa’s bare statement, and Thalassa is a facile liar.” Barrant’s tone was scornful.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“He is not lying now,” returned Charles, “and there is more than his bare statement to support his story. Thalassa found his master cowering upstairs with fear in his study shortly before he met his death. He then told Thalassa he had heard Remington’s footsteps outside. Thalassa laughed at him, but undoubtedly Remington was out there, waiting for his opportunity, which he took as soon as he saw Thalassa leave the house. If I had not followed Thalassa and Miss Turold I might have seen him.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It’s rather a pity you didn’t.” Barrant’s tone was not free from irony. “For then you might have secured the proof which at present the story lacks.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“There are other proofs,” Charles earnestly continued. “There were the marks on my uncle’s arm, and the letter he wrote to his lawyer under the influence of the terror in which Thalassa found him—the fear caused by overhearing Remington’s footsteps. Thalassa posted that letter.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Did he tell you so?” asked Barrant quickly. Then, as Charles remained silent, he went on—")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“How did you find out about the marks on your uncle’s arm?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Charles hesitated before replying in a low voice—")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I paid a visit to Flint House on the night after the murder.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“For what purpose?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“To see if I could find out anything which might throw light on the mystery. I got in through a window and went upstairs. I saw the marks . . . then.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Did you discover anything else?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No; the dog started to bark, and I left as quickly as I could.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I see.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant’s voice was non-committal, followed after a pause by a quick change of tone.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I shall investigate this story later,” he said coldly. “Meantime—”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Why not investigate it immediately?” asked Charles in a disappointed voice. “Thalassa will be back directly, or I can take you down to the cliffs were I left him.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant was reminded of the flight of time. It would be as well to remove Charles before Thalassa returned. Time enough for Thalassa’s story later! At that moment it seemed to Barrant that the final solution of the mystery was almost in his hands. Mrs. Thalassa had been wiser than he. The single game of patience suggested the solution of the problem of the time. It did more than that. It seemed to provide the key of the greater problem of Charles Turold’s actions on that night. He had endeavoured to shield Sisily by altering the hands of the clock. The rest, for the present, must remain mere conjecture. One more question he essayed—")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Can you tell me where Miss Turold is to be found?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I know, but I am not going to tell you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Barrant’s eye rested on Charles.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You must come with me,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Charles nodded. Despairingly he reflected that the interview had not turned out as he expected. There were other means, and he must be patient.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("And Sisily? There was anguish in that thought.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer032"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-32"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor031"
    }
  }), _vm._v("Chapter XXXI")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("With a beating heart Sisily gained the shelter of her room and locked the door, her eyes glancing quickly around her. She did not expect to see anything there, but she had reached the stage of instinctive terror when one fears lurking shadows, unexpected noises, or an imagined alteration in the contour of familiar things. There was nothing in the room to alarm her, and her thoughts flew back to the face of the man she had seen in the street outside. The owner of the face had leered at first, and then his glance hardened into suspicion as he looked. When she hurried past him he had shifted his position to stare at her by the light of the street lamp. Had he followed her? That was the question she could not answer. She had heard footsteps behind her in the dark street, horrible stealthy footsteps which had caused terror to rush over her like a flood, and sent her flying along the street to her one haven. As she ran she had felt a touching faith in the security of her room, if she could reach it. Out there, in the open street, it had seemed impregnable, like a fortress.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Now as she sat there she had a revulsion of feeling. The room was not safe, the house was not safe. Not now. She had been very imprudent. She had run straight home to her hiding-place, her only refuge. Why had she not waited to make sure that she was followed? Then she could have slipped away in a different direction until she had evaded pursuit, and returned to her room afterwards. She had been very foolish.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She approached her window and gazed down, but could discern nothing in the darkness. She tried to shake off her fear, telling herself that it was imagination. But her mind remained full of misgivings, and her inner consciousness peopled the obscurity of the street below with lurking figures.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Weariness overcame her. She retired from the window and laid down on her bed, not to sleep, but to think. Her fright had turned her mind temporarily from the contemplation of a greater disaster. That was the arrest of Charles Turold. She had learnt the news from an evening paper which she had bought at the corner of the street. The announcement was very brief, merely stating that he had been arrested in Cornwall. The guarded significance of the information was not lost upon her. Charles had been captured on his way back to her, and her agonized heart whispered that she was responsible for his fate.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Bitterly she now blamed herself for having let him go on the quest. She hardly asked herself whether it had succeeded or failed, perhaps because she had subconsciously accepted the view that Thalassa, after all, had nothing to tell. Nor did she think of the calamity which had again overtaken her love. The effect of her original renunciation was still strong within her, and Charles’s discovery of her and her promise to him had not really altered her attitude. His finding her, and their subsequent conversation in the room below, bore an air of the strangest unreality to her, as if she had been merely an actor in a stirring scene which did not actually affect her. Some subtle inward voice told her that these things did not matter to her.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It was part of a feeling which she had always within her—the sense of living under the shadow of some dark destiny which would not be mitigated or withheld. It was a strange point of view for one so young, but it had been hers ever since she remembered anything. The tragedy and the shame which had come into her life recently had found her, as it were, waiting. She regarded them merely as the partial fulfilment of the unescapable thing which had been prepared for her before she was born, and had dogged her lonely footsteps since childhood. In the isolated circumstances of her life and upbringings it was not strange, perhaps, that she had such imaginings.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She had loved Charles Turold with all the strength of a passionate solitary nature, and it was this feeling or instinct of fatality which had given her the strength to renounce him. Indeed, it seemed to her that that inseparable companion of her inmost thoughts had prompted her to linger outside the door at Flint House on this afternoon so that she should overhear her father’s words—catch that sinister fragment of a sentence which compelled her to refuse the love of Charles until she had learnt the truth. She could not listen to him with that secret half-guessed. And, the full truth known, no other course was open to her save renunciation.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She had not wavered. Sometimes, in the vain way of the young heart seeking for happiness, she found herself wishing that she had not listened at the door to those few words which sent her back to Flint House that awful night to learn the truth from her father, or, at least, had not acted upon them. The words she overheard had not told her much, and she might have tried to forget them. But she thrust that thought from her like an evil thing. She would have hated herself if she had followed that course and found out the truth of her birth afterwards, deeming herself unworthy of the love of one who had been ready to sacrifice everything for her sake. No! It was better, far better, that she should know.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She had not thought of suspicion falling on herself. Her youth and inexperience, borne upward on the lofty wings of sacrifice, had not foreseen the damning significance which might gather round her secret visit to Flint House and her subsequent disappearance. Not even when she heard of her father’s death had the folly of her contemplated action dawned on her. Her dreamy unpractical temperament, keyed up to the great act of abnegation, had not paused to consider what the consequences might be to herself.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Lying there in the darkness of her room, she recalled how that revelation had been made to her. It was the first night after her arrival in London, in the drawing-room of a private hotel near Russell Square, where she had intended staying for a few days while she sought for some kind of employment. There was a group of women seated round the fireplace, talking. She was seated by herself some distance away, turning over the leaves of a magazine, when a loud remark by one of the speakers startled her into an attitude of listening fear. “Have you read about this Cornwall murder?” The words, cold and distinct, had broken into her sad reflections like a stone dropped from a great height. They had gone on talking without looking at her, and she had listened intently, masking her conscious features with the open magazine. It was well that she did. They discussed the murder in animated tones. The strangest case. . . ! A great title . . . the Turrald title . . . to be heard before the House of Lords next week . . . and now the claimant was murdered . . . he was very wealthy, too. Thus they talked; then the first voice, which seemed to dominate all the others, broke in: “It was thought to be suicide at first, but I see by tonight’s paper that his daughter is suspected. She has disappeared, and is supposed to have fled to London. What are girls coming to—always shooting somebody or somebody shooting them! It’s the war, I suppose. . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The shock of that double disclosure had been almost too much to bear. Till then she had not known that her father had been murdered, much less that she was suspected of killing him. Dizziness had swept over her. Things seemed to spin round her, yet she saw them rotating with a kind of dreadful distinctness—"), _c('br'), _vm._v("the false smiling faces of the women, the furniture, a cat blinking on the hearthrug, an empty coffee cup on a small table. One stout lady, enthroned on a pile of red and blue cushions, sailed round and round on a sofa with the preposterous repetition and tragic reality of a fat woman on a roundabout. Then the circling faces and furniture vanished. She swayed with the sensation of growing darkness, and had the oddest fancy that the break of the waves on Cornish cliffs was sounding in her ears. She was dreamily inhaling the sea air. . . .")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She had pulled herself sharply together. She had something of her father’s tenacity and courage in her composition, and that had nerved her to face the ordeal and saved her from giving herself away. The darkness lightened, the electric lights danced dizzily back into view, and the room became stationary once more. With an effort at calmness she rose from her seat and sought her room, and next morning she left the house. Henceforth her lot was one of furtive movement and concealment.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("As she lay there, staring open-eyed into the darkness, her thoughts slipped back to the night of her visit to Flint House in a vain effort to recollect some overlooked incident which might throw light on her father’s mysterious death. There was one thing over which she had frequently puzzled without arriving at any interpretation of it. She thought of it now. She saw herself stealing from her father’s room with the sound of his last awful words ringing through her being. Beneath, near the foot of the staircase, she could see Thalassa waiting, the glow of the tiny hall light falling on his stern listening face. She was walking along the passage to go to him when some impulse impelled her to glance through a window which looked out on the moors and the rocks near the house.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Her eyes had fallen on a shape, shrouded in the obscurity of the rocks not far from the window, which seemed to have some semblance to the motionless figure of a man. She had stood there for a moment, glancing down intently, but it had not stirred. If it had human semblance, it seemed to be carved in stone. She came to the conclusion that she was mistaken. Experience had taught her what strange shapes the rocks took after nightfall. With another fleeting glance she had hurried downstairs, and from the house.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She thought about it now without arriving at any conclusion as to what it was that she had seen so indistinctly—whether man or rock. Charles had been up there that night, but it was not Charles. This figure or rock was on the other side of the house.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Stupor descended gradually on her tired brain like the coming of darkness, and she fell into sleep—the first rest that had visited her since she learnt of Charles’s arrest. But her slumber was disturbed by dreams. She dreamt that she was back in Cornwall, sitting on her old perch at the foot of the cliffs, looking at the Moon Rock. The face in the Rock was watching her, as it had always watched her, but this time with a dreadful sneer which she had never seen before. It frightened her so that she moaned and tossed uneasily, and awoke with a cry, shaking with terror.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("As she reached out her hand for the matches by the bedside to light the gas, the sound of the front door-bell pealed through the house. Sisily sprang up, her eyes seeking to pierce the darkness, her ears listening intently. Who could it be? She was alone in the house. Mrs. Johns had gone to one of her spiritualistic meetings, and was not likely to be home until late. Besides, she had her own key, with which she always let herself in. She crept cautiously to the window and strained her eyes downward. She was just able to catch a glimpse of two vague figures underneath in the darkness. The light of the street lamp glinted on something one of them was wearing on his head. It was a policeman’s helmet.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The terror of the hunted took possession of her. She sought to remain calm; her trembling lips essayed a sentence of a prayer. But it was no use. She was too young for philosophy or Christian resignation. Terror shook her with massive jaws. She did not want to be caught, to be put in prison, to be killed. She wandered aimlessly about the room like a trapped creature. She must escape—she would escape!")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("With a great effort she calmed herself to reflect—to calculate if there was any chance of getting away. She esteemed it fortunate that she had not lit the gas in her room. The whole house was in darkness. The policeman might think there was nobody in, and go away. But she dared not reckon on that.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("There came another and louder ring of the bell downstairs.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Again she crept to the window and looked down. The policeman and the other man were conferring in a murmur which reached her ears. The policeman stepped back into the garden path and scanned the darkened windows of the house. She shrank back from the window.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The ring was followed by the sound of knocking at the front door—knocking heavy and prolonged, which reverberated solemnly through the silent house. Then once more there was silence.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("In her ignorance of the methods of the law she wondered wildly whether the next step would be to break in the door and search the house. Terror shook her again at this thought, scorched her with burning breath. She would escape—she must. But how? Her fingernails pierced the palms of her hands as she vainly tried to think out a way. Should she hide somewhere? She rejected that plan as impracticable. The back way? But there was no outlet—only a small garden abutting on other back gardens. There was a dark side street only a few houses away. If she could only reach it. . . .")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She stood quite motionless, expecting the knocking to start again. But it did not. She thought she heard the shuffle of feet and husky whispers in the garden path underneath, but she could not be sure of that. What were they doing? Why were they so silent? “Suppose they got in through the window?” she whispered to herself. Her soul died within her at that thought. She tried to assure herself that the windows were locked, but her staring eyes peopled the invisible staircase with creeping figures. The darkness grew intense and terrifying, like a rushing black torrent flowing over her head. She was alone, in an empty world . . . The torrent ceased, and the darkness took the form of a great sable wing, moving, flapping, seeking to enfold her. She put up her hands to ward it off.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("At that instant a sharp and decisive sound reached her. It was the click of a shut gate. As she recognized the sound a new thought came to her—a hope, when hope seemed gone. She stepped noiselessly to the window and looked down. She was just in time to catch a glimpse of two retreating figures revealed in dark contour beneath the rays of the street lamp. The next moment they passed out of sight.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("They had gone! But they would return—she felt sure of that. She must get away at once before they did—run out of the door and make for the side street.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She listened for a moment longer. There was no sound anywhere now. The house was lapped in absolute quietness. She felt for her hat, and calming her nerves with a desperate effort, stole quickly from the room and downstairs. As she stood in the silent hall, facing the closed door, she again thought she heard whisperings. She recoiled in fear, wondering if they were outside, waiting. It was her worst ordeal yet. Then desperation conquered her terror. Her trembling fingers pulled back the bolt, and she issued forth.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("There was no one there to check her flight. The streets seemed empty. Without turning her head she ran past the houses which intervened between her and the side street. She gained it, and turned into its friendly darkness. She was as free as a bird again, for the moment.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("A kind of exultation seized her at this unexpected deliverance from her adventure, but that mood passed as she reflected upon her present position. She had left the house without her few belongings, and what was far worse, without her money, which she kept in a hand-bag locked up in her small case in the bedroom she had just left.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She had not a penny in the world, and she dared not go back.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("That was not the moment to reflect upon the grimness of her situation. The sound of approaching footsteps shaped her fears of capture into renewed action. She walked rapidly away.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The time was near midnight, and the streets were almost empty. She kept her way along dark obscure streets, shunning the lighted thoroughfares. She had no settled plan in her mind, except to keep on. Hers was the instinct of the hunted creature for darkness and obscurity. Her fevered spirit hurried her along, spurring her with the menace of an imprisonment which was worse than the cramped horror of the grave. In the grave there was no consciousness of the weight of the earth above, but in prison, held like an animal, watched by horrible men, beating despairing hands against locked doors—ah, no, no! Her free young body and soul revolted with nausea at the thought. Death would be better than that. She walked still more rapidly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("With that possibility impending she shrank from any chance contact with passers-by, turning into side streets to avoid any one she saw coming. Once, a policeman, appearing unexpectedly out of the shadows, set her heart beating wildly, but he passed by without looking at her.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It grew later, and the streets became quite deserted. She had been walking for more than an hour when she noticed that the houses were scattered, with open spaces now and then, and a bracing freshness in the air which suggested that she was getting away from where the herds of London slept, into open spaces. For some obscure reason this made her nervous, and she turned back. After a while London closed in on her again, but this time in a more squalid quarter, a wilderness of dirty narrow streets, where even in the darkness the debasing marks and odours of squalid poverty were perceptible in the endless rows of houses which seemed to crowd in upon her. She came to a bridge and crossed it into an area of gaunt and darkened factories. Here, strange nocturnal noises and sights frightened her. She saw shadowy forms, and heard rough voices on a wharf in the blackness of the river beneath her, followed by a woman’s scream. She ran when she heard that—ran along the riverside till she came to another bridge, which she recrossed. She found herself in a quieter and better part of London, where the streets were wide and well-kept, and she slackened her pace into a walk again.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The night wore on like eternity, with immeasurable slowness yet incredible swiftness. She had been walking for hours, and yet she had no feeling of fatigue. She seemed to move through the streets without any effort of her own. Towards the morning she was carried along with a complete absence of bodily sensation, as if she had been in very truth one of those disembodied spirits of Mrs. Johns’ spirit world, driven through the solitude of the ages by the implacable decree of some incalculable malignant force called immortality. She felt as though centuries of time had rolled over her head when the murk of the lowering sky lightened, and the London dawn was born, naked and grey.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The dawn brought London to life with a speed which was in the nature of a miracle. From the appearance of the first workers to the flocking of the streets, was, as it were, but a moment. The ’buses and trams commenced running, and shops opened. Sisily found herself walking along Holborn, where the thickening crowds jostled her as she walked. But she did not care for that now, nor did she seek the comparative seclusion of the side streets. Her fear of capture had passed away, and her only feeling was impenetrable isolation and loneliness. The people who were passing had no more existence to her than if they had been a troop of ghosts. She had the sensation of belonging to another world and could not have communicated with them if she had wished. But the spirit which had sustained her during the night disappeared with the clamorous advance of the day. She became in an instant conscious of the grievous pangs of a body which seemed to have been flung back to her in a damaged state. It ached all over. Her head throbbed with a dull buzzing sound, and she was so tired that she could hardly stand. She felt as if she must lie down—in the street, anywhere. And she was tormented by thirst. But she still kept on.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She found herself, after a while, by one of those little backwaters which are the salvation of strangers to London: a green railed square, with trees and fountains, and a quiet pavement where a street artist was drawing bright pictures with crayons. An old four-wheeler was moored in the gutter by the entrance, the horse munching in the depths of a nose-bag, the elderly driver reclining against the side of the cab, smoking and watching the pavement artist.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Sisily entered the empty square to rest herself. As she sat there on one of the wooden seats the full misery of her situation came home to her, and she asked herself anxiously what she was to do. She had nowhere to go, and no money to buy food or shelter—nothing in the world that she could call her own except the clothes she was wearing. They were the coat and skirt she had put on to come to London, and she noticed with feminine concern that the dark cloth showed disreputable stains and splashes of her night’s exposure. Hastily she took her handkerchief from her pocket to remove the tell-tale marks. As she did so a bit of buff cardboard fluttered on to the gravel at her feet. She stooped and picked it up. It was the return half of her ticket to Cornwall.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The remembrance of her arrival at Paddington revived in her as she looked at it—the fright she had had when the ticket collector caught her by the arm to return half of the whole ticket she had given up. She had put the ticket in the pocket of her jacket and never thought of it again. Had Fate decreed her original mistake of taking a return ticket when she needed only a single one? She was at that moment inclined to think so.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The question of its use was decided as soon as she saw it. The ticket would take her back to Cornwall and Thalassa. Thalassa would help and shield her.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The gilt hands of a church clock opposite the square pointed to half-past eight. She knew that the morning express for Cornwall started shortly after ten, but she did not know what part of London she was in or the direction of Paddington. Animated by a new hope, she left her seat and asked the cabman for directions.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The cabman looked at her with a ruminating eye. That eye, with unfathomable perspicacity, seemed to pry into her empty pockets and pierce her penniless state. He did not ask her if she wanted to be driven there, but intimated with a shake of his grey head that Paddington was a goodish walk. Then he gave her directions for finding it—implicit and repeated directions, as though his all-seeing eye had also divined that she was a stranger to the ways of London.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Sisily thanked him and turned away, repeating his directions so that she should not have to ask anybody else. First to the right, second to the left, along Tottenham Court Road to Oxford Street, up Oxford Street to Edgeware Road, down Edgeware Road to Praed Street—so it ran. She followed them carefully, and found herself on Paddington station a quarter of an hour before the departure of the express.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She entered a third-class carriage, but sat in a corner seat, longing for the train to move out. The minutes dragged slowly, and passengers kept thronging in. All sorts of people seemed to have business in Cornwall at that late season of the year. They came hurrying along in groups looking for vacant compartments. Sisily kept an eager eye upon the late arrivals, hoping that they would pass by her compartment. By some miraculous chance she was left undisturbed until almost starting time, then a group of fat women dashed along the platform with the celerity of fear, and crowded ponderously in. The next moment the train began to slip away from the station, and was soon rushing into the open country at high speed.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Of the details of that journey she knew nothing at all. She sat staring out of the window, her thoughts racing faster than the train. The events of the last few days receded from her mental vision like the flying houses and fields outside the carriage window, fading into some remote distance of her mind. Relief swelled in her heart as the train rushed west and London was left farther and farther behind. Something within her seemed to sing piercingly for joy, as though she had been a strange wild bird escaping from captivity to wing her way westward to the open spaces by the sea. London had frightened her. Its crowded vastness had suffocated her, its indifference had appalled her. She had felt so hopelessly alone there; far lonelier than she had ever been in Cornwall or Norfolk. Nature could be brutal, but never indifferent. She could be friendly—sometimes. The sea and the sky had whispered loving greetings to her, but not London. There was nothing but a hideous and blank indifference there. She was glad to get away—away from the endless rows of shops and houses, from the unceasing throngs of indifferent people, back to the lonely moors of Cornwall, to look down from the rocks at the sea, and breathe the keen gusty air.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("As the journey advanced and the train swept farther west she became dull, languid, almost inert. Lack of food and the previous night’s exposure induced in her a feeling of giddiness which at times had in it something of the nature of delirium. In this state her mind turned persistently to Thalassa, and the object of her return to him. She was struggling towards him, up great heights, under a nightmare burden. She seemed to see him standing there with his hands outstretched, ready to lift the burden off her shoulders if she could only reach him. Then she was back in the kitchen at Flint House, watching him bending over his lamps, listening to the wicked old song he used to sing—")]), _vm._v(" "), _c('p', {
    staticClass: "extract-flush-left"
  }, [_vm._v("“The devil and me we went away to sea, ")]), _vm._v(" "), _c('p', {
    staticClass: "extract-flush-left-space-after"
  }, [_vm._v("In the old brig ’Lizbeth-Jane. . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("The train caught up the refrain and thundered it into her tired head . . . “Went away to sea, went away to sea, In the old brig "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("’")]), _vm._v("Lizbeth-Jane.” And, listening to it, she fell into a dazed slumber.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She awoke with a start to find that it was getting dusk and the train was running smoothly through South Cornwall. As she looked out of the window a grey corpse of a hill seemed to rise out of the sea. It was Mount St. Michael. Then she caught a glimpse of Carn Brea and the purple moors. The people in the carriage began to collect light luggage and put on coats and wraps. The next moment the train came to a standstill at Penzance station.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She clung to the safety of the throng in passing through the barrier, fearing most the St. Fair wagonette which might be drawn up outside. She was not known in Penzance, but the driver of the wagonette might recognize her. But Mr. Crows, indifferent to shillings, had not yet arrived. Sisily hurried past a group scanning the distant heights for the gaunt outline of the descending cab, like shipwrecked mariners on the look-out for a sail.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She reached the moor road by a short cut through the back part of the town, and set out for Flint House in the velvety shadows of the early gloaming.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It had been raining, but the rain had ceased. The sun, hidden through a long grey day, shone with dying brilliance in a patch of horizon blue, gilding the wet road, and making the wayside puddles glitter like mirrors. A soddened little bird twittered joyfully in the hedge, casting a round black eye at her as she passed. The moors, carpeted with purple, stretched all around her, glistening, wet, beautiful.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("In the train she had felt hungry and tired, with burning head and cold limbs. As she walked these feelings wore off, and were replaced by a feeling of upliftment which was magical in its change. Her misery and her burden dropped from her. The softness of the moors was beneath her feet, and a sweet wind touched her lips and cheeks with a breath which was a caress. The plaintive distant cry of a gull reached her like a greeting. The solitude of Cornwall surrounded her.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("When she reached the cross-roads she struck out across the moors. Before her, at no great distance, she could see the swelling mountainous reaches of green water breaking on the rocks in a long white line of foam, and the dark outline of Flint House clinging to the dizzy summit of the black broken cliffs.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Her false strength failed her suddenly as she neared her journey’s end. The house loomed dimly before her tired vision in the fast gathering darkness. She stumbled with faltering steps round the side of the house to the kitchen door, and turned the handle. It was locked. She knocked loudly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("As in a vision she saw the white furtive face of Mrs. Thalassa peering out at her from the window, and her fluttering hands pressed against the glass, as though to thrust her back. Sisily rushed to the window.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Let me in!” she cried. “It is I—Sisily.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The window opened suddenly, and Mrs. Thalassa stood there looking out at her like a small grey ghost—a ghost with watchful glittering eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Go away—go away,” she whispered with a cunning glance. “Quick! They’re looking for you—they’ll catch you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Sisily’s heart went cold within her. “Where is Thalassa?” she faltered. “Send him to me—tell him I have come back.” Her eyes travelled vainly around the gloom of the empty kitchen in search of him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“He’s gone—gone away!”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Gone? Oh, no, no! Don’t say that. Where has he gone?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I don’t know. He went away. He’s not coming back.” She shook her head angrily, with a wild gleam in her eye. “You go away, too, or they’ll catch you—the police. They come every night to look for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She cast another cunning look at the girl, and shut down the window. Sisily could see her reaching up and fumbling with the lock. Thalassa gone! Despair clutched her with iron hands, and held her fast. She glanced up at the window of her father’s study, and thought she saw the dead man there, his stern face looking coldly down upon her. She turned away shuddering. Where could she go? She had nowhere to go, and she knew her strength would not carry her much farther.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She plunged blindly into the shelter of the great rocks near the house. She found herself wandering among them like a being in a dream. Then complete unconsciousness overtook her, and she sank down.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("When she came to herself again night had descended and a storm was brewing. She sat up wonderingly and looked around her, indifferent to the rain which had commenced to fall on her uncovered head. Gradually remembrance came back to her. She saw that she was lying on the great slab of basalt which overhung the Moon Rock. She could hear the beat of the sea far beneath her, but she felt no fear. She was not conscious of her body or limbs—of nothing but a burning brain, and wide-open eyes which gazed out into the darkness and stillness around her.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("As she looked it seemed to her startled imagination that the masses of rocks which littered the edge of the cliff moved closer to each other, starting out of the shadows into monstrous grotesque life, then circling round her in a strange and dizzy whirl. It was as though the old Cornish giants had come back to life for a corybantic dance with the demirips of their race—dancing to the music of the sea sucking and gurgling into the caves at the base of the cliffs. With swimming eyes Sisily watched them careering and pirouetting around her. Faster and faster they went, advancing, retreating, bending clumsily, then wavering, toppling, reeling, like giants well drunk. A great stone fell into the sea with a splash, as if dislodged by a giant foot. As though that signalled the cockcrow of their glee, the dancers stopped in listening attitudes, and sank back into rocks once more.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Sisily turned her eyes weakly from the slumbering rocks to the hills. The light of a coming moon behind them showed the outline of the granite pillars and stone altars of the Druids, where they had once sought to appease their savage gods, like the Israelites of old. Sisily had often meditated by these places of sacrifice, trying to picture the scene. Now, as she looked, it was enacted before her eyes. A red light brooded on one of the hills, growing brighter and brighter. Brutish shaggy figures came out of the darkness, dragging a youth to the altar. Sisily saw him distinctly. He was naked, with a beautiful face, haggard and white, and was bound with cords. Suddenly he freed himself, and dashed down the slope into the darkness. He was pursued and brought back, and the cries of his pursuers mingled with an appalling scream for help which seemed to float down the mountain side to where she lay, filling the silent air with echoes.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("This scene, too, faded away, and the beams of the rising moon, now beginning to show over the hill-tops, formed in her mind the mirage of a beautiful day—one of those exquisite days which Nature produces at long intervals. Sisily saw a blue sky, sunlight like burnished silver, green fields and clear pools in which everything was reflected . . . a slumbrous perfect day, with drowsy cattle knee-deep in grass, bees, and floating butterflies, and the shrill notes of happy birds.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Once more the tangled loom of her fevered brain wove a new picture. She was back in her bedroom at Flint House, looking down at the graven face of the Moon Rock. As she looked, a great hand seemed to come out of the sea and beckon to her. The summons was one she dare not disobey. She left her bed, crept downstairs in the darkness, out to the edge of the cliff, and looked down. The face of the Moon Rock was watching her intently. She thought it called her name.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Ah, what was that cry? She came to her senses, startled, and looked fearfully round her. She was alone on the cliffs, above the Moon Rock, and she could hear the sea hissing at its base. But what else had she heard? Had somebody called her name? It was still very dark. To the south the light of the Lizard stabbed the black sky with a white flaming finger as if seeking to pierce the darkness of eternity. Nearer, the red light of the Wolf rock gleamed—a warning to passing souls flying southward from England to eternal bliss to fly high above the rock where the spirit dog lay howling in wait. Had the cry come from there?")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Sisily! Sisily!”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("No. It was not the howl of the Wolf dog that she had heard. That was her own name. She crept closer to the edge of the cliff and looked down into the sea—down at the Moon Rock. The old Cornish legend of the drowned love came back to her. Was Charles dead? and calling her to him? She would go to him gladly. She had loved him in life, and if he wanted her in death she would go to him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("She clutched a broken spur of rock on the brink and looked down to where the sea bored round the black sides of the Moon Rock. She could see her own pool too, lying peaceful and calm in the encircling arm of the rock. In her delirium she struggled to her feet and started to climb down the face of the cliff.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer033"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-33"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor032"
    }
  }), _vm._v("Chapter XXXII")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("The wind tapped angrily at the windows of Flint House, the rain fell stealthily, the sea made a droning uneasy sound. The fire which burnt on the kitchen hearth was a poor one, a sullen thing of green boughs and coal which refused to harmonize, but spluttered and fizzed angrily. The coal smouldered blackly, but sometimes cracked with a startling report. When this happened, a crooked bough sticking up in the middle of the fire, like a curved fang, would jump out on to the hearthstone as though frightened by the noise.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa sat on one side of the fire, his wife on the other. Her eyes were rapt and vacant; he sat with frowning brows, deep in thought. Robert Turold’s dog crouched in the circle of the glow with amber eyes fixed on the old man’s face as if he were a god, and Thalassa lived up to one of the attributes of divinity by not deigning to give his worshipper a sign. Occasionally the dog lifted a wistful supplicating paw, dropping it again in dejection when it passed unregarded.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Presently Thalassa got up and went to a cupboard in the corner. From some hidden receptacle he extracted a coil of ship’s tobacco and a wooden pipe shaped into a negro’s head, with little beads for eyes, such as may be bought for a few pence in shops near the London docks. He returned to his seat, filled the pipe, lit it with a burning bough, and fell to smoking with lingering whiffs, gazing into the fire with dark gleaming eyes as motionless as the glinting beads in the negro’s carved head.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The clock on the mantel-piece ticked steadily away in the silence. The dog, with a brute recognition of the unsatisfactory nature of spiritual aspiration, descended to the care of his own affairs, and scratched for fleas which knew no other world than his hind-quarters.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Go away, go away! You mustn’t come in here!”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The shrill voice of Mrs. Thalassa broke the silence like a cracked bell, shattering her husband’s meditations, and causing the dog to spring to his feet. Thalassa looked at her angrily. She was making mysterious motions with her hands, as if expostulating with some phantom of her thoughts, muttering and shaking her head rapidly. Her husband stared across in silence for a moment.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“By God! she doesn’t improve with age,” he growled; then, louder: “What’s the matter with you? What are you making that noise for?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The question went unheeded. To his astonishment she sprang to her feet with a kind of grotesque vivacity, and, darting over to the window, began gesticulating again with an angry persistency, as if to some one outside.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa left his seat and went to the window also. His wife had ceased her gestures, and stood still listening and watching. Thalassa pulled back the blind, and looked out. The moor and rocks were draped in black, and the only sounds which reached him were the disconsolate wail of the wind and the savage break of the sea on the rocks below. He looked at his wife. She had started tossing her hands again at some spectral invisible thing in the shadowy night. She was quite mad—there could be no doubt of that. He endeavoured to lead her back to her seat by the fireside, but she broke away from him with surprising strength, and again her voice rang out—")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Go away . . . go away! You can’t come in. I won’t let you in. You’re a wicked girl, Miss Sisily, and I won’t let you in. You killed your father, and you’d like to kill me, but I’ll keep you locked out. Go away!” Her voice rose to a screech.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The blood rushed to Thalassa’s head as he listened to these words. He understood quite suddenly—this was not a demented raving. Sisily had been there—she had come back to him in her fear—and she had been driven away. He turned to his wife and caught her up in his great arms, shaking her violently, as one shakes a child. The sight was terrible and absurd, but there was no one to witness it but the dog, who circled round and round in yelping excitement, as though the scene was enacted for his benefit alone.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Has Miss Sisily been here?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The question thundered out in the empty silence. Mrs. Thalassa crouched like a preposterous hunched-up doll on the seat where her husband had flung her, looking up at him with stupid eyes, but not speaking. He approached her again.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Speak, woman, speak, or I’ll strangle you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She backed away, whimpering with fear. “No, no, Jasper, leave me alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Has Miss Sisily been here?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The sight of those long outstretched hands, by their menace to her life, seemed to restore her reason. “Yes,” she mumbled.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“When?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“This evening—before dark—when you were out.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“And you wouldn’t let her in?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“How did you know it was her?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“She knocked at the door, and I looked out of the window.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Did you see which way she went?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Over by the cliffs, where she used to go.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa repeated these last words mechanically. Anger possessed him, but apprehension stirred in his heart. Sisily had trusted him, she had come back to him, and he had failed her. That had been at six o’clock, and it was now nine. Three hours, and there had been a storm. Where was she? Had she been out in the storm?")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He searched in the cupboard for a lantern, lit it, and made for the door, followed by the dog. As he flung open the door the wind rushed in with such force that it beat him back, and the candle in the lantern flickered and lengthened like a naked flame. He fought his way out furiously, slamming the door behind him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Outside, the rocks crouched in the darkness in nameless shapes. Thalassa prowled among them, struggling desperately with the wind, telling himself that she was safe—yes, by God, she was safe. Of course she wouldn’t stay on the rocks in that storm. She would seek shelter. “Where?” asked something within him mockingly, “Where would she dare go, except to you?” He stood still to reflect. “She might go to Dr. Ravenshaw’s,” he said aloud, as though answering an unseen but real questioner. “Fool!” came the reply, “you know she would not go to Dr. Ravenshaw’s. She would not dare.” And fear gripped his heart coldly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He stumbled on again, bruising and cutting his limbs among the rocks. As he went he kept calling her name—“Miss Sisily” at first, and then, as his fear grew stronger, “Sisily, Sisily!” The wind wailed back to him, but that was all.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He stopped again to reflect. It was useless looking for her in the darkness. He could do nothing until the moon was up. The sky was already beginning to brighten with the coming light. So he stood where he was, waiting.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("In a quarter of an hour the moon showed above the horizon, slurred through the rain, like a great drowned face. Higher and higher it rose until the black curtain lifted off the moors, and the light shimmered on little pools left after the rain, made fretwork in the shadows of the rocks, and fell upon the surface of the sea. And as the moon rose the hideous uproar of wind and sea began to die away.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa threw down the lantern, and resumed his search. Carefully he explored in and out among the rude masses of rock, beating farther and farther away from the house, cautiously skirting the perpendicular edge of the cliffs, looking over, and backing away again. His wider cast brought him at length to where the Moon Rock rose from the turmoil of the sea. He crept on hands and knees to the bald face of the cliff, and looked down.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("By the light of the moon something caught his eye far below—something white and small, showing distinctly against the black glistening base of the Moon Rock. He could not discern what it was, but a nameless terror seized him, and his jaw dropped as he crouched there, gazing. Then he scrambled to his feet with a wild cry, and made for the path down the cliffs to the pool. It was some distance from where he was, but there was no shorter way. He rushed recklessly along the cliff edge till he reached it, and climbed down.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("It was there he found her.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She was lying limp and motionless on the edge of the pool, and the receding tide was still lapping over the shelf of the rock where the sea had flung her.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa dropped on his knees beside her. “Sisily, Sisily!” he cried hoarsely—“It’s me—Thalassa!”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He stooped over her, calling her repeatedly, but she did not reply. Her face showed still and white in the moonlight. He unfastened the front of her dress, and put his hard hand on her soft flesh, but he could not feel her heart beating. He lifted her tenderly in his arms, and she lay against his body inert and cold, her wet head resting on his shoulder. Thus he started the ascent of the cliff.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("A giant’s strength still lurked in his ageing frame. It was well for him that it did. He had only his feet to depend upon in that long slippery ascent, and the wind tugged at him angrily, as if anxious to jerk him off the path into the sea. But he fought his way up with his burden, though his body was swaying and his head was dizzy when he reached the top.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He did not stop for a moment. Still holding her fast he set out, not for Flint House, but to the churchtown. Dizzy, panting, and staggering, he struggled on across the moors, and as he walked he listened anxiously for any sound from the inanimate form in his arms.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("But she lay still and motionless against his breast.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("On he went until he reached the churchtown, and made his way up the empty street to Dr. Ravenshaw’s house. He turned in the garden gate, and beat with his heavy boot against the closed door.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer034"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-34"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor033"
    }
  }), _vm._v("Chapter XXXIII")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("Some one stirred within, and a ray of light in the fanlight grew bright as footsteps in the passage drew near. The door opened, and showed the figure of Dr. Ravenshaw holding in his hand a lighted lamp which shone upon Thalassa and the dripping figure in his arms. The doctor looked down from the doorstep in silent surprise, then stepped quickly back from the threshold and opened the surgery door, holding the lamp high to guide Thalassa in.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“There—on the couch,” he said, placing the lamp on the table. “What has happened?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Miss Sisily fell over the cliffs by the Moon Rock. I found her and carried her up, and brought her straight here.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The doctor’s quick glance was a professional tribute to the strength of a frame capable of performing such a feat. He turned his attention to Sisily, bending over her and feeling her pulse. With a sharp exclamation he dropped her wrist and tore open the front of her dress, placing his hand on her heart. With his other hand he took up his stethoscope from the table.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Bring that lamp closer—quick!” he cried.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa lifted the lamp from the table and stood beside him. The yellow glow of the lamp enveloped the livid bluish features of Sisily and the stooping form with the stethoscope. The instrument of silver and rubber held miraculous possibilities of life and death to Thalassa. He watched it anxiously—directed the light upon it. The shape on the couch remained motionless.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa’s gaze wandered from the stethoscope to Dr. Ravenshaw. The doctor’s bent neck showed white between the top of his shirt and the grey hair above it. He was wearing no collar, so he must have been going to bed—when the knock came. Thalassa’s eyes dwelt on the exposed flesh with a steady yet wondering contemplation. The lamp in his hand wavered slightly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Dr. Ravenshaw rose to his feet, oblivious of the man who was staring at his neck from behind. His downward glance rested on Sisily’s face, and his eyes were grave. He turned away and walked out of the room, but returned almost immediately with a small mirror.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Hold the lamp higher,” he said to Thalassa. “I want the light to fall right on her face. Higher still—so.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He fell on his knees by the couch and held the mirrored side of the glass to Sisily’s lips. The lamp, held aloft, illumined his face as well as hers. His features were set and rigid.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa stood still, his eyes brooding on the sharp outline of the bent mask. A vague idea, startling and terrible, was magnifying itself in his mind. Once his glance wandered to Ravenshaw’s neck, then returned with growing fixity to his face, seen at closer range than he had ever beheld it. In the vivid light the elemental lines beneath the changes of time took on a strange resemblance to a face he had known in the distant past. A spectral being seemed to rise from the dead and resume life in the kneeling body of Dr. Ravenshaw.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Involuntarily he stepped back, and the likeness vanished in the added distance. The veil of the past was dropped again. He could see nothing now but the commonplace whiskered face of an elderly Cornish doctor bending over the inanimate form on the couch. Again the lamp shook slightly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What are you doing with that light?” said Ravenshaw peevishly. “Cannot you hold it steady? Bring it closer, man—closer than that. Now, hold it there.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("In the nearer vision the elemental lines of a forgotten face again confronted Thalassa beneath the flabby contours of age. It was like looking at a familiar outline covered by a mask—a transparent mask. He stood stock still with uplifted lamp, like a man in a trance, but his eyes never left Dr. Ravenshaw’s face.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Some minutes passed silently before Dr. Ravenshaw withdrew the mirror from Sisily’s lips. He turned it over and looked closely at the surface of the glass. The man behind him stared over his shoulder. Their eyes met in the mirror, and held for a moment fascinated. In that brief space of time the revelation and recognition were completed. Dr. Ravenshaw’s glance was the first to break away. The hard brown eyes watching him followed the direction of his view to a pair of spectacles resting on the table. Thalassa understood the intention, and harshly forestalled it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No use to put on your glasses now,” he said. “I recognize ye, and I’ve seen that damned scar on your neck.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("He put the lamp back on the table, and his hand went towards his belt. Ravenshaw understood the motion and checked it with a gesture.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No need for that, either, Thalassa. There are other things to think about.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa’s hand dropped to his side. “You’re right,” he muttered. “Get on with your doctoring.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No—not now,” answered Ravenshaw sadly. “It’s no use. She is dead.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Dead!” Thalassa stood overwhelmed. Silently he surveyed the slight recumbent form on the couch, his moving lips seemed to be counting the drops which dripped from her clinging garments on to the carpet. “Dead, did ye say? Why, I carried her here—brought her across the moors to you.” His voice trembled. “Can’t ye do nothing?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No—not now. It is too late.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa’s eyes rested attentively on the other’s face. Ravenshaw’s complete acquiescence in death as an unalterable fact stung his untutored feelings by its calmness. “Dead!” he repeated fiercely. “Then you’ve got that to pay for now—Remington.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Pay? Oh, yes, I’ll pay—make payment in full,” was the reply, delivered with a bitter look. “But not to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“To think I shouldn’t a’ known ye!” Thalassa spoke like a man in a dream.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“After all these years? After what I suffered alone on that island—through you and Turold? You’d hardly have known me if you’d met me six months afterwards instead of thirty years. Robert Turold didn’t know me. Nobody knew me.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa’s eyes still dwelt upon him with the unwilling look of a man compelled to gaze upon an evocation of the dead.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Where did you get to—that night?” he quavered. “I could a’ sworn—could a’ taken Bible oath—”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That you and that other scoundrel had killed me? I’ve no doubt. But it so happened that I was saved—miraculously and unfortunately. I fell on to a projecting spur of stone or rock not far down, which caught and held me. By the light of the moon I saw you come along the ridge to look for me. You were almost close enough for me to push you into that infernal sulphur lake where you hoped I had gone. You turned back in time—fortunately for yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa kept his gaze upon him with the meditating intentness of one trying to learn anew a face so greatly altered by the awful changes of the years. His great brown hands, hanging loosely at his sides, clenched and opened rapidly with a quickness of action which had something vaguely menacing in it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I know your eyes now,” he mumbled. “With the glasses on, you’re different. That’s why ye wore them, I suppose. Turold heered ye that night you killed ’un. He knew your footstep—or thought he did. I laughed at him. A’ would to God A’mighty I’d hearkened to him, and then I might a’ catched you. How did ye get away from the island?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Ravenshaw raised his head to reply, then stood mute, in a listening attitude. Outside the window the sound of footsteps crunched the gravel walk, and approached the house. Thalassa heard and listened too. The crunching ceased, and there was a knock at the door. Thalassa looked questioningly at Ravenshaw, who nodded in the direction of the door.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Open it,” he said. Thalassa hesitated. His eyes sought the couch. “Yes, in here,” said Ravenshaw understandingly. “We shall want witnesses.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Thalassa went to the door and opened it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("A man’s voice in the darkness asked for Dr. Ravenshaw, and the owner of the voice stepped quickly inside at Thalassa’s invitation. The visitor peered at the tall figure in the unlighted passage. “Is it you, Thalassa?” he said hesitatingly, and Thalassa recognized the voice of Austin Turold. The voice went on: “Tell me—”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“In there.” Thalassa jerked his head towards the gleam falling through the partly open surgery door. “He wants you.” He walked ahead and pushed the door open. Austin Turold followed, but started back as he looked within. Then he entered, his eyes dwelling on the shadowy outline on the couch in the corner.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What has happened at Flint House, Ravenshaw? Now—to-night, I mean.” He spoke shakily. “There’s a story abroad of Thalassa having been seen carrying a figure through the churchtown and entering your house. Has somebody fallen off the cliffs—been drowned? Is that it?” He stepped quickly across to the couch, and, looking down, as swiftly recoiled. “What does this mean?” he hoarsely cried.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Ravenshaw did not speak.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Miss Sisily fell over the cliffs by the Moon Rock,” said Thalassa. “I went down for her, but it was too late. She was drowned.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Austin’s look sought Ravenshaw’s, who nodded in confirmation.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“More horror—more misery,” whispered Austin. A shudder ran through him. “I do not understand,” he said simply. “Thalassa?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It’s not for me to explain,” said Thalassa quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You then, Ravenshaw.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Ravenshaw spoke slowly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“They have been looking for the man who killed Robert Turold—your brother. Well, I am he.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You!” gasped Austin, in a choking voice. “What do you mean? I do not understand you. My son has been arrested.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“He has been arrested wrongly, then. It is I—I alone am responsible.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Austin groped for his glasses like a man suddenly enveloped in darkness. His fingers closed on them and adjusted them on the bridge of his nose. Through them he surveyed the man before him with close attention.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Ravenshaw,” he said gravely, “either you are mad or I am. Did not my sister call here to see you on the night my brother was killed, and did you not go with her to Flint House and break into my brother’s room? How, then, could you have killed Robert? Besides, I saw my son at Penzance to-day. He tells me he is innocent, and that the murderer is a man whom Robert and Thalassa robbed and wounded on a lonely island thirty years ago, and left there for dead, as they thought. What does it all mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“These things can all be explained,” replied Ravenshaw. “It is a long story. Sit down, and I will tell it to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Not here—not here!” replied Austin unsteadily. His glance went to the corner of the room and the tranquil figure on the couch. He hid his face for a moment in his hands, then said: “Let us go to another room.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Ravenshaw made a sad gesture of acquiescence. “Come,” he said quietly, lifting the lamp from the table. The other two followed him, and Thalassa closed the surgery door gently behind them. The doctor led them into a sitting-room opposite, where they seated themselves. After a moment’s silence Ravenshaw began to speak in low controlled tones which gave no indication of the state of his feelings.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You know all about this island part of the story,” he said, inquiringly, “how your brother and Remington, seeking their fortune together, came to be there?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Austin Turold nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I am Remington,” pursued the other. “I will take up the story from that point—it will save time.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("Again Austin Turold assented with a nod. There was neither anger nor resentment in his glance. The look which rested on the speaker was one of unmixed amazement.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer035"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-35"
    }
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor034"
    }
  }), _vm._v("Chapter XXXIV")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_vm._v("“I will pass over as briefly as possible what happened after I was left behind in that horrible place. By the light of the moon I saw them go—from the ridge I saw them put out to sea. I watched them until the boat was a mere speck on the luminous waters, and finally vanished from sight. I was left alone, a desperately wounded man, on an arid sulphurous island, without food or water.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“When I was sure the boat had gone I returned to our camping place, and bound my wounds with strips torn off my shirt. Then I fell asleep. I must have developed fever in my slumber, for I have no clear recollections of the next few days. I vaguely recall roaming like a demented being among those solitudes in search of water, and finding a boiling spring. The water, when cooled, was drinkable. I suppose that saved my life. For food, there was shell-fish and mutton-bird eggs, with no lack of boiling water to cook them.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I lived there so long that I forgot the flight of time. I became a wild man—a mere shaggy animal, living, eating, and sleeping like a beast.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I was rescued by a passing steamer at last, rescued without any effort of my own, for I had gone past caring. From the ship they saw me leaping about the naked sides of the volcanic hills like a goat, and they put off a boat. Some lady passengers were badly scared when I was brought aboard—and no wonder. They were very kind to me on that ship. She was homeward bound, and brought me to England. I told the captain my story, but I could see that he didn’t believe me, so I told nobody else. Not that anybody wanted to know—really. One’s misfortunes are never interesting to other people.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I had a little money left when I landed in England—not much, but sufficient to take me to my wife and support me until I found Robert Turold. I had left my wife living with her parents in a London suburb. Robert Turold and I had both been in love with her before we left England. She loved me, but he had some strange kind of influence over her—the dominance of a strong nature over a weak, I think. Or perhaps it was a more primitive feminine instinct. He was always the strong man—even then—ruthless, determined. It was strange that he should have loved such a gentle timid creature, though that, perhaps, was not so strange as a man like Robert Turold loving any woman. But love her he did.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“She had a great capacity for affection—she was one of those women who have to love, and be loved. Her guileless face, her appealing eyes, seemed to beseech the protection of a masculine shield in a world which has no mercy for the weak. She was born to be guided, to be led. It was my fear of her simple trustful disposition which led me to urge her to marry me secretly before I left England with Turold. Her parents did not favour me, and they wished their daughter to marry well—there was an aunt from whom she had expectations, and the aunt had a prospective husband in view for her. I feared their joint influence. She consented willingly enough; she was easy to persuade—on the eve of our parting. She clung to me weeping—her husband.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I was to make enough money to return to England to claim her in a year or so—that was the plan. But I had been absent nearly three when I was left on the island. And another twelve months passed before I reached England again. Four years! A long time. Almost any combination of circumstances can "), _c('br'), _vm._v("be brought about in such a period. People die, marry, or can be forgotten as though they had never existed. It was my lot to be forgotten.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I hastened to London, to my wife’s old home, and learnt that the family no longer lived there. Where had they gone to? The maid who opened the door could not tell me—she did not know. At my request she went for her mistress. The lady of the house came down to me, a tall slender woman, indifferent, but well-bred enough to be polite. She had taken the house from the Bruntons, she said. It was too large for them after their daughter’s marriage. It was dusk, and she could not see my face, but she heard my startled exclamation—‘Married? To whom?’ To a Mr. Turold—a very suitable match. They had been married for some months, and she was expecting a child.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“How she gathered that last piece of information I do not know. Perhaps she and Mrs. Brunton exchanged letters—women write to one another on the slightest pretexts. That thought made me cautious. Fortunately, I had not given my name. I thanked her, and rose to go. She offered to write down the Bruntons’ address for me (they had gone to live in the country), but I said I could remember it. And I got away from the house in the gathering darkness without her actually seeing my face—not that it would have mattered much, if she had.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I thought it all over that night. I visualized readily enough what had happened. Robert Turold, returning to England with some concocted story of my death, had swept her off her feet, caught her on the rebound. He had returned a prosperous man, and doubtless his love-making was reinforced by Alice’s worldly parents and the match-making old aunt. The combination was a strong one, and I was supposed to be dead. So she married him, without breathing a word to anybody of her previous secret marriage to me. I realized that at once. She would be too afraid—left to herself. She would tell herself that it wasn’t worth while—that nobody need ever know now. I could imagine her twisting her little hands together in apprehension as she faced the problem—our secret—then gradually becoming calmer as something whispered in her ear that it was her secret now, and need not be told. You see, I knew her nature so well. There are many such natures—gentle souls who shrink from responsibility in a world which, sooner or later, generally sees to it that we are compelled to shoulder the burden of our own acts.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I was not long in making up my mind. I determined to do nothing. I take no special credit to myself for that decision. The marriage with Robert Turold was an accomplished fact, and my belated reappearance upon the scene would have plunged her in unhappiness. She was about to become a mother, too. That weighed with me. I loved her far too well to injure her or her child. It meant letting Robert Turold go free if I remained dead, but there are other things in life besides money and revenge. Fortunately the position from the practical point of view was simplified by the death of my only relative, my uncle, during my absence from England, who had bequeathed his small property to me—not much, but sufficient for my own simple needs.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I took my uncle’s name, the better to conceal my identity, and resumed the medical studies which had been interrupted by my departure from England four years before. When I received my degree I searched for a remote spot where I was not likely to encounter any one who had known me in my past life, and chose this lonely part of the Cornish coast. And here I have remained for thirty years.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“They have not been unhappy years. It was not my disposition to waste my life by hugging the illusions of the past. My days were occupied walking long distances to see my patients scattered at distant intervals on this desolate coast, and my nights I spent in antiquarian and archaeological studies, which were always a favourite pursuit of mine. It was a hobby which earned me some local repute in the course of the years, and was ultimately the means of bringing me face to face with Robert Turold again. That was the last thing in the world I desired to happen. In the early years I used to think of him wedded to my wife, and wonder whether he had succeeded in his great ambition. After a while the memory faded, as most memories do with the passing of the years.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Then the meeting came—six months ago. I heard Flint House was let, though not to whom. The news did not interest me. But next evening, when I returned from my rounds, my servant met me at the door with the information that the new tenant of Flint House was in the consulting-room waiting to see me.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I went in. The tall elderly figure sitting there rose at my entrance and said: ‘Not a patient, doctor—quite another matter.’ I started slightly at the familiar ring to that harsh authoritative voice, but I did not know who he was until he handed me his card. He had already commenced talking about that accursed title as he did so, and he did not notice my agitation. He had come to Cornwall in pursuit of the last pieces of evidence for his family tree, and some local busybody had told him that I was versed in Cornish antiquities and heraldry. That piece of information had brought him to me. He begged for my assistance—my valuable assistance—in elucidating the last scraps of his genealogy from the graves of the past.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I could have cut him short by laughing aloud—though not in mirth. I had regained my self-command, for I saw that he had not the slightest suspicion to whom he was talking. That in itself was not surprising. I had not recognized him. And how much greater was the change in my own case! Time alters us all in a much less period than thirty years, and there was more than the passage of time. Those months of horrible solitude on that island had changed me into an old man in appearance, with grey hair, and bleared and weak eyes from the sulphur fumes. And Time had made the disguise impenetrable in the thirty added years. I was an old man. My hair and beard were white, and I wore thick glasses. I felt I need be under no apprehension of Robert Turold recognizing me—then, or at any time, unless I was careless.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“His request for my help had a strange fascination for me. There was an uncanny thrill in sitting there within an arm’s length of him, meeting his unsuspicious glance, and listening to him with the knowledge that I could have put his plans and ambitions to flight with a single word, and had him begging for mercy. I was in the position of Providence, and withheld my hand, as Providence generally does. My desire to punish Robert Turold had long since died. At sixty, revenge is a small thing. What is human retribution to the ferocity of Time’s revenge on us all? Retribution and Justice—these are human catchwords, signifying nothing. What is Justice? Who is to judge when the scales are even? It was easier to comply with his request than arouse suspicion by refusal, but that wasn’t what weighed with me. I wanted to see more of him, to win his confidence, if possible. I was curious to know what kind of life he had given the woman for whose sake I had let him go free for thirty years.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“He took a liking to me. My knowledge of ancient Cornish lore proved useful in the final stages of his search—his thirty years’ search for a family tree. It was not long before I discovered that he had found no happiness in life. At times his face wore a hunted look—the look of a man who walked his days in fear. His imperfect vision peered out on a darkened world with apprehension, though not of me. In my strange position with him I felt like a ghost permitted to watch, unseen and unsuspected, the travail of a gloomy solitary mind. It was apparent enough, but only to me. My quickened eyes pierced the outward husk and saw within. I thought I had outlived my desire for revenge, but it grew again at the sight of a punishment which was so much more subtle than anything I could have planned. Death would have put his restless soul to sleep, granted him eternal respite. The sufferings of the spirit were a living torment. His was a strange case. His lifelong pursuit of a single idea, his restricted consciousness of one image, had made him morbid, lonely, introspective. And so the past had revisited him, darkening and disquieting his mind. He feared shadows, he was haunted by footsteps.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Footsteps! I learnt that when he consulted me for sleeplessness. He told me he used to lie awake at night, imagining he heard footsteps pattering on the rocks outside. I knew well enough whose footsteps he was haunted by. I imagined him lying there in that lonely house, sweating with horror, listening . . . listening. He asked me once, did I believe in ghosts? I told him no, but I said I’d known a case of man returning to life long after he was supposed to be dead. I related the story—one which had come under my observation as a medical man. He listened with gnawing lip and pale face, and from my window afterwards I saw him striding home across the moors, glancing backwards in the dusk.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It was his own fault that he ever heard those footsteps in the way he feared. He did not play the game, according to our poor conception of what the game is. If he had done so he would have been quite safe from me. But there are some things too shocking to be contemplated, even in the worst of our kind. A man does not give away a woman—that is one of the rules. Robert Turold put a woman to shame in her coffin.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I had kept out of her way, never going to Flint House because I feared her feminine eyes might be too sharp for me. But she fell ill, and Robert Turold asked me to attend her. Refusal was impossible, as there was no other doctor nearer than Penzance.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“She did not recognize me—at first, but the shock I received when I saw her left me almost stunned. I had carried her memory through the years—the image of a pretty slim girl, with brown hair and eyes, and kind of soft vivacity which was her greatest charm. In her place I found, lying there, a withered grey woman with dim eyes and broken spirit. God knows what she had gone through at his hands, but it had destroyed her.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It was her death-bed. She was worn out in body and spirit, and had no strength to rally. She was weeks dying, but her life was steadily ebbing all that time. It was a kind of slow fever. She was delirious when I first saw her, and delirious or unconscious, with few lucid intervals, until she died. And the jargon of her wandering mind was in reality the outpouring of a tortured soul. It was the title and the family name—always that, and nothing else. She wasn’t well-born enough or sufficiently educated to bear the title as his wife—it seemed that that fact had been impressed on her again and again in the long lean years of the search for the family tree. Let her go away . . . go away somewhere quietly with Sisily, and she would never bother him any more. That was the unceasing burden of her cry, a cry to which I was compelled to listen with a torn heart.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“The reserve, the frame of mind, which I wore like armour in Robert Turold’s company I dropped altogether at her bedside. Her lucid intervals were few, but I was not afraid of her recognizing the old Cornish doctor with his muffler, his glasses, his shaggy white hair and beard. The daily sight of her shrunken ageing features reminded me that I had nothing to fear—that Time had effectually disguised us from each other’s recognition. We were old, we two. Life had receded from us—what had we to do with its fever, its regrets, its passions and futile joys? The clock had ticked the time away, the fire was dying out, the hearth desolate and cold. I was resigned before, I was resigned then. I did what I could for her, which was little enough. Human progress, such as it is, has been acquired through the spirit. The body defies us—we have no control over it. So she died—mercifully"), _c('br'), _vm._v(" unconscious most of the time—and died, as I had hoped, without the least suspicion of the truth.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You cannot faintly imagine the shock of Turold’s announcement on the day of her burial, to me, who had been so arrogantly certain that the secret was safe. If you remember what took place at Flint House on that occasion you will recall that it was a question from me which brought the truth to light. Your brother’s answer awakened my suspicions, and made me determined to find out what he actually knew. He brought out the truth then, as I’ve no doubt now he intended to do in any case.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“The puzzle to me was the exact extent of his knowledge. He knew two things for certain. One was that I had married Alice before leaving England, and the other was that I was still alive. But he obviously did not know that I was Remington. How had he found out the two facts? I guessed that the woman he believed to be his wife had revealed the secret of her earlier marriage on her death-bed, but the other was a problem which I could not solve. Nor did I try to. When I reached home I went mad. The calmness, the self-repression of thirty years, vanished in an instant in the monstrous infamy of that disclosure. There was something too horribly sinister in the character of a man who could be driven by ambition to make such a disclosure without regret, almost without hesitation. He sacrificed and put to shame two gentle creatures at the beck of his implacable mania. For the title he had forfeited tenderness, pity, decency—all the human attributes—with a brazen and unashamed face. That man walked the earth alone. By that act he set himself apart, defying all laws, all feeling—everything.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“As I grew calmer I reflected that he could not defy me. I could bring him tumbling from his lofty perch with a few words. He might brazen out his attitude to the whole world, but not to me. What was more, I could dictate to him—could keep his mouth shut with a threat of reviving the past, of putting him on his trial for robbery and attempted murder thirty years before.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I determined to do it—to see him and reveal myself, and let him know that my own course of action would be decided by his. If he chose to keep silent, he would have nothing to fear from me.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I set out across the moors in the darkness. It was raining, and I walked fast until Flint House loomed out of the blackness before me. Then I paused to consider my course of action. I was about to thwart a madman with a fixed idea, in a lonely house where he had in his service another man who could be depended on to make common cause against me when he knew the truth. I was not afraid of Robert Turold, but I was of Thalassa. I knew he was strong enough to hurl me through the window into the sea. These elements in the situation called for caution. I crept across the rocks towards the kitchen window. As I did so I thought I saw a figure move among the rocks, and I ran quickly to the narrow lip of cliff which overhangs the sea at the back of the house. There I stood for awhile, but could hear nothing but the sea raging far down beneath me. I came to the conclusion that I had been mistaken. Who was likely to be prowling round Flint House in a storm—except myself? I crept round the side of the house and looked through the kitchen window.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Thalassa’s wife was in the kitchen, alone, with some playing cards spread out on the table in front of her. But before long the door leading into the passage opened, and Thalassa came in. He sat down, but after the lapse of a few minutes he rose from his chair and approached the window. I shrank back into the shadow of a rock, watching him. He stood looking out into the darkness for perhaps five minutes, then I saw him start, turn his head, and go out of the room. I heard the front door open, followed by the sound of footsteps ascending the stairs. A moment later I heard the murmur of voices in Robert Turold’s room upstairs.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I went nearer to try and find out what had happened, but it was no use. I could see a gleam of light in the study window, and could hear Robert Turold’s voice mingled with feminine tones, then—silence, followed once more by the sound of an opening door. From my place of concealment I saw two people going down the garden path—Thalassa and a female figure. They passed through the gate and vanished into the darkness of the moors.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“My opportunity had come. I went to the house and tried the front window. It was unlocked, and yielded. I got through, and went quickly upstairs. A light was shining underneath the study door. I opened it, and saw Robert Turold sitting at his table writing with his back towards me.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“At the sight of that atrocious scoundrel sitting there immersed in his shameful project against a woman I had loved, my self-control gave way utterly, completely. I had intended to be calm, to reason with him, to exact my terms with a cold logical brain. I did none of these things. Without a word of warning, before he even knew I was in the room, I sprang on him, clutching him, shaking him in a blind insensate fury till my strength suddenly failed me and left me sick and giddy.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“‘I am Remington,’ I said—‘Jim Remington.’ I leaned against the table, panting and exhausted, looking at him. His self-control was something to marvel at. He just sat still, returning my look with cold motionless eyes, no doubt trying to discern the features of the man he had wronged through the film of age. But in spite of his self-control I could see the grey pallor of fear creeping into his face, and he could not keep his lips from trembling. Twice he essayed to speak, but his mouth refused to utter the words. What he did say was strange to me, when he got it out at last. ‘I was right’—I heard him whisper, almost to himself—‘I knew, I knew.’ He repeated those words several times. It was then I saw that his self-control arose from the fact that although he was terrified he did not appear to be so greatly surprised. Surprised he was, but not in the way I had expected. His prime difficulty seemed to be to get out of his head the identity by which he had known me. ‘You are Ravenshaw—Dr. Ravenshaw,’ he said. ‘How can you be Remington?’ He brought out this with an effort, like a man trying to shake off an unreasoning horror.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I had expected him to face it out, to challenge me, perhaps deny all knowledge of my existence. Instead, he merely sat there staring at me with an air of terrified realization, like a person gazing upon the dreadful materialization of an expected phantom. I told him the truth in the fewest possible words, and he listened silently, never removing his eyes from me, the phantom of his past. When I had finished he lay back in his chair, but his eyes stared up at me with a kind of dead look, like half-closed eyes in a coffin. ‘I knew that you were rescued from the island,’ he said. ‘But I thought you were long since dead.’")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That statement surprised me. I asked him how he had learned of it. He told me it was through the medium of an overheard conversation in a London hotel nearly thirty years before. He had gone up to town to see his lawyer, and one of the people at the hotel where he put up happened to be one of the passengers of the "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Erechtheus")]), _vm._v(", the steamer which had rescued me. The man sat at the next table, and Turold heard him tell the story to a friend one night at dinner. It had happened just like that—quite simply, but it was a possibility I had overlooked. Not that it mattered, as it happened, but it would have—if Alice had been with him. Turold, of course, kept his knowledge to himself. He was too cautious to approach the passenger, but he instructed his lawyer to make guarded inquiries at the shipping office of the vessel in order to verify the story. Then he returned home, consumed by anxiety, no doubt, to wait for my reappearance. As the months slipped past and I did not appear, hope revived within him. It appears that he had heard the passenger say that I was a wreck—a physical wreck. That must have been a cheering item in a bad piece of news. I can imagine its growing importance in Turold’s mind as the time went on and I made no sign. Finally (and thankfully) he reached the conclusion that I was indeed dead, and that he had nothing more to fear. There was an element of uncertainty about it, though, a lack of definite knowledge. I fancy that was one of the reasons which led him to take Thalassa into his service when he turned up some time later. It was a deep and subtle thing to do. Thalassa was bound to help him against me, if ever I came back.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“The years went on, and he grew quite certain, as any man in his position would, in the circumstances. He forgot all about me. That frame of mind lasted until he came to Cornwall, and then, it seemed, I came back into his life in the strangest way. I haunted him in the spirit, and he never once guessed that I might be there in the flesh. Who can explain this?")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“As he spoke of it he looked as though he had a grievance against me, as, perhaps, he had—from his point of view. ‘You faded from my mind for twenty years,’ he said. ‘But here—in Cornwall—your memory began to haunt me. It was your footsteps, principally. I used to fancy you were following me across the moors. Tonight for the first time I actually heard them—heard them above the noise of the storm. They came to my ears clear and sharp, around the house, on the rocks, under the window.’ He cast on me an appalled, a hopeless glance. ‘Why have you left it so long?’ he cried. ‘What do you want—now?’")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“He positively had no glimmering of my feelings. His fixed idea, like a cancerous growth, had sucked all the healthy life out of him. Hot anger stirred within me again, but I retained control of myself this time. I asked him how he had found out about the earlier marriage, and he told me Alice had babbled something in her delirium—enough to arouse his suspicions. It seemed that he had waited for one of her lucid intervals, and wormed the truth out of her. ‘The proofs—of course you’ve obtained them?’ I asked casually. Yes, he had the proofs. He had sent to London for them immediately. I asked him where they were. ‘What do you want to know for?’ he asked in an agitated voice. I told him quite simply, that he must give me his proofs and tell the members of his family that he had been mistaken—that Alice’s first husband had really died before she married him. If he agreed to do that he had nothing farther to fear from me—I would remain dead forever. ‘You can destroy proofs, but not facts,’ he muttered in reply to this. I told him the facts were never likely to come to light if he entered into a compact of silence.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“He sat for a few moments as if contemplating the alternatives I had placed before him—sat with one hand in his table-drawer, seeking for papers, I thought. He desisted from doing this, and said quite suddenly, ‘The proofs are in the clock-case.’")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I had no suspicion. He had once shown me a curious receptacle in the bottom of the clock-case, where he kept papers. I went towards the clock, and was stooping over the drawer in the bottom of the case when I heard a swift footstep behind me. I turned. He was approaching with a revolver. The secret of his disclosure and the open drawer were explained. I suppose I owed my life to his dim sight, which compelled him to come so near.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I sprang at him, and we struggled. That struggle brought down the clock with a shattering crash. Robert Turold and I were locked in one another’s arms, wrestling desperately for the revolver, when I saw the great moon face of the clock flit past my vision like the face of a man taking a header off a pier. The crash startled Robert Turold. His hand loosened, and I got the revolver from him. As I tore it from his fingers it went off, and shot him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“He backed away from me with a kind of frozen smile, then crumpled up and slid to the floor. I bent over him. He made a slight movement, but I could see that he was dying—that he had only a very few moments to live.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Coolly and rapidly I reflected. The fall of the clock would be heard downstairs. Flight! There was a chance, if Thalassa had not returned. My other instinct was to secure the proofs first, though they were really useless then. I rummaged in the clock-case, and found a large envelope which I stuffed in my pocket. The face stared up at me; the clock had stopped at a minute to nine. I had an idea—an inspiration. I pulled the long hand down to the hour-half—to half-past nine. If I escaped from the house undiscovered, with only that half-stupid little woman downstairs, I would rush across the moors home—call my servant on some pretext as soon as I got in, and ask her the time. Then I should be quite safe—could defy everybody. Make it ten o’clock, then! No—too long to be safe. It might be discovered.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“It is strange how quickly the brain works when the instinct of self-preservation is aroused. These thoughts flashed through my mind in a kind of mental lightning. In the briefest possible space of time I was on my feet and out of the room. I locked the door on the outside, intending to take the key to defer discovery, but it slipped from my fingers in my haste, and fell in the dark passage. I dared not stop to search, for just then I heard a sound—or thought I did. Panic seized me. I feared I was trapped—my escape cut off. I flung precaution aside and went leaping downstairs to the door. I fumbled for the door-catch in the darkness, flung open the door, and ran out into the night—across the moors and home.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I had hardly got inside before your sister came with her husband to see me—to beg me to go with her to Flint House and reason with your brother. To reason with him! He was beyond the futility of argument, the folly of retort. I did not want to go—at first. Then it dawned upon me that a kindly fate offered me a providential chance of securing my safety. No suspicion could fall on me if I went back—and found the body.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“And so it turned out. We reached Flint House just at the right moment, for me. I broke into the room and found him—dead. He was not where I had left him. In a last paroxysm he had struggled to his feet and fallen across the clock-case, with the intention, as I shall always believe, of putting back the hand of the clock. I think his dying vision saw me alter it, and his last thought—his last effort—was to thwart my intention to mislead those upon whom would devolve the duty of investigating his death. But death was too quick to allow him to carry out his intention.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The cessation of the speaker’s voice was followed by silence. Thalassa had nothing to say—no need for words. Austin Turold could not trust himself to speak. It was not that his cynical philosophy of life failed him at that moment. The eternal staging of the drama was the eternal tragedy of the performers. But he was thinking of his son. He had vision enough to realize that in Sisily’s death Charles had lost all. His own hardness of outlook melted at that thought. It crumbled his worldliness to ashes, flooded his heart with vain regret, found utterance at last in the whispered words—")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“How am I to tell my son?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("His eyes, dwelling on the door of the inner room, revealed the direction of his thought.")])])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(93),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9781504093149',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(97)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(99);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 99 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.50f7e1c46963e18eb5b2.js